const musicLibrary = [
  {
    Name: "Kupe Dance",
    Artist: "A-STAR",
    Album: "Kupe Dance - Single",
    Time: 184,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "New Level REMIX (feat. Future, A$AP Rocky & Lil Uzi Vert)",
    Artist: "A$AP Ferg",
    Album: "New Level REMIX (feat. Future, A$AP Rocky & Lil Uzi Vert) - Single",
    Time: 251,
    Year: 2016,
    Plays: 50,
  },
  {
    Name: "No Ceilings (feat. Lil Wayne & Jay Gwuapo)",
    Artist: "A$AP Ferg",
    Album: "No Ceilings (feat. Lil Wayne & Jay Gwuapo) - Single",
    Time: 243,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "M'$ (feat. Lil Wayne)",
    Artist: "A$AP Rocky",
    Album: "AT.LONG.LAST.A$AP",
    Time: 233,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Babushka Boi",
    Artist: "A$AP Rocky",
    Album: "Babushka Boi - Single",
    Time: 187,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Praise The Lord (Da Shine) [feat. Skepta]",
    Artist: "A$AP Rocky",
    Album: "TESTING",
    Time: 205,
    Year: 2018,
    Plays: 107,
  },
  {
    Name: "Dancin (Krono Remix) [feat. Luvli]",
    Artist: "Aaron Smith",
    Album: "Dancin (Krono Remix) [feat. Luvli] - Single",
    Time: 198,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Dancing Queen",
    Artist: "ABBA",
    Album: "ABBA Gold: Greatest Hits",
    Time: 231,
    Year: 1976,
    Plays: 1,
  },
  {
    Name: "Highway to Hell",
    Artist: "AC/DC",
    Album: "Highway to Hell",
    Time: 208,
    Year: 1979,
    Plays: 15,
  },
  {
    Name: "Bugatti (feat. Future & Rick Ross)",
    Artist: "Ace Hood",
    Album: "Trials & Tribulations (Deluxe Version)",
    Time: 269,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "Standing In the Rain",
    Artist: "Action Bronson, Mark Ronson & Dan Auerbach",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 202,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Glory to Glory",
    Artist: "Ada Ehi",
    Album: "Future Now",
    Time: 243,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Determinate",
    Artist: "Adam Hicks, Bridgit Mendler, Naomi Scott & Hayley Kiyoko",
    Album: "Lemonade Mouth (Original TV Movie Soundtrack)",
    Time: 198,
    Year: 2011,
    Plays: 10,
  },
  {
    Name: "Lost Stars",
    Artist: "Adam Levine",
    Album: "V (Deluxe)",
    Time: 267,
    Year: 2015,
    Plays: 8,
  },
  {
    Name: "Damn, Delilah",
    Artist: "Adekunle Gold",
    Album: "About 30",
    Time: 171,
    Year: 2018,
    Plays: 28,
  },
  {
    Name: "Sade",
    Artist: "Adekunle Gold",
    Album: "Afrobeats with Love, Vol. 3",
    Time: 244,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Catch Me If You Can",
    Artist: "Adekunle Gold",
    Album: "Catch Me If You Can",
    Time: 199,
    Year: 2022,
    Plays: 4,
  },
  {
    Name: "Sade (Bonus)",
    Artist: "Adekunle Gold",
    Album: "Gold",
    Time: 226,
    Year: 2014,
    Plays: 45,
  },
  {
    Name: "High",
    Artist: "Adekunle Gold & Davido",
    Album: "High - Single",
    Time: 193,
    Year: 2021,
    Plays: 83,
  },
  {
    Name: "Rolling In The Deep",
    Artist: "Adele",
    Album: "21",
    Time: 229,
    Year: 2011,
    Plays: 25,
  },
  {
    Name: "Rumour Has It",
    Artist: "Adele",
    Album: "21",
    Time: 223,
    Year: 2011,
    Plays: 24,
  },
  {
    Name: "Turning Tabels",
    Artist: "Adele",
    Album: "21",
    Time: 250,
    Year: 2011,
    Plays: 6,
  },
  {
    Name: "Turning Tables",
    Artist: "Adele",
    Album: "21",
    Time: 250,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Don't You Remember",
    Artist: "Adele",
    Album: "21",
    Time: 243,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Set Fire To The Rain",
    Artist: "Adele",
    Album: "21",
    Time: 241,
    Year: 2011,
    Plays: 20,
  },
  {
    Name: "He Won't Go",
    Artist: "Adele",
    Album: "21",
    Time: 277,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "Take It All",
    Artist: "Adele",
    Album: "21",
    Time: 228,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "I'll Be Waiting",
    Artist: "Adele",
    Album: "21",
    Time: 241,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "One And Only",
    Artist: "Adele",
    Album: "21",
    Time: 348,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Lovesong",
    Artist: "Adele",
    Album: "21",
    Time: 316,
    Year: 2011,
    Plays: 17,
  },
  {
    Name: "Someone Like You",
    Artist: "Adele",
    Album: "21",
    Time: 287,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "I Found a Boy (Bonus Track)",
    Artist: "Adele",
    Album: "21",
    Time: 217,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "If It Hadn't Been For Love",
    Artist: "Adele",
    Album: "21",
    Time: 188,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "Hiding My Heart",
    Artist: "Adele",
    Album: "21",
    Time: 208,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Hello",
    Artist: "Adele",
    Album: "25",
    Time: 295,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Send my love (to your new lover)",
    Artist: "Adele",
    Album: "25",
    Time: 223,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "I miss you",
    Artist: "Adele",
    Album: "25",
    Time: 348,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "When we were young",
    Artist: "Adele",
    Album: "25",
    Time: 290,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Remedy",
    Artist: "Adele",
    Album: "25",
    Time: 245,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Water under the bridge",
    Artist: "Adele",
    Album: "25",
    Time: 240,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "River lea",
    Artist: "Adele",
    Album: "25",
    Time: 225,
    Year: 2015,
    Plays: 15,
  },
  {
    Name: "Love in the dark",
    Artist: "Adele",
    Album: "25",
    Time: 286,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Million years ago",
    Artist: "Adele",
    Album: "25",
    Time: 227,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "All i ask",
    Artist: "Adele",
    Album: "25",
    Time: 271,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Sweetest devotion",
    Artist: "Adele",
    Album: "25",
    Time: 251,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Drifting",
    Artist: "Adelitas Way",
    Album: "Drifting - Single",
    Time: 179,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "Lets Just Drive",
    Artist: "Adelitas Way",
    Album: "Lets Just Drive - Single",
    Time: 215,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Ready for War (Pray for Peace)",
    Artist: "Adelitas Way",
    Album: "Ready for War (Pray for Peace) - Single",
    Time: 211,
    Year: 2016,
    Plays: 29,
  },
  {
    Name: "What You Want",
    Artist: "Adelitas Way",
    Album: "Shine On",
    Time: 194,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Something More",
    Artist: "Adelitas Way",
    Album: "Shine On",
    Time: 191,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Dream On",
    Artist: "Aerosmith",
    Album: "Aerosmith",
    Time: 267,
    Year: 1973,
    Plays: 6,
  },
  {
    Name: "Break Angels",
    Artist: "AFI",
    Album: "The Missing Man - EP",
    Time: 207,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Mr President",
    Artist: "African China",
    Album: "Mr. President",
    Time: 342,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Because I Got High",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 197,
    Year: 2001,
    Plays: 6,
  },
  {
    Name: "Crazy Rap (Colt 45 & 2 Zig Zags)",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 328,
    Year: 2000,
    Plays: null,
  },
  {
    Name: "She Won't Let Me Fuck",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 361,
    Year: 2001,
    Plays: null,
  },
  {
    Name: "Hush",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 279,
    Year: 2001,
    Plays: 1,
  },
  {
    Name: "Tumbleweed",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 313,
    Year: 2001,
    Plays: null,
  },
  {
    Name: "Let's All Get Drunk",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 344,
    Year: 2001,
    Plays: null,
  },
  {
    Name: "Tall Cans",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 429,
    Year: 2001,
    Plays: 1,
  },
  {
    Name: "Palmdale",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 400,
    Year: 2001,
    Plays: null,
  },
  {
    Name: "Mississippi",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 367,
    Year: 2001,
    Plays: 1,
  },
  {
    Name: "The American Dream",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 172,
    Year: 2001,
    Plays: null,
  },
  {
    Name: "Because I Got High (Extended Version)",
    Artist: "Afroman",
    Album: "The Good Times",
    Time: 310,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Nerve",
    Artist: "Age of Days",
    Album: "Nerve - Single",
    Time: 231,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "I Did it for Love",
    Artist: "Age of Days",
    Album: "Radioactivity",
    Time: 219,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Whatever",
    Artist: "Age of Days",
    Album: "Whatever - Single",
    Time: 208,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "Brave Shine",
    Artist: "Aimer",
    Album: "DAWN",
    Time: 233,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Brave Shine",
    Artist: "Aimer",
    Album: "DAWN",
    Time: 233,
    Year: 2015,
    Plays: 12,
  },
  {
    Name: "haruhayuku",
    Artist: "Aimer",
    Album: "Hananouta / I beg you / Haruhayuku - EP",
    Time: 305,
    Year: 2020,
    Plays: 41,
  },
  {
    Name: "Hana No Uta end of spring version",
    Artist: "Aimer",
    Album: "Hananouta / I beg you / Haruhayuku - EP",
    Time: 353,
    Year: 2020,
    Plays: 15,
  },
  {
    Name: "haruhayuku (the late spring version)",
    Artist: "Aimer",
    Album: "Hananouta / I beg you / Haruhayuku - EP",
    Time: 333,
    Year: 2020,
    Plays: 19,
  },
  {
    Name: "Run Riot",
    Artist: "Aimer",
    Album: "haruhayuku marie - EP",
    Time: 256,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "I beg you",
    Artist: "Aimer",
    Album: "Penny Rain",
    Time: 267,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Hana No Uta",
    Artist: "Aimer",
    Album: "Penny Rain",
    Time: 371,
    Year: 2017,
    Plays: 11,
  },
  {
    Name: "SPARK - AGAIN",
    Artist: "Aimer",
    Album: "Walpurgis",
    Time: 242,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Torches",
    Artist: "Aimer",
    Album: "Walpurgis",
    Time: 294,
    Year: 2019,
    Plays: 10,
  },
  {
    Name: "Oh, The Moon!",
    Artist: "AJ Abdullah",
    Album: "Oh, The Moon! - Single",
    Time: 169,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Do You Hear the Thunder?",
    Artist: "AJ Abdullah & Me Here",
    Album: "Sunshine, Nevermind - Single",
    Time: 137,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Sunshine, Nevermind",
    Artist: "AJ Abdullah & Me Here",
    Album: "Sunshine, Nevermind - Single",
    Time: 202,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Kiss and Tell",
    Artist: "AJ Tracey & Skepta",
    Album: "Kiss and Tell - Single",
    Time: 192,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Barawo",
    Artist: "Ajebo Hustlers",
    Album: "Barawo - Single",
    Time: 229,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Barawo (feat. Davido) [Remix]",
    Artist: "Ajebo Hustlers",
    Album: "Barawo (Remix) [feat. Davido] - Single",
    Time: 211,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Loyalty",
    Artist: "Ajebo Hustlers",
    Album: "Loyalty - Single",
    Time: 167,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Omo Pastor (feat. BOJ)",
    Artist: "Ajebutter 22",
    Album: "Anytime Soon (Deluxe Edition)",
    Time: 224,
    Year: 2012,
    Plays: 23,
  },
  {
    Name: "4Am (feat. Dremo)",
    Artist: "Ajebutter 22",
    Album: "What Happens in Lagos",
    Time: 232,
    Year: 2017,
    Plays: 5,
  },
  {
    Name: "Bad Gang (feat. Falz)",
    Artist: "Ajebutter 22",
    Album: "What Happens in Lagos",
    Time: 204,
    Year: 2016,
    Plays: 50,
  },
  {
    Name: "We Are Bad Boys (feat. M.I Abaga)",
    Artist: "Ajebutter 22",
    Album: "What Happens in Lagos",
    Time: 199,
    Year: 2017,
    Plays: 59,
  },
  {
    Name: "Lagos Big Boy",
    Artist: "Ajebutter 22",
    Album: "What Happens in Lagos",
    Time: 221,
    Year: 2016,
    Plays: 144,
  },
  {
    Name: "Ronaldo",
    Artist: "Ajebutter 22, BOJ & Falz",
    Album: "Make E No Cause Fight 2 - EP",
    Time: 195,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Rock Your Body",
    Artist: "Ajebutter 22, BOJ & Falz",
    Album: "Make E No Cause Fight 2 - EP",
    Time: 192,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Omo Pastor (prod by Studio Magic)",
    Artist: "Ajebutter22 (ft. BOJ)",
    Album: "Studio Magic Presents: Anytime soon",
    Time: 224,
    Year: 2012,
    Plays: 34,
  },
  {
    Name: "Be With You",
    Artist: "Akon",
    Album: "Freedom",
    Time: 231,
    Year: 2008,
    Plays: 8,
  },
  {
    Name: "Right Now (Na Na Na)",
    Artist: "Akon",
    Album: "Freedom (Bonus Track Version)",
    Time: 240,
    Year: 2008,
    Plays: 25,
  },
  {
    Name: "Beautiful",
    Artist: "Akon",
    Album: "Freedom (Bonus Track Version)",
    Time: 312,
    Year: 2008,
    Plays: 11,
  },
  {
    Name: "Be with You",
    Artist: "Akon",
    Album: "Freedom (Bonus Track Version)",
    Time: 230,
    Year: 2008,
    Plays: 27,
  },
  {
    Name: "Don't Matter",
    Artist: "Akon",
    Album: "Konvicted",
    Time: 293,
    Year: 2006,
    Plays: 4,
  },
  {
    Name: "Alone",
    Artist: "Alan Walker",
    Album: "Alone - Single",
    Time: 161,
    Year: 2016,
    Plays: 32,
  },
  {
    Name: "Faded",
    Artist: "Alan Walker",
    Album: "Faded - EP",
    Time: 212,
    Year: 2015,
    Plays: 110,
  },
  {
    Name: "Faded (Instrumental)",
    Artist: "Alan Walker",
    Album: "Faded - EP",
    Time: 214,
    Year: 2015,
    Plays: 48,
  },
  {
    Name: "Faded (Restrung)",
    Artist: "Alan Walker",
    Album: "Faded - EP",
    Time: 217,
    Year: 2016,
    Plays: 27,
  },
  {
    Name: "Faded (Piano Version)",
    Artist: "Alan Walker",
    Album: "Faded - EP",
    Time: 215,
    Year: 2015,
    Plays: 21,
  },
  {
    Name: "Sing Me to Sleep",
    Artist: "Alan Walker",
    Album: "Sing Me to Sleep - Single",
    Time: 189,
    Year: 2016,
    Plays: 11,
  },
  {
    Name: "The Spectre",
    Artist: "Alan Walker",
    Album: "The Spectre - Single",
    Time: 193,
    Year: 2017,
    Plays: 33,
  },
  {
    Name: "Tired (feat. Gavin James)",
    Artist: "Alan Walker",
    Album: "Tired (feat. Gavin James) - Single",
    Time: 192,
    Year: 2017,
    Plays: 8,
  },
  {
    Name: "Tired (Kygo Remix)",
    Artist: "Alan Walker & Gavin James",
    Album: "Tired (Kygo Remix) - Single",
    Time: 240,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Diamond Heart",
    Artist: "Alan Walker & Sophia Somajo",
    Album: "Different World",
    Time: 240,
    Year: 2018,
    Plays: 53,
  },
  {
    Name: "Lost Control",
    Artist: "Alan Walker & Sorana",
    Album: "Different World",
    Time: 222,
    Year: 2018,
    Plays: 35,
  },
  {
    Name: "On My Way",
    Artist: "Alan Walker, Sabrina Carpenter & Farruko",
    Album: "On My Way - Single",
    Time: 193,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "Boy in the Bubble",
    Artist: "Alec Benjamin",
    Album: "Narrated for You",
    Time: 181,
    Year: 2018,
    Plays: 93,
  },
  {
    Name: "Cold",
    Artist: "Alec Chambers",
    Album: "Cold - Single",
    Time: 230,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "River of Tears",
    Artist: "Alessia Cara",
    Album: "Know-It-All (Deluxe)",
    Time: 254,
    Year: 2015,
    Plays: 28,
  },
  {
    Name: "A Million On My Soul",
    Artist: "Alexiane",
    Album:
      "Valerian and the City of a Thousand Planets (Original Motion Picture Soundtrack)",
    Time: 247,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "It's You",
    Artist: "Ali Gatie",
    Album: "YOU",
    Time: 212,
    Year: 2019,
    Plays: 173,
  },
  {
    Name: "Holding On",
    Artist: "Ali Gatie",
    Album: "YOU",
    Time: 137,
    Year: 2019,
    Plays: 45,
  },
  {
    Name: "No One",
    Artist: "Alicia Keys",
    Album: "As I Am (Expanded Edition)",
    Time: 253,
    Year: 2007,
    Plays: 2,
  },
  {
    Name: "Fallin'",
    Artist: "Alicia Keys",
    Album: "Songs In A Minor (Expanded Edition)",
    Time: 210,
    Year: 2001,
    Plays: 5,
  },
  {
    Name: "Tomorrow Never Knows [Beatles cover] ",
    Artist: "Alison Mosshart and Carla Azar",
    Album: "Sucker Punch",
    Time: 455,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Mercy Me",
    Artist: "Alkaline Trio",
    Album: "Crimson",
    Time: 169,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Blackbird",
    Artist: "Alkaline Trio",
    Album: "Is This Thing Cursed?",
    Time: 200,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "For the Glory",
    Artist: "All Good Things",
    Album: "Machines",
    Time: 279,
    Year: 2017,
    Plays: 13,
  },
  {
    Name: "Everything's Wrong",
    Artist: "All That Remains",
    Album: "Everything's Wrong - Single",
    Time: 250,
    Year: 2018,
    Plays: 17,
  },
  {
    Name: "This Probably Won’t End Well",
    Artist: "All That Remains",
    Album: "The Order of Things",
    Time: 228,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Hallelujah",
    Artist: "Allison Crowe",
    Album: "Zack Snyder's Justice League (Original Motion Picture Soundtrack)",
    Time: 370,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "ThisMoney",
    Artist: "Alpha Ojini",
    Album: "Chvmeleon",
    Time: 216,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "More",
    Artist: "Alpha P",
    Album: "King of the Wolves - EP",
    Time: 208,
    Year: 2019,
    Plays: 24,
  },
  {
    Name: "Show Me a Leader",
    Artist: "Alter Bridge",
    Album: "The Last Hero",
    Time: 305,
    Year: 2016,
    Plays: 72,
  },
  {
    Name: 'Call Your Heroes (From "Attack on Titan") [Medley]',
    Artist: "AmaLee",
    Album: 'Call Your Heroes (From "Attack on Titan") [Medley] - Single',
    Time: 325,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: 'Might+U (from "My Hero Academia") [feat. Ricco Fajardo][Cover Version]',
    Artist: "AmaLee",
    Album:
      'Might+U (from "My Hero Academia") [feat. Ricco Fajardo][Cover Version] - Single',
    Time: 202,
    Year: 2020,
    Plays: 11,
  },
  {
    Name: "Reluctant Heroes (Attack on Titan)",
    Artist: "AmaLee",
    Album: "Reluctant Heroes (Attack on Titan) - Single",
    Time: 311,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Guren no Yumiya",
    Artist: "AmaLee & Luke Thomas",
    Album: "Guren no Yumiya - Single",
    Time: 214,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Strong (feat. Noora Louhimo)",
    Artist: "Amaranthe",
    Album: "Manifest",
    Time: 186,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Digital World",
    Artist: "Amaranthe",
    Album: "MASSIVE ADDICTIVE",
    Time: 197,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Invincible",
    Artist: "Aminé",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 196,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Ivy (Doomsday)",
    Artist: "The Amity Affliction",
    Album: "Misery",
    Time: 219,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "Feels Like I'm Dying",
    Artist: "The Amity Affliction",
    Album: "Misery",
    Time: 219,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "Drag the Lake",
    Artist: "The Amity Affliction",
    Album: "Misery",
    Time: 211,
    Year: 2018,
    Plays: 24,
  },
  {
    Name: "Set Me Free",
    Artist: "The Amity Affliction",
    Album: "Misery",
    Time: 210,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "All F****d Up",
    Artist: "The Amity Affliction",
    Album: "This Could Be Heartbreak",
    Time: 229,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Can't Stop What's Coming (feat. Dave Eggar)",
    Artist: "Amy Lee",
    Album: "Aftermath",
    Time: 124,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Rise Up",
    Artist: "Andra Day",
    Album: "Cheers to the Fall",
    Time: 253,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "In My Veins",
    Artist: "Andrew Belle",
    Album: "",
    Time: 319,
    Year: null,
    Plays: 8,
  },
  {
    Name: "Ever Again",
    Artist: "Andrew W.K.",
    Album: "You're Not Alone",
    Time: 198,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Coming In Hot",
    Artist: "Andy Mineo & Lecrae",
    Album: "Coming In Hot (Remix Pack) - EP",
    Time: 200,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Battle Cry",
    Artist: "Angel Haze & Sia",
    Album: "Dirty Gold",
    Time: 292,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "KINGS",
    Artist: "angela",
    Album: "KINGS",
    Time: 319,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "THE DARK",
    Artist: "angela",
    Album: "KINGS",
    Time: 258,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Turn It Up",
    Artist: "Anikdote",
    Album: "Turn It Up - Single",
    Time: 247,
    Year: 2016,
    Plays: 9,
  },
  {
    Name: "Indecente",
    Artist: "Anitta",
    Album: "Indecente - Single",
    Time: 205,
    Year: 2018,
    Plays: 43,
  },
  {
    Name: "Cups",
    Artist: "Anna Kendrick",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 77,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Ciao Adiós",
    Artist: "Anne-Marie",
    Album: "Speak Your Mind (Deluxe)",
    Time: 199,
    Year: 2017,
    Plays: 6,
  },
  {
    Name: "Then",
    Artist: "Anne-Marie",
    Album: "Then - Single",
    Time: 214,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "I Put a Spell On You (Fifty Shades of Grey)",
    Artist: "Annie Lennox",
    Album: "Fifty Shades of Grey",
    Time: 210,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Stfu",
    Artist: "Annisokay",
    Album: "STFU - Single",
    Time: 210,
    Year: 2020,
    Plays: 10,
  },
  {
    Name: "Medicine (feat. Conor Maynard)",
    Artist: "ANTH",
    Album: "Medicine (feat. Conor Maynard) - Single",
    Time: 237,
    Year: 2019,
    Plays: 35,
  },
  {
    Name: "So Many Reasons",
    Artist: "ANTH & Twista",
    Album: "So Many Reasons - Single",
    Time: 219,
    Year: 2022,
    Plays: 5,
  },
  {
    Name: "Igbotic (feat. Kcee)",
    Artist: "Anyidons",
    Album: "Igbotic (feat. Kcee) - Single",
    Time: 204,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Slime",
    Artist: "Apex Village",
    Album: "Welcome to the Ville",
    Time: 174,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "En Route To Mayhem",
    Artist: "Apocalyptica",
    Album: "Cell-0",
    Time: 328,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Talk To Me (feat. Lzzy Hale)",
    Artist: "Apocalyptica",
    Album: "Talk To Me (feat. Lzzy Hale) - Single",
    Time: 208,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Okay (feat. Phourthelove)",
    Artist: "Apollo, Promoting Sounds & Packy",
    Album: "Okay (feat. Phourthelove) - Single",
    Time: 249,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Shadows",
    Artist: "Apollo's Prophecy",
    Album: "Shadows - EP",
    Time: 255,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Black Lungs",
    Artist: "Architects",
    Album: "For Those That Wish to Exist",
    Time: 231,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Royal Beggars",
    Artist: "Architects",
    Album: "Holy Hell",
    Time: 241,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Bleu Chanel",
    Artist: "ARIA",
    Album: "Bleu Chanel - Single",
    Time: 144,
    Year: 2018,
    Plays: 39,
  },
  {
    Name: "On Me Tho",
    Artist: "ARIA",
    Album: "On Me Tho - Single",
    Time: 178,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "7 rings",
    Artist: "Ariana Grande",
    Album: "thank u, next",
    Time: 178,
    Year: 2019,
    Plays: 78,
  },
  {
    Name: "Don't Call Me Angel (Charlie's Angels)",
    Artist: "Ariana Grande, Miley Cyrus & Lana Del Rey",
    Album: "Charlie's Angels (Original Motion Picture Soundtrack)",
    Time: 190,
    Year: 2019,
    Plays: 27,
  },
  {
    Name: "Bozoo",
    Artist: "armoo & 6ix9ine",
    Album: "Bozoo - Single",
    Time: 130,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Hole in the Roof",
    Artist: "AronChupa & Little Sis Nora",
    Album: "Hole in the Roof - Single",
    Time: 170,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Rearview Mirror",
    Artist: "Art of Dying",
    Album: "Armageddon",
    Time: 205,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "9 Lives",
    Artist: "Aṣa",
    Album: "Lucid",
    Time: 179,
    Year: 2019,
    Plays: 96,
  },
  {
    Name: "Show Me Off",
    Artist: "Aṣa",
    Album: "V",
    Time: 197,
    Year: 2022,
    Plays: 2,
  },
  {
    Name: "Mr Money",
    Artist: "Asake",
    Album: "Mr Money - Single",
    Time: 124,
    Year: 2020,
    Plays: 37,
  },
  {
    Name: "Long Live ASAP",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 289,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Goldie",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 192,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "PMW (All I Really Need) (Feat. Schoolboy Q)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 234,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "LVL",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 220,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Hell (Feat. Santigold)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 231,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Pain (Feat. Overdoz)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 233,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Fuckin Problems (Feat. Drake, 2 Chainz, Kendrick Lamar)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 233,
    Year: 2013,
    Plays: 13,
  },
  {
    Name: "Wild For The Night (Feat. Skrillex)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 209,
    Year: 2013,
    Plays: 14,
  },
  {
    Name: "1 Train (Feat. Kendrick Lamar, Joey Badass, Yelawolf, Danny Brown, Action Bronson, Big K.R.I.T.)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 372,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Fashion Killa",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 236,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Phoenix",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 233,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Suddenly",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 270,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Jodye (Bonus Track)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 260,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Ghetto Symphony (Feat. Gunplay, ASAP Ferg) (Bonus Track)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 237,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Angels (Bonus Track)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 228,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "I Come Apart (Feat. Florence Welch) (Bonus Track)",
    Artist: "ASAP Rocky",
    Album: "Long Live ASAP-(Deluxe Edition)",
    Time: 217,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Moral of the Story",
    Artist: "Ashe",
    Album: "Ashlyn",
    Time: 201,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Into the Fire",
    Artist: "Asking Alexandria",
    Album: "Asking Alexandria",
    Time: 237,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Where Did It Go?",
    Artist: "Asking Alexandria",
    Album: "Asking Alexandria",
    Time: 193,
    Year: 2017,
    Plays: 79,
  },
  {
    Name: "Here I Am",
    Artist: "Asking Alexandria",
    Album: "The Black",
    Time: 259,
    Year: 2016,
    Plays: 37,
  },
  {
    Name: "Down To Hell",
    Artist: "Asking Alexandria",
    Album: "Like a House On Fire",
    Time: 196,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Antisocialist",
    Artist: "Asking Alexandria",
    Album: "Like a House On Fire",
    Time: 216,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Alone In a Room",
    Artist: "Asking Alexandria",
    Album: "Lp5 DLX",
    Time: 245,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "When the Lights Come On",
    Artist: "Asking Alexandria",
    Album: "Lp5 DLX",
    Time: 203,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Moving On",
    Artist: "Asking Alexandria",
    Album: "Moving On - Single",
    Time: 242,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Moving On (Acoustic)",
    Artist: "Asking Alexandria",
    Album: "Moving On - Single",
    Time: 243,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "They Don't Want What We Want (And They Don't Care)",
    Artist: "Asking Alexandria",
    Album: "They Don't Want What We Want (And They Don't Care) - Single",
    Time: 195,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "I Dream in Lines",
    Artist: "Astronoid",
    Album: "Astronoid",
    Time: 290,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Rubik's Cube",
    Artist: "Athlete",
    Album: "Black Swan (Deluxe Version)",
    Time: 269,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Underrated",
    Artist: "Atreyu",
    Album: "Baptize",
    Time: 180,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "In Our Wake",
    Artist: "Atreyu",
    Album: "In Our Wake",
    Time: 193,
    Year: 2018,
    Plays: 19,
  },
  {
    Name: "The Time Is Now",
    Artist: "Atreyu",
    Album: "In Our Wake",
    Time: 199,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "All My Life",
    Artist: "Attack Attack! (US)",
    Album: "All My Life - Single",
    Time: 184,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Runaway",
    Artist: "AURORA",
    Album: "All My Demons Greeting Me As a Friend (Deluxe)",
    Time: 248,
    Year: 2015,
    Plays: 23,
  },
  {
    Name: "A Million Dreams (Reprise)",
    Artist: "Austyn Johnson, Cameron Seely & Hugh Jackman",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 60,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Want You to Stay",
    Artist: "Autumn Kings",
    Album: "Electrified - EP",
    Time: 230,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Kings & Queens",
    Artist: "Ava Max",
    Album: "Heaven & Hell",
    Time: 162,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Sweet but Psycho",
    Artist: "Ava Max",
    Album: "Sweet but Psycho - Single",
    Time: 187,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Scream Until You Wake",
    Artist: "Avatar",
    Album: "Hunter Gatherer",
    Time: 250,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Afterlife",
    Artist: "Avenged Sevenfold",
    Album: "Avenged Sevenfold",
    Time: 352,
    Year: 2007,
    Plays: 3,
  },
  {
    Name: "Hail to the King",
    Artist: "Avenged Sevenfold",
    Album: "Hail to the King (Deluxe Edition)",
    Time: 304,
    Year: 2013,
    Plays: 10,
  },
  {
    Name: "Wake Me Up",
    Artist: "Avicii",
    Album: "TRUE",
    Time: 249,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Sk8er Boi",
    Artist: "Avril Lavigne",
    Album: "Let Go",
    Time: 204,
    Year: 2002,
    Plays: 2,
  },
  {
    Name: "My Happy Ending",
    Artist: "Avril Lavigne",
    Album: "Under My Skin",
    Time: 242,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "The Best",
    Artist: "AWOLNATION",
    Album: "Angel Miners & the Lightning Riders",
    Time: 223,
    Year: 2020,
    Plays: 9,
  },
  {
    Name: "California Halo Blue",
    Artist: "AWOLNATION",
    Album: "Angel Miners & the Lightning Riders",
    Time: 233,
    Year: 2020,
    Plays: 6,
  },
  {
    Name: "I'm On Fire",
    Artist: "AWOLNATION",
    Album: "Fifty Shades of Grey",
    Time: 154,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Run",
    Artist: "AWOLNATION",
    Album: "Run",
    Time: 241,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "More Than You Know",
    Artist: "Axwell Λ Ingrosso",
    Album: "More Than You Know - EP",
    Time: 203,
    Year: 2017,
    Plays: 53,
  },
  {
    Name: "Dawn",
    Artist: "Axwell Λ Ingrosso",
    Album: "More Than You Know - EP",
    Time: 332,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Alive",
    Artist: "Ayano Mashiro",
    Album: "Alive - EP",
    Time: 236,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Ideal White",
    Artist: "Ayano Mashiro",
    Album: "WHITE PLACE",
    Time: 257,
    Year: 2014,
    Plays: 12,
  },
  {
    Name: "Cast (Gen Z Anthem)",
    Artist: "Ayra Starr",
    Album: "19 & Dangerous",
    Time: 165,
    Year: 2021,
    Plays: 12,
  },
  {
    Name: "Bloody Samaritan",
    Artist: "Ayra Starr",
    Album: "19 & Dangerous",
    Time: 187,
    Year: 2021,
    Plays: 20,
  },
  {
    Name: "Airplanes",
    Artist: "B.o.B",
    Album: "B.o.B Presents The Adventures of Bobby Ray",
    Time: 178,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Airplanes (Part 2)",
    Artist: "B.o.B",
    Album: "B.o.B Presents The Adventures of Bobby Ray",
    Time: 317,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Airplanes (feat. Hayley Williams of Paramore)",
    Artist: "B.o.B",
    Album: "B.o.B Presents: The Adventures of Bobby Ray (Deluxe)",
    Time: 181,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Airplanes, Part II (feat Eminem & Hayley Williams of Paramore)",
    Artist: "B.o.B",
    Album: "B.o.B Presents: The Adventures of Bobby Ray (Deluxe)",
    Time: 319,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Starlight",
    Artist: "BABYMETAL",
    Album: "Starlight - Single",
    Time: 217,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Strike Back",
    Artist: "BACK-ON",
    Album: "Strike Back - Single",
    Time: 226,
    Year: 2014,
    Plays: 12,
  },
  {
    Name: "Show Me the Meaning of Being Lonely",
    Artist: "Backstreet Boys",
    Album: "Millennium",
    Time: 234,
    Year: 1999,
    Plays: 5,
  },
  {
    Name: "Incomplete",
    Artist: "Backstreet Boys",
    Album: "Never Gone",
    Time: 239,
    Year: 2005,
    Plays: 11,
  },
  {
    Name: "Have Fun",
    Artist: "Bad Boy Timz",
    Album: "Have Fun - Single",
    Time: 136,
    Year: 2020,
    Plays: 105,
  },
  {
    Name: "Yo Perreo Sola",
    Artist: "Bad Bunny",
    Album: "YHLQMDLG",
    Time: 172,
    Year: 2020,
    Plays: 23,
  },
  {
    Name: "Fight As One",
    Artist: "Bad City",
    Album: "Avengers Earth's Mightiest Heroes",
    Time: 137,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Take Me For A Ride",
    Artist: "Bad City",
    Album: "Bad City",
    Time: 221,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Welcome 2 Hell",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 177,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Fast Lane",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 249,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "The Reunion",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 290,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Above The Law",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 209,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "I'm On Everything (feat Mike Epps)",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 271,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "A Kiss",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 274,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Lighters (feat Bruno Mars)",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 303,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Take From Me",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 205,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Loud Noises (feat Slaughterhouse)",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 260,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Living Proof",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 235,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Echo",
    Artist: "Bad Meets Evil",
    Album: "Hell: The Sequel (Deluxe Edition)",
    Time: 294,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Never Know",
    Artist: "Bad Omens",
    Album: "Finding God Before God Finds Me (Deluxe)",
    Time: 213,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Faith Alone 2020",
    Artist: "Bad Religion",
    Album: "Faith Alone 2020 - Single",
    Time: 216,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Lifeline",
    Artist: "Bad Wolves",
    Album: "Dear Monsters",
    Time: 193,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "In the Middle",
    Artist: "Bad Wolves",
    Album: "Dear Monsters",
    Time: 249,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Toast to the Ghost",
    Artist: "Bad Wolves",
    Album: "Disobey",
    Time: 341,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Hear Me Now (feat. DIAMANTE)",
    Artist: "Bad Wolves",
    Album: "Hear Me Now (feat. DIAMANTE) - Single",
    Time: 219,
    Year: 2018,
    Plays: 153,
  },
  {
    Name: "Hear Me Now (feat. DIAMANTE) [Acoustic]",
    Artist: "Bad Wolves",
    Album: "Hear Me Now (feat. DIAMANTE) [Acoustic] - Single",
    Time: 223,
    Year: 2018,
    Plays: 17,
  },
  {
    Name: "I'll Be There",
    Artist: "Bad Wolves",
    Album: "N.A.T.I.O.N.",
    Time: 242,
    Year: 2019,
    Plays: 7,
  },
  {
    Name: "Killing Me Slowly",
    Artist: "Bad Wolves",
    Album: "N.A.T.I.O.N.",
    Time: 237,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Sober",
    Artist: "Bad Wolves",
    Album: "N.A.T.I.O.N.",
    Time: 195,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Zombie (Acoustic)",
    Artist: "Bad Wolves",
    Album: "Zombie - EP",
    Time: 259,
    Year: 2018,
    Plays: 20,
  },
  {
    Name: "Zombie",
    Artist: "Bad Wolves",
    Album: "Zombie - Single",
    Time: 254,
    Year: 2018,
    Plays: 221,
  },
  {
    Name: "Pete Yangu (feat. Nadia Mukami)",
    Artist: "Bahati",
    Album: "Love Like This",
    Time: 178,
    Year: 2021,
    Plays: 14,
  },
  {
    Name: "Bellas Regionals: The Sign/Eternal Flame/Turn the Beat Around",
    Artist: "The Barden Bellas",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 160,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Pool Mashup: Just the Way You Are/Just a Dream",
    Artist: "The Barden Bellas",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 98,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Party In the U.S.A.",
    Artist: "The Barden Bellas",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 63,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Bellas Finals: Price Tag/Don‚t You (Forget About Me)/Give Me Everything/Just the Way You Are/Party In the U.S.A./Turn the Beat Around",
    Artist: "The Barden Bellas",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 217,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Riff Off: Mickey/Like a Virgin/Hit Me With Your Best Shot/S&M/Let‚s Talk About Sex/I‚ll Make Love To You/Feels Like the First Time/No Diggity",
    Artist: "The Barden Bellas, The Treblemakers & The Bu Harmonics",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 223,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Shock Me",
    Artist: "Baroness",
    Album: "Purple",
    Time: 257,
    Year: 2015,
    Plays: 62,
  },
  {
    Name: "Ride Or Die",
    Artist: "Basketmouth, LADIPOE & Waje",
    Album: "Yabasi",
    Time: 185,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Myself",
    Artist: "Basketmouth, Show Dem Camp & Oxlade",
    Album: "Yabasi",
    Time: 203,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Love & Life (feat. M.I Abaga)",
    Artist: "Basketmouth, Simi & Johnny Drille",
    Album: "Horoscopes",
    Time: 219,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "All I Ever Wanted (Extended Mix)",
    Artist: "Basshunter",
    Album: "All I Ever Wanted - EP",
    Time: 328,
    Year: 2008,
    Plays: 9,
  },
  {
    Name: "Pompeii",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 214,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Things We Lost In The Fire",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 240,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Bad Blood",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 212,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Overjoyed",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 206,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "These Streets",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 175,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Weight Of Living, Pt. II",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 174,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Icarus",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 225,
    Year: 2013,
    Plays: 123,
  },
  {
    Name: "Oblivion",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 196,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Flaws",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 218,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Daniel In The Den",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 188,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Laura Palmer",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 186,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Get Home",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 191,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Poet",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 165,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "The Silence",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 231,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Weight Of Living, Pt. I",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 207,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Sleepsong",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 221,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Durban Skies",
    Artist: "Bastille",
    Album: "All This Bad Blood (Deluxe Edition)",
    Time: 250,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Plan the Escape",
    Artist: "Bat for Lashes",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 150,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "My Declaration",
    Artist: "Bayless",
    Album: "My Declaration - Single",
    Time: 252,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "That Bitch",
    Artist: "Bea Miller",
    Album: "That Bitch - Single",
    Time: 201,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "it's not u it's me",
    Artist: "Bea Miller & 6LACK",
    Album: "it's not u it's me - Single",
    Time: 194,
    Year: 2019,
    Plays: 16,
  },
  {
    Name: "Fed Up",
    Artist: "Beartooth",
    Album: "Below",
    Time: 201,
    Year: 2021,
    Plays: 14,
  },
  {
    Name: "Disease",
    Artist: "Beartooth",
    Album: "Disease",
    Time: 228,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "You Never Know",
    Artist: "Beartooth",
    Album: "Disease",
    Time: 183,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "In Between",
    Artist: "Beartooth",
    Album: "Disgusting",
    Time: 213,
    Year: 2014,
    Plays: 48,
  },
  {
    Name: "Blind and Frozen",
    Artist: "Beast in Black",
    Album: "Berserker",
    Time: 304,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Walk This Way",
    Artist: "THE BEAT GARDEN",
    Album: "I'm",
    Time: 208,
    Year: 2017,
    Plays: 35,
  },
  {
    Name: "Let Go",
    Artist: "Beau Young Prince",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 177,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "LBD",
    Artist: "Becky G.",
    Album: "LBD - Single",
    Time: 203,
    Year: 2019,
    Plays: 14,
  },
  {
    Name: "MALA SANTA",
    Artist: "Becky G.",
    Album: "MALA SANTA",
    Time: 173,
    Year: 2019,
    Plays: 11,
  },
  {
    Name: "Shower",
    Artist: "Becky G.",
    Album: "Shower - Single",
    Time: 206,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Sin Pijama",
    Artist: "Becky G. & Natti Natasha",
    Album: "MALA SANTA",
    Time: 190,
    Year: 2018,
    Plays: 110,
  },
  {
    Name: "Revenant",
    Artist: "Behind the Fallen",
    Album: "Revenant - Single",
    Time: 230,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "Forever Fury",
    Artist: "Berserkyd",
    Album: "Megacity Commando",
    Time: 326,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Diary of Jane (feat. Frank Palangi)",
    Artist: "Between Now And Forever",
    Album: "Diary of Jane (feat. Frank Palangi) - Single",
    Time: 180,
    Year: 2018,
    Plays: 63,
  },
  {
    Name: "Leave",
    Artist: "Between Now And Forever",
    Album: "Leave - Single",
    Time: 209,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "7/11",
    Artist: "Beyoncé",
    Album: "BEYONCÉ (Platinum Edition)",
    Time: 213,
    Year: 2014,
    Plays: 16,
  },
  {
    Name: "Haunted (Michael Diamond Remix)",
    Artist: "Beyoncé",
    Album: "Fifty Shades of Grey",
    Time: 308,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Crazy In Love (2014 Remix)",
    Artist: "Beyoncé",
    Album: "Fifty Shades of Grey",
    Time: 226,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Radio",
    Artist: "Beyoncé",
    Album: "I Am... Sasha Fierce",
    Time: 218,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Formation",
    Artist: "Beyoncé",
    Album: "Lemonade",
    Time: 206,
    Year: 2016,
    Plays: 40,
  },
  {
    Name: "BIGGER",
    Artist: "Beyoncé",
    Album: "The Lion King: The Gift",
    Time: 226,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "FIND YOUR WAY BACK",
    Artist: "Beyoncé",
    Album: "The Lion King: The Gift",
    Time: 162,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "OTHERSIDE",
    Artist: "Beyoncé",
    Album: "The Lion King: The Gift",
    Time: 219,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: 'SPIRIT (From Disney\'s "The Lion King")',
    Artist: "Beyoncé",
    Album: "The Lion King: The Gift",
    Time: 277,
    Year: 2019,
    Plays: null,
  },
  {
    Name: 'SPIRIT (From Disney\'s "The Lion King")',
    Artist: "Beyoncé",
    Album: "The Lion King: The Gift",
    Time: 277,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Run the World (Girls)",
    Artist: "Beyoncé",
    Album: "4 (Expanded Edition)",
    Time: 238,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "NILE",
    Artist: "Beyoncé & Kendrick Lamar",
    Album: "The Lion King: The Gift",
    Time: 107,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Beautiful Liar",
    Artist: "Beyoncé & Shakira",
    Album: "Beautiful Liar - EP",
    Time: 201,
    Year: 2007,
    Plays: 15,
  },
  {
    Name: "come home (nala interlude)",
    Artist: "Beyonce Knowles-Carter",
    Album: "The Lion King: The Gift",
    Time: 14,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "war (nala interlude)",
    Artist: "Beyonce Knowles-Carter",
    Album: "The Lion King: The Gift",
    Time: 18,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "reunited (nala & simba interlude)",
    Artist: "Beyonce Knowles-Carter & Donald Glover",
    Album: "The Lion King: The Gift",
    Time: 8,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Can You Feel the Love Tonight",
    Artist: "Beyoncé, Donald Glover, Billy Eichner & Seth Rogen",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 182,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "MOOD 4 EVA (feat. Oumou Sangaré)",
    Artist: "Beyoncé, JAY-Z & Childish Gambino",
    Album: "The Lion King: The Gift",
    Time: 272,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "BROWN SKIN GIRL",
    Artist: "Beyoncé, SAINt JHN, Wizkid & Blue Ivy Carter",
    Album: "The Lion King: The Gift",
    Time: 248,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "ALREADY",
    Artist: "Beyoncé, Shatta Wale & Major Lazer",
    Album: "The Lion King: The Gift",
    Time: 222,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Heart of the Hurricane",
    Artist: "Beyond The Black",
    Album: "Heart of the Hurricane",
    Time: 219,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Dark Sky",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 178,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Blessings",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 252,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "All Your Fault",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 224,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "I Don't Fuck With You",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 284,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Play No Games",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 216,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Paradise",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 215,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Win Some Lose Some",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 304,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Stay Down",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 250,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "I Know",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 320,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Deep",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 276,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "One Man Can Change The World",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 254,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Outro",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 223,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Deserve It",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 261,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Research",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 230,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Platinum & Wood",
    Artist: "Big Sean",
    Album: "Dark Sky Paradise",
    Time: 163,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Don Life (feat. Lil Wayne)",
    Artist: "Big Sean",
    Album: "Detroit 2 (Deluxe Video Version)",
    Time: 194,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Dance (A$$) Remix [feat. Nicki Minaj]",
    Artist: "Big Sean",
    Album: "Finally Famous (Super Deluxe Edition)",
    Time: 220,
    Year: 2011,
    Plays: 12,
  },
  {
    Name: "Nothing Is Stopping You",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 303,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Fire",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 262,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "10 2 10",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 202,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Toyota Music",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 203,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "You Don't Know",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 222,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Beware (feat. Lil Wayne & Jhene Aiko)",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 235,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "First Chain (feat. Nas & Kid Cudi)",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 329,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Mona Lisa",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 210,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Freaky",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 42,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "MILF (feat. Nicki Minaj & Juicy J)",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 263,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Sierra Leone / Greedy Ho's",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 284,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "It's Time (feat. Jeezy & Payroll)",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 281,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "World Ablaze (feat. James Fauntleroy)",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 288,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Ashley (feat. Miguel)",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 262,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "All Figured Out",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 285,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Mula Remix (feat. 2 Chainz, Meek Mill & Earlly Mac)",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 354,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Switch Up (feat. Common)",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 309,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Guap",
    Artist: "Big Sean",
    Album: "Hall of Fame",
    Time: 271,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Man Don't Dance",
    Artist: "Big Shaq",
    Album: "Man Don't Dance - Single",
    Time: 218,
    Year: 2018,
    Plays: 14,
  },
  {
    Name: "Man's Not Hot",
    Artist: "Big Shaq",
    Album: "Man's Not Hot - Single",
    Time: 186,
    Year: 2017,
    Plays: 30,
  },
  {
    Name: "DAYDREAM",
    Artist: "Big Story",
    Album: "DAYDREAM - Single",
    Time: 215,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Til I Forget About You",
    Artist: "Big Time Rush",
    Album: "Btr",
    Time: 237,
    Year: 2010,
    Plays: 33,
  },
  {
    Name: "Shayo",
    Artist: "Bigiano",
    Album: "Shayo Master",
    Time: 226,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "bitches broken hearts",
    Artist: "Billie Eilish",
    Album: "bitches broken hearts - Single",
    Time: 176,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "ocean eyes",
    Artist: "Billie Eilish",
    Album: "dont smile at me",
    Time: 200,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "everything i wanted",
    Artist: "Billie Eilish",
    Album: "everything i wanted - Single",
    Time: 245,
    Year: 2019,
    Plays: 12,
  },
  {
    Name: "Lost Cause",
    Artist: "Billie Eilish",
    Album: "Happier Than Ever",
    Time: 212,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Therefore I Am",
    Artist: "Billie Eilish",
    Album: "Happier Than Ever",
    Time: 173,
    Year: 2020,
    Plays: 7,
  },
  {
    Name: "No Time To Die",
    Artist: "Billie Eilish",
    Album: "No Time To Die - Single",
    Time: 242,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "bad guy",
    Artist: "Billie Eilish",
    Album: "WHEN WE ALL FALL ASLEEP, WHERE DO WE GO?",
    Time: 194,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "you should see me in a crown",
    Artist: "Billie Eilish",
    Album: "WHEN WE ALL FALL ASLEEP, WHERE DO WE GO?",
    Time: 180,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "when the party's over",
    Artist: "Billie Eilish",
    Album: "WHEN WE ALL FALL ASLEEP, WHERE DO WE GO?",
    Time: 196,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "lovely",
    Artist: "Billie Eilish & Khalid",
    Album: "lovely - Single",
    Time: 200,
    Year: 2018,
    Plays: 36,
  },
  {
    Name: "The Lion Sleeps Tonight",
    Artist: "Billy Eichner & Seth Rogen",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 84,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "new lesson (timon, pumbaa & young simba interlude)",
    Artist: "Billy Eichner, Seth Rogen & JD McCrary",
    Album: "The Lion King: The Gift",
    Time: 53,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Hakuna Matata",
    Artist: "Billy Eichner, Seth Rogen, JD McCrary & Donald Glover",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 251,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "We Didn't Start the Fire",
    Artist: "Billy Joel",
    Album: "Storm Front",
    Time: 291,
    Year: 1989,
    Plays: 1,
  },
  {
    Name: "Pedestal",
    Artist: "Bipolar Sunshine",
    Album: "Imaginarium - EP",
    Time: 233,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Pressure",
    Artist: "Bipolar Sunshine",
    Album: "Imaginarium - EP",
    Time: 222,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Major Love",
    Artist: "Bipolar Sunshine",
    Album: "Imaginarium - EP",
    Time: 141,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Army of Me [Sucker Punch Remix]",
    Artist: "Bjork [feat Skunk Anansie]",
    Album: "Sucker Punch",
    Time: 410,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "GIRL LIKE ME",
    Artist: "Black Eyed Peas & Shakira",
    Album: "TRANSLATION",
    Time: 222,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Angel of Mercy",
    Artist: "Black Label Society",
    Album: "Catacombs of the Black Vatican",
    Time: 254,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "All That Once Shined",
    Artist: "Black Label Society",
    Album: "Grimmest Hits",
    Time: 234,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "All Type of Drugs (feat. Bloody Jay, Ola Playa & Thug)",
    Artist: "Black Portland & DJ Tripp da HitMajor",
    Album: "All Type of Drugs (feat. Bloody Jay, Ola Playa & Thug) - Single",
    Time: 205,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Kwaku the Traveller",
    Artist: "Black Sherif",
    Album: "Kwaku the Traveller - Single",
    Time: 185,
    Year: 2022,
    Plays: 6,
  },
  {
    Name: "The Shattered God",
    Artist: "Black Veil Brides",
    Album: "Black Veil Brides",
    Time: 242,
    Year: 2014,
    Plays: 23,
  },
  {
    Name: "Saints of the Blood",
    Artist: "Black Veil Brides",
    Album: "The Night - Single",
    Time: 228,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "The Vengeance",
    Artist: "Black Veil Brides",
    Album: "The Night - Single",
    Time: 209,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Fallen Angels",
    Artist: "Black Veil Brides",
    Album: "Set the World On Fire",
    Time: 224,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "The Last One",
    Artist: "Black Veil Brides",
    Album: "Vale",
    Time: 281,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "Wake Up",
    Artist: "Black Veil Brides",
    Album: "Vale",
    Time: 162,
    Year: 2018,
    Plays: 19,
  },
  {
    Name: "The Outsider",
    Artist: "Black Veil Brides",
    Album: "Vale",
    Time: 226,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Knives and Pens",
    Artist: "Black Veil Brides",
    Album: "We Stitch These Wounds",
    Time: 255,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Lost It All",
    Artist: "Black Veil Brides",
    Album: "Wretched and Divine: The Story of the Wild Ones (Ultimate Edition)",
    Time: 319,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "In the End",
    Artist: "Black Veil Brides",
    Album: "Wretched and Divine: The Story of the Wild Ones (Ultimate Edition)",
    Time: 228,
    Year: 2012,
    Plays: 10,
  },
  {
    Name: "We Are The Danger",
    Artist: "Blacklite District",
    Album: "",
    Time: 212,
    Year: null,
    Plays: 22,
  },
  {
    Name: "Repete",
    Artist: "BlackMagic",
    Album: "Blackmagic (Version 2.0)",
    Time: 218,
    Year: 2011,
    Plays: 14,
  },
  {
    Name: "How You Like That",
    Artist: "BLACKPINK",
    Album: "How You Like That - Single",
    Time: 181,
    Year: 2020,
    Plays: 36,
  },
  {
    Name: "DDU-DU DDU-DU",
    Artist: "BLACKPINK",
    Album: "SQUARE UP - EP",
    Time: 211,
    Year: 2018,
    Plays: 64,
  },
  {
    Name: "What's Up Danger",
    Artist: "Blackway & Black Caviar",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 222,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "Wishful Sinking",
    Artist: "blessthefall",
    Album: "Hard Feelings",
    Time: 267,
    Year: 2018,
    Plays: 26,
  },
  {
    Name: "Hollow Bodies",
    Artist: "blessthefall",
    Album: "Hollow Bodies",
    Time: 257,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Thotiana",
    Artist: "Blueface",
    Album: "Famous Cryp",
    Time: 129,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Stop Cappin",
    Artist: "Blueface",
    Album: "Stop Cappin - Single",
    Time: 161,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Commander",
    Artist: "BNXN fka Buju",
    Album: "Commander - Single",
    Time: 216,
    Year: 2019,
    Plays: 33,
  },
  {
    Name: "Kilometer",
    Artist: "BNXN fka Buju",
    Album: "Sorry I'm Late",
    Time: 198,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Masayume chasing",
    Artist: "BoA",
    Album: "Masayume chasing - Single",
    Time: 219,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "How You Do that",
    Artist: "Bob",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 188,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Every Little Step",
    Artist: "Bobby Brown",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 239,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "No Time For Sleep (Freestyle)",
    Artist: "Bobby Shmurda",
    Album: "No Time For Sleep (Freestyle) - Single",
    Time: 375,
    Year: 2021,
    Plays: 17,
  },
  {
    Name: "Hot N*gga",
    Artist: "Bobby Shmurda",
    Album: "Shmurda She Wrote - EP",
    Time: 194,
    Year: 2014,
    Plays: 12,
  },
  {
    Name: "Bobby Bitch",
    Artist: "Bobby Shmurda",
    Album: "Shmurda She Wrote - EP",
    Time: 160,
    Year: 2014,
    Plays: 32,
  },
  {
    Name: "They Don't Know",
    Artist: "Bobby Shmurda",
    Album: "They Don't Know - Single",
    Time: 147,
    Year: 2022,
    Plays: 4,
  },
  {
    Name: "Awolowo (feat. Kwesi Arthur, Darko Vibes & Joey B)",
    Artist: "BOJ",
    Album: "Awolowo (feat. Kwesi Arthur, Darko Vibes & Joey B) - Single",
    Time: 240,
    Year: 2019,
    Plays: 10,
  },
  {
    Name: "It's My Life",
    Artist: "Bon Jovi",
    Album: "Crush",
    Time: 224,
    Year: 2000,
    Plays: 12,
  },
  {
    Name: "You Give Love a Bad Name",
    Artist: "Bon Jovi",
    Album: "Slippery When Wet",
    Time: 222,
    Year: 1986,
    Plays: 1,
  },
  {
    Name: "Melody X",
    Artist: "Bonaparte",
    Album: "Melody X - Single",
    Time: 244,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Me and My Guitar",
    Artist: "A Boogie wit da Hoodie",
    Album: "Artist 2.0",
    Time: 161,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "End of the Road",
    Artist: "Boyz II Men",
    Album: "Legacy - The Greatest Hits Collection",
    Time: 349,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Girl (feat. Wizkid)",
    Artist: "Bracket",
    Album: "Cupid Stories",
    Time: 294,
    Year: 2011,
    Plays: 8,
  },
  {
    Name: "Right Here (Departed)",
    Artist: "Brandy",
    Album: "Human",
    Time: 217,
    Year: 2008,
    Plays: 11,
  },
  {
    Name: "Do Better",
    Artist: "Brandy Feat. Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 228,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Rains of Castamere",
    Artist: "Break of Reality",
    Album: "Rains of Castamere - Single",
    Time: 148,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "So Cold (Aurora Version)",
    Artist: "Breaking Benjamin",
    Album: "Aurora",
    Time: 272,
    Year: 2020,
    Plays: 14,
  },
  {
    Name: "Angels Fall (Aurora Version)",
    Artist: "Breaking Benjamin",
    Album: "Aurora",
    Time: 226,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Never Again (Aurora Version)",
    Artist: "Breaking Benjamin",
    Album: "Aurora",
    Time: 222,
    Year: 2020,
    Plays: 25,
  },
  {
    Name: "Failure",
    Artist: "Breaking Benjamin",
    Album: "Dark Before Dawn",
    Time: 214,
    Year: 2015,
    Plays: 413,
  },
  {
    Name: "Angels Fall",
    Artist: "Breaking Benjamin",
    Album: "Dark Before Dawn",
    Time: 228,
    Year: 2015,
    Plays: 49,
  },
  {
    Name: "Never Again",
    Artist: "Breaking Benjamin",
    Album: "Dark Before Dawn",
    Time: 223,
    Year: 2015,
    Plays: 361,
  },
  {
    Name: "I Will Not Bow",
    Artist: "Breaking Benjamin",
    Album: "Dear Agony",
    Time: 216,
    Year: 2009,
    Plays: 99,
  },
  {
    Name: "Crawl",
    Artist: "Breaking Benjamin",
    Album: "Dear Agony",
    Time: 238,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Red Cold River",
    Artist: "Breaking Benjamin",
    Album: "Ember",
    Time: 200,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Torn in Two",
    Artist: "Breaking Benjamin",
    Album: "Ember",
    Time: 257,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Save Yourself",
    Artist: "Breaking Benjamin",
    Album: "Ember",
    Time: 186,
    Year: 2018,
    Plays: 32,
  },
  {
    Name: "Phobia (Intro)",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 73,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "The Diary of Jane",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 200,
    Year: 2006,
    Plays: 3,
  },
  {
    Name: "Breath",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 218,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "You",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 201,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "Evil Angel",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 220,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Until the End",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 252,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "Dance with the Devil",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 227,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Topless",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 181,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Here We Are",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 258,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "Unknown Soldier",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 226,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Had Enough",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 228,
    Year: 2006,
    Plays: 7,
  },
  {
    Name: "You Fight Me",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 190,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Phobia (Outro)",
    Artist: "Breaking Benjamin",
    Album: "Phobia",
    Time: 125,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "The Diary of Jane",
    Artist: "Breaking Benjamin",
    Album: "Shallow Bay: The Best of Breaking Benjamin (Deluxe Edition)",
    Time: 200,
    Year: 2006,
    Plays: 4,
  },
  {
    Name: "Until the End",
    Artist: "Breaking Benjamin",
    Album: "Shallow Bay: The Best of Breaking Benjamin (Deluxe Edition)",
    Time: 252,
    Year: 2006,
    Plays: 4,
  },
  {
    Name: "Give Me a Sign",
    Artist: "Breaking Benjamin",
    Album: "Shallow Bay: The Best of Breaking Benjamin (Deluxe Edition)",
    Time: 257,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Failure (Aurora Version)",
    Artist: "Breaking Benjamin & Red",
    Album: "Aurora",
    Time: 217,
    Year: 2020,
    Plays: 22,
  },
  {
    Name: "Far Away",
    Artist: "Breaking Benjamin & Scooter Ward",
    Album: "Aurora",
    Time: 292,
    Year: 2020,
    Plays: 14,
  },
  {
    Name: "Bury the Ashes",
    Artist: "Breaking Through",
    Album: "Something to Believe In",
    Time: 250,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Love Is Wicked",
    Artist: "Brick & Lace",
    Album: "Love Is Wicked",
    Time: 241,
    Year: 2009,
    Plays: 15,
  },
  {
    Name: "Ready or Not",
    Artist: "Bridgit Mendler",
    Album: "Hello My Name Is... (Deluxe Version)",
    Time: 200,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "There Will Be Blood",
    Artist: "Brighter Than a Thousand Suns",
    Album: "Rebirth - EP",
    Time: 194,
    Year: 2018,
    Plays: 81,
  },
  {
    Name: "MANTRA",
    Artist: "Bring Me The Horizon",
    Album: "amo",
    Time: 233,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "mother tongue",
    Artist: "Bring Me The Horizon",
    Album: "amo",
    Time: 217,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "DiE4u",
    Artist: "Bring Me The Horizon",
    Album: "DiE4u - Single",
    Time: 207,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Parasite Eve",
    Artist: "Bring Me The Horizon",
    Album: "Parasite Eve - Single",
    Time: 291,
    Year: 2020,
    Plays: 37,
  },
  {
    Name: "Kingslayer (feat. BABYMETAL)",
    Artist: "Bring Me The Horizon",
    Album: "POST HUMAN: SURVIVAL HORROR",
    Time: 220,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Throne",
    Artist: "Bring Me The Horizon",
    Album: "That's the Spirit",
    Time: 191,
    Year: 2015,
    Plays: 13,
  },
  {
    Name: "Thinkin‚ To Myself (With Her Eyes) BONUS",
    Artist: "Brisco Lil Wayne And Birdman",
    Album: "No Ceilings",
    Time: 273,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Till The World Ends",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 238,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Hold It Against Me",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 228,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Inside Out",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 218,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "I Wanna Go",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 210,
    Year: 2011,
    Plays: 7,
  },
  {
    Name: "How I Roll",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 216,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "(Drop Dead) Beautiful (Feat. Sabi)",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 216,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Seal It With A Kiss",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 206,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Big Fat Bagg (Feat. will.i.am)",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 284,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Trouble For Me",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 200,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Trip To Your Heart",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 213,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Gasoline",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 188,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Criminal",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 225,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Up 'n Down (Bonus Track)",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 222,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "He About To Lose Me (Bonus Track)",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 228,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Selfish (Bonus Track)",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 224,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Don't Keep Me Waiting (Bonus Track)",
    Artist: "Britney Spears",
    Album: "Femme Fatale",
    Time: 201,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "This Cancer",
    Artist: "A Broken Silence",
    Album: "All the Way Down",
    Time: 192,
    Year: 2017,
    Plays: 72,
  },
  {
    Name: "At the End of the Day",
    Artist: "A Broken Silence",
    Album: "Soul",
    Time: 203,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Grenade",
    Artist: "Bruno Mars",
    Album: "Doo-Wops & Hooligans (Deluxe Version)",
    Time: 222,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Count On Me",
    Artist: "Bruno Mars",
    Album: "Doo-Wops & Hooligans (Deluxe Version)",
    Time: 197,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Locked Out of Heaven",
    Artist: "Bruno Mars",
    Album: "Unorthodox Jukebox",
    Time: 233,
    Year: 2012,
    Plays: 19,
  },
  {
    Name: "When I Was Your Man",
    Artist: "Bruno Mars",
    Album: "Unorthodox Jukebox",
    Time: 213,
    Year: 2012,
    Plays: 6,
  },
  {
    Name: "Down",
    Artist: "Brymo",
    Album: "Merchants, Dealers & Slaves",
    Time: 186,
    Year: 2013,
    Plays: 12,
  },
  {
    Name: "Jungle Fever",
    Artist: "Brymo",
    Album: "Tabula Rasa",
    Time: 194,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Ara",
    Artist: "Brymo",
    Album: "#TheSonOfaKapenta",
    Time: 256,
    Year: 2011,
    Plays: 36,
  },
  {
    Name: "Market Square",
    Artist: "Brymo",
    Album: "Theta",
    Time: 162,
    Year: 2022,
    Plays: 23,
  },
  {
    Name: "Àkọ́kọ́",
    Artist: "Brymo",
    Album: "9: Èsan",
    Time: 164,
    Year: 2021,
    Plays: 23,
  },
  {
    Name: "Méjì Méjì",
    Artist: "Brymo",
    Album: "9: Èsan",
    Time: 245,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "F**King Awesome",
    Artist: "Brymo",
    Album: "9: Harmattan & Winter",
    Time: 228,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Heartbeat (BTS World Original Soundtrack)",
    Artist: "BTS",
    Album: "BTS WORLD (Original Soundtrack)",
    Time: 253,
    Year: 2019,
    Plays: 19,
  },
  {
    Name: "Omen",
    Artist: "Bullet for My Valentine",
    Album: "Bullet For My Valentine (Deluxe)",
    Time: 233,
    Year: 2022,
    Plays: 4,
  },
  {
    Name: "Your Betrayal",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 292,
    Year: 2010,
    Plays: 102,
  },
  {
    Name: "Fever",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 236,
    Year: 2010,
    Plays: 6,
  },
  {
    Name: "The Last Fight",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 257,
    Year: 2010,
    Plays: 51,
  },
  {
    Name: "A Place Where You Belong",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 306,
    Year: 2010,
    Plays: 5,
  },
  {
    Name: "Pleasure and Pain",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 232,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Alone",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 355,
    Year: 2010,
    Plays: 82,
  },
  {
    Name: "Breaking Out, Breaking Down",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 243,
    Year: 2010,
    Plays: 16,
  },
  {
    Name: "Bittersweet Memories",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 307,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Dignity",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 267,
    Year: 2010,
    Plays: 99,
  },
  {
    Name: "Begging for Mercy",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 235,
    Year: 2010,
    Plays: 16,
  },
  {
    Name: "Pretty On The Outside",
    Artist: "Bullet For My Valentine",
    Album: "Fever",
    Time: 234,
    Year: 2010,
    Plays: 38,
  },
  {
    Name: "Your Betrayal",
    Artist: "Bullet for My Valentine",
    Album: "Fever (Tour Edition)",
    Time: 291,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Bittersweet Memories",
    Artist: "Bullet for My Valentine",
    Album: "Fever (Tour Edition)",
    Time: 308,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Leap of Faith",
    Artist: "Bullet for My Valentine",
    Album: "Gravity",
    Time: 199,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "Over It",
    Artist: "Bullet for My Valentine",
    Album: "Gravity",
    Time: 227,
    Year: 2018,
    Plays: 21,
  },
  {
    Name: "Not Dead Yet",
    Artist: "Bullet for My Valentine",
    Album: "Gravity",
    Time: 201,
    Year: 2018,
    Plays: 14,
  },
  {
    Name: "Tears Don't Fall",
    Artist: "Bullet for My Valentine",
    Album: "The Poison",
    Time: 348,
    Year: 2005,
    Plays: null,
  },
  {
    Name: "Scream Aim Fire",
    Artist: "Bullet For My Valentine",
    Album: "Scream Aim Fire",
    Time: 266,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Eye Of The Storm",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 242,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Hearts Burst Into Fire",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 298,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Waking The Demon",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 247,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Disappear",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 245,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Deliver Us From Evil",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 358,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Take It Out On Me",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 352,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Say Goodnight",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 283,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "End Of Days",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 258,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Last To Know",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 195,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Forever And Always",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 410,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Road to Nowhere",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 259,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Watching Us Die Tonight",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 233,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "One Good Reason Why",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 244,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Ashes Of The Innocent",
    Artist: "Bullet for My Valentine",
    Album: "Scream Aim Fire",
    Time: 255,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Breaking Point",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 222,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Truth Hurts",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 216,
    Year: 2013,
    Plays: 40,
  },
  {
    Name: "Temper Temper",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 188,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "P.O.W.",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 233,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Dirty Little Secret",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 295,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Leech",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 239,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Dead To the World",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 315,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Riot",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 169,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Saints & Sinners",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 209,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Tears Don't Fall, Pt. 2",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 338,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Livin' Life (On the Edge of a Knife)",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 241,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Not Invincible",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 206,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Whole Lotta Rosie (Live at BBC Radio 1)",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 250,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Scream Aim Fire (Live at BBC Radio 1)",
    Artist: "Bullet For My Valentine",
    Album: "Temper Temper (Deluxe Version)",
    Time: 303,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "V",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 86,
    Year: 2015,
    Plays: 47,
  },
  {
    Name: "No Way Out",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 234,
    Year: 2015,
    Plays: 24,
  },
  {
    Name: "Army of Noise",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 258,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "Worthless",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 198,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "You Want a Battle? (Here's a War)",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 254,
    Year: 2015,
    Plays: 30,
  },
  {
    Name: "Broken",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 220,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "Venom",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 234,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "The Harder the Heart (The Harder It Breaks)",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 240,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Skin",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 239,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Hell or High Water",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 276,
    Year: 2015,
    Plays: 26,
  },
  {
    Name: "Pariah",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 226,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Playing God",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 232,
    Year: 2015,
    Plays: 105,
  },
  {
    Name: "Run for Your Life",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 214,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "In Loving Memory",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 242,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Raising Hell",
    Artist: "Bullet For My Valentine",
    Album: "Venom (Deluxe Edition)",
    Time: 275,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "End of Sorrow",
    Artist: "Burn the Rez",
    Album: "Isolation: Chapter 3 - EP",
    Time: 282,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Last Goodbye",
    Artist: "Burn the Rez",
    Album: "Isolation: Chapter 3 - EP",
    Time: 297,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Gum Body (feat. Jorja Smith)",
    Artist: "Burna Boy",
    Album: "African Giant",
    Time: 195,
    Year: 2019,
    Plays: 17,
  },
  {
    Name: "Show & Tell (feat. Future)",
    Artist: "Burna Boy",
    Album: "African Giant",
    Time: 162,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Trumpet (feat. Davido)",
    Artist: "Burna Boy",
    Album: "Best of Burn Series, Vol. 1",
    Time: 263,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Kilometre",
    Artist: "Burna Boy",
    Album: "Kilometre - Single",
    Time: 153,
    Year: 2022,
    Plays: 5,
  },
  {
    Name: "JA ARA E",
    Artist: "Burna Boy",
    Album: "The Lion King: The Gift",
    Time: 190,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Monsters You Made (feat. Chris Martin)",
    Artist: "Burna Boy",
    Album: "Twice As Tall",
    Time: 217,
    Year: 2020,
    Plays: 10,
  },
  {
    Name: "20 10 20",
    Artist: "Burna Boy",
    Album: "20 10 20 - Single",
    Time: 213,
    Year: 2020,
    Plays: 37,
  },
  {
    Name: "나를 부르면 Whenever You Call Me",
    Artist: "Bursters",
    Album: "Independent - EP",
    Time: 240,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Borracho de Amor",
    Artist: "Cali y El Dandee & Reik",
    Album: "Colegio",
    Time: 175,
    Year: 2020,
    Plays: 32,
  },
  {
    Name: "Little Girls (2014 Film Version)",
    Artist: "Cameron Diaz",
    Album: "Annie (Original Motion Picture Soundtrack)",
    Time: 138,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "Havana (feat. Young Thug)",
    Artist: "Camila Cabello",
    Album: "Camila",
    Time: 217,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "Cry for Me",
    Artist: "Camila Cabello",
    Album: "Cry for Me - Single",
    Time: 189,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Bodak Yellow",
    Artist: "Cardi B",
    Album: "Bodak Yellow - Single",
    Time: 223,
    Year: 2017,
    Plays: 32,
  },
  {
    Name: "Drip (feat. Migos)",
    Artist: "Cardi B",
    Album: "Invasion of Privacy",
    Time: 262,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "WAP (feat. Megan Thee Stallion)",
    Artist: "Cardi B",
    Album: "WAP (feat. Megan Thee Stallion) - Single",
    Time: 187,
    Year: 2020,
    Plays: 56,
  },
  {
    Name: "I Like It",
    Artist: "Cardi B, Bad Bunny & J Balvin",
    Album: "Invasion of Privacy",
    Time: 253,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "Circle of Life",
    Artist: "Carmen Twillie & Lebo M",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 239,
    Year: 1994,
    Plays: null,
  },
  {
    Name: "My Mother Wants Me Dead",
    Artist: "carolesdaughter",
    Album: "My Mother Wants Me Dead - Single",
    Time: 105,
    Year: 2021,
    Plays: 11,
  },
  {
    Name: "Gone Now",
    Artist: "Carpenter Brut",
    Album: "Blood Machines - Original Motion Picture Soundtrack",
    Time: 217,
    Year: 2020,
    Plays: 9,
  },
  {
    Name: "APESHIT",
    Artist: "THE CARTERS",
    Album: "EVERYTHING IS LOVE",
    Time: 264,
    Year: 2018,
    Plays: 55,
  },
  {
    Name: "Falling Apart",
    Artist: "Caskets",
    Album: "Falling Apart - Single",
    Time: 273,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Praise You In This Storm",
    Artist: "Casting Crowns",
    Album: "Lifesong",
    Time: 297,
    Year: 2005,
    Plays: 13,
  },
  {
    Name: "Guren no Yumiya",
    Artist: "Cat Trumpet",
    Album: "Attack on Titan Piano Collection",
    Time: 159,
    Year: 2016,
    Plays: 6,
  },
  {
    Name: "The Reluctant Heroes",
    Artist: "Cat Trumpet",
    Album: "Attack on Titan Piano Collection",
    Time: 218,
    Year: 2016,
    Plays: 33,
  },
  {
    Name: "Swordland",
    Artist: "Cat Trumpet",
    Album: "Sword Art Online Piano Collection",
    Time: 256,
    Year: 2016,
    Plays: 15,
  },
  {
    Name: "Luminous Sword",
    Artist: "Cat Trumpet",
    Album: "Sword Art Online Piano Collection",
    Time: 255,
    Year: 2016,
    Plays: 8,
  },
  {
    Name: 'Unravel (from "Tokyo Ghoul")',
    Artist: "Cat Trumpet",
    Album: "Tokyo Ghoul Piano Collection - EP",
    Time: 220,
    Year: 2016,
    Plays: 7,
  },
  {
    Name: "Turn it Up",
    Artist: "Celestina and Bianca Raquel",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 225,
    Year: 2014,
    Plays: null,
  },
  {
    Name: 'My Heart Will Go On (Love Theme from "Titanic")',
    Artist: "Céline Dion",
    Album: "Let's Talk About Love",
    Time: 280,
    Year: 1997,
    Plays: 1,
  },
  {
    Name: "I Surrender",
    Artist: "Céline Dion",
    Album: "A New Day Has Come",
    Time: 287,
    Year: 2002,
    Plays: 11,
  },
  {
    Name: "Nkao Tempela",
    Artist: "Ch'cco & Mellow & Sleazy",
    Album: "Nkao Tempela - Single",
    Time: 361,
    Year: 2021,
    Plays: 13,
  },
  {
    Name: "Something Just Like This",
    Artist: "The Chainsmokers & Coldplay",
    Album: "Memories...Do Not Open",
    Time: 247,
    Year: 2017,
    Plays: 17,
  },
  {
    Name: "Takeaway (feat. Lennon Stella)",
    Artist: "The Chainsmokers & ILLENIUM",
    Album: "Ascend",
    Time: 209,
    Year: 2019,
    Plays: 15,
  },
  {
    Name: "No Problem (feat. Lil Wayne & 2 Chainz)",
    Artist: "Chance the Rapper",
    Album: "Coloring Book",
    Time: 304,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Kingdom (feat. Simon Le Bon)",
    Artist: "Charli XCX",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 245,
    Year: 2014,
    Plays: 11,
  },
  {
    Name: "I Warned Myself",
    Artist: "Charlie Puth",
    Album: "I Warned Myself - Single",
    Time: 159,
    Year: 2019,
    Plays: 121,
  },
  {
    Name: "Mother",
    Artist: "Charlie Puth",
    Album: "Mother - Single",
    Time: 162,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Marvin Gaye (feat. Meghan Trainor)",
    Artist: "Charlie Puth",
    Album: "Nine Track Mind",
    Time: 190,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "We Don’t Talk Anymore (feat. Selena Gomez)",
    Artist: "Charlie Puth",
    Album: "Nine Track Mind",
    Time: 217,
    Year: 2016,
    Plays: 6,
  },
  {
    Name: "Suffer",
    Artist: "Charlie Puth",
    Album: "Nine Track Mind",
    Time: 210,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "Strut",
    Artist: "The Cheetah Girls",
    Album: "The Cheetah Girls 2 (Original Soundtrack)",
    Time: 198,
    Year: 2006,
    Plays: 26,
  },
  {
    Name: "This Is Not a Game (feat. Miguel)",
    Artist: "The Chemical Brothers",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 194,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "History (Mixed)",
    Artist: "Cheque & Fireboy DML",
    Album: "Party In The Jungle: DJ Sheggz, Feb 2022 (DJ Mix)",
    Time: 69,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "So Long, Mother Earth",
    Artist: "Chevelle",
    Album: "NIRATIAS",
    Time: 292,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Self Destructor",
    Artist: "Chevelle",
    Album: "NIRATIAS",
    Time: 347,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Piistol Star (Gravity Heals)",
    Artist: "Chevelle",
    Album: "NIRATIAS",
    Time: 289,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Faneto",
    Artist: "Chief Keef",
    Album: "Back from the Dead 2",
    Time: 206,
    Year: 2014,
    Plays: 22,
  },
  {
    Name: "Love Sosa",
    Artist: "Chief Keef",
    Album: "Finally Rich",
    Time: 246,
    Year: 2012,
    Plays: 42,
  },
  {
    Name: "I Don't Like (feat. Lil Reese)",
    Artist: "Chief Keef",
    Album: "Finally Rich",
    Time: 293,
    Year: 2012,
    Plays: 16,
  },
  {
    Name: "INTRO",
    Artist: "CHIKA",
    Album: "INDUSTRY GAMES",
    Time: 62,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "INDUSTRY GAMES",
    Artist: "CHIKA",
    Album: "INDUSTRY GAMES",
    Time: 136,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "SONGS ABOUT YOU",
    Artist: "CHIKA",
    Album: "INDUSTRY GAMES",
    Time: 241,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "BALENCIES",
    Artist: "CHIKA",
    Album: "INDUSTRY GAMES",
    Time: 144,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "DESIGNER",
    Artist: "CHIKA",
    Album: "INDUSTRY GAMES",
    Time: 263,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "ON MY WAY",
    Artist: "CHIKA",
    Album: "INDUSTRY GAMES",
    Time: 193,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "CROWN",
    Artist: "CHIKA",
    Album: "INDUSTRY GAMES",
    Time: 175,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "This Is America",
    Artist: "Childish Gambino",
    Album: "This Is America - Single",
    Time: 225,
    Year: 2018,
    Plays: 19,
  },
  {
    Name: "What's My Name",
    Artist: "China Anne McClain, Thomas Doherty & Dylan Playfair",
    Album: "Descendants 2 (Original TV Movie Soundtrack)",
    Time: 190,
    Year: 2017,
    Plays: 11,
  },
  {
    Name: "Andas En Mi Cabeza (feat. Daddy Yankee)",
    Artist: "Chino & Nacho",
    Album: "Andas En Mi Cabeza (feat. Daddy Yankee) - Single",
    Time: 247,
    Year: 2016,
    Plays: 23,
  },
  {
    Name: "Andas En Mi Cabeza (Remix) [feat. Daddy Yankee, Don Omar & Wisin]",
    Artist: "Chino & Nacho",
    Album:
      "Andas En Mi Cabeza (Remix) [feat. Daddy Yankee, Don Omar & Wisin] - Single",
    Time: 255,
    Year: 2016,
    Plays: 35,
  },
  {
    Name: "Champion (feat. Chris Brown)",
    Artist: "Chipmunk",
    Album: "Transition",
    Time: 354,
    Year: 2011,
    Plays: 8,
  },
  {
    Name: "Be Prepared (2019)",
    Artist: "Chiwetel Ejiofor",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 123,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "uncle scar (scar interlude)",
    Artist: "Chiwetel Ejiofor",
    Album: "The Lion King: The Gift",
    Time: 13,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Have Mercy",
    Artist: "Chlöe",
    Album: "Have Mercy - Single",
    Time: 148,
    Year: 2021,
    Plays: 80,
  },
  {
    Name: "Treat Me",
    Artist: "Chlöe",
    Album: "Treat Me - Single",
    Time: 149,
    Year: 2022,
    Plays: 5,
  },
  {
    Name: "Deuces (feat. Tyga & Kevin McCall)",
    Artist: "Chris Brown",
    Album: "F.A.M.E. (Expanded Edition)",
    Time: 276,
    Year: 2010,
    Plays: 27,
  },
  {
    Name: "Look At Me Now (feat. Lil Wayne & Busta Rhymes)",
    Artist: "Chris Brown",
    Album: "F.A.M.E. (Expanded Edition)",
    Time: 222,
    Year: 2011,
    Plays: 18,
  },
  {
    Name: "I Can Transform Ya (feat. Swizz Beatz & Lil Wayne)",
    Artist: "Chris Brown",
    Album: "Graffiti (Expanded Edition)",
    Time: 228,
    Year: 2009,
    Plays: 8,
  },
  {
    Name: "Only 4 Me (feat. Ty Dolla $ign & Verse Simmonds)",
    Artist: "Chris Brown",
    Album: "Heartbreak on a Full Moon",
    Time: 307,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Wobble Up (feat. Nicki Minaj & G-Eazy)",
    Artist: "Chris Brown",
    Album: "Indigo",
    Time: 221,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "X",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 260,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Add Me In",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 193,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "101 (Interlude)",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 76,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Stereotype",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 231,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Time For Love",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 225,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Lady In A Glass Dress (Interlude)",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 77,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "See You Around",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 222,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Don't Be Gone Too Long",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 202,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Body Shots",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 222,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Lost In Ya Love",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 229,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Fine China",
    Artist: "Chris Brown",
    Album: "X (Deluxe Version)",
    Time: 213,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Loyal (feat. Lil Wayne & Tyga)",
    Artist: "Chris Brown",
    Album: "X (Expanded Edition)",
    Time: 264,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Don't Think They Know",
    Artist: "Chris Brown Feat. Aaliyah",
    Album: "X (Deluxe Version)",
    Time: 238,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Came To Do",
    Artist: "Chris Brown Feat. Akon",
    Album: "X (Deluxe Version)",
    Time: 228,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Drunk Texting",
    Artist: "Chris Brown Feat. Jhené Aiko",
    Album: "X (Deluxe Version)",
    Time: 227,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Autumn Leaves",
    Artist: "Chris Brown Feat. Kendrick Lamar",
    Album: "X (Deluxe Version)",
    Time: 268,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Loyal",
    Artist: "Chris Brown Feat. Lil Wayne & Tyga",
    Album: "X (Deluxe Version)",
    Time: 265,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Love More",
    Artist: "Chris Brown Feat. Nicki Minaj",
    Album: "X (Deluxe Version)",
    Time: 189,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Drown In It",
    Artist: "Chris Brown Feat. R. Kelly",
    Album: "X (Deluxe Version)",
    Time: 222,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Songs On 12 Play",
    Artist: "Chris Brown Feat. Trey Songz",
    Album: "X (Deluxe Version)",
    Time: 228,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "New Flame",
    Artist: "Chris Brown Feat. Usher & Rick Ross",
    Album: "X (Deluxe Version)",
    Time: 244,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Showdown",
    Artist: "Chris Cornell",
    Album: "No One Sings Like You Anymore, Vol. 1",
    Time: 203,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "When You Fall (feat. Noni Culotta & Lucie Paradis)",
    Artist: "Christian Reindl",
    Album: "When You Fall (feat. Noni Culotta & Lucie Paradis) - Single",
    Time: 217,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Lure",
    Artist: "Christian Reindl & Dream Harlowe",
    Album: "Lure - Single",
    Time: 185,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Sweet Low",
    Artist: "Christian Reindl & Dream Harlowe",
    Album: "Sweet Low - Single",
    Time: 250,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Run Away",
    Artist: "Christian Reindl & Emily Sophie",
    Album: "Run Away - Single",
    Time: 226,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Jar of Hearts",
    Artist: "Christina Perri",
    Album: "Lovestrong.",
    Time: 248,
    Year: 2011,
    Plays: 19,
  },
  {
    Name: "A Thousand Years",
    Artist: "Christina Perri",
    Album:
      "The Twilight Saga: Breaking Dawn - Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 285,
    Year: 2011,
    Plays: 42,
  },
  {
    Name: "Toner (Instrumental Suite)",
    Artist: "Christophe Beck & Mark Kilian",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 178,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Dead Air",
    Artist: "CHVRCHES",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 194,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Quédate Conmigo (feat. Wisin & Gente de Zona)",
    Artist: "Chyno Miranda",
    Album: "Quédate Conmigo (feat. Wisin & Gente de Zona) - Single",
    Time: 223,
    Year: 2017,
    Plays: 20,
  },
  {
    Name: "El Peor",
    Artist: "Chyno Miranda & J Balvin",
    Album: "El Peor - Single",
    Time: 192,
    Year: 2018,
    Plays: 21,
  },
  {
    Name: "Hasta El Ombligo",
    Artist: "Chyno Miranda & Zion & Lennox",
    Album: "Hasta El Ombligo - Single",
    Time: 232,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Level Up",
    Artist: "Ciara",
    Album: "Level Up - Single",
    Time: 204,
    Year: 2019,
    Plays: 8,
  },
  {
    Name: "Apocalypse",
    Artist: "Cigarettes After Sex",
    Album: "Cigarettes After Sex",
    Time: 290,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Falling in Love",
    Artist: "Cigarettes After Sex",
    Album: "Cry",
    Time: 245,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "To Build A Home",
    Artist: "Cinematic Orchestra",
    Album: "Step Up Revolution",
    Time: 371,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Bitter",
    Artist: "Citizen Soldier",
    Album: "Bitter - Single",
    Time: 230,
    Year: 2019,
    Plays: 10,
  },
  {
    Name: "15 Minutes of Fame",
    Artist: "Citizen Soldier",
    Album: "Caroline - EP",
    Time: 283,
    Year: 2017,
    Plays: 13,
  },
  {
    Name: "Let It Burn",
    Artist: "Citizen Soldier",
    Album: "Caroline - EP",
    Time: 252,
    Year: 2017,
    Plays: 11,
  },
  {
    Name: "Empty Cup",
    Artist: "Citizen Soldier",
    Album: "Empty Cup - Single",
    Time: 227,
    Year: 2021,
    Plays: 32,
  },
  {
    Name: "Fever",
    Artist: "Citizen Soldier",
    Album: "Fever - Single",
    Time: 188,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Found",
    Artist: "Citizen Soldier",
    Album: "Found - Single",
    Time: 200,
    Year: 2018,
    Plays: 11,
  },
  {
    Name: "Irreplaceable",
    Artist: "Citizen Soldier",
    Album: "Irreplaceable - Single",
    Time: 213,
    Year: 2022,
    Plays: 3,
  },
  {
    Name: "Let Me Let Go",
    Artist: "Citizen Soldier",
    Album: "Let Me Let Go - Single",
    Time: 201,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "Numb to Everything",
    Artist: "Citizen Soldier",
    Album: "Numb to Everything - Single",
    Time: 220,
    Year: 2022,
    Plays: 2,
  },
  {
    Name: "Save Your Story",
    Artist: "Citizen Soldier",
    Album: "Save Your Story - Single",
    Time: 188,
    Year: 2022,
    Plays: 21,
  },
  {
    Name: "Screaming in Silence",
    Artist: "Citizen Soldier",
    Album: "Screaming in Silence - Single",
    Time: 192,
    Year: 2022,
    Plays: 3,
  },
  {
    Name: "Thank You for Hating Me",
    Artist: "Citizen Soldier",
    Album: "Thank You for Hating Me - Single",
    Time: 189,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Isolate",
    Artist: "Citizen Soldier",
    Album: "This Is Your Sign Part I",
    Time: 207,
    Year: 2021,
    Plays: 49,
  },
  {
    Name: "Pandora's Box",
    Artist: "Citizen Soldier",
    Album: "This Is Your Sign Part I",
    Time: 226,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Still Breathing",
    Artist: "Citizen Soldier",
    Album: "This Is Your Sign Part II",
    Time: 194,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Unsaid",
    Artist: "Citizen Soldier",
    Album: "Unsaid - Single",
    Time: 223,
    Year: 2022,
    Plays: 5,
  },
  {
    Name: "Wanted",
    Artist: "Citizen Soldier",
    Album: "Wanted - Single",
    Time: 182,
    Year: 2022,
    Plays: 11,
  },
  {
    Name: "Go (Let Me Save You)",
    Artist: "Citizen Zero",
    Album: "State of Mind",
    Time: 278,
    Year: 2016,
    Plays: 25,
  },
  {
    Name: "Twerk (feat. Cardi B)",
    Artist: "City Girls",
    Album: "Girl Code",
    Time: 166,
    Year: 2018,
    Plays: 14,
  },
  {
    Name: "JT First Day Out",
    Artist: "City Girls & JT",
    Album: "JT First Day Out - Single",
    Time: 187,
    Year: 2019,
    Plays: 18,
  },
  {
    Name: "Handle It",
    Artist: "City Girls & Kali Cass",
    Album: "Handle It - Single",
    Time: 124,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "The One That Got Away",
    Artist: "The Civil Wars",
    Album: "The Civil Wars",
    Time: 212,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Dust to Dust",
    Artist: "The Civil Wars",
    Album: "The Civil Wars",
    Time: 229,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Kingdom Come",
    Artist: "The Civil Wars",
    Album: "The Hunger Games (Songs from District 12 and Beyond)",
    Time: 222,
    Year: 2012,
    Plays: 6,
  },
  {
    Name: "Emiliana",
    Artist: "CKay",
    Album: "Emiliana - Single",
    Time: 164,
    Year: 2021,
    Plays: 24,
  },
  {
    Name: "Alive",
    Artist: "Clint Lowery",
    Album: "God Bless the Renegades",
    Time: 214,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "La Equivocada",
    Artist: "CNCO",
    Album: "La Equivocada - Single",
    Time: 198,
    Year: 2022,
    Plays: 17,
  },
  {
    Name: "Pretend",
    Artist: "CNCO",
    Album: "Pretend - Single",
    Time: 200,
    Year: 2019,
    Plays: 18,
  },
  {
    Name: "Reggaetón Lento (Bailemos)",
    Artist: "CNCO",
    Album: "Primera Cita",
    Time: 222,
    Year: 2016,
    Plays: 106,
  },
  {
    Name: "Pegao",
    Artist: "CNCO & Manuel Turizo",
    Album: "Que Quiénes Somos",
    Time: 204,
    Year: 2019,
    Plays: 16,
  },
  {
    Name: "Llegaste Tú",
    Artist: "CNCO & Prince Royce",
    Album: "Llegaste Tú - Single",
    Time: 190,
    Year: 2018,
    Plays: 30,
  },
  {
    Name: "Hey DJ",
    Artist: "CNCO & Yandel",
    Album: "CNCO",
    Time: 206,
    Year: 2017,
    Plays: 92,
  },
  {
    Name: "Hey DJ (Remix)",
    Artist: "CNCO, Meghan Trainor & Sean Paul",
    Album: "Hey DJ (Remix) - Single",
    Time: 189,
    Year: 2018,
    Plays: 149,
  },
  {
    Name: "Deranged",
    Artist: "Coheed and Cambria",
    Album: "Batman: Arkham City",
    Time: 266,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "The Dark Sentencer",
    Artist: "Coheed and Cambria",
    Album: "The Dark Sentencer - Single",
    Time: 464,
    Year: 2018,
    Plays: 23,
  },
  {
    Name: "Welcome Home",
    Artist: "Coheed and Cambria",
    Album:
      "Good Apollo I'm Burning Star IV, Vol. 1 - From Fear Through the Eyes of Madness",
    Time: 374,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Jessie's Girl 2 (feat. Rick Springfield)",
    Artist: "Coheed and Cambria",
    Album: "Jessie's Girl 2 (feat. Rick Springfield) - Single",
    Time: 231,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "The Dark Sentencer",
    Artist: "Coheed and Cambria",
    Album: "The Unheavenly Creatures",
    Time: 464,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Unheavenly Creatures",
    Artist: "Coheed and Cambria",
    Album: "The Unheavenly Creatures",
    Time: 253,
    Year: 2018,
    Plays: 22,
  },
  {
    Name: "Queen of the Dark",
    Artist: "Coheed and Cambria",
    Album: "The Unheavenly Creatures",
    Time: 351,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "The Pavilion (A Long Way Back)",
    Artist: "Coheed and Cambria",
    Album: "The Unheavenly Creatures",
    Time: 311,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "The Wicked Side of Me",
    Artist: "Cold Driven",
    Album: "The Wicked Side of Me - Single",
    Time: 227,
    Year: 2011,
    Plays: 55,
  },
  {
    Name: "Always In My Head",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 216,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Magic",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 285,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Ink",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 228,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "True Love",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 245,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Midnight",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 294,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Another's Arms",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 234,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Oceans",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 321,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "A Sky Full of Stars",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 268,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "O (Hidden Track)",
    Artist: "Coldplay",
    Album: "Ghost Stories",
    Time: 466,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "A Head Full Of Dreams",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 223,
    Year: 2015,
    Plays: 32,
  },
  {
    Name: "Birds",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 229,
    Year: 2015,
    Plays: 37,
  },
  {
    Name: "Hymn For The Weekend",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 258,
    Year: 2015,
    Plays: 37,
  },
  {
    Name: "Everglow",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 282,
    Year: 2015,
    Plays: 20,
  },
  {
    Name: "Adventure Of A Lifetime",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 263,
    Year: 2015,
    Plays: 23,
  },
  {
    Name: "Fun (feat. Tove Lo)",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 267,
    Year: 2015,
    Plays: 16,
  },
  {
    Name: "Kaleidoscope",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 111,
    Year: 2015,
    Plays: 17,
  },
  {
    Name: "Army Of One",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 376,
    Year: 2015,
    Plays: 17,
  },
  {
    Name: "Amazing Day",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 271,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "Colour Spectrum",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 60,
    Year: 2015,
    Plays: 14,
  },
  {
    Name: "Up&Up",
    Artist: "Coldplay",
    Album: "A Head Full Of Dreams",
    Time: 405,
    Year: 2015,
    Plays: 12,
  },
  {
    Name: "Don't Panic",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 137,
    Year: 2000,
    Plays: 3,
  },
  {
    Name: "Shiver",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 299,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Spies",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 318,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Sparks",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 227,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Yellow",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 269,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Trouble",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 270,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Parachutes",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 46,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "High Speed",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 254,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "We Never Change",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 249,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Everything's Not Lost",
    Artist: "Coldplay",
    Album: "Parachutes",
    Time: 435,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Life In Technicolor",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 159,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "Cemeteries Of London",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 200,
    Year: 2008,
    Plays: 4,
  },
  {
    Name: "Lost!",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 234,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "42",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 237,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "Lovers In Japan/Reign Of Love",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 410,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "Yes",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 426,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "Viva La Vida",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 244,
    Year: 2008,
    Plays: 13,
  },
  {
    Name: "Violet Hill",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 229,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "Strawberry Swing",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 249,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "Death And All His Friends",
    Artist: "Coldplay",
    Album: "Viva La Vida",
    Time: 378,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Viva la Vida",
    Artist: "Coldplay",
    Album: "Viva la Vida or Death and All His Friends",
    Time: 241,
    Year: 2008,
    Plays: 4,
  },
  {
    Name: 'Glory (From the Motion Picture "Selma")',
    Artist: "Common & John Legend",
    Album: 'Glory (From the Motion Picture "Selma") - Single',
    Time: 272,
    Year: 2014,
    Plays: 27,
  },
  {
    Name: "I Started a Joke (feat. Becky Hanson)",
    Artist: "ConfidentialMX",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 190,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Out in the Rain (feat. Lzzy Hale)",
    Artist: "Cory Marks",
    Album: "Who I Am",
    Time: 254,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "All Over Now",
    Artist: "The Cranberries",
    Album: "In the End",
    Time: 256,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Zombie",
    Artist: "The Cranberries",
    Album: "No Need to Argue (The Complete Sessions 1994–1995)",
    Time: 306,
    Year: 1994,
    Plays: 132,
  },
  {
    Name: "Fortunate Son",
    Artist: "Creedence Clearwater Revival",
    Album: "Willy and the Poor Boys",
    Time: 141,
    Year: 1968,
    Plays: 1,
  },
  {
    Name: "Napalm Girls",
    Artist: "Creeper",
    Album: "Sex, Death & the Infinite Void",
    Time: 213,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Knuck If You Buck",
    Artist: "Crime Mob",
    Album: "Crime Mob",
    Time: 205,
    Year: 2004,
    Plays: 31,
  },
  {
    Name: "Who Knows",
    Artist: "Crimson Apple",
    Album: "Somebody - EP",
    Time: 181,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Cold",
    Artist: "Crossfade",
    Album: "Crossfade",
    Time: 194,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Oh, Catastrophe",
    Artist: "Crown the Empire",
    Album: "The Fallout (Deluxe Reissue)",
    Time: 119,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Lead Me Out of the Dark",
    Artist: "Crown the Empire",
    Album: "The Fallout (Deluxe Reissue)",
    Time: 198,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Satellites (Act III)",
    Artist: "Crown the Empire",
    Album: "The Resistance: Rise of the Runaways",
    Time: 127,
    Year: 2014,
    Plays: 117,
  },
  {
    Name: "20/20",
    Artist: "Crown the Empire",
    Album: "20/20 - Single",
    Time: 241,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Leave It All Behind",
    Artist: "Cult To Follow",
    Album: "Leave It All Behind - Single",
    Time: 224,
    Year: 2011,
    Plays: 18,
  },
  {
    Name: "Heart",
    Artist: "Cyan Kicks",
    Album: "Heart - Single",
    Time: 174,
    Year: 2019,
    Plays: 122,
  },
  {
    Name: "Let Me Down Slowly",
    Artist: "Cyan Kicks",
    Album: "Let Me Down Slowly - Single",
    Time: 191,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Tidal Wave",
    Artist: "Cyan Kicks",
    Album: "Tidal Wave - Single",
    Time: 200,
    Year: 2019,
    Plays: 12,
  },
  {
    Name: "Why Me",
    Artist: "D'Banj",
    Album: "Best of Nigerian Local Classics 1",
    Time: 235,
    Year: 2006,
    Plays: 4,
  },
  {
    Name: "Fall in Love",
    Artist: "D'Banj",
    Album: "D'banj Essentials",
    Time: 256,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Mo Gbono Feli Feli",
    Artist: "D'Banj",
    Album: "D'banj Essentials",
    Time: 258,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Everything Is Ok",
    Artist: "D'Banj",
    Album: "Everything Is Ok - Single",
    Time: 182,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Mr Endowed (feat. Snoop Dogg) [Remix]",
    Artist: "D'Banj",
    Album: "Mr Endowed (Remix) [feat. Snoop Dogg] - Single",
    Time: 280,
    Year: 2011,
    Plays: 10,
  },
  {
    Name: "Baecation",
    Artist: "D'Banj & 2Baba",
    Album: "Baecation - Single",
    Time: 225,
    Year: 2019,
    Plays: 21,
  },
  {
    Name: "Baby Sitter (feat. Offset)",
    Artist: "DaBaby",
    Album: "Baby on Baby",
    Time: 157,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "ROCKSTAR (feat. Roddy Ricch)",
    Artist: "DaBaby",
    Album: "BLAME IT ON BABY",
    Time: 181,
    Year: 2020,
    Plays: 20,
  },
  {
    Name: "BOP",
    Artist: "DaBaby",
    Album: "KIRK",
    Time: 159,
    Year: 2019,
    Plays: 22,
  },
  {
    Name: "VIBEZ",
    Artist: "DaBaby",
    Album: "KIRK",
    Time: 144,
    Year: 2019,
    Plays: 15,
  },
  {
    Name: "TOES (feat. Lil Baby & Moneybagg Yo)",
    Artist: "DaBaby",
    Album: "KIRK",
    Time: 136,
    Year: 2019,
    Plays: 7,
  },
  {
    Name: "Alive",
    Artist: "Daddy Rock",
    Album: "Daddy Rock",
    Time: 264,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Gasolina",
    Artist: "Daddy Yankee",
    Album: "El sol ta que quema",
    Time: 192,
    Year: 2004,
    Plays: 12,
  },
  {
    Name: "Hula Hoop",
    Artist: "Daddy Yankee",
    Album: "Hula Hoop - Single",
    Time: 236,
    Year: 2017,
    Plays: 21,
  },
  {
    Name: "Limbo",
    Artist: "Daddy Yankee",
    Album: "Prestige",
    Time: 224,
    Year: 2012,
    Plays: 6,
  },
  {
    Name: "King in the North (feat. BadmanSkillz & Ikayh)",
    Artist: "DAMIAN",
    Album: "King in the North (feat. BadmanSkillz & Ikayh) - Single",
    Time: 189,
    Year: 2020,
    Plays: 19,
  },
  {
    Name: "Best or Nothing",
    Artist: "DAMIAN, Ikayh & O.H.I.S",
    Album: "Best or Nothing - Single",
    Time: 196,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "'Jo'",
    Artist: "Dammy Krane, zlatan & Olamide",
    Album: "'Jo' - Single",
    Time: 212,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "There's a Storm Coming",
    Artist: "Dance With the Dead",
    Album: "The Shape",
    Time: 134,
    Year: 2016,
    Plays: 100,
  },
  {
    Name: "Rush",
    Artist: "Dangbana Republik & Bella Shmurda",
    Album: "High Tension 2.0",
    Time: 150,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Save My Life Tonight",
    Artist: "Danger Silent",
    Album: "Save My Life Tonight - Single",
    Time: 224,
    Year: 2017,
    Plays: 16,
  },
  {
    Name: "Who Hurt You?",
    Artist: "Daniel Caesar",
    Album: "Who Hurt You? - Single",
    Time: 231,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Tewkesbury's Trail",
    Artist: "Daniel Pemberton",
    Album: "Enola Holmes (Music from the Netflix Film)",
    Time: 101,
    Year: 2020,
    Plays: 6,
  },
  {
    Name: "An Old Friend",
    Artist: "Daniel Pemberton",
    Album: "Enola Holmes (Music from the Netflix Film)",
    Time: 114,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Enola Holmes (The Future Is Up To Us)",
    Artist: "Daniel Pemberton",
    Album: "Enola Holmes (Music from the Netflix Film)",
    Time: 225,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "From Nothing Comes a King",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 43,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "King Arthur: Legend of the Sword",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 172,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Growing Up Londinium",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 161,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Jackseye's Tale",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 211,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "The Story of Mordred",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 120,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Vortigen and the Syrens",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 138,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "The Legend of Excalibur",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 163,
    Year: 2017,
    Plays: 19,
  },
  {
    Name: "Seasoned Oak",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 138,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "The Vikings & the Barons",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 179,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Tower & Power",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 232,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "The Born King",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 150,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Assassins Breathe",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 263,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Run Londinium",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 345,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Fireball",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 123,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Journey to the Caves",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 116,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "The Wolf & the Hanged Men",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 148,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Camelot in Flames",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 144,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "The Lady in the Lake",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 187,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "The Darklands",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 163,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Revelation",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 185,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "King Arthur: Destiny of the Sword",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 162,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "The Power of Excalibur",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 243,
    Year: 2017,
    Plays: 26,
  },
  {
    Name: "Knights of the Round Table",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 210,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "King Arthur: The Coronation",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 105,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "The Ballad of Londinium (Bonus Track)",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 169,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Riot & Flames (Bonus Track)",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 119,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Anger (Bonus Track)",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 114,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Cave Fight (Bonus Track)",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 85,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Confrontation with the Common Man (Bonus Track)",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 151,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "The Devil & the Daughter (Bonus Track)",
    Artist: "Daniel Pemberton",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 265,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "The Politics & the Life",
    Artist: "Daniel Pemberton & Gareth Williams",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 202,
    Year: 2017,
    Plays: 6,
  },
  {
    Name: "The Devil & the Huntsman",
    Artist: "Daniel Pemberton & Sam Lee",
    Album:
      "King Arthur: Legend of the Sword (Original Motion Picture Soundtrack)",
    Time: 258,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Diamonds On Me (feat. Gunna & Yella Beezy)",
    Artist: "DaniLeigh",
    Album: "MOVIE",
    Time: 228,
    Year: 2020,
    Plays: 15,
  },
  {
    Name: "Diamonds On Me (feat. Gunna & Yella Beezy)",
    Artist: "DaniLeigh",
    Album: "MOVIE",
    Time: 228,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Ana and Christian",
    Artist: "Danny Elfman",
    Album: "Fifty Shades of Grey",
    Time: 204,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Did That Hurt?",
    Artist: "Danny Elfman",
    Album: "Fifty Shades of Grey",
    Time: 174,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Halcyon",
    Artist: "Danny Olson & Henry Hartley",
    Album: "Halcyon - Single",
    Time: 278,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Reality Stalling",
    Artist: "The Darkest Moment",
    Album: "Reality Stalling - Single",
    Time: 318,
    Year: 2018,
    Plays: 23,
  },
  {
    Name: "Smother",
    Artist: "Daughter",
    Album: "If You Leave",
    Time: 241,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "How I Met My Ex",
    Artist: "Dave",
    Album: "Game Over - EP",
    Time: 445,
    Year: 2017,
    Plays: 17,
  },
  {
    Name: "No Words (feat. Mostack)",
    Artist: "Dave",
    Album: "Game Over - EP",
    Time: 210,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Paper Cuts",
    Artist: "Dave",
    Album: "Paper Cuts - Single",
    Time: 179,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Psycho",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 248,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Streatham",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 205,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Black",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 228,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Purple Heart",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 164,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Location (feat. Burna Boy)",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 241,
    Year: 2019,
    Plays: 14,
  },
  {
    Name: "Disaster (feat. J Hus)",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 240,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Screwface Capital",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 253,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Environment",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 202,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Lesley (feat. Ruelle)",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 667,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "Voices",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 198,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Drama",
    Artist: "Dave",
    Album: "PSYCHODRAMA",
    Time: 423,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Professor X",
    Artist: "Dave",
    Album: "Top Boy (A Selection of Music Inspired by the Series)",
    Time: 217,
    Year: 2019,
    Plays: 110,
  },
  {
    Name: "Verdansk (Survival Mode)",
    Artist: "Dave",
    Album: "Verdansk (Survival Mode) - Single",
    Time: 266,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "We're All Alone",
    Artist: "Dave",
    Album: "We're All Alone In This Together",
    Time: 280,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Verdansk",
    Artist: "Dave",
    Album: "We're All Alone In This Together",
    Time: 182,
    Year: 2021,
    Plays: 23,
  },
  {
    Name: "In The Fire",
    Artist: "Dave",
    Album: "We're All Alone In This Together",
    Time: 423,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Three Rivers",
    Artist: "Dave",
    Album: "We're All Alone In This Together",
    Time: 331,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Twenty To One",
    Artist: "Dave",
    Album: "We're All Alone In This Together",
    Time: 201,
    Year: 2021,
    Plays: 228,
  },
  {
    Name: "Heart Attack",
    Artist: "Dave",
    Album: "We're All Alone In This Together",
    Time: 595,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Survivor's Guilt",
    Artist: "Dave",
    Album: "We're All Alone In This Together",
    Time: 340,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Thiago Silva",
    Artist: "Dave & AJ Tracey",
    Album: "Thiago Silva - Single",
    Time: 201,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Lazarus",
    Artist: "Dave & BOJ",
    Album: "We're All Alone In This Together",
    Time: 204,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Funky Friday",
    Artist: "Dave & Fredo",
    Album: "Funky Friday - Single",
    Time: 182,
    Year: 2018,
    Plays: 205,
  },
  {
    Name: "Both Sides Of A Smile",
    Artist: "Dave & James Blake",
    Album: "We're All Alone In This Together",
    Time: 479,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Law Of Attraction",
    Artist: "Dave & Snoh Aalegra",
    Album: "We're All Alone In This Together",
    Time: 181,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Clash",
    Artist: "Dave & Stormzy",
    Album: "We're All Alone In This Together",
    Time: 251,
    Year: 2021,
    Plays: 15,
  },
  {
    Name: "System (Mixed)",
    Artist: "Dave & Wizkid",
    Album: "Party In The Jungle: Paranormal DJ, Oct 2021 (DJ Mix)",
    Time: 70,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "System",
    Artist: "Dave & Wizkid",
    Album: "We're All Alone In This Together",
    Time: 181,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Smile",
    Artist: "David Amber",
    Album: "David Amber and Friends, Vol. 1 - EP",
    Time: 231,
    Year: 2015,
    Plays: 18,
  },
  {
    Name: "9MM (feat. Akon, Snoop Dogg & Lil Wayne)",
    Artist: "David Banner",
    Album: "The Greatest Story Ever Told",
    Time: 247,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "Dangerous (feat. Sam Martin)",
    Artist: "David Guetta",
    Album: "Listen",
    Time: 203,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "She Wolf (Falling to Pieces) [feat. Sia]",
    Artist: "David Guetta",
    Album: "Nothing But the Beat Ultimate",
    Time: 222,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Little Bad Girl (feat. Taio Cruz & Ludacris)",
    Artist: "David Guetta",
    Album: "Nothing But the Beat Ultimate",
    Time: 192,
    Year: 2011,
    Plays: 20,
  },
  {
    Name: "The Alphabeat",
    Artist: "David Guetta",
    Album: "Nothing But the Beat Ultimate",
    Time: 269,
    Year: 2011,
    Plays: 8,
  },
  {
    Name: "Toy Story",
    Artist: "David Guetta",
    Album: "Nothing But the Beat Ultimate",
    Time: 225,
    Year: 2011,
    Plays: 10,
  },
  {
    Name: "Say My Name",
    Artist: "David Guetta, Bebe Rexha & J Balvin",
    Album: "7",
    Time: 198,
    Year: 2018,
    Plays: 38,
  },
  {
    Name: "The World Retreats",
    Artist: "David O'Dowda",
    Album: "The World Retreats - EP",
    Time: 222,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "FEM",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 202,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Jowo",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 176,
    Year: 2020,
    Plays: 54,
  },
  {
    Name: "Holy Ground (feat. Nicki Minaj)",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 162,
    Year: 2020,
    Plays: 10,
  },
  {
    Name: "Very Special",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 164,
    Year: 2020,
    Plays: 9,
  },
  {
    Name: "The Best (feat. Mayorkun)",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 171,
    Year: 2020,
    Plays: 18,
  },
  {
    Name: "Shopping Spree (feat. Chris Brown & Young Thug)",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 213,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Birthday Cake (feat. Nas & Hit-Boy)",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 170,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "I Got a Friend (feat. Mayorkun & Sho Madjozi)",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 278,
    Year: 2020,
    Plays: 17,
  },
  {
    Name: "Fade (feat. Bella Shmurda)",
    Artist: "Davido",
    Album: "A Better Time",
    Time: 206,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "FIA",
    Artist: "Davido",
    Album: "FIA - Single",
    Time: 214,
    Year: 2017,
    Plays: 17,
  },
  {
    Name: "Dami Duro",
    Artist: "Davido",
    Album: "Omo Baba Olowo: The Genesis",
    Time: 252,
    Year: 2011,
    Plays: 6,
  },
  {
    Name: "Skelewu",
    Artist: "Davido",
    Album: "Skelewu - Single",
    Time: 187,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "Champion Sound",
    Artist: "Davido & Focalistic",
    Album: "Champion Sound - Single",
    Time: 237,
    Year: 2021,
    Plays: 13,
  },
  {
    Name: "Risky",
    Artist: "Davido & Popcaan",
    Album: "Risky - Single",
    Time: 270,
    Year: 2019,
    Plays: 7,
  },
  {
    Name: "Book of Revelations",
    Artist: "Dax",
    Album: "I'll Say It For You",
    Time: 204,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Bullfight",
    Artist: "A Day to Remember",
    Album: "Bad Vibrations (Deluxe Edition)",
    Time: 275,
    Year: 2016,
    Plays: 24,
  },
  {
    Name: "The Plot To Bomb The Panhandle",
    Artist: "A Day to Remember",
    Album: "For Those Who Have Heart",
    Time: 243,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "I'm Made Of Wax, Larry, What Are You Made Of?",
    Artist: "A Day to Remember",
    Album: "Homesick (Special Edition)",
    Time: 180,
    Year: 2009,
    Plays: 21,
  },
  {
    Name: "Mindreader",
    Artist: "A Day to Remember",
    Album: "Mindreader - Single",
    Time: 173,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Resentment",
    Artist: "A Day to Remember",
    Album: "Resentment - Single",
    Time: 227,
    Year: 2020,
    Plays: 13,
  },
  {
    Name: "Brick Wall",
    Artist: "A Day to Remember",
    Album: "You're Welcome",
    Time: 210,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Permanent",
    Artist: "A Day to Remember",
    Album: "You're Welcome",
    Time: 222,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Insomnia",
    Artist: "Daya",
    Album: "Insomnia - Single",
    Time: 179,
    Year: 2019,
    Plays: 81,
  },
  {
    Name: "Memory",
    Artist: "Dead By April",
    Album: "Memory - Single",
    Time: 211,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Prisoner",
    Artist: "Dead Eyes",
    Album: "Prisoner - Single",
    Time: 191,
    Year: 2019,
    Plays: 53,
  },
  {
    Name: "Medicine",
    Artist: "Dead Girls Academy",
    Album: "Alchemy",
    Time: 210,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Everything",
    Artist: "Dead Girls Academy",
    Album: "Alchemy",
    Time: 177,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "This is War",
    Artist: "Dead Girls Academy",
    Album: "This is War - Single",
    Time: 189,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Paradise",
    Artist: "Dead Lakes",
    Album: "New Language - EP",
    Time: 230,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Jessie",
    Artist: "DEADLOCKED STATE",
    Album: "Jessie - Single",
    Time: 177,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Kill Beautiful Things",
    Artist: "DED",
    Album: "School of Thought",
    Time: 251,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Parasite",
    Artist: "DED",
    Album: "School of Thought",
    Time: 171,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Become the Storm",
    Artist: "Dee Snider",
    Album: "For the Love of Metal",
    Time: 250,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "In Eclipse",
    Artist: "Defences",
    Album: "In Eclipse - Single",
    Time: 264,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Heart Afire (feat. Strix)",
    Artist: "Defqwop",
    Album: "",
    Time: 240,
    Year: null,
    Plays: 5,
  },
  {
    Name: "April Rain",
    Artist: "Delain",
    Album: "April Rain",
    Time: 276,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Stay Forever",
    Artist: "Delain",
    Album: "April Rain",
    Time: 266,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Invidia",
    Artist: "Delain",
    Album: "April Rain",
    Time: 229,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Hands of Gold",
    Artist: "Delain",
    Album: "Moonbathers",
    Time: 309,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "We Are the Others",
    Artist: "Delain",
    Album: "We Are the Others",
    Time: 199,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Can't Back Down",
    Artist: "Demi Lovato",
    Album: "Camp Rock 2 Soundtrack",
    Time: 195,
    Year: 2010,
    Plays: 9,
  },
  {
    Name: "Lonely (feat. Lil Wayne)",
    Artist: "Demi Lovato",
    Album: "Tell Me You Love Me (Deluxe)",
    Time: 281,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Every Breath You Take",
    Artist: "Denmark & Winter",
    Album: "",
    Time: 195,
    Year: null,
    Plays: 18,
  },
  {
    Name: "Don't Fear the Reaper (Re:Imagined)",
    Artist: "Denmark + Winter",
    Album: "Don't Fear the Reaper (Re:Imagined) - Single",
    Time: 375,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Every Breath You Take (Re:Imagined)",
    Artist: "Denmark + Winter",
    Album: "Every Breath You Take (Re:Imagined) - Single",
    Time: 222,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "Secret (Pretty Little Liars: The Perfectionists Theme)",
    Artist: "Denmark + Winter",
    Album: "Secret (Pretty Little Liars: The Perfectionists Theme) - Single",
    Time: 207,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "We Gotta Get Out of This Place (Re:Imagined)",
    Artist: "Denmark + Winter",
    Album: "We Gotta Get Out of This Place (Re:Imagined) - Single",
    Time: 242,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Ult",
    Artist: "Denzel Curry",
    Album: "Imperial",
    Time: 247,
    Year: 2016,
    Plays: 18,
  },
  {
    Name: "CLOUT COBAIN l CLOUT CO13A1N",
    Artist: "Denzel Curry",
    Album: "TA13OO",
    Time: 231,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "The Best of the Best",
    Artist: "DerrienWhite",
    Album: "Free Your Mind Fridays",
    Time: 154,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Stronger",
    Artist: "Designer Disguise",
    Album: "Stronger - Single",
    Time: 240,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Panda",
    Artist: "Desiigner",
    Album: "",
    Time: 246,
    Year: null,
    Plays: 36,
  },
  {
    Name: "Honey Dip",
    Artist: "Dev",
    Album: "Bittersweet July - EP",
    Time: 232,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Feel It",
    Artist: "Dev",
    Album: "Bittersweet July - EP",
    Time: 243,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Baby, We Go",
    Artist: "Dev",
    Album: "Bittersweet July - EP",
    Time: 202,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Kids",
    Artist: "Dev",
    Album: "Bittersweet July - EP",
    Time: 178,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Who Needs a Heart",
    Artist: "Dev",
    Album: "Bittersweet July - EP",
    Time: 174,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Naked (feat. Enrique Iglesias)",
    Artist: "Dev",
    Album: "Power Hits 2012 (CD)",
    Time: 238,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Sour Breath",
    Artist: "The Devil Wears Prada",
    Album: "Sour Breath - Single",
    Time: 190,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "(All Along the) Watchtower",
    Artist: "Devlin & Ed Sheeran",
    Album: "A Moving Picture",
    Time: 272,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Lightning in the Sky",
    Artist: "Devour the Day",
    Album: "S.O.A.R",
    Time: 204,
    Year: 2016,
    Plays: 10,
  },
  {
    Name: "Serves You Right",
    Artist: "Diamante",
    Album: "American Dream",
    Time: 214,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "I Love Myself for Hating You",
    Artist: "Diamante",
    Album: "American Dream",
    Time: 183,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Auld Lang Syne",
    Artist: "Diamante",
    Album: "Auld Lang Syne - Single",
    Time: 217,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Sleepwalking",
    Artist: "Diamante",
    Album: "Coming in Hot",
    Time: 190,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "New Dior (feat. D-Block Europe)",
    Artist: "DigDat",
    Album: "Ei8ht Mile",
    Time: 203,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Paper Bag Princess",
    Artist: "Digital Daggers",
    Album: "Paper Bag Princess - Single",
    Time: 250,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "The Devil Within",
    Artist: "Digital Daggers",
    Album: "",
    Time: 231,
    Year: null,
    Plays: 19,
  },
  {
    Name: "Revolution (Feat Faustix, Imanos and Kai)",
    Artist: "Diplo",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 263,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "U Don't Like Me (Feat. Lil Jon) (Datsik Remix)",
    Artist: "Diplo",
    Album: "Step Up Revolution",
    Time: 283,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Hands Up (Yellow Claw Remix)",
    Artist: "Dirtcaps",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 200,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Requiem of the Drunk",
    Artist: "The Dirty Youth",
    Album: "Red Light Fix",
    Time: 177,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "Utopia",
    Artist: "The Dirty Youth",
    Album: "Utopia",
    Time: 207,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Open Your Eyes",
    Artist: "Disturbed",
    Album: "Immortalized (Deluxe Edition)",
    Time: 237,
    Year: 2015,
    Plays: 9,
  },
  {
    Name: "Down with the Sickness",
    Artist: "Disturbed",
    Album: "The Sickness",
    Time: 278,
    Year: 2000,
    Plays: null,
  },
  {
    Name: "The Sound Of Silence",
    Artist: "Disturbed",
    Album: "",
    Time: 248,
    Year: 2015,
    Plays: 44,
  },
  {
    Name: "All I Do Is Win (Remix) [feat. T-Pain, Diddy, Nicki Minaj, Rick Ross, Busta Rhymes, Fabolous, Jadakiss, Fat Joe & Swizz Beatz]",
    Artist: "DJ Khaled",
    Album:
      "All I Do Is Win (Remix) [feat. T-Pain, Diddy, Nicki Minaj, Rick Ross, Busta Rhymes, Fabolous, Jadakiss, Fat Joe & Swizz Beatz] - Single",
    Time: 320,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Top Off (feat. JAY-Z, Future & Beyoncé)",
    Artist: "DJ Khaled",
    Album: "Father of Asahd",
    Time: 230,
    Year: 2018,
    Plays: 123,
  },
  {
    Name: "That Range Rover Came With Steps (feat. Future & Yo Gotti)",
    Artist: "DJ Khaled",
    Album: "Grateful",
    Time: 256,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "I'm On One (feat. Drake, Rick Ross & Lil Wayne)",
    Artist: "DJ Khaled",
    Album: "I'm On One (feat. Drake, Rick Ross & Lil Wayne) - Single",
    Time: 298,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Cold.1",
    Artist: "DJ Khaled",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 216,
    Year: 2012,
    Plays: 18,
  },
  {
    Name: "Bitches and Bottles (Let's Get It Started) (Feat. Lil Wayne, T.I. and Future)",
    Artist: "Dj Khaled",
    Album: "Kiss The Ring (Deluxe Edition)",
    Time: 269,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Take It to the Head (feat. Chris Brown, Rick Ross, Nicki Minaj & Lil Wayne)",
    Artist: "DJ Khaled",
    Album: "Kiss the Ring (Deluxe Version)",
    Time: 267,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "I Got the Keys (feat. JAY Z & Future)",
    Artist: "DJ Khaled",
    Album: "Major Key",
    Time: 219,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Do You Mind (feat. Nicki Minaj, Chris Brown, August Alsina, Jeremih, Future & Rick Ross)",
    Artist: "DJ Khaled",
    Album: "Major Key",
    Time: 325,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Out Here Grindin' (feat. Akon, Rick Ross, Young Jeezy, Lil Boosie, Plies, Ace Hood & Trick Daddy)",
    Artist: "DJ Khaled",
    Album:
      "Out Here Grindin' (feat. Akon, Rick Ross, Young Jeezy, Lil Boosie, Plies, Ace Hood & Trick Daddy) - Single",
    Time: 261,
    Year: 2008,
    Plays: 12,
  },
  {
    Name: "Out Here Grindin' (feat. Akon, Rick Ross, Young Jeezy, Lil Boosie, Plies, Ace Hood, Trick Daddy)",
    Artist: "DJ Khaled",
    Album:
      "Out Here Grindin' (feat. Akon, Rick Ross, Young Jeezy, Lil Boosie, Plies, Ace Hood, Trick Daddy) - Single",
    Time: 263,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "No New Friends Feat. Drake, Rick Ross & Lil Wayne",
    Artist: "DJ Khaled",
    Album: "Suffering From Success",
    Time: 306,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "All I Do is Win",
    Artist: "DJ Khaled",
    Album: "Victory",
    Time: 227,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "We Takin' Over (feat. Akon, Birdman, Fat Joe, Lil Wayne & Rick Ross)",
    Artist: "DJ Khaled",
    Album: "We the Best",
    Time: 263,
    Year: 2007,
    Plays: 3,
  },
  {
    Name: "Welcome to My Hood",
    Artist: "Dj Khaled",
    Album: "We The Best Forever",
    Time: 250,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Welcome to My Hood",
    Artist: "Dj Khaled",
    Album: "We The Best Forever",
    Time: 430,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Elevate (feat. Denzel Curry, YBN Cordae, SwaVay & Trevor Rich)",
    Artist: "DJ Khalil",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 219,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Nobody",
    Artist: "DJ Neptune, Joeboy & Mr Eazi",
    Album: "Nobody - Single",
    Time: 145,
    Year: 2020,
    Plays: 225,
  },
  {
    Name: "Nobody (Icons Remix)",
    Artist: "DJ Neptune, Laycon & Joeboy",
    Album: "Nobody (Icons Remix) - Single",
    Time: 171,
    Year: 2020,
    Plays: 41,
  },
  {
    Name: "You Want To Bamba",
    Artist: "dj pertubado",
    Album: "You Want To Bamba - Single",
    Time: 226,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Yaba Buluku (feat. Preck & Nelson Tivane) [Mixed]",
    Artist: "DJ Tarico & Burna Boy",
    Album: "Piano Heat [Edited Version] [DJ Mix]",
    Time: 141,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Require",
    Artist: "DJ Tunez & Olamide",
    Album: "Require - Single",
    Time: 223,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Matured Gentility",
    Artist: "DJ Void",
    Album: "Matured Gentility - EP",
    Time: 775,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Corona",
    Artist: "DjiKew",
    Album: "Corona - Single",
    Time: 111,
    Year: 2020,
    Plays: 17,
  },
  {
    Name: "Overkillin' (feat. M.I Abaga, Jesse Jagz & Ice Prince) [Remix]",
    Artist: "Djinee",
    Album: "Djinee the Album",
    Time: 304,
    Year: 2009,
    Plays: 16,
  },
  {
    Name: "Ego",
    Artist: "Djinee",
    Album: "Westside Bootleg, Vol. 1",
    Time: 243,
    Year: 2006,
    Plays: 3,
  },
  {
    Name: "Overkilling (Remix) (Feat M.i, Jesse Jagz, Ice Prince)",
    Artist: "Djinee",
    Album: "",
    Time: 304,
    Year: 2005,
    Plays: 12,
  },
  {
    Name: "Kriola (Rainha Africana)",
    Artist: "Djodje",
    Album: "Feedback",
    Time: 259,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Go To Town",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 217,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Cookie Jar",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 199,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Roll With Us",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 180,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Wine Pon You (feat. Konshens)",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 219,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Fancy",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 179,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Wild Beach",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 204,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Morning Light",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 239,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Candy",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 190,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Game",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 195,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Casual",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 240,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Down Low",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 211,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Body Language",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 245,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "All Nighter",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 193,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Juicy",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 200,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Tia Tamera (feat. Rico Nasty)",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 211,
    Year: 2019,
    Plays: 10,
  },
  {
    Name: "MOOO!",
    Artist: "Doja Cat",
    Album: "Amala (Deluxe Version)",
    Time: 285,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Won't Bite (feat. Smino)",
    Artist: "Doja Cat",
    Album: "Hot Pink",
    Time: 195,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Say So",
    Artist: "Doja Cat",
    Album: "Hot Pink",
    Time: 237,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Like That (feat. Gucci Mane)",
    Artist: "Doja Cat",
    Album: "Hot Pink",
    Time: 163,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Juicy",
    Artist: "Doja Cat & Tyga",
    Album: "Hot Pink",
    Time: 203,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Endorphins",
    Artist: "Don Broco",
    Album: "Amazing Things",
    Time: 234,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Bruce Willis",
    Artist: "Don Broco",
    Album: "Amazing Things",
    Time: 195,
    Year: 2021,
    Plays: 26,
  },
  {
    Name: "Fingernails",
    Artist: "Don Broco",
    Album: "Fingernails - Single",
    Time: 245,
    Year: 2022,
    Plays: 10,
  },
  {
    Name: "Danza Kuduro (feat. Lucenzo)",
    Artist: "Don Omar & Lucenzo",
    Album: "Meet the Orphans",
    Time: 198,
    Year: 2010,
    Plays: 90,
  },
  {
    Name: "HAD ENOUGH (feat. Quavo & Offset)",
    Artist: "Don Toliver",
    Album: "JACKBOYS",
    Time: 157,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "surrender (simba & scar interlude)",
    Artist: "Donald Glover & Chiwetel Ejiofor",
    Album: "The Lion King: The Gift",
    Time: 14,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "follow me (simba & rafiki interlude)",
    Artist: "Donald Glover & John Kani",
    Album: "The Lion King: The Gift",
    Time: 31,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "I'll Make a Man Out of You (Soundtrack Version)",
    Artist: "Donny Osmond, Chorus - Mulan & Disney",
    Album: "Mulan (Original Soundtrack)",
    Time: 201,
    Year: 1998,
    Plays: 22,
  },
  {
    Name: "The Wicked Ones",
    Artist: "Dorothy",
    Album: "",
    Time: 173,
    Year: null,
    Plays: 5,
  },
  {
    Name: "Nuthin' But A 'G' Thang (Feat. Snoop Doggy Dogg)",
    Artist: "Dr. Dre",
    Album: "Straight Outta Compton",
    Time: 239,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "I'm Sorry",
    Artist: "Drag Me Out",
    Album: "I'm Sorry - Single",
    Time: 232,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Through The Fire And Flames",
    Artist: "DragonForce",
    Album: "Inhuman Rampage",
    Time: 444,
    Year: 2006,
    Plays: 3,
  },
  {
    Name: "Back To Back",
    Artist: "Drake",
    Album: "Back To Back - Single",
    Time: 170,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Fair Trade (feat. Travis Scott)",
    Artist: "Drake",
    Album: "Certified Lover Boy",
    Time: 291,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Get Along Better (feat. Ty Dolla $ign)",
    Artist: "Drake",
    Album: "Certified Lover Boy",
    Time: 229,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "You Only Live Twice (feat. Lil Wayne & Rick Ross)",
    Artist: "Drake",
    Album: "Certified Lover Boy",
    Time: 213,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "I'm Goin In (feat. Lil Wayne & Young Jeezy)",
    Artist: "Drake",
    Album: "I'm Goin In (feat. Lil Wayne & Young Jeezy) - Single",
    Time: 225,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Legend",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 241,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Energy",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 181,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "10 Bands",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 177,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Know Yourself",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 275,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "No Tellin'",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 310,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Madonna",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 177,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "6 God",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 180,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Star67",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 295,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Preach (feat. PARTYNEXTDOOR)",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 237,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Wednesday Night Interlude (feat. PARTYNEXTDOOR)",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 212,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Used To (feat. Lil Wayne)",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 268,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "6 Man",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 167,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Now & Forever",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 281,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Company (feat. Travi$ Scott)",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 252,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "You & The 6",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 264,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Jungle",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 320,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "6PM In New York",
    Artist: "Drake",
    Album: "If You're Reading This It's Too Late",
    Time: 283,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Tuscan Leather",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 366,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Furthest Thing",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 267,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Started From The Bottom",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 174,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Wu-Tang Forever",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 217,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Own It",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 252,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Worst Behavior",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 270,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "From Time (Feat. Jhene Aiko)",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 322,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Hold On, We're Going Home (Feat. Majid Jordan)",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 227,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Connect",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 296,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "The Language",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 224,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "305 To My City (Feat. Detail)",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 255,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Too Much (Feat. Sampha)",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 261,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Pound Cake/Paris Morton Music 2 (Feat. Jay-Z)",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 433,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Come Thru",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 236,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "All Me (Feat. Big Sean & 2 Chainz)",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 271,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "The Motion (Feat. Sampha)",
    Artist: "Drake",
    Album: "Nothing Was The Same",
    Time: 241,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Over My Dead Body",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 272,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Shot for Me",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 224,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Headlines",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 235,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Crew Love (feat. The Weeknd)",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 208,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Take Care (feat. Rihanna)",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 277,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Marvins Room",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 347,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Buried Alive Interlude (feat. Kendrick Lamar)",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 150,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Under Ground Kings",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 212,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "We'll Be Fine (feat. Birdman)",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 247,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Make Me Proud (feat. Nicki Minaj)",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 219,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Lord Knows (feat. Rick Ross)",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 307,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Cameras / Good Ones Go Interlude",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 434,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Doing It Wrong",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 265,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "The Real Her (feat. Lil Wayne & Andre 3000)",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 321,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Look What You've Done",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 301,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "HYFR (Hell Ya Fucking Right) [feat. Lil Wayne]",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 206,
    Year: 2011,
    Plays: 19,
  },
  {
    Name: "HYFR (Hell Ya Fucking Right) [feat. Lil Wayne]",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 206,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Practice",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 237,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "The Ride",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 351,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "The Motto (Bonus Track) [feat. Lil Wayne]",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 181,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "The Motto (feat. Lil Wayne) [Bonus Track]",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 181,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Hate Sleeping Alone (Bonus Track)",
    Artist: "Drake",
    Album: "Take Care (Deluxe Version)",
    Time: 213,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Live From the Gutter",
    Artist: "Drake & Future",
    Album: "What a Time To Be Alive",
    Time: 211,
    Year: 2015,
    Plays: 18,
  },
  {
    Name: "Forever",
    Artist: "Drake, Kanye West, Lil Wayne & Eminem",
    Album: "Forever - Single",
    Time: 357,
    Year: 2009,
    Plays: 5,
  },
  {
    Name: "Amebo",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 204,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Bring Out the Rose (feat. Fresh L.)",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 218,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "3Kingz",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 252,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Cut Corners (feat. Teezee, Fresh L., BOJ & Bez)",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 210,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "LXIX (feat. Teezee, Fresh L. & BOJ)",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 267,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Mrs Officer (feat. BOJ, Fresh L. & Teezee)",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 210,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Selecta (feat. BOJ, Teezee, Fresh L. & Shank)",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 224,
    Year: 2018,
    Plays: 104,
  },
  {
    Name: "Shakara (feat. BOJ, Fresh L. & Teezee)",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 258,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Swagga Mi Gbona (feat. Teezee & BOJ)",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 243,
    Year: 2018,
    Plays: 14,
  },
  {
    Name: "Toyin (feat. BOJ, Teezee & Fresh L.)",
    Artist: "DRB Lasgidi",
    Album: "Drb 10",
    Time: 258,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Trouble (feat. Teezee, Fresh L., Tems)",
    Artist: "DRB Lasgidi",
    Album: "Pioneers",
    Time: 194,
    Year: 2020,
    Plays: 8,
  },
  {
    Name: "Let It In",
    Artist: "Dream On Dreamer",
    Album: "Let It In - Single",
    Time: 258,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "White Lies (Piano)",
    Artist: "Dream State",
    Album: "White Lies - Single",
    Time: 273,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Down Bad (feat. JID, Bas, J. Cole, EARTHGANG & Young Nudy)",
    Artist: "Dreamville",
    Album: "Revenge of the Dreamers III",
    Time: 169,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Outta Pocket (feat. Girl Talk)",
    Artist: "Dreamville, Bas & Cozz",
    Album: "Revenge of the Dreamers III: Director's Cut",
    Time: 157,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Faya",
    Artist: "Dremo",
    Album: "Codename, Vol. 1",
    Time: 195,
    Year: 2018,
    Plays: 22,
  },
  {
    Name: "E Be Tins (feat. Mayorkun)",
    Artist: "Dremo",
    Album: "E Be Tins (feat. Mayorkun) - Single",
    Time: 157,
    Year: 2020,
    Plays: 465,
  },
  {
    Name: "Mirror",
    Artist: "Dremo",
    Album: "Mirror - Single",
    Time: 176,
    Year: 2019,
    Plays: 11,
  },
  {
    Name: "Wonder (feat. Patoranking)",
    Artist: "Dremo",
    Album: "Wonder (feat. Patoranking) - Single",
    Time: 173,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Confam",
    Artist: "Dremo & Simi",
    Album: "Confam - Single",
    Time: 170,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "I'm Shipping up to Boston",
    Artist: "Dropkick Murphys",
    Album: "The Warrior's Code",
    Time: 153,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Omg",
    Artist: "Drug Restaurant",
    Album: "Escape to Hangover",
    Time: 245,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "New Rules",
    Artist: "Dua Lipa",
    Album: "Dua Lipa (Deluxe)",
    Time: 209,
    Year: 2017,
    Plays: 75,
  },
  {
    Name: "Physical",
    Artist: "Dua Lipa",
    Album: "Future Nostalgia",
    Time: 193,
    Year: 2020,
    Plays: 210,
  },
  {
    Name: "Kiss and Make Up",
    Artist: "Dua Lipa & BLACKPINK",
    Album: "Dua Lipa (Complete Edition)",
    Time: 189,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "LOVE IS LIKE A MOSHPIT (feat. Rico Nasty & Medasin)",
    Artist: "DUCKWRTH",
    Album: "THE FALLING MAN",
    Time: 177,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Start a Riot",
    Artist: "DUCKWRTH & Shaboozey",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 171,
    Year: 2018,
    Plays: 85,
  },
  {
    Name: "Arcade",
    Artist: "Duncan Laurence",
    Album: "Arcade - Single",
    Time: 183,
    Year: 2019,
    Plays: 71,
  },
  {
    Name: "Portharcourt Son",
    Artist: "Duncan Mighty",
    Album: "Legacy (Ahamefuna)",
    Time: 345,
    Year: 2010,
    Plays: 11,
  },
  {
    Name: "Tsunami (Jump) [feat. Tinie Tempah] [Radio Edit]",
    Artist: "DVBBS & Borgeous",
    Album: "Demonstration",
    Time: 159,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Epiphany",
    Artist: "Dvicio",
    Album: "Impulso",
    Time: 188,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "No Cryin (feat. Future)",
    Artist: "dvsn",
    Album: "No Cryin (feat. Future) - Single",
    Time: 204,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "You're Welcome",
    Artist: "Dwayne Johnson",
    Album: "Moana (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 163,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Fuck It (I Don't Want You Back)",
    Artist: "Eamon",
    Album: "Fuck It (I Don't Want You Back)",
    Time: 224,
    Year: 2003,
    Plays: 2,
  },
  {
    Name: "We Want Eazy",
    Artist: "Eazy-E",
    Album: "Straight Outta Compton",
    Time: 300,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "The Boyz-N-The Hood",
    Artist: "Eazy-E",
    Album: "Straight Outta Compton",
    Time: 337,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "All the Way (ft. Lord E)",
    Artist: "EBEN",
    Album: "Justified",
    Time: 302,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "Hate You (feat. Veronica Bravo)",
    Artist: "EBEN",
    Album: "You (feat. Veronica Bravo) - Single",
    Time: 164,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Alive",
    Artist: "Echoes",
    Album: "Alive - Single",
    Time: 238,
    Year: 2018,
    Plays: 162,
  },
  {
    Name: "Bad Habits (feat. Bring Me The Horizon)",
    Artist: "Ed Sheeran",
    Album: "Bad Habits (feat. Bring Me The Horizon) - Single",
    Time: 250,
    Year: 2022,
    Plays: 7,
  },
  {
    Name: "Perfect",
    Artist: "Ed Sheeran",
    Album: "÷ (Deluxe)",
    Time: 263,
    Year: 2017,
    Plays: 16,
  },
  {
    Name: "Supermarket Flowers",
    Artist: "Ed Sheeran",
    Album: "÷ (Deluxe)",
    Time: 221,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Take Me Back to London (feat. Stormzy)",
    Artist: "Ed Sheeran",
    Album: "No.6 Collaborations Project",
    Time: 189,
    Year: 2019,
    Plays: 18,
  },
  {
    Name: "Perfect (Acoustic)",
    Artist: "Ed Sheeran",
    Album: "Perfect (Acoustic) - Single",
    Time: 260,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Photograph",
    Artist: "Ed Sheeran",
    Album: "x (Deluxe Edition)",
    Time: 258,
    Year: 2014,
    Plays: 15,
  },
  {
    Name: "Tenerife Sea",
    Artist: "Ed Sheeran",
    Album: "x (Deluxe Edition)",
    Time: 241,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Shivers",
    Artist: "Ed Sheeran",
    Album: "=",
    Time: 207,
    Year: 2021,
    Plays: 28,
  },
  {
    Name: 'You Can Become a Hero! (From "Boku No Hero Academia")',
    Artist: "Eddie van der Meer",
    Album: "Anime Songs #9",
    Time: 166,
    Year: 2017,
    Plays: 38,
  },
  {
    Name: "Jaga Jaga",
    Artist: "Eedris Abdulkareem",
    Album: "Jaga Jaga",
    Time: 226,
    Year: 2004,
    Plays: 1,
  },
  {
    Name: "Chenkez",
    Artist: "EESKAY",
    Album: "Chenkez - Single",
    Time: 266,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "Disrespect the Gram",
    Artist: "EESKAY",
    Album: "Disrespect the Gram - Single",
    Time: 183,
    Year: 2019,
    Plays: 15,
  },
  {
    Name: "The Matter",
    Artist: "EESKAY",
    Album: "The Matter - Single",
    Time: 148,
    Year: 2018,
    Plays: 141,
  },
  {
    Name: "Sanitize",
    Artist: "EESKAY",
    Album: "Sanitize - Single",
    Time: 213,
    Year: 2020,
    Plays: 29,
  },
  {
    Name: "As Long As God Loves Us",
    Artist: "Efisio Cross",
    Album: "As Long As God Loves Us - Single",
    Time: 371,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Blue (Da Ba Dee) [Gabry Ponte Video Edit]",
    Artist: "Eiffel 65",
    Album: "Blue (Da Ba Dee)",
    Time: 219,
    Year: 1998,
    Plays: 9,
  },
  {
    Name: "Unravel",
    Artist: "Élan Vital",
    Album: "Unravel - Single",
    Time: 235,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "Wash Wash",
    Artist: "eLDee",
    Album: "Undeniable",
    Time: 232,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Love Me Like You Do",
    Artist: "Ellie Goulding",
    Album: "Fifty Shades of Grey",
    Time: 250,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Burn",
    Artist: "Ellie Goulding",
    Album: "Halcyon Days (Deluxe Version)",
    Time: 231,
    Year: 2013,
    Plays: null,
  },
  {
    Name: 'Still Falling for You (From "Bridget Jones\'s Baby")',
    Artist: "Ellie Goulding",
    Album:
      'Still Falling for You (From "Bridget Jones\'s Baby" Original Motion Picture Soundtrack) - Single',
    Time: 240,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Between the Bars",
    Artist: "Elliott Smith",
    Album: "Either/Or (20th Anniversary Expanded Edition) [2017 Remaster]",
    Time: 141,
    Year: 1997,
    Plays: 5,
  },
  {
    Name: "Candle In the Wind",
    Artist: "Elton John",
    Album: "Goodbye Yellow Brick Road",
    Time: 228,
    Year: 1973,
    Plays: 12,
  },
  {
    Name: "Circle of Life",
    Artist: "Elton John",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 291,
    Year: 1994,
    Plays: null,
  },
  {
    Name: "Never Too Late",
    Artist: "Elton John",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 249,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Made In England",
    Artist: "Elton John",
    Album: "Made In England",
    Time: 308,
    Year: 1995,
    Plays: 5,
  },
  {
    Name: "Believe",
    Artist: "Elton John & Paul Buckmaster",
    Album: "Made In England",
    Time: 295,
    Year: 1995,
    Plays: 4,
  },
  {
    Name: "Ategnatos",
    Artist: "Eluveitie",
    Album: "Ategnatos",
    Time: 293,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "A Rose for Epona",
    Artist: "Eluveitie",
    Album: "Helvetios",
    Time: 266,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Can't Help Falling In Love",
    Artist: "Elvis Presley",
    Album: "Elv1s: 30 #1 Hits",
    Time: 177,
    Year: 1961,
    Plays: 8,
  },
  {
    Name: "White Rabbit [Jefferson Airplane cover] ",
    Artist: "Emiliana Torrini",
    Album: "Sucker Punch",
    Time: 308,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Sweet Dreams [Are Made of This] [Eurythmics cover] ",
    Artist: "Emily Browning",
    Album: "Sucker Punch",
    Time: 318,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "Asleep [Smiths cover] ",
    Artist: "Emily Browning",
    Album: "Sucker Punch",
    Time: 263,
    Year: 2011,
    Plays: 16,
  },
  {
    Name: "Intro (Curtain Call)",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 34,
    Year: 2005,
    Plays: 4,
  },
  {
    Name: "FACK",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 205,
    Year: 2005,
    Plays: 5,
  },
  {
    Name: "The Way I Am",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 291,
    Year: 2005,
    Plays: 10,
  },
  {
    Name: "My Name Is",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 268,
    Year: 2005,
    Plays: 4,
  },
  {
    Name: "Lose Yourself",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 326,
    Year: 2005,
    Plays: 13,
  },
  {
    Name: "Shake That",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 274,
    Year: 2005,
    Plays: 3,
  },
  {
    Name: "Sing for the Moment",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 340,
    Year: 2005,
    Plays: 21,
  },
  {
    Name: "Without Me",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 291,
    Year: 2005,
    Plays: 10,
  },
  {
    Name: "Like Toy Soldiers",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 295,
    Year: 2005,
    Plays: 11,
  },
  {
    Name: "The Real Slim Shady",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 284,
    Year: 2005,
    Plays: 6,
  },
  {
    Name: "Mockingbird",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 251,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Cleanin' Out My Closet",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 299,
    Year: 2005,
    Plays: 7,
  },
  {
    Name: "Just Lose It",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 248,
    Year: 2005,
    Plays: 5,
  },
  {
    Name: "When I'm Gone",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 281,
    Year: 2005,
    Plays: 18,
  },
  {
    Name: "Stan (Featuring Elton John)",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 380,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Role Model",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 205,
    Year: 2005,
    Plays: 3,
  },
  {
    Name: "Kill You",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 264,
    Year: 2005,
    Plays: 3,
  },
  {
    Name: "S**t On You (Featuring D12)",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 328,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Criminal",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 313,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Just Don't Give a F**k",
    Artist: "Eminem",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 242,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Without Me",
    Artist: "Eminem",
    Album: "The Eminem Show",
    Time: 290,
    Year: 2002,
    Plays: 1,
  },
  {
    Name: "The Ringer",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 337,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Greatest",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 226,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Lucky You (feat. Joyner Lucas)",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 244,
    Year: 2018,
    Plays: 65,
  },
  {
    Name: "Normal",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 222,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Em Calls Paul (Skit)",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 49,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Stepping Stone",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 309,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Not Alike (feat. Royce da 5'9\")",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 288,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Kamikaze",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 216,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Fall",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 262,
    Year: 2018,
    Plays: 14,
  },
  {
    Name: "Good Guy (feat. Jessie Reyez)",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 142,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Venom (Music From The Motion Picture)",
    Artist: "Eminem",
    Album: "Kamikaze",
    Time: 269,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Killshot",
    Artist: "Eminem",
    Album: "Killshot - Single",
    Time: 253,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "The King and I (feat. CeeLo Green) [From the Original Motion Picture Soundtrack ELVIS]",
    Artist: "Eminem",
    Album:
      "The King and I (feat. CeeLo Green) [From the Original Motion Picture Soundtrack ELVIS] - Single",
    Time: 193,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Venom (Remix)",
    Artist: "Eminem",
    Album: "Last One Standing (From Venom: Let There Be Carnage) - Single",
    Time: 261,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Public Service Announcement 2000",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 28,
    Year: 2000,
    Plays: 5,
  },
  {
    Name: "Kill You",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 264,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Stan",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 404,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Paul (Skit)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 10,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Who Knew",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 227,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Steve Berman (Skit)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 53,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "The Way I Am",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 290,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "The Real Slim Shady",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 284,
    Year: 2000,
    Plays: 5,
  },
  {
    Name: "Remember Me?",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 218,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "I'm Back",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 309,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Marshall Mathers",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 321,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Ken Kaniff (Skit)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 61,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Drug Ballad",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 300,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Amityville",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 254,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Bitch Please II",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 288,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Kim",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 378,
    Year: 2000,
    Plays: 3,
  },
  {
    Name: "Under The Influence",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 321,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Criminal",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP",
    Time: 319,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Bad Guy",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 434,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Parking Lot (Skit)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 55,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Rhyme or Reason",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 301,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "So Much Better",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 261,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Survival",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 272,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Legacy",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 296,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "Asshole (feat. Skylar Grey)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 288,
    Year: 2013,
    Plays: 47,
  },
  {
    Name: "Berzerk",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 238,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Rap God",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 363,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "Brainless",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 286,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Stronger Than I Was",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 336,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "The Monster (feat. Rihanna)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 250,
    Year: 2013,
    Plays: 20,
  },
  {
    Name: "So Far...",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 317,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Love Game (feat. Kendrick Lamar)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 296,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Headlights (feat. Nate Ruess)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 343,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Evil Twin",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 356,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Baby",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 263,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Desperation (feat. Jamie N Commons)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 236,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Groundhog Day",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 293,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Beautiful Pain (feat. Sia)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 265,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Wicked Ways (feat. X Ambassadors)",
    Artist: "Eminem",
    Album: "The Marshall Mathers LP2 (Deluxe)",
    Time: 392,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Godzilla (feat. Juice WRLD)",
    Artist: "Eminem",
    Album: "Music To Be Murdered By",
    Time: 210,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Cold Wind Blows",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 303,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Talkin' 2 Myself",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 300,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "On Fire",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 213,
    Year: 2010,
    Plays: 4,
  },
  {
    Name: "Won't Back Down",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 266,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "W.T.P.",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 238,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Going Through Changes",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 298,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Not Afraid",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 248,
    Year: 2010,
    Plays: 21,
  },
  {
    Name: "Seduction",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 275,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "No Love",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 299,
    Year: 2010,
    Plays: 44,
  },
  {
    Name: "Space Bound",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 278,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Cinderella Man",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 280,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "25 to Life",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 241,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "So Bad",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 325,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Almost Famous",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 292,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Love the Way You Lie",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 263,
    Year: 2010,
    Plays: 25,
  },
  {
    Name: "You're Never Over",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 305,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Untitled",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 194,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Ridaz",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 300,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Session One",
    Artist: "Eminem",
    Album: "Recovery (Deluxe Edition)",
    Time: 268,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Dr. West (skit)",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 89,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "3 a.m.",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 319,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "My Mom",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 319,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Insane",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 181,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Bagpipes From Baghdad",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 283,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Hello",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 248,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Tonya (skit)",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 42,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Same Song & Dance",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 246,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "We Made You",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 269,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Medicine Ball",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 237,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Paul (skit)",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 19,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Stay Wide Awake",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 320,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Old Time's Sake (feat Dr Dre)",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 278,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Must Be the Ganja",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 242,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Mr. Mathers (skit)",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 42,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Déjà Vu",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 283,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Beautiful",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 392,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Crack a Bottle (feat Dr Dre & 50 Cent)",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 297,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Steve Berman (skit)",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 89,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Underground",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 371,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "My Darling",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 320,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Careful What You Wish For",
    Artist: "Eminem",
    Album: "Relapse (Deluxe Edition)",
    Time: 227,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Walk On Water (feat. Beyoncé)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 303,
    Year: 2017,
    Plays: 5,
  },
  {
    Name: "Believe",
    Artist: "Eminem",
    Album: "Revival",
    Time: 315,
    Year: 2017,
    Plays: 70,
  },
  {
    Name: "Chloraseptic (feat. PHRESHER)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 301,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Untouchable",
    Artist: "Eminem",
    Album: "Revival",
    Time: 370,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "River (feat. Ed Sheeran)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 221,
    Year: 2017,
    Plays: 8,
  },
  {
    Name: "Remind Me (Intro)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 26,
    Year: 2017,
    Plays: 6,
  },
  {
    Name: "Remind Me",
    Artist: "Eminem",
    Album: "Revival",
    Time: 225,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Revival (Interlude)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 51,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Like Home (feat. Alicia Keys)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 245,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Bad Husband (feat. X Ambassadors)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 287,
    Year: 2017,
    Plays: 98,
  },
  {
    Name: "Tragic Endings (feat. Skylar Grey)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 252,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Framed",
    Artist: "Eminem",
    Album: "Revival",
    Time: 253,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Nowhere Fast (feat. Kehlani)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 264,
    Year: 2017,
    Plays: 26,
  },
  {
    Name: "Heat",
    Artist: "Eminem",
    Album: "Revival",
    Time: 250,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Offended",
    Artist: "Eminem",
    Album: "Revival",
    Time: 320,
    Year: 2017,
    Plays: 21,
  },
  {
    Name: "Need Me (feat. P!nk)",
    Artist: "Eminem",
    Album: "Revival",
    Time: 265,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "In Your Head",
    Artist: "Eminem",
    Album: "Revival",
    Time: 182,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Castle",
    Artist: "Eminem",
    Album: "Revival",
    Time: 254,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Arose",
    Artist: "Eminem",
    Album: "Revival",
    Time: 274,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Stan",
    Artist: "Eminem & Dido",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 404,
    Year: 2005,
    Plays: 4,
  },
  {
    Name: "Guilty Conscience",
    Artist: "Eminem & Dr. Dre",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 200,
    Year: 2005,
    Plays: 6,
  },
  {
    Name: "Renegade",
    Artist: "Eminem & Jay-Z",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 336,
    Year: 2005,
    Plays: 3,
  },
  {
    Name: "Nice Guy",
    Artist: "Eminem & Jessie Reyez",
    Album: "Kamikaze",
    Time: 150,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Dead Wrong",
    Artist: "Eminem & The Notorious B.I.G.",
    Album: "Curtain Call - The Hits (Deluxe Version)",
    Time: 297,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Hollywood",
    Artist: "Emma Ruth Rundle & Thou",
    Album: "The Helm of Sorrow - EP",
    Time: 315,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "903",
    Artist: "EMO Grae & BNXN fka Buju",
    Album: "0903 - Single",
    Time: 186,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Ain't About the Money (feat. Jussie Smollett and Yazz)",
    Artist: "Empire Cast",
    Album: "Empire: Music From 'Poor Yorick' - EP",
    Time: 192,
    Year: 2015,
    Plays: 46,
  },
  {
    Name: "Snitch Bitch (feat. Terrence Howard and Petey Pablo)",
    Artist: "Empire Cast",
    Album: "Empire: Music From 'Without a Country' - EP",
    Time: 228,
    Year: 2015,
    Plays: 8,
  },
  {
    Name: 'Trapped (feat. Jussie Smollett & Yazz) [From "Empire"]',
    Artist: "Empire Cast",
    Album: 'Trapped (From "Empire") [feat. Jussie Smollett & Yazz] - Single',
    Time: 132,
    Year: 2017,
    Plays: 75,
  },
  {
    Name: "Hurricane",
    Artist: "Endgame",
    Album: "Hurricane - Single",
    Time: 229,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "DUELE EL CORAZON (feat. Wisin)",
    Artist: "Enrique Iglesias",
    Album: "DUELE EL CORAZON (feat. Wisin) - Single",
    Time: 199,
    Year: 2016,
    Plays: 18,
  },
  {
    Name: "Hero",
    Artist: "Enrique Iglesias",
    Album: "Greatest Hits",
    Time: 264,
    Year: 2001,
    Plays: 1,
  },
  {
    Name: "Takin' Back My Love",
    Artist: "Enrique Iglesias",
    Album: "Greatest Hits",
    Time: 230,
    Year: 2008,
    Plays: 8,
  },
  {
    Name: "Heart Attack",
    Artist: "Enrique Iglesias",
    Album: "SEX AND LOVE (Deluxe Edition)",
    Time: 170,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "SÚBEME LA RADIO (feat. Descemer Bueno & Zion & Lennox)",
    Artist: "Enrique Iglesias",
    Album: "SÚBEME LA RADIO (feat. Descemer Bueno & Zion & Lennox) - Single",
    Time: 207,
    Year: 2017,
    Plays: 19,
  },
  {
    Name: "SÚBEME LA RADIO (REMIX) [feat. Sean Paul & Matt Terry]",
    Artist: "Enrique Iglesias",
    Album: "SÚBEME LA RADIO (REMIX) [feat. Sean Paul & Matt Terry] - Single",
    Time: 207,
    Year: 2017,
    Plays: 31,
  },
  {
    Name: "Boulevard of Broken Dreams",
    Artist: "Entail of Crow",
    Album: "Boulevard of Broken Dreams - Single",
    Time: 222,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "I'm Not Utopia",
    Artist: "Entail of Crow",
    Album: "I'm Not Utopia - Single",
    Time: 253,
    Year: 2017,
    Plays: 84,
  },
  {
    Name: "Nah Sir",
    Artist: "Entail of Crow",
    Album: "Nah Sir - Single",
    Time: 188,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Donald Trump vs Hillary Clinton",
    Artist: "Epic Rap Battles of History",
    Album: "Donald Trump vs Hillary Clinton - Single",
    Time: 274,
    Year: 2016,
    Plays: 9,
  },
  {
    Name: "Gandhi vs. Martin Luther King Jr.",
    Artist: "Epic Rap Battles of History",
    Album: "Gandhi vs. Martin Luther King Jr. - Single",
    Time: 92,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "J. R. R. Tolkien vs George R. R. Martin",
    Artist: "Epic Rap Battles of History",
    Album: "J. R. R. Tolkien vs George R. R. Martin - Single",
    Time: 179,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Michael Jackson vs Elvis Presley",
    Artist: "Epic Rap Battles of History",
    Album: "Michael Jackson vs Elvis Presley - Single",
    Time: 130,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Philosophers East vs West",
    Artist: "Epic Rap Battles of History",
    Album: "Philosophers East vs West - Single",
    Time: 259,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Unleashed (Duet Version)",
    Artist: "Epica",
    Album: "Design Your Universe",
    Time: 350,
    Year: 2009,
    Plays: 8,
  },
  {
    Name: "Indigo",
    Artist: "Epica",
    Album: "The Divine Conspiracy",
    Time: 125,
    Year: 1996,
    Plays: 34,
  },
  {
    Name: "Buss It",
    Artist: "Erica Banks",
    Album: "Buss It - Single",
    Time: 187,
    Year: 2020,
    Plays: 18,
  },
  {
    Name: "Buss It",
    Artist: "Erica Banks",
    Album: "Erica Banks",
    Time: 187,
    Year: 2020,
    Plays: 63,
  },
  {
    Name: "An Ocean Between Us",
    Artist: "Escape The Day",
    Album: "An Ocean Between Us - Single",
    Time: 221,
    Year: 2019,
    Plays: 11,
  },
  {
    Name: "Shut up and Listen",
    Artist: "Escape the Fate",
    Album: "Chemical Warfare: B - Sides - EP",
    Time: 197,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Empire",
    Artist: "Escape the Fate",
    Album: "I Am Human",
    Time: 192,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "One For the Money",
    Artist: "Escape the Fate",
    Album: "Ungrateful ",
    Time: 200,
    Year: 2013,
    Plays: 37,
  },
  {
    Name: "Walk On",
    Artist: "Escape the Fate",
    Album: "Walk On - Single",
    Time: 214,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Since U Been Gone",
    Artist: "Ester Dean & Skylar Astin",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 146,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "I'd Rather Go Blind",
    Artist: "Etta James",
    Album: "Tell Mama",
    Time: 156,
    Year: 1967,
    Plays: null,
  },
  {
    Name: "I Don't Like You (Nick Thayer Remix)",
    Artist: "Eva Simons",
    Album: "Step Up Revolution",
    Time: 268,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Misery",
    Artist: "Eva Under Fire",
    Album: "Heavy on the Heart - Single",
    Time: 221,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Across The Universe",
    Artist: "Evanescence",
    Album: "Across The Universe - Single",
    Time: 222,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Artifact/The Turn",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 146,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Broken Pieces Shine",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 230,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "The Game Is Over",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 262,
    Year: 2020,
    Plays: 9,
  },
  {
    Name: "Yeah Right",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 209,
    Year: 2020,
    Plays: 6,
  },
  {
    Name: "Feeding the Dark",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 254,
    Year: 2021,
    Plays: 32,
  },
  {
    Name: "Wasted On You",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 264,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Better Without You",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 245,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Use My Voice",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 241,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Take Cover",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 194,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Far From Heaven",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 297,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Part of Me",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 238,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Blind Belief",
    Artist: "Evanescence",
    Album: "The Bitter Truth",
    Time: 254,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "The Chain",
    Artist: "Evanescence",
    Album: "The Chain - Single",
    Time: 248,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "What You Want",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 221,
    Year: 2011,
    Plays: 62,
  },
  {
    Name: "Made of Stone",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 213,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "The Change",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 222,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "My Heart Is Broken",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 269,
    Year: 2011,
    Plays: 115,
  },
  {
    Name: "The Other Side",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 245,
    Year: 2011,
    Plays: 7,
  },
  {
    Name: "Erase This",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 235,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "Lost In Paradise",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 282,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Sick",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 210,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "End of the Dream",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 229,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Oceans",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 218,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Never Go Back",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 267,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Swimming Home",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 224,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "New Way to Bleed (Bonus Track)",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 226,
    Year: 2011,
    Plays: 10,
  },
  {
    Name: "Say You Will (Bonus Track)",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 223,
    Year: 2011,
    Plays: 28,
  },
  {
    Name: "Disappear (Bonus Track)",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 186,
    Year: 2011,
    Plays: 8,
  },
  {
    Name: "Secret Door (Bonus Track)",
    Artist: "Evanescence",
    Album: "Evanescence (Deluxe Version)",
    Time: 233,
    Year: 2011,
    Plays: 15,
  },
  {
    Name: "Going Under",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 214,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Bring Me to Life",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 235,
    Year: 2003,
    Plays: 3,
  },
  {
    Name: "Everybody's Fool",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 195,
    Year: 2003,
    Plays: 8,
  },
  {
    Name: "My Immortal",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 262,
    Year: 2003,
    Plays: 2,
  },
  {
    Name: "Haunted",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 185,
    Year: 2003,
    Plays: 10,
  },
  {
    Name: "Tourniquet",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 278,
    Year: 2003,
    Plays: 3,
  },
  {
    Name: "Imaginary",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 256,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Taking Over Me",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 228,
    Year: 2003,
    Plays: 3,
  },
  {
    Name: "Hello",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 220,
    Year: 2003,
    Plays: null,
  },
  {
    Name: "My Last Breath",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 247,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Whisper",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 327,
    Year: 2003,
    Plays: null,
  },
  {
    Name: "My Immortal (Band Version)",
    Artist: "Evanescence",
    Album: "Fallen",
    Time: 273,
    Year: 2003,
    Plays: null,
  },
  {
    Name: "Hi-Lo (feat. Lindsey Stirling) [Radio Edit]",
    Artist: "Evanescence",
    Album: "Hi-Lo (feat. Lindsey Stirling) [Radio Edit] - Single",
    Time: 256,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Sweet Sacrifice",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 185,
    Year: 2006,
    Plays: 9,
  },
  {
    Name: "Call Me When You're Sober",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 214,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Weight Of The World",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 217,
    Year: 2006,
    Plays: 3,
  },
  {
    Name: "Lithium",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 224,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Cloud Nine",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 262,
    Year: 2006,
    Plays: 5,
  },
  {
    Name: "Snow White Queen",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 261,
    Year: 2006,
    Plays: 3,
  },
  {
    Name: "Lacrymosa",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 217,
    Year: 2006,
    Plays: 7,
  },
  {
    Name: "Like You",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 258,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "Lose Control",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 290,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "The Only One",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 280,
    Year: 2006,
    Plays: 2,
  },
  {
    Name: "Your Star",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 283,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "All That I'm Living For",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 227,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "Good Enough",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 333,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Call Me When You're Sober (Acoustic Version)",
    Artist: "Evanescence",
    Album: "The Open Door",
    Time: 219,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Overture",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 57,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Never Go Back",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 290,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Hi-Lo",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 307,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "My Heart Is Broken",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 274,
    Year: 2017,
    Plays: 22,
  },
  {
    Name: "Lacrymosa",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 222,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "The End of the Dream",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 294,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Bring Me to Life (Synthesis)",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 257,
    Year: 2017,
    Plays: 6,
  },
  {
    Name: "Unraveling (Interlude)",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 100,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Imaginary",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 243,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Secret Door",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 228,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Lithium",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 245,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Lost in Paradise",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 283,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Your Star",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 278,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "My Immortal",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 265,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "The In-Between (Piano Solo)",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 131,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Imperfection",
    Artist: "Evanescence",
    Album: "Synthesis",
    Time: 262,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Use My Voice",
    Artist: "Evanescence",
    Album: "Use My Voice - Single",
    Time: 242,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Wasted On You",
    Artist: "Evanescence",
    Album: "Wasted On You - Single",
    Time: 262,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "This Time It's Different",
    Artist: "Evans Blue",
    Album: "Graveyard of Empires",
    Time: 209,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Gravity",
    Artist: "Everlit",
    Album: "Gravity - Single",
    Time: 208,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Thing with Feathers",
    Artist: "Every Time I Die",
    Album: "Radical",
    Time: 218,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "We Reached for the Sky",
    Artist: "Eyes Wide Open",
    Album: "And So It Begins",
    Time: 221,
    Year: 2017,
    Plays: 28,
  },
  {
    Name: "Devastation",
    Artist: "Eyes Wide Open",
    Album: "Burn 'Em - Single",
    Time: 220,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "The Disheartened Song",
    Artist: "Eyes Wide Open",
    Album: "The Disheartened Song - Single",
    Time: 204,
    Year: 2019,
    Plays: 7,
  },
  {
    Name: "Devastation",
    Artist: "Eyes Wide Open",
    Album: "Through Life and Death",
    Time: 220,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "By Your Side",
    Artist: "Faber Drive",
    Album: "can'T KeEp a SecrEt",
    Time: 239,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Tangled Up",
    Artist: "FAIDLESS",
    Album: "Tangled Up - Single",
    Time: 214,
    Year: 2019,
    Plays: 68,
  },
  {
    Name: "Walk Away",
    Artist: "FAIDLESS",
    Album: "Walk Away - Single",
    Time: 220,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "Irresistible",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 206,
    Year: 2015,
    Plays: 28,
  },
  {
    Name: "American Beauty American Psycho",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 195,
    Year: 2015,
    Plays: 24,
  },
  {
    Name: "Centuries",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 228,
    Year: 2015,
    Plays: 34,
  },
  {
    Name: "The Kids Aren't Alright",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 260,
    Year: 2015,
    Plays: 48,
  },
  {
    Name: "Uma Thurman",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 211,
    Year: 2015,
    Plays: 37,
  },
  {
    Name: "Jet Pack Blues",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 179,
    Year: 2015,
    Plays: 30,
  },
  {
    Name: "Novocaine",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 226,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "Fourth of July",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 224,
    Year: 2015,
    Plays: 34,
  },
  {
    Name: "Favorite Record",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 203,
    Year: 2015,
    Plays: 42,
  },
  {
    Name: "Immortals",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 189,
    Year: 2015,
    Plays: 308,
  },
  {
    Name: "Twin Skeleton's (Hotel in NYC)",
    Artist: "Fall Out Boy",
    Album: "American Beauty/American Psycho",
    Time: 220,
    Year: 2015,
    Plays: 42,
  },
  {
    Name: "My Songs Know What You Did In the Dark (Light Em Up)",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 188,
    Year: 2013,
    Plays: 10,
  },
  {
    Name: "The Phoenix",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 244,
    Year: 2013,
    Plays: 9,
  },
  {
    Name: "Alone Together",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 203,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Young Volcanoes",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 204,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Centuries",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 231,
    Year: 2014,
    Plays: 7,
  },
  {
    Name: "Immortals",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 189,
    Year: 2014,
    Plays: 14,
  },
  {
    Name: "Uma Thurman",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 211,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "Irresistible",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 206,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Champion",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 192,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "The Last of the Real Ones",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 230,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Dear Future Self (Hands Up) [feat. Wyclef Jean]",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 171,
    Year: 2019,
    Plays: 25,
  },
  {
    Name: "Bob Dylan",
    Artist: "Fall Out Boy",
    Album: "Believers Never Die (Volume Two)",
    Time: 193,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Champion (Remix) [feat. RM]",
    Artist: "Fall Out Boy",
    Album: "Champion (Remix) [feat. RM] - Single",
    Time: 210,
    Year: 2017,
    Plays: 24,
  },
  {
    Name: "Disloyal Order of Water Buffaloes",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 257,
    Year: 2008,
    Plays: 5,
  },
  {
    Name: "I Don't Care",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 218,
    Year: 2008,
    Plays: 12,
  },
  {
    Name: "She's My Winona",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 231,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "America's Suitehearts",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 214,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Headfirst Slide Into Cooperstown On a Bad Bet",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 234,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "The (Shipped) Gold Standard",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 198,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Coffee's for Closers",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 275,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "What a Catch, Donnie",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 290,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "27",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 192,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Tiffany Blews",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 223,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "W.A.M.S.",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 278,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "20 Dollar Nose Bleed",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 257,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "West Coast Smoker",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 165,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "I Don't Care (Cobra Starship Suave Suarez Remix) [Bonus Track]",
    Artist: "Fall Out Boy",
    Album: "Folie à Deux (Deluxe Version)",
    Time: 191,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Our Lawyer Made Us Change the Name of This Song So We Wouldn't Get Sued",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 188,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Of All the Gin Joints In All the World",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 191,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Dance, Dance",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 180,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Sugar, We're Goin Down",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 229,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Nobody Puts Baby In the Corner",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 200,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "I've Got a Dark Alley and a Bad Idea That Says You Should Shut Your Mouth (Summer Song)",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 190,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "7 Minutes In Heaven (Atavan Halen)",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 182,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Sophmore Slump or Comeback of the Year",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 203,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Champagne for My Real Friends, Real Pain for My Sham Friends",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 203,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "I Slept With Someone In Fall Out Boy and All I Got Was This Stupid Song Written About Me",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 211,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: 'A Little Less Sixteen Candles, a Little More "Touch Me"',
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 169,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Get Busy Living or Get Busy Dying (Do Your Part to Save the Scene and Stop Going to Shows)",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 207,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "XO",
    Artist: "Fall Out Boy",
    Album: "From Under the Cork Tree",
    Time: 220,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Thriller",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 209,
    Year: 2007,
    Plays: 3,
  },
  {
    Name: "The Take Over, The Break's Over",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 213,
    Year: 2007,
    Plays: 3,
  },
  {
    Name: "This Ain't A Scene, It's An Arms Race",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 212,
    Year: 2007,
    Plays: 114,
  },
  {
    Name: "I'm Like A Lawyer With The Way I'm Always Trying To Get You Off (Me & You)",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 211,
    Year: 2007,
    Plays: 3,
  },
  {
    Name: "Hum Hallelujah",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 230,
    Year: 2007,
    Plays: 28,
  },
  {
    Name: "Golden",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 152,
    Year: 2007,
    Plays: 2,
  },
  {
    Name: "Thnks Fr Th Mmrs",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 203,
    Year: 2007,
    Plays: 10,
  },
  {
    Name: "Don't You Know Who I Think I Am?",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 172,
    Year: 2007,
    Plays: 3,
  },
  {
    Name: "The (After) Life Of The Party",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 201,
    Year: 2007,
    Plays: 2,
  },
  {
    Name: "The Carpal Tunnel Of Love",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 203,
    Year: 2007,
    Plays: 62,
  },
  {
    Name: "Bang The Doldrums",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 211,
    Year: 2007,
    Plays: 7,
  },
  {
    Name: "Fame < Infamy",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 186,
    Year: 2007,
    Plays: 4,
  },
  {
    Name: "You're Crashing, But You're No Wave",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 222,
    Year: 2007,
    Plays: 4,
  },
  {
    Name: "I've Got All This Ringing In My Ears And None On My Fingers",
    Artist: "Fall Out Boy",
    Album: "Infinity On High",
    Time: 246,
    Year: 2007,
    Plays: 4,
  },
  {
    Name: "Stay Frosty Royal Milk Tea",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 170,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "The Last of the Real Ones",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 230,
    Year: 2017,
    Plays: 48,
  },
  {
    Name: "HOLD ME TIGHT OR DON’T",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 210,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Wilson (Expensive Mistakes)",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 216,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Church",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 211,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Heaven’s Gate",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 225,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Champion",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 192,
    Year: 2017,
    Plays: 115,
  },
  {
    Name: "Sunshine Riptide (feat. Burna Boy)",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 204,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Young and Menace",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 223,
    Year: 2017,
    Plays: 151,
  },
  {
    Name: "Bishops Knife Trick",
    Artist: "Fall Out Boy",
    Album: "M A N I A",
    Time: 263,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Immortals (feat. Black Thought) [Remix]",
    Artist: "Fall Out Boy",
    Album: "Make America Psycho Again",
    Time: 245,
    Year: 2015,
    Plays: 11,
  },
  {
    Name: "The Phoenix",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 244,
    Year: null,
    Plays: 59,
  },
  {
    Name: "My Songs Know What You Did In the Dark (Light Em Up)",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 186,
    Year: 2013,
    Plays: 142,
  },
  {
    Name: "Alone Together",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 203,
    Year: 2013,
    Plays: 29,
  },
  {
    Name: "Where Did The Party Go",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 243,
    Year: 2013,
    Plays: 30,
  },
  {
    Name: "Just One Yesterday (ft. Foxes)",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 245,
    Year: 2013,
    Plays: 35,
  },
  {
    Name: "The Mighty Fall (ft. Big Sean)",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 213,
    Year: 2013,
    Plays: 40,
  },
  {
    Name: "Miss Missing You",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 211,
    Year: 2013,
    Plays: 28,
  },
  {
    Name: "Death Valley",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 227,
    Year: 2013,
    Plays: 32,
  },
  {
    Name: "Young Volcanoes",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 205,
    Year: 2013,
    Plays: 27,
  },
  {
    Name: "Save Rock and Roll (ft. Elton John)",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 282,
    Year: 2013,
    Plays: 42,
  },
  {
    Name: "Rat a Tat",
    Artist: "Fall Out Boy",
    Album: "Save Rock and Roll",
    Time: 243,
    Year: null,
    Plays: 14,
  },
  {
    Name: "Tell That Mick He Just Made My List Of Things To Do Today",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 210,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Dead On Arrival",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 194,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Grand Theft Autumn (Where Is Your Boy)",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 191,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Saturday",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 216,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Homesick At Space Camp",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 188,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Sending Postcards From A Plane Crash (Wish You Were Here)",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 176,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Chicago Is So Two Years Ago",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 199,
    Year: 2005,
    Plays: 3,
  },
  {
    Name: "The Pros And Cons Of Breathing",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 201,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Grenade Jumper",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 178,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Calm Before The Storm",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 267,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Reinventing The Wheel To Run Myself Over",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 141,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "The Patron Saint Of Liars And Fakes",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 200,
    Year: 2005,
    Plays: 4,
  },
  {
    Name: "Roxanne (Police Cover)",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 191,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Grand Theft Autumn (Remix)",
    Artist: "Fall Out Boy",
    Album: "Take This To Your Grave",
    Time: 228,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Coming Home",
    Artist: "Falling In Reverse",
    Album: "Coming Home (Deluxe Edition)",
    Time: 294,
    Year: 2016,
    Plays: 25,
  },
  {
    Name: "The Drug in Me Is Reimagined",
    Artist: "Falling In Reverse",
    Album: "The Drug in Me Is Reimagined - Single",
    Time: 340,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Drugs",
    Artist: "Falling In Reverse",
    Album: "Drugs - Single",
    Time: 231,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Losing My Life",
    Artist: "Falling In Reverse",
    Album: "Losing My Life - Single",
    Time: 299,
    Year: 2018,
    Plays: 21,
  },
  {
    Name: "Popular Monster",
    Artist: "Falling In Reverse",
    Album: "Popular Monster - Single",
    Time: 220,
    Year: 2019,
    Plays: 28,
  },
  {
    Name: "Body Language (feat. Ajebo Hustlers) [1]",
    Artist: "Falz",
    Album: "Body Language (feat. Ajebo Hustlers) - Single",
    Time: 147,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Bon Soir (feat. Olu Maintain)",
    Artist: "Falz",
    Album: "Bon Soir (feat. Olu Maintain) - Single",
    Time: 185,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "Bop Daddy (feat. Ms Banks)",
    Artist: "Falz",
    Album: "Bop Daddy (feat. Ms Banks) - Single",
    Time: 215,
    Year: 2020,
    Plays: 16,
  },
  {
    Name: "Girls (feat. Patoranking)",
    Artist: "Falz",
    Album: "Girls (feat. Patoranking) - Single",
    Time: 217,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Mercy",
    Artist: "Falz",
    Album: "Mercy - Single",
    Time: 140,
    Year: 2021,
    Plays: 33,
  },
  {
    Name: "Johnny",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 165,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Follow Follow",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 157,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Hypocrite (feat. Demmie Vee)",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 223,
    Year: 2019,
    Plays: 23,
  },
  {
    Name: "Talk",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 151,
    Year: 2019,
    Plays: 22,
  },
  {
    Name: "Amen",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 171,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Brother's Keeper (feat. SESS)",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 205,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Paper (feat. Chillz)",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 174,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "E No Finish",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 187,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "After All Said and Done",
    Artist: "Falz",
    Album: "Moral Instruction",
    Time: 53,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Something Light (feat. Ycee)",
    Artist: "Falz",
    Album: "Something Light (feat. Ycee) - Single",
    Time: 189,
    Year: 2017,
    Plays: 23,
  },
  {
    Name: "Kabiyesi (feat. Oyinkansola)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 222,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Soft Work",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 205,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "My People",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 262,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Karishika (feat. Phyno & Chigurl)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 253,
    Year: 2015,
    Plays: 27,
  },
  {
    Name: "Soldier (feat. Simi)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 204,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Workaholic",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 196,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Soupé (feat. Yemi Alade & Shaydee)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 226,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Clap (feat. Reminisce)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 196,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Time Difference (feat. SESS)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 221,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Mid-flight Announcement (Skit)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 81,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Celebrity Girlfriend (feat. Reekado Banks)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 185,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Chardonnay Music (feat. Poe & Chyn)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 276,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Kawosoke",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 188,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Love You Pass (feat. Bez)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 185,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Karishika, Pt. 2 (feat. M.I & Show Dem Camp)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 243,
    Year: 2015,
    Plays: 12,
  },
  {
    Name: "Everybody (Thank You)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 167,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Ello Bae (Bonus Track)",
    Artist: "Falz",
    Album: "Stories That Touch",
    Time: 216,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Sweet Boy",
    Artist: "Falz",
    Album: "Sweet Boy - Single",
    Time: 162,
    Year: 2018,
    Plays: 18,
  },
  {
    Name: "Polished",
    Artist: "Falz",
    Album: "27",
    Time: 186,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "La Fête",
    Artist: "Falz",
    Album: "27",
    Time: 186,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Alright (feat. Burna Boy)",
    Artist: "Falz",
    Album: "27",
    Time: 184,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Jeje",
    Artist: "Falz",
    Album: "27",
    Time: 210,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Child of the World",
    Artist: "Falz",
    Album: "27",
    Time: 267,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Boogie (feat. Sir Dauda)",
    Artist: "Falz",
    Album: "27",
    Time: 253,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "The Lamba Song",
    Artist: "Falz",
    Album: "27",
    Time: 196,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Get Me",
    Artist: "Falz",
    Album: "27",
    Time: 192,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Way (feat. Wande Coal)",
    Artist: "Falz",
    Album: "27",
    Time: 188,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "I Do It",
    Artist: "Falz",
    Album: "27",
    Time: 219,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Something Light (feat. Ycee)",
    Artist: "Falz",
    Album: "27",
    Time: 189,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Le Vrai Bahd Guy",
    Artist: "Falz",
    Album: "27",
    Time: 169,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "My Money (feat. Terry Apala)",
    Artist: "Falz",
    Album: "27",
    Time: 216,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Confirm (feat. Sir Dauda)",
    Artist: "Falz",
    Album: "27",
    Time: 226,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Next (feat. Maleek Berry & Medikal)",
    Artist: "Falz",
    Album: "27",
    Time: 203,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Wehdone Sir",
    Artist: "Falz",
    Album: "27",
    Time: 185,
    Year: 2017,
    Plays: 18,
  },
  {
    Name: "Bahd Baddo Baddest (feat. Olamide & Davido)",
    Artist: "Falz",
    Album: "27",
    Time: 230,
    Year: 2016,
    Plays: 20,
  },
  {
    Name: "Happier",
    Artist: "Fame on Fire",
    Album: "Happier - Single",
    Time: 211,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Scars of Love",
    Artist: "Fame on Fire",
    Album: "LEVELS - Deluxe",
    Time: 193,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Without Me",
    Artist: "Fame on Fire",
    Album: "Without Me - Single",
    Time: 229,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Like A G6",
    Artist: "Far East Movement",
    Album: "Like A G6 (Single)",
    Time: 219,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Live My Life (Feat. Justin Bieber & RedFoo) (Party Rock Remix)",
    Artist: "Far East Movement",
    Album: "Step Up Revolution",
    Time: 255,
    Year: 2012,
    Plays: 14,
  },
  {
    Name: "Turn up (Flex Ju)",
    Artist: "Faridah",
    Album: "The Men's Club Original Soundtrack",
    Time: 201,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Baby Riddim",
    Artist: "Fave",
    Album: "Baby Riddim - Single",
    Time: 190,
    Year: 2021,
    Plays: 26,
  },
  {
    Name: "Beautifully",
    Artist: "Fave",
    Album: "Beautifully - Single",
    Time: 169,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Kolomental",
    Artist: "Faze",
    Album: "Independent",
    Time: 278,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "Just Awake",
    Artist: "Fear,and Loathing in Las Vegas",
    Album: "Just Awake",
    Time: 219,
    Year: 2012,
    Plays: 11,
  },
  {
    Name: "Coffin For Head of State, Pt. 1 & 2",
    Artist: "Fela Kuti",
    Album: "Coffin For Head of State, Pt. 1 & 2",
    Time: 1362,
    Year: 1980,
    Plays: 1,
  },
  {
    Name: "Shuffering and Shmiling, Pt. 1 & 2",
    Artist: "Fela Kuti",
    Album: "Shuffering and Shmiling",
    Time: 1293,
    Year: 1977,
    Plays: 1,
  },
  {
    Name: "Zombie",
    Artist: "Fela Kuti",
    Album: "Zombie",
    Time: 745,
    Year: 1976,
    Plays: 2,
  },
  {
    Name: "SICKO (feat. GASHI & FAANGS)",
    Artist: "Felix Jaehn",
    Album: "SICKO (feat. GASHI & FAANGS) - Single",
    Time: 157,
    Year: 2020,
    Plays: 83,
  },
  {
    Name: "Own Brand Freestyle (feat. Finch Fetti)",
    Artist: "FelixThe1st & Dréya Mac",
    Album: "Own Brand Freestyle (feat. Finch Fetti) - Single",
    Time: 153,
    Year: 2021,
    Plays: 22,
  },
  {
    Name: "Feel Alive (Feat. Pitbull & DJ Poet) (Revolution Remix)",
    Artist: "Fergie",
    Album: "Step Up Revolution",
    Time: 248,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Trap Queen",
    Artist: "Fetty Wap",
    Album: "Fetty Wap (Deluxe Edition)",
    Time: 222,
    Year: 2014,
    Plays: 20,
  },
  {
    Name: "KINGDOM",
    Artist: "FEVER 333",
    Album: "KINGDOM - Single",
    Time: 205,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "SUPREMACY",
    Artist: "FEVER 333",
    Album: "SUPREMACY - Single",
    Time: 174,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Undone",
    Artist: "FFH",
    Album: "Undone - Single",
    Time: 282,
    Year: 2010,
    Plays: 5,
  },
  {
    Name: "Undone",
    Artist: "FFH",
    Album: "",
    Time: 282,
    Year: 2009,
    Plays: 88,
  },
  {
    Name: "Work from Home (feat. Ty Dolla $ign)",
    Artist: "Fifth Harmony",
    Album: "7/27 (Deluxe)",
    Time: 214,
    Year: 2016,
    Plays: 5,
  },
  {
    Name: "Claudia",
    Artist: "FINNEAS",
    Album: "Claudia - Single",
    Time: 161,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "God Only Knows",
    Artist: "Fireboy DML",
    Album: "APOLLO",
    Time: 191,
    Year: 2020,
    Plays: 18,
  },
  {
    Name: "Vibration",
    Artist: "Fireboy DML",
    Album: "Laughter, Tears & Goosebumps",
    Time: 198,
    Year: 2019,
    Plays: 63,
  },
  {
    Name: "Scatter",
    Artist: "Fireboy DML",
    Album: "Laughter, Tears & Goosebumps",
    Time: 164,
    Year: 2019,
    Plays: 82,
  },
  {
    Name: "Like I Do",
    Artist: "Fireboy DML",
    Album: "Laughter, Tears & Goosebumps",
    Time: 232,
    Year: 2018,
    Plays: 14,
  },
  {
    Name: "Peru",
    Artist: "Fireboy DML",
    Album: "Peru - Single",
    Time: 151,
    Year: 2021,
    Plays: 24,
  },
  {
    Name: "Scatter (Acoustic)",
    Artist: "Fireboy DML",
    Album: "Scatter (Acoustic) - Single",
    Time: 186,
    Year: 2020,
    Plays: 50,
  },
  {
    Name: "Champion",
    Artist: "Fireboy DML & D Smoke",
    Album: "APOLLO",
    Time: 179,
    Year: 2019,
    Plays: 88,
  },
  {
    Name: "Peru",
    Artist: "Fireboy DML & Ed Sheeran",
    Album: "Peru - Single",
    Time: 187,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Spell",
    Artist: "Fireboy DML & Wande Coal",
    Album: "APOLLO",
    Time: 173,
    Year: 2020,
    Plays: 19,
  },
  {
    Name: "When Everything Means Nothing",
    Artist: "Fit for a King",
    Album: "Dark Skies",
    Time: 231,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Sham Pain",
    Artist: "Five Finger Death Punch",
    Album: "And Justice for None (Deluxe)",
    Time: 209,
    Year: 2018,
    Plays: 25,
  },
  {
    Name: "Blue on Black",
    Artist: "Five Finger Death Punch",
    Album: "And Justice for None (Deluxe)",
    Time: 274,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Blue on Black (feat. Kenny Wayne Shepherd, Brantley Gilbert & Brian May)",
    Artist: "Five Finger Death Punch",
    Album:
      "Blue on Black (feat. Kenny Wayne Shepherd, Brantley Gilbert & Brian May) - Single",
    Time: 274,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Gone Away",
    Artist: "Five Finger Death Punch",
    Album: "A Decade of Destruction",
    Time: 275,
    Year: 2017,
    Plays: 34,
  },
  {
    Name: "Wrong Side of Heaven",
    Artist: "Five Finger Death Punch",
    Album: "A Decade of Destruction",
    Time: 271,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "My Nemesis",
    Artist: "Five Finger Death Punch",
    Album: "A Decade of Destruction",
    Time: 215,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Blue on Black",
    Artist: "Five Finger Death Punch",
    Album: "A Decade of Destruction, Vol. 2",
    Time: 274,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "A Little Bit Off",
    Artist: "Five Finger Death Punch",
    Album: "F8",
    Time: 190,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Brighter Side of Grey",
    Artist: "Five Finger Death Punch",
    Album: "F8",
    Time: 269,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "White Knuckles",
    Artist: "Five Finger Death Punch",
    Album: "The Way of the Fist",
    Time: 249,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Till Death",
    Artist: "Fivefold",
    Album: "Hold On - EP",
    Time: 303,
    Year: 2013,
    Plays: 24,
  },
  {
    Name: "Step Back",
    Artist: "Fivefold",
    Album: "Hold On - EP",
    Time: 223,
    Year: 2013,
    Plays: 12,
  },
  {
    Name: "Dear God (feat. Kevin Gates)",
    Artist: "FL Dusa",
    Album: "Dear God (feat. Kevin Gates) - Single",
    Time: 181,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Levels",
    Artist: "Flavour",
    Album: "Levels - Single",
    Time: 196,
    Year: 2021,
    Plays: 13,
  },
  {
    Name: "Undrunk",
    Artist: "FLETCHER",
    Album: "You Ruined New York City for Me - EP",
    Time: 183,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Love and War",
    Artist: "Fleurie",
    Album: "Love and War",
    Time: 315,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "The Breakdown",
    Artist: "Flight Paths",
    Album: "The Breakdown - Single",
    Time: 238,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Downpour",
    Artist: "Flight Paths",
    Album: "Downpour - Single",
    Time: 248,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Motion & Side Effects",
    Artist: "Flight Paths",
    Album: "Motion & Side Effects - Single",
    Time: 254,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Parachute",
    Artist: "Flight Paths",
    Album: "Parachute - Single",
    Time: 217,
    Year: 2019,
    Plays: 9,
  },
  {
    Name: "Rapture Day",
    Artist: "Flight Paths",
    Album: "Rapture Day - Single",
    Time: 222,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Leave Me Alone",
    Artist: "Flipp Dinero",
    Album: "Leave Me Alone - Single",
    Time: 195,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Low (feat. T-Pain)",
    Artist: "Flo Rida",
    Album: "Low (feat. T-Pain) - Single",
    Time: 231,
    Year: 2007,
    Plays: 166,
  },
  {
    Name: "Through the Summer Fields",
    Artist: "Floating Lights",
    Album: "Landscapes Below - EP",
    Time: 328,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Ghost (feat. Sincerely Collins) [Radio Edit]",
    Artist: "Floowood",
    Album: "Inferno (Descent)",
    Time: 230,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Yoru Wa Nemurerukai?",
    Artist: "flumpool",
    Album: "Yoru Wa Nemurerukai? - EP",
    Time: 227,
    Year: 2016,
    Plays: 15,
  },
  {
    Name: "Blame It On the Boogie",
    Artist: "The Footnotes",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 52,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Unstoppable",
    Artist: "For the Fallen Dreams",
    Album: "Six",
    Time: 244,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Judas",
    Artist: "Fozzy",
    Album: "Judas",
    Time: 250,
    Year: 2017,
    Plays: 18,
  },
  {
    Name: "Omemma",
    Artist: "Frank Edwards",
    Album: "Definition",
    Time: 323,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "You Too Dey Bless Me (Remix) [feat. Tbi]",
    Artist: "Frank Edwards",
    Album: "Unlimited Verse 2",
    Time: 307,
    Year: 2011,
    Plays: 7,
  },
  {
    Name: "Street Fighter",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 22,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Strawberry Swing",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 235,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Novacane",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 302,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "We All Try",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 171,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Bitches Talkin'",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 22,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Songs For Women",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 253,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Lovecrimes",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 240,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Goldeneye",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 18,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "There Will Be Tears",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 194,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Swim Good",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 256,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Dust",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 153,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "American Wedding",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 420,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Soul Calibur",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 18,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Nature Feels",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 224,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Pyrite (Fool's Gold) (Rapblog Bonus Track)",
    Artist: "Frank Ocean",
    Album: "Nostalgia, Ultra",
    Time: 246,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Witchcraft (Remastered)",
    Artist: "Frank Sinatra",
    Album: "Fifty Shades of Grey",
    Time: 171,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Trouble",
    Artist: "The Franklin Electric",
    Album: "In Your Head / In Your Heart",
    Time: 230,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Netflix & Chill",
    Artist: "Fredo",
    Album: "Netflix & Chill - Single",
    Time: 221,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Pop That (feat. Rick Ross, Drake & Lil Wayne)",
    Artist: "French Montana",
    Album: "Excuse My French (Deluxe)",
    Time: 303,
    Year: 2012,
    Plays: 21,
  },
  {
    Name: "Unforgettable (feat. Swae Lee)",
    Artist: "French Montana",
    Album: "German Top 100 Single Charts",
    Time: 233,
    Year: 2017,
    Plays: 20,
  },
  {
    Name: "If I Go Down (from the film National Champions)",
    Artist: "French Montana",
    Album: "If I Go Down (from the film National Champions) - Single",
    Time: 212,
    Year: 2021,
    Plays: 18,
  },
  {
    Name: "Famous",
    Artist: "French Montana",
    Album: "Jungle Rules",
    Time: 244,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "50's & 100's (feat. Juicy J)",
    Artist: "French Montana",
    Album: "MONTANA",
    Time: 161,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Breaking Now",
    Artist: "From Ashes to New",
    Album: "Day One",
    Time: 210,
    Year: 2016,
    Plays: 40,
  },
  {
    Name: "Crazy",
    Artist: "From Ashes to New",
    Album: "The Future",
    Time: 185,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Heartache",
    Artist: "From Ashes to New",
    Album: "Heartache - Single",
    Time: 225,
    Year: 2022,
    Plays: 14,
  },
  {
    Name: "Panic",
    Artist: "From Ashes to New",
    Album: "Panic",
    Time: 200,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Bulletproof",
    Artist: "From Ashes to New",
    Album: "Panic",
    Time: 207,
    Year: 2020,
    Plays: 19,
  },
  {
    Name: "Panic",
    Artist: "From Ashes to New",
    Album: "Panic - Single",
    Time: 200,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Wait for Me (feat. Trevor Mcnevan of Thousand Foot Krutch)",
    Artist: "From Ashes to New",
    Album: "Quarantine Chronicles Vol. 3 - EP",
    Time: 189,
    Year: 2021,
    Plays: 14,
  },
  {
    Name: "Famous Last Words",
    Artist: "From Fall to Spring",
    Album: "Disconnected - EP",
    Time: 197,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "I Need to Feel Alive",
    Artist: "From Inside",
    Album: "When I'm Breathing Without You - EP",
    Time: 196,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Ready Or Not",
    Artist: "Fugees",
    Album: "The Score",
    Time: 227,
    Year: 1996,
    Plays: 3,
  },
  {
    Name: "We Are Young (feat. Janelle Monáe)",
    Artist: "Fun.",
    Album: "We Are Young (feat. Janelle Monáe) - Single",
    Time: 250,
    Year: 2011,
    Plays: 13,
  },
  {
    Name: "(Not Just) Knee Deep",
    Artist: "Funkadelic",
    Album: "Straight Outta Compton",
    Time: 269,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "31 DAYS",
    Artist: "Future",
    Album: "BEASTMODE 2",
    Time: 240,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Thought It Was a Drought",
    Artist: "Future",
    Album: "DS2 (Deluxe)",
    Time: 265,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Where Ya At (feat. Drake)",
    Artist: "Future",
    Album: "DS2 (Deluxe)",
    Time: 208,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Stick Talk",
    Artist: "Future",
    Album: "DS2 (Deluxe)",
    Time: 171,
    Year: 2015,
    Plays: 44,
  },
  {
    Name: "Rotation",
    Artist: "Future",
    Album: "DS2 (Deluxe)",
    Time: 167,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Slave Master",
    Artist: "Future",
    Album: "DS2 (Deluxe)",
    Time: 199,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Blow a Bag",
    Artist: "Future",
    Album: "DS2 (Deluxe)",
    Time: 194,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Real Sisters",
    Artist: "Future",
    Album: "DS2 (Deluxe)",
    Time: 174,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "F*ck Up Some Commas",
    Artist: "Future",
    Album: "DS2 (Deluxe)",
    Time: 237,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "Mask Off",
    Artist: "Future",
    Album: "FUTURE",
    Time: 204,
    Year: 2017,
    Plays: 21,
  },
  {
    Name: "When I Was Broke",
    Artist: "Future",
    Album: "FUTURE",
    Time: 185,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "Afterlife",
    Artist: "Future",
    Album: "Future & Juice WRLD Present... WRLD ON DRUGS",
    Time: 214,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Transformer (feat. Nicki Minaj)",
    Artist: "Future",
    Album: "Future & Juice WRLD Present... WRLD ON DRUGS",
    Time: 196,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Never Stop",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 291,
    Year: 2019,
    Plays: 226,
  },
  {
    Name: "Temptation",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 167,
    Year: 2019,
    Plays: 11,
  },
  {
    Name: "Promise U That",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 205,
    Year: 2019,
    Plays: 17,
  },
  {
    Name: "Unicorn Purp (feat. Young Thug & Gunna)",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 246,
    Year: 2019,
    Plays: 67,
  },
  {
    Name: "Goin Dummi",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 161,
    Year: 2019,
    Plays: 15,
  },
  {
    Name: "First Off (feat. Travis Scott)",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 228,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Faceshot",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 175,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Ain't Coming Back",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 219,
    Year: 2019,
    Plays: 14,
  },
  {
    Name: "Tricks on Me",
    Artist: "Future",
    Album: "Future Hndrxx Presents: The WIZRD",
    Time: 262,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "Trapped in the Sun",
    Artist: "Future",
    Album: "High Off Life",
    Time: 201,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "HiTek Tek",
    Artist: "Future",
    Album: "High Off Life",
    Time: 182,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Touch the Sky",
    Artist: "Future",
    Album: "High Off Life",
    Time: 144,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Solitaires (feat. Travis Scott)",
    Artist: "Future",
    Album: "High Off Life",
    Time: 205,
    Year: 2020,
    Plays: 33,
  },
  {
    Name: "Ridin Strikers",
    Artist: "Future",
    Album: "High Off Life",
    Time: 225,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "One of My",
    Artist: "Future",
    Album: "High Off Life",
    Time: 142,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Posted with Demons",
    Artist: "Future",
    Album: "High Off Life",
    Time: 189,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Hard to Choose One",
    Artist: "Future",
    Album: "High Off Life",
    Time: 193,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Trillionaire (feat. YoungBoy Never Broke Again)",
    Artist: "Future",
    Album: "High Off Life",
    Time: 167,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Harlem Shake (feat. Young Thug)",
    Artist: "Future",
    Album: "High Off Life",
    Time: 148,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Up the River",
    Artist: "Future",
    Album: "High Off Life",
    Time: 189,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Pray for a Key",
    Artist: "Future",
    Album: "High Off Life",
    Time: 173,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Too Comfortable",
    Artist: "Future",
    Album: "High Off Life",
    Time: 236,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "All Bad (feat. Lil Uzi Vert)",
    Artist: "Future",
    Album: "High Off Life",
    Time: 207,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Outer Space Bih",
    Artist: "Future",
    Album: "High Off Life",
    Time: 175,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Accepting My Flaws",
    Artist: "Future",
    Album: "High Off Life",
    Time: 259,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Life Is Good (feat. Drake)",
    Artist: "Future",
    Album: "High Off Life",
    Time: 237,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Last Name (feat. Lil Durk)",
    Artist: "Future",
    Album: "High Off Life",
    Time: 208,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Tycoon",
    Artist: "Future",
    Album: "High Off Life",
    Time: 201,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "100 Shooters (feat. Meek Mill & Doe Boy)",
    Artist: "Future",
    Album: "High Off Life",
    Time: 208,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Life Is Good (Remix) [feat. Drake, DaBaby & Lil Baby]",
    Artist: "Future",
    Album: "High Off Life",
    Time: 314,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "My Collection",
    Artist: "Future",
    Album: "HNDRXX",
    Time: 255,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "Comin Out Strong (feat. The Weeknd)",
    Artist: "Future",
    Album: "HNDRXX",
    Time: 254,
    Year: 2017,
    Plays: 16,
  },
  {
    Name: "Damage",
    Artist: "Future",
    Album: "HNDRXX",
    Time: 237,
    Year: 2017,
    Plays: 12,
  },
  {
    Name: "Fresh Air",
    Artist: "Future",
    Album: "HNDRXX",
    Time: 270,
    Year: 2017,
    Plays: 14,
  },
  {
    Name: "Neva Missa Lost",
    Artist: "Future",
    Album: "HNDRXX",
    Time: 238,
    Year: 2017,
    Plays: 11,
  },
  {
    Name: "I Thank U",
    Artist: "Future",
    Album: "HNDRXX",
    Time: 141,
    Year: 2017,
    Plays: 14,
  },
  {
    Name: "Turn on Me",
    Artist: "Future",
    Album: "HNDRXX",
    Time: 264,
    Year: 2017,
    Plays: 13,
  },
  {
    Name: "Move That Dope (feat. Pharrell, Pusha T & Casino)",
    Artist: "Future",
    Album: "Honest (Deluxe)",
    Time: 340,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "Honest",
    Artist: "Future",
    Album: "Honest (Deluxe)",
    Time: 200,
    Year: 2013,
    Plays: 30,
  },
  {
    Name: "Never Satisfied (feat. Drake)",
    Artist: "Future",
    Album: "Honest (Deluxe)",
    Time: 115,
    Year: 2014,
    Plays: 15,
  },
  {
    Name: "Benz Friendz (Whatchutola) [feat. André 3000]",
    Artist: "Future",
    Album: "Honest (Deluxe)",
    Time: 281,
    Year: 2014,
    Plays: 17,
  },
  {
    Name: "Sh!t",
    Artist: "Future",
    Album: "Honest (Deluxe)",
    Time: 289,
    Year: 2013,
    Plays: 27,
  },
  {
    Name: "LOVE YOU BETTER",
    Artist: "Future",
    Album: "I NEVER LIKED YOU",
    Time: 129,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Life Is Good (feat. Drake)",
    Artist: "Future",
    Album: "Life Is Good (feat. Drake) - Single",
    Time: 237,
    Year: 2020,
    Plays: 9,
  },
  {
    Name: "Hardly",
    Artist: "Future",
    Album: "Monster",
    Time: 157,
    Year: 2014,
    Plays: 17,
  },
  {
    Name: "Mad Luv",
    Artist: "Future",
    Album: "Monster",
    Time: 183,
    Year: 2015,
    Plays: 11,
  },
  {
    Name: "Codeine Crazy",
    Artist: "Future",
    Album: "Monster",
    Time: 346,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "Turn On the Lights",
    Artist: "Future",
    Album: "Pluto 3D",
    Time: 248,
    Year: 2012,
    Plays: 13,
  },
  {
    Name: "Same Damn Time (Remix) [feat. Diddy & Ludacris]",
    Artist: "Future",
    Album: "Pluto 3D",
    Time: 273,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Tony Montana (feat. Drake)",
    Artist: "Future",
    Album: "Pluto 3D",
    Time: 245,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Magic (feat. T.I.) [remix]",
    Artist: "Future",
    Album: "Pluto 3D",
    Time: 210,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Rockstar Chainz",
    Artist: "Future",
    Album: "Pluto x Baby Pluto",
    Time: 181,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "All Right",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 145,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Never Forget",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 199,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Inside the Mattress",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 210,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Drippin (How U Luv That)",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 190,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Hater Shit",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 184,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Salute",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 225,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Bye Bye",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 175,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "No Charge",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 162,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Run Up",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 197,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Perkys Calling",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 246,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Purple Reign",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 241,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "News or Something",
    Artist: "Future",
    Album: "Purple Reign",
    Time: 213,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "XanaX Damage",
    Artist: "Future",
    Album: "SAVE ME",
    Time: 104,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Government Official",
    Artist: "Future",
    Album: "SAVE ME",
    Time: 150,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "What's Up With That (feat. 21 Savage)",
    Artist: "Future",
    Album: "SUPERFLY (Original Motion Picture Soundtrack)",
    Time: 182,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "March Madness",
    Artist: "Future",
    Album: "56 Nights",
    Time: 243,
    Year: 2015,
    Plays: 76,
  },
  {
    Name: "Stripes Like Burberry",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 274,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Marni on Me",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 133,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Sleeping on the Floor",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 167,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Real Baby Pluto",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 196,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Drankin N Smokin",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 213,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Million Dollar Play",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 166,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Plastic",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 193,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "That's It",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 228,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Bought a Bad Bitch",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 210,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "She Never Been to Pluto",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 204,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Off Dat",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 184,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "I Don't Wanna Break Up",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 243,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Bankroll",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 186,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Moment of Clarity",
    Artist: "Future & Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 222,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "No Limit (feat. A$AP Rocky & Cardi B)",
    Artist: "G-Eazy",
    Album: "The Beautiful & Damned",
    Time: 245,
    Year: 2017,
    Plays: 128,
  },
  {
    Name: "Scary Nights",
    Artist: "G-Eazy",
    Album: "Scary Nights",
    Time: 236,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Him & I",
    Artist: "G-Eazy & Halsey",
    Album: "The Beautiful & Damned",
    Time: 268,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "To The World (feat. Kanye West & R. Kelly)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 231,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Clique (feat. Big Sean, Jay-Z & Kanye West)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 293,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Mercy (feat. Kanye West, Big Sean, Pusha T & 2 Chainz)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 332,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "New God Flow (feat. Pusha T & Kanye West)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 294,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The Morning (feat. Pusha T, Common, CyHi Da Prynce, Kid Cudi, D'banj, Raekwon & 2 Chainz)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 275,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Cold (feat. Kanye West & DJ Khaled)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 155,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Higher (feat. Pusha T, Mase & The-Dream)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 274,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Sin City (feat. John Legend, Teyana Taylor, CyHi Da Prynce, Malik Yusef & Travis Scott)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 268,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The One (feat. Kanye West, Big Sean, 2 Chainz & Marsha Ambrosius",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 344,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Creepers (feat. Kid Cudi)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 194,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Bliss (feat. John Legend & Teyana Taylor)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 210,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "I Don't Like (Remix) (feat. Kanye West, Pusha T, Chief Keef, Big Sean & Jadakiss)",
    Artist: "G.O.O.D. Music",
    Album: "Cruel Summer",
    Time: 291,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Sleep On It",
    Artist: "Gallant",
    Album: "Sweet Insomnia",
    Time: 216,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Red Nation (feat. Lil Wayne)",
    Artist: "The Game",
    Album: "The R.E.D. Album",
    Time: 229,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Achilles Come Down",
    Artist: "Gang of Youths",
    Album: "Go Farther in Lightness",
    Time: 422,
    Year: 2017,
    Plays: 5,
  },
  {
    Name: "Resurrection",
    Artist: "Gank",
    Album: "Resurrection - Single",
    Time: 143,
    Year: 2019,
    Plays: 10,
  },
  {
    Name: "Come Together",
    Artist: "Gary Clark Jr. & Junkie XL",
    Album: "Come Together - Single",
    Time: 193,
    Year: 2017,
    Plays: 6,
  },
  {
    Name: "Telemo (feat. Capasta)",
    Artist: "Gasmilla",
    Album: "Telemo (feat. Capasta) - Single",
    Time: 254,
    Year: 2015,
    Plays: 77,
  },
  {
    Name: "Fire",
    Artist: "Gavin DeGraw",
    Album: "Finest Hour: The Best of Gavin DeGraw",
    Time: 228,
    Year: 2014,
    Plays: 36,
  },
  {
    Name: "abcdefu",
    Artist: "GAYLE",
    Album: "abcdefu - Single",
    Time: 168,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Remember We Die",
    Artist: "Gemini Syndrome",
    Album: "Memento Mori",
    Time: 225,
    Year: 2016,
    Plays: 21,
  },
  {
    Name: "Si No Vuelves",
    Artist: "Gente de Zona",
    Album: "OTRA COSA",
    Time: 215,
    Year: 2017,
    Plays: 111,
  },
  {
    Name: "Algo Contigo",
    Artist: "Gente de Zona",
    Album: "Visualízate",
    Time: 210,
    Year: 2016,
    Plays: 12,
  },
  {
    Name: "Hunter’s Moon (From HALLOWEEN KILLS)",
    Artist: "Ghost",
    Album: "Hunter's Moon - Single",
    Time: 196,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Square Hammer",
    Artist: "Ghost",
    Album: "Meliora (Deluxe Edition)",
    Time: 239,
    Year: 2015,
    Plays: 45,
  },
  {
    Name: "Rats",
    Artist: "Ghost",
    Album: "Prequelle",
    Time: 261,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Dance Macabre",
    Artist: "Ghost",
    Album: "Prequelle",
    Time: 219,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "In Those Jeans",
    Artist: "Ginuwine",
    Album: "The Senior",
    Time: 243,
    Year: 2003,
    Plays: 4,
  },
  {
    Name: "I Stand Alone",
    Artist: "Godsmack",
    Album: "Faceless",
    Time: 246,
    Year: 2002,
    Plays: 1,
  },
  {
    Name: "When Legends Rise",
    Artist: "Godsmack",
    Album: "When Legends Rise",
    Time: 172,
    Year: 2018,
    Plays: 59,
  },
  {
    Name: "Eye of the Storm",
    Artist: "Godsmack",
    Album: "When Legends Rise",
    Time: 201,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Original Beast",
    Artist: "Grace Jones",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 261,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Blood // Water",
    Artist: "grandson",
    Album: "a modern tragedy, vol. 1 - EP",
    Time: 214,
    Year: 2017,
    Plays: 15,
  },
  {
    Name: "Riptide",
    Artist: "grandson",
    Album: "Riptide - Single",
    Time: 192,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "The Other self",
    Artist: "GRANRODEO",
    Album: "The Other self",
    Time: 281,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "My Greater Cause",
    Artist: "Green Carnation",
    Album: "My Greater Cause (Single)",
    Time: 457,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Jesus of Suburbia",
    Artist: "Green Day",
    Album: "American Idiot",
    Time: 548,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "Holiday",
    Artist: "Green Day",
    Album: "American Idiot",
    Time: 232,
    Year: 2004,
    Plays: 1,
  },
  {
    Name: "Boulevard of Broken Dreams",
    Artist: "Green Day",
    Album: "American Idiot",
    Time: 260,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "She's a Rebel",
    Artist: "Green Day",
    Album: "American Idiot",
    Time: 120,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "99 Revolutions (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 246,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Angel Blue (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 175,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Carpe Diem (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 219,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "State Of Shock ",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 147,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Let Yourself Go (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 179,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Sex, Drugs And Violence (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 205,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Ashley (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 167,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Fell For You (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 192,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Stay The Night (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 280,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Nuclear Family (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 183,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Stray Heart (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 230,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Rusty James (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 254,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "A Little Boy Named Train (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 237,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Baby Eyes (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 135,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Makeout Party (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 192,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Oh Love (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 313,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Missing You (Demo)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 221,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Stay The Night (Acoustic)",
    Artist: "Green Day",
    Album: "Demolicious",
    Time: 189,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "black on black",
    Artist: "Greyson Chance",
    Album: "portraits",
    Time: 203,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Medieval Warfare",
    Artist: "Grimes",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 181,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Curve (feat. The Weeknd)",
    Artist: "Gucci Mane",
    Album: "Mr. Davis",
    Time: 161,
    Year: 2017,
    Plays: 15,
  },
  {
    Name: "Richer Than Errybody (feat. YoungBoy Never Broke Again & DaBaby)",
    Artist: "Gucci Mane",
    Album:
      "Richer Than Errybody (feat. YoungBoy Never Broke Again & DaBaby) - Single",
    Time: 239,
    Year: 2019,
    Plays: 24,
  },
  {
    Name: "Wasted (Remix) BONUS",
    Artist: "Gucci Mane Ft. Lil Wayne, Jadakiss, And Birdman",
    Album: "No Ceilings",
    Time: 277,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Wake Up in the Sky",
    Artist: "Gucci Mane, Bruno Mars & Kodak Black",
    Album: "Wake Up in the Sky - Single",
    Time: 204,
    Year: 2018,
    Plays: 135,
  },
  {
    Name: "Akwaaba (feat. Pappy Kojo & Patapaa)",
    Artist: "GuiltyBeatz & Mr Eazi",
    Album: "Akwaaba (feat. Pappy Kojo & Patapaa) - Single",
    Time: 206,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "Pilolo",
    Artist: "GuiltyBeatz, Mr Eazi & Kwesi Arthur",
    Album: "Pilolo - Single",
    Time: 145,
    Year: 2019,
    Plays: 17,
  },
  {
    Name: "pushin P (feat. Young Thug)",
    Artist: "Gunna & Future",
    Album: "DRIP SEASON 4EVER",
    Time: 136,
    Year: 2022,
    Plays: 9,
  },
  {
    Name: "Stereo Hearts (feat. Adam Levine)",
    Artist: "Gym Class Heroes",
    Album: "The Papercut Chronicles II",
    Time: 210,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Come Clean",
    Artist: "H.e.a.t",
    Album: "H.E.A.T II",
    Time: 223,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "What Is Love",
    Artist: "Haddaway",
    Album: "What Is Love",
    Time: 270,
    Year: 1993,
    Plays: 3,
  },
  {
    Name: "Go Go Power Rangers - End Titles",
    Artist: "Haim Saban, Shuki Levy & Brian Tyler",
    Album: "Power Rangers (Original Motion Picture Soundtrack)",
    Time: 182,
    Year: 2017,
    Plays: 43,
  },
  {
    Name: "Back From The Dead (Unplugged)",
    Artist: "Halestorm",
    Album: "Back From The Dead (Unplugged) - Single",
    Time: 216,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Break In (feat. Amy Lee)",
    Artist: "Halestorm",
    Album: "Break In (feat. Amy Lee) - Single",
    Time: 294,
    Year: 2020,
    Plays: 33,
  },
  {
    Name: "I Get Off",
    Artist: "Halestorm",
    Album: "Halestorm (Bonus Track Version)",
    Time: 183,
    Year: 2009,
    Plays: 6,
  },
  {
    Name: "I Am the Fire",
    Artist: "Halestorm",
    Album: "Into the Wild Life (Deluxe)",
    Time: 217,
    Year: 2015,
    Plays: 11,
  },
  {
    Name: "Amen",
    Artist: "Halestorm",
    Album: "Into the Wild Life (Deluxe)",
    Time: 178,
    Year: 2015,
    Plays: 51,
  },
  {
    Name: "Apocalyptic",
    Artist: "Halestorm",
    Album: "Into the Wild Life (Deluxe)",
    Time: 193,
    Year: 2015,
    Plays: 17,
  },
  {
    Name: "Break In (feat. Amy Lee)",
    Artist: "Halestorm",
    Album: "Reimagined - EP",
    Time: 294,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Daughters of Darkness",
    Artist: "Halestorm",
    Album: "The Strange Case Of...",
    Time: 235,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Black Vultures",
    Artist: "Halestorm",
    Album: "Vicious",
    Time: 250,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Do Not Disturb",
    Artist: "Halestorm",
    Album: "Vicious",
    Time: 203,
    Year: 2018,
    Plays: 77,
  },
  {
    Name: "Killing Ourselves to Live",
    Artist: "Halestorm",
    Album: "Vicious",
    Time: 240,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Vicious",
    Artist: "Halestorm",
    Album: "Vicious",
    Time: 181,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "Castle",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 277,
    Year: 2015,
    Plays: 96,
  },
  {
    Name: "Hold Me Down",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 204,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "New Americana",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 183,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "Drive",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 258,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Hurricane",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 223,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Roman Holiday",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 201,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Ghost",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 153,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Colors",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 249,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "Colors pt. II",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 96,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Strange Love",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 247,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Coming Down",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 223,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Haunting",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 260,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Gasoline",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 199,
    Year: 2015,
    Plays: 52,
  },
  {
    Name: "Control",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 214,
    Year: 2015,
    Plays: 117,
  },
  {
    Name: "Young God",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 180,
    Year: 2015,
    Plays: 15,
  },
  {
    Name: "I Walk The Line",
    Artist: "Halsey",
    Album: "BADLANDS (Deluxe Edition)",
    Time: 165,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Castle (Live From Webster Hall)",
    Artist: "Halsey",
    Album: "BADLANDS (Live From Webster Hall)",
    Time: 274,
    Year: 2020,
    Plays: 36,
  },
  {
    Name: "Control (Live From Webster Hall)",
    Artist: "Halsey",
    Album: "BADLANDS (Live From Webster Hall)",
    Time: 233,
    Year: 2020,
    Plays: 40,
  },
  {
    Name: "Devil In Me",
    Artist: "Halsey",
    Album: "hopeless fountain kingdom (Deluxe)",
    Time: 249,
    Year: 2017,
    Plays: 34,
  },
  {
    Name: "The Tradition",
    Artist: "Halsey",
    Album: "If I Can’t Have Love, I Want Power",
    Time: 226,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "You asked for this",
    Artist: "Halsey",
    Album: "If I Can’t Have Love, I Want Power",
    Time: 265,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Without Me",
    Artist: "Halsey",
    Album: "Manic",
    Time: 201,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Nightmare",
    Artist: "Halsey",
    Album: "Nightmare - Single",
    Time: 231,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Without Me",
    Artist: "Halsey",
    Album: "Without Me - Single",
    Time: 201,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "Alanis' Interlude",
    Artist: "Halsey & Alanis Morissette",
    Album: "Manic",
    Time: 161,
    Year: 2020,
    Plays: 51,
  },
  {
    Name: "Overthinking",
    Artist: "Hands Like Houses",
    Album: "Anon.",
    Time: 173,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Time",
    Artist: "Hans Zimmer",
    Album: "Inception (Music from the Motion Picture)",
    Time: 275,
    Year: 2010,
    Plays: 14,
  },
  {
    Name: "No Time for Caution",
    Artist: "Hans Zimmer",
    Album:
      "Interstellar (Original Motion Picture Soundtrack) [Expanded Edition]",
    Time: 246,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Life's Not Fair",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 103,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Rafiki's Fireflies",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 112,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Elephant Graveyard",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 398,
    Year: 2019,
    Plays: 8,
  },
  {
    Name: "Stampede",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 466,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Scar Takes the Throne",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 170,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Simba Is Alive!",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 218,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Reflections of Mufasa",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 309,
    Year: 2019,
    Plays: 9,
  },
  {
    Name: "Battle for Pride Rock",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 661,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Remember",
    Artist: "Hans Zimmer",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 189,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Flight",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack)",
    Time: 248,
    Year: 2013,
    Plays: 22,
  },
  {
    Name: "Look To the Stars",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 178,
    Year: 2013,
    Plays: 16,
  },
  {
    Name: "Oil Rig",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 105,
    Year: 2013,
    Plays: 18,
  },
  {
    Name: "Sent Here For a Reason",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 226,
    Year: 2013,
    Plays: 16,
  },
  {
    Name: "Dna",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 214,
    Year: 2013,
    Plays: 16,
  },
  {
    Name: "Goodbye My Son",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 121,
    Year: 2013,
    Plays: 16,
  },
  {
    Name: "If You Love These People",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 202,
    Year: 2013,
    Plays: 17,
  },
  {
    Name: "Krypton's Last",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 118,
    Year: 2013,
    Plays: 16,
  },
  {
    Name: "Terraforming",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 589,
    Year: 2013,
    Plays: 14,
  },
  {
    Name: "Tornado",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 173,
    Year: 2013,
    Plays: 14,
  },
  {
    Name: "You Die Or I Do",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 193,
    Year: 2013,
    Plays: 80,
  },
  {
    Name: "Launch",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 156,
    Year: 2013,
    Plays: 13,
  },
  {
    Name: "Ignition",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 79,
    Year: 2013,
    Plays: 14,
  },
  {
    Name: "I Will Find Him",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 177,
    Year: 2013,
    Plays: 12,
  },
  {
    Name: "This Is Clark Kent",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 227,
    Year: 2013,
    Plays: 12,
  },
  {
    Name: "I Have So Many Questions",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 227,
    Year: 2013,
    Plays: 10,
  },
  {
    Name: "Flight",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 258,
    Year: 2013,
    Plays: 197,
  },
  {
    Name: "What Are You Going To Do When You Are Not Saving the World?",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 327,
    Year: 2013,
    Plays: 12,
  },
  {
    Name: "Man of Steel (Hans' Original Sketchbook)",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 1696,
    Year: 2013,
    Plays: 9,
  },
  {
    Name: "Are You Listening, Clark?",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 169,
    Year: 2013,
    Plays: 9,
  },
  {
    Name: "General Zod",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 441,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "You Led Us Here",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 179,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "This Is Madness!",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 228,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Earth",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 371,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Arcade",
    Artist: "Hans Zimmer",
    Album: "Man of Steel (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 445,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Hoist the Colours",
    Artist: "Hans Zimmer",
    Album:
      "Pirates of the Caribbean: At World's End (Soundtrack from the Motion Picture)",
    Time: 91,
    Year: 2007,
    Plays: 11,
  },
  {
    Name: "Die in the City",
    Artist: "THE HARA",
    Album: "Die in the City - Single",
    Time: 147,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Existe",
    Artist: "Harmonik",
    Album: "Respè",
    Time: 337,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "The Battle",
    Artist: "Harry Gregson-Williams",
    Album: "The Chronicles of Narnia - The Lion, the Witch and the Wardrobe",
    Time: 428,
    Year: 2005,
    Plays: 6,
  },
  {
    Name: "Baba for the Girls (feat. Kcee)",
    Artist: "Harrysong",
    Album: "Baba for the Girls (feat. Kcee) - Single",
    Time: 190,
    Year: 2016,
    Plays: 7,
  },
  {
    Name: "Sora wa Tataku Kaze wa Utau",
    Artist: "Haruna Luna",
    Album: "Sora wa Tataku Kaze wa Utau",
    Time: 270,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Demons",
    Artist: "Hayley Kiyoko",
    Album: "I'm Too Sensitive For This Shit - Single",
    Time: 179,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Pardon Me",
    Artist: "He Is We",
    Album: "Fall out of Line",
    Time: 213,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Satisfy Me",
    Artist: "Headie One",
    Album: "Too Loyal for My Own Good",
    Time: 200,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "NEW COKE",
    Artist: "HEALTH",
    Album: "DEATH MAGIC",
    Time: 219,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Goya no Machiawase",
    Artist: "Hello Sleepwalkers",
    Album: "Goya no Machiawase",
    Time: 170,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Goyanomachiawase",
    Artist: "Hello Sleepwalkers",
    Album: "Goyanomachiawase - Single",
    Time: 170,
    Year: 2014,
    Plays: 20,
  },
  {
    Name: "Love Falls",
    Artist: "HELLYEAH",
    Album: "Unden!able (Deluxe 2.0)",
    Time: 274,
    Year: 2016,
    Plays: 20,
  },
  {
    Name: "Madiba (feat. TBO & Mfana Kah Gogo)",
    Artist: "HENNYBELIT",
    Album: "Madiba (feat. TBO & Mfana Kah Gogo) - Single",
    Time: 413,
    Year: 2022,
    Plays: 14,
  },
  {
    Name: "All Roads",
    Artist: "Here from the Start",
    Album: "All Roads - Single",
    Time: 240,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Kono Te Nobashite",
    Artist: "Hi-Fi CAMP",
    Album: "Fairy Tail OP ED Theme Songs Vol.2",
    Time: 262,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Hold On To Me (feat. Svrcina)",
    Artist: "Hidden Citizens",
    Album: "Adscendo - EP",
    Time: 167,
    Year: 2020,
    Plays: 50,
  },
  {
    Name: "Raise Your Flag (feat. Rånya)",
    Artist: "Hidden Citizens",
    Album: "Aella - EP",
    Time: 221,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Don't Look Down (feat. Erin McCarley)",
    Artist: "Hidden Citizens",
    Album: "Aella - EP",
    Time: 219,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Fight For You (feat. Alaina Cross)",
    Artist: "Hidden Citizens",
    Album: "Aella - EP",
    Time: 241,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Out of Time (feat. Erin McCarley)",
    Artist: "Hidden Citizens",
    Album: "Celestine",
    Time: 204,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Come At Me (feat. Jung Youth)",
    Artist: "Hidden Citizens",
    Album: "Come At Me (feat. Jung Youth) - Single",
    Time: 176,
    Year: 2021,
    Plays: 43,
  },
  {
    Name: "Hungry Like the Wolf (2020 Remaster) [feat. Tim Halperin] [2020 Remaster]",
    Artist: "Hidden Citizens",
    Album: "Hungry Like the Wolf (2020 Remaster) [feat. Tim Halperin] - Single",
    Time: 210,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "I Follow (feat. Katie Herzig)",
    Artist: "Hidden Citizens",
    Album: "I Follow (feat. Katie Herzig) - Single",
    Time: 209,
    Year: 2021,
    Plays: 16,
  },
  {
    Name: "(I Just) Died In Your Arms [Epic Trailer Version] [Epic Trailer Version]",
    Artist: "Hidden Citizens",
    Album: "(I Just) Died In Your Arms (Epic Trailer Version) - Single",
    Time: 235,
    Year: 2016,
    Plays: 144,
  },
  {
    Name: "My People (We Ready) (feat. Bryce Fox)",
    Artist: "Hidden Citizens",
    Album: "My People (We Ready) (feat. Bryce Fox) - Single",
    Time: 184,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Our Time (feat. Aloe Blacc)",
    Artist: "Hidden Citizens",
    Album: "Our Time (feat. Aloe Blacc) - Single",
    Time: 241,
    Year: 2021,
    Plays: 29,
  },
  {
    Name: "Paint It Black (feat. Rånya) [Epic Trailer Version]",
    Artist: "Hidden Citizens",
    Album: "Reawakenings Vol. 2",
    Time: 230,
    Year: 2019,
    Plays: 12,
  },
  {
    Name: "O Fortuna (Epic Trailer Version)",
    Artist: "Hidden Citizens",
    Album: "Revivals, Vol. 2 (Epic Trailer Version)",
    Time: 203,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Take Over (feat. Ruelle)",
    Artist: "Hidden Citizens",
    Album: "Take Over (feat. Ruelle) - Single",
    Time: 170,
    Year: 2018,
    Plays: 17,
  },
  {
    Name: "Unleash the Power (feat. Sam Tinnesz & Rayelle)",
    Artist: "Hidden Citizens",
    Album: "Unleash the Power (feat. Sam Tinnesz & Rayelle) - Single",
    Time: 192,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Silent Running",
    Artist: "Hidden Citizens",
    Album: "",
    Time: 235,
    Year: null,
    Plays: 116,
  },
  {
    Name: "All For One",
    Artist: "Hidden Citizens & Hael",
    Album: "All For One - Single",
    Time: 215,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Warrior (Stand Up)",
    Artist: "Hidden Citizens & Rayelle",
    Album: "Warrior (Stand Up) - Single",
    Time: 192,
    Year: 2020,
    Plays: 22,
  },
  {
    Name: "Here We Stand",
    Artist: "Hidden Citizens & Svrcina",
    Album: "Here We Stand - Single",
    Time: 216,
    Year: 2019,
    Plays: 121,
  },
  {
    Name: "Untamable",
    Artist: "Hidden Citizens & Tim Halperin",
    Album: "Untamable - Single",
    Time: 205,
    Year: 2021,
    Plays: 20,
  },
  {
    Name: "Smoke (feat. Bryce Fox)",
    Artist: "Hidden Citizens, HAYASA G & Kazu",
    Album: "Smoke (feat. Bryce Fox) - Single",
    Time: 185,
    Year: 2022,
    Plays: 4,
  },
  {
    Name: "Open Season",
    Artist: "High Highs",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 229,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "16",
    Artist: "Highly Suspect",
    Album: "MCID",
    Time: 278,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Oceans (Where Feet May Fail) [Reloaded]",
    Artist: "Hillsong UNITED & TAYA",
    Album: "Zion",
    Time: 418,
    Year: 2013,
    Plays: 107,
  },
  {
    Name: "Burn It Down",
    Artist: "Hinder",
    Album: "The Reign",
    Time: 217,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "K2-",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 346,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Zero Eclipse",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 253,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 1-1st: 0Sk",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 370,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 1-2nd: Historia",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 231,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 1-3rd: Barrichestra",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 359,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 1-4th: 7-B@$",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 317,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "K21",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 203,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Aots3-3Spens / 21seki",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 392,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Call Your Name (Gv)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 259,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 2-1st: Attack on Titan (Wmid)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 310,
    Year: 2019,
    Plays: 58,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 2-2nd: Shingekinokyojin",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 182,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 2-3rd: Before Lights Out",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 175,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 2-4th: 2An",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 158,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 2-5th: Apple Seed",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 166,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Symphonicsuite (Aot), Pt. 2-6th: Thanksat",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 239,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Eren the Hyou (Movie Ver.)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 384,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Barricades (Movie Ver.)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 257,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Aots3-Pf1",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 125,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "T-Kt",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 174,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "A 1 G U",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 200,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Aots3-Pf2",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 204,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Aots3-1000Ryaku",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 207,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Tooth-I:",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 183,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Len Zo 97N10 Hi Kyosetsu Mahle",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 134,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "K21 (Instrumental)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 201,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Zero Eclipse (Instrumental)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 251,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Barricades (Movie Ver. / Instrumental)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 256,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Call Your Name (Gv) [Instrumental]",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 259,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Attack on Titan (Wmid) [Instrumental]",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 308,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Before Lights Out (Instrumental)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 173,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Apple Seed (Instrumental)",
    Artist: "Hiroyuki Sawano",
    Album: "Attack on Titan Season 3 (Original Soundtrack)",
    Time: 166,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "KINGDOM - DUE",
    Artist: "Hiroyuki Sawano",
    Album: "TV ANIMATION KINGDOM Gasshōgun Original Sound Track",
    Time: 260,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Barricades",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 221,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "APETITAN",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 331,
    Year: 2017,
    Plays: 9,
  },
  {
    Name: "YouSeeBIGGIRL/T:T",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 359,
    Year: 2017,
    Plays: 43,
  },
  {
    Name: "Shingeki St - Hrn- Egt 20130629 Kyojin",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 301,
    Year: 2017,
    Plays: 26,
  },
  {
    Name: "Shingeki St - Hrn - Gt - Pf 20130629 Kyojin",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 276,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "ymniam-orch (sm2_Final#2)",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 189,
    Year: 2017,
    Plays: 14,
  },
  {
    Name: "The Reluctant Heroes <MODv>",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 269,
    Year: 2014,
    Plays: 14,
  },
  {
    Name: "Shingeki St - Hrn - Gt 20130629 Kyojin",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 252,
    Year: 2017,
    Plays: 22,
  },
  {
    Name: "YAMANAIAME <FMv>",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan Season 2" (Original Soundtrack)',
    Time: 267,
    Year: 2015,
    Plays: 12,
  },
  {
    Name: "ətˈæk 0N tάɪtn",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan" (Original Soundtrack)',
    Time: 256,
    Year: 2013,
    Plays: 200,
  },
  {
    Name: "The Reluctant Heroes",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan" (Original Soundtrack)',
    Time: 267,
    Year: 2013,
    Plays: 47,
  },
  {
    Name: "The Reluctant Heroes",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan" (Original Soundtrack)',
    Time: 267,
    Year: 2013,
    Plays: 53,
  },
  {
    Name: "Vogel im Käfig",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan" (Original Soundtrack)',
    Time: 380,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "XL-TT",
    Artist: "Hiroyuki Sawano",
    Album: 'TV Anime "Attack on Titan" (Original Soundtrack)',
    Time: 397,
    Year: 2013,
    Plays: 9,
  },
  {
    Name: "Birdcage",
    Artist: "Holding Absence",
    Album: "Birdcage - Single",
    Time: 203,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "CHAOS",
    Artist: "Hollywood Undead",
    Album: "CHAOS - Single",
    Time: 182,
    Year: 2022,
    Plays: 19,
  },
  {
    Name: "War Child",
    Artist: "Hollywood Undead",
    Album: "Day of the Dead",
    Time: 238,
    Year: 2015,
    Plays: 45,
  },
  {
    Name: "California Dreaming",
    Artist: "Hollywood Undead",
    Album: "Five",
    Time: 234,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "City Of The Dead",
    Artist: "Hollywood Undead",
    Album: "Hotel Kalifornia",
    Time: 173,
    Year: 2022,
    Plays: 7,
  },
  {
    Name: "Already Dead",
    Artist: "Hollywood Undead",
    Album: "New Empire, Vol. 1",
    Time: 236,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Worth It",
    Artist: "Hollywood Undead",
    Album: "New Empire, Vol. 2 (Bonus Track Version)",
    Time: 181,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Lion",
    Artist: "Hollywood Undead",
    Album: "Notes from the Underground (Unabridged) [Deluxe Version]",
    Time: 234,
    Year: 2013,
    Plays: 64,
  },
  {
    Name: "Bloody Nose",
    Artist: "Hollywood Undead",
    Album: "Psalms - EP",
    Time: 250,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Young",
    Artist: "Hollywood Undead",
    Album: "Swan Songs (Collector's Edition)",
    Time: 196,
    Year: 2008,
    Plays: 23,
  },
  {
    Name: "Love (feat. Davido)",
    Artist: "Holmes",
    Album: "Love (feat. Davido) - Single",
    Time: 186,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Sea Shanty Medley",
    Artist: "Home Free",
    Album: "Sea Shanty Medley - Single",
    Time: 234,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "The Old Us",
    Artist: "Hopsin",
    Album: "The Old Us - Single",
    Time: 274,
    Year: 2019,
    Plays: 22,
  },
  {
    Name: "Picasso",
    Artist: "Hopsin",
    Album: "Picasso - Single",
    Time: 197,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "You Should've Known",
    Artist: "Hopsin & Dax",
    Album: "You Should've Known - Single",
    Time: 194,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Zutto Tabi wo Shite Itai",
    Artist: "Horie Mitsuko",
    Album: "Furui Kyuujitsu no Uta",
    Time: 237,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Nina Cried Power (feat. Mavis Staples)",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 225,
    Year: 2018,
    Plays: 36,
  },
  {
    Name: "Almost (Sweet Music)",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 217,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Movement",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 237,
    Year: 2018,
    Plays: 63,
  },
  {
    Name: "No Plan",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 331,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Nobody",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 210,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "To Noise Making (Sing)",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 206,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "As It Was",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 207,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Shrike",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 298,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Talk",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 206,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Be",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 289,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Dinner & Diatribes",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 224,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Would That I",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 268,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Sunlight",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 257,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Wasteland, Baby!",
    Artist: "Hozier",
    Album: "Wasteland, Baby!",
    Time: 266,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "21st Century Vampire",
    Artist: "Huddy",
    Album: "Teenage Heartbreak",
    Time: 167,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "From Now On",
    Artist: "Hugh Jackman & The Greatest Showman Ensemble",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 349,
    Year: 2017,
    Plays: 21,
  },
  {
    Name: "The Other Side",
    Artist: "Hugh Jackman & Zac Efron",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 214,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Come Alive",
    Artist:
      "Hugh Jackman, Keala Settle, Daniel Everidge, Zendaya & The Greatest Showman Ensemble",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 225,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "The Greatest Show",
    Artist:
      "Hugh Jackman, Keala Settle, Zac Efron, Zendaya & The Greatest Showman Ensemble",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 302,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "The Final Countdown",
    Artist: "Hullabahoos",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 75,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Saint Laurent Mask",
    Artist: "HUNCHO JACK, Travis Scott & Quavo",
    Album: "Huncho Jack, Jack Huncho",
    Time: 190,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Scorned (Live Acoustic Version) [feat. ShyBoy]",
    Artist: "Hypnogaja",
    Album: "Acoustic Sunset - Live At the Longhouse (feat. ShyBoy)",
    Time: 278,
    Year: 2006,
    Plays: 12,
  },
  {
    Name: "Scorned",
    Artist: "Hypnogaja",
    Album: "Audio from Last Night's Dream",
    Time: 223,
    Year: 2007,
    Plays: 105,
  },
  {
    Name: "Scorned (feat. ShyBoy) [Live]",
    Artist: "Hypnogaja",
    Album: "Mixtape",
    Time: 225,
    Year: 2007,
    Plays: 13,
  },
  {
    Name: "Impossible",
    Artist: "I Am King",
    Album: "Impossible - Single",
    Time: 225,
    Year: 2018,
    Plays: 28,
  },
  {
    Name: "Blank Space",
    Artist: "I Prevail",
    Album: "Blank Space - Single",
    Time: 240,
    Year: 2014,
    Plays: 17,
  },
  {
    Name: "Love, Lust, and Liars",
    Artist: "I Prevail",
    Album: "Heart Vs. Mind",
    Time: 202,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Scars",
    Artist: "I Prevail",
    Album: "Lifelines",
    Time: 229,
    Year: 2016,
    Plays: 732,
  },
  {
    Name: "Stuck in Your Head",
    Artist: "I Prevail",
    Album: "Lifelines",
    Time: 214,
    Year: 2016,
    Plays: 274,
  },
  {
    Name: "Lifelines",
    Artist: "I Prevail",
    Album: "Lifelines",
    Time: 201,
    Year: 2016,
    Plays: 7,
  },
  {
    Name: "Bow Down",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 242,
    Year: 2019,
    Plays: 8,
  },
  {
    Name: "Paranoid",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 144,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Every Time You Leave (feat. Delaney Jane)",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 216,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Rise Above It (feat. Justin Stone)",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 184,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Breaking Down",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 206,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "DOA",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 196,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Gasoline",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 153,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Hurricane",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 223,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Let Me Be Sad",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 214,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Low",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 165,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Goodbye (Interlude)",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 102,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Deadweight",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 184,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "I Don't Belong Here",
    Artist: "I Prevail",
    Album: "TRAUMA",
    Time: 221,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Find Dreams",
    Artist: "I-Exist",
    Album: "Find Dreams - Single",
    Time: 245,
    Year: 2018,
    Plays: 19,
  },
  {
    Name: "Not From Here",
    Artist: "I-Exist",
    Album: "Not From Here - Single",
    Time: 307,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Only That Real (feat. 2 Chainz & Sage the Gemini)",
    Artist: "IamSu",
    Album: "Only That Real (feat. 2 Chainz & Sage the Gemini) - Single",
    Time: 220,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Prospect (feat. Lil Baby)",
    Artist: "iann dior",
    Album: "I'm Gone",
    Time: 226,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Problems",
    Artist: "iann dior",
    Album: "Industry Plant",
    Time: 144,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "The Nigga Ya Love To Hate",
    Artist: "Ice Cube",
    Album: "Straight Outta Compton",
    Time: 193,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "No Vaseline",
    Artist: "Ice Cube",
    Album: "Straight Outta Compton",
    Time: 312,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Hunting Season",
    Artist: "ICE NINE KILLS",
    Album: "Hunting Season - Single",
    Time: 198,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "Thank God It's Friday",
    Artist: "ICE NINE KILLS",
    Album: "The Silver Scream (Final Cut)",
    Time: 263,
    Year: 2018,
    Plays: 34,
  },
  {
    Name: "Welcome To Horrorwood",
    Artist: "ICE NINE KILLS",
    Album: "Welcome To Horrorwood: The Silver Scream 2",
    Time: 235,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "The Shower Scene",
    Artist: "ICE NINE KILLS",
    Album: "Welcome To Horrorwood: The Silver Scream 2",
    Time: 191,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Hip To Be Scared (feat. Jacoby Shaddix)",
    Artist: "ICE NINE KILLS",
    Album: "Welcome To Horrorwood: The Silver Scream 2",
    Time: 203,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Aboki",
    Artist: "Ice Prince",
    Album: "Afrobeats the Hits, Vol. 1",
    Time: 216,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Oleku (feat. Brymo)",
    Artist: "Ice Prince",
    Album: "Oleku (feat. Brymo) - Single",
    Time: 291,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Brittle (Prelude)",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 44,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Brittle",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 208,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Curse or Cure",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 200,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Enemies",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 193,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Panic Attacks",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 210,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Seeds",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 191,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Thirteen (Interlude)",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 71,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Background Sad",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 211,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Last One Standing",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 204,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Waste My Hate",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 146,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Impossibles & Obstacles (Interlude)",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 64,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Sticks & Stones",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 174,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Warrior",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 211,
    Year: 2021,
    Plays: 54,
  },
  {
    Name: "Only Be a Story",
    Artist: "Icon for Hire",
    Album: "Amorphous",
    Time: 222,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Struggle, Succeed",
    Artist: "Icon for Hire",
    Album: "Amorphous (Extended Edition)",
    Time: 214,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Brittle (Acoustic)",
    Artist: "Icon for Hire",
    Album: "Amorphous (Extended Edition)",
    Time: 212,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Blindside",
    Artist: "Icon for Hire",
    Album: "Blindside - Single",
    Time: 196,
    Year: 2019,
    Plays: 75,
  },
  {
    Name: "Hollow",
    Artist: "Icon for Hire",
    Album: "Hollow - Single",
    Time: 199,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Rock and Roll Thugs",
    Artist: "Icon for Hire",
    Album: "Icon for Hire",
    Time: 216,
    Year: 2013,
    Plays: 16,
  },
  {
    Name: "Dismantled",
    Artist: "Icon for Hire",
    Album: "The Reckoning",
    Time: 191,
    Year: 2022,
    Plays: 52,
  },
  {
    Name: "Get Well",
    Artist: "Icon for Hire",
    Album: "Scripted",
    Time: 177,
    Year: 2011,
    Plays: 10,
  },
  {
    Name: "Background Sad (Radio Edit)",
    Artist: "Icon for Hire & Kid Bookie",
    Album: "Background Sad (Radio Edit) - Single",
    Time: 206,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Fancy (feat. Charli XCX)",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 199,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Walk the Line",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 219,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Work",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 223,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Don't Need Y'all",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 213,
    Year: null,
    Plays: null,
  },
  {
    Name: "New Bitch",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 217,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Goddess",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 190,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Black Widow (feat. Rita Ora)",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 209,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "Lady Patra (feat. Mavado)",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 236,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Fuck Love",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 159,
    Year: null,
    Plays: 2,
  },
  {
    Name: "Bounce",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 167,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Rolex",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 204,
    Year: null,
    Plays: 6,
  },
  {
    Name: "Just Askin'",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 180,
    Year: null,
    Plays: null,
  },
  {
    Name: "Impossible Is Nothing",
    Artist: "Iggy Azalea",
    Album: "The New Classic (Deluxe Version)",
    Time: 190,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Lola",
    Artist: "Iggy Azalea & Alice Chater",
    Album: "Wicked Lips - EP",
    Time: 232,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Change Your Life (Featuring T.I.)",
    Artist: "Iggy Azalea/T.I.",
    Album: "The New Classic (Deluxe Version)",
    Time: 219,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "100",
    Artist: "Iggy Azalea/Watch the Duck",
    Album: "The New Classic (Deluxe Version)",
    Time: 249,
    Year: null,
    Plays: null,
  },
  {
    Name: "Manhattan Skyline (feat. Einar Solberg)",
    Artist: "Ihsahn",
    Album: "Pharos - EP",
    Time: 290,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Critical (feat. Dbanj)",
    Artist: "Ikechukwu",
    Album: "The Alliance Reconstructed",
    Time: 238,
    Year: 2011,
    Plays: 31,
  },
  {
    Name: "Wind Am Well (feat. Don Jazzy)",
    Artist: "Ikechukwu",
    Album: "Carnival Street Bangers - EP",
    Time: 273,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Bank Alert",
    Artist: "Illbliss",
    Album: "#Powerful",
    Time: 192,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Bad Liar – Stripped",
    Artist: "Imagine Dragons",
    Album: "Bad Liar – Stripped - Single",
    Time: 253,
    Year: 2019,
    Plays: 114,
  },
  {
    Name: "Battle Cry",
    Artist: "Imagine Dragons",
    Album: "Battle Cry - Single",
    Time: 273,
    Year: 2014,
    Plays: 49,
  },
  {
    Name: "I Don't Know Why",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 190,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "Next to Me",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 230,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "I Don’t Know Why",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 190,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Whatever It Takes",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 201,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "Believer",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 204,
    Year: 2017,
    Plays: 54,
  },
  {
    Name: "Walking The Wire",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 232,
    Year: 2017,
    Plays: 17,
  },
  {
    Name: "Rise Up",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 231,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "I'll Make It Up To You",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 262,
    Year: 2017,
    Plays: 5,
  },
  {
    Name: "I’ll Make It Up to You",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 262,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Yesterday",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 205,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Mouth Of The River",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 221,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Thunder",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 187,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Start Over",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 186,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Dancing In The Dark",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 233,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Levitate",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 198,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Not Today",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 260,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Believer (Kaskade Remix)",
    Artist: "Imagine Dragons",
    Album: "Evolve",
    Time: 190,
    Year: 2017,
    Plays: 11,
  },
  {
    Name: "Cutthroat",
    Artist: "Imagine Dragons",
    Album: "Follow You / Cutthroat - Single",
    Time: 169,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "My Life",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 224,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Lonely",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 159,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Wrecked",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 244,
    Year: 2021,
    Plays: 24,
  },
  {
    Name: "Monday",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 187,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "#1",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 205,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Easy Come Easy Go",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 179,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Giants",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 210,
    Year: 2021,
    Plays: 26,
  },
  {
    Name: "It's Ok",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 202,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Dull Knives",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 213,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Follow You",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 175,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Cutthroat",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 169,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "No Time For Toxic People",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 207,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "One Day",
    Artist: "Imagine Dragons",
    Album: "Mercury - Act 1",
    Time: 151,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Monster",
    Artist: "Imagine Dragons",
    Album: "Monster (Single)",
    Time: 249,
    Year: null,
    Plays: 12,
  },
  {
    Name: "Radioactive",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 186,
    Year: 2012,
    Plays: 27,
  },
  {
    Name: "Tiptoe",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 194,
    Year: 2012,
    Plays: 20,
  },
  {
    Name: "It's Time",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 240,
    Year: 2012,
    Plays: 12,
  },
  {
    Name: "Demons",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 177,
    Year: 2012,
    Plays: 32,
  },
  {
    Name: "On Top of the World",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 192,
    Year: 2012,
    Plays: 22,
  },
  {
    Name: "Amsterdam",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 241,
    Year: 2012,
    Plays: 26,
  },
  {
    Name: "Hear Me",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 235,
    Year: 2012,
    Plays: 7,
  },
  {
    Name: "Every Night",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 217,
    Year: 2012,
    Plays: 14,
  },
  {
    Name: "Bleeding Out",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 223,
    Year: 2012,
    Plays: 34,
  },
  {
    Name: "Underdog",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 209,
    Year: 2012,
    Plays: 13,
  },
  {
    Name: "Nothing Left to Say / Rocks",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 539,
    Year: 2012,
    Plays: 70,
  },
  {
    Name: "Working Man",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 235,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Fallen",
    Artist: "Imagine Dragons",
    Album: "Night Visions",
    Time: 179,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "Natural",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 189,
    Year: 2018,
    Plays: 37,
  },
  {
    Name: "Boomerang",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 187,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Machine",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 181,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Cool Out",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 217,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Bad Liar",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 260,
    Year: 2018,
    Plays: 58,
  },
  {
    Name: "West Coast",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 217,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: 'Zero (From the Original Motion Picture "Ralph Breaks The Internet")',
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 210,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Bullet In A Gun",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 204,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Digital",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 201,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Only",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 180,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Stuck",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 190,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Love",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 166,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Birds",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 219,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Burn Out",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 273,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Real Life",
    Artist: "Imagine Dragons",
    Album: "Origins (Deluxe)",
    Time: 247,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Shots",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 229,
    Year: 2015,
    Plays: 17,
  },
  {
    Name: "Gold",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 216,
    Year: 2015,
    Plays: 100,
  },
  {
    Name: "Smoke and Mirrors",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 260,
    Year: 2014,
    Plays: 9,
  },
  {
    Name: "I'm So Sorry",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 230,
    Year: 2014,
    Plays: 26,
  },
  {
    Name: "I Bet My Life",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 194,
    Year: 2015,
    Plays: 21,
  },
  {
    Name: "Polaroid",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 231,
    Year: 2014,
    Plays: 15,
  },
  {
    Name: "Friction",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 201,
    Year: 2014,
    Plays: 107,
  },
  {
    Name: "It Comes Back To You",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 217,
    Year: 2014,
    Plays: 14,
  },
  {
    Name: "Dream",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 259,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "Trouble",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 192,
    Year: 2014,
    Plays: 15,
  },
  {
    Name: "Summer",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 218,
    Year: 2014,
    Plays: 20,
  },
  {
    Name: "Hopeless Opus",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 241,
    Year: 2014,
    Plays: 25,
  },
  {
    Name: "The Fall",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 365,
    Year: 2014,
    Plays: 16,
  },
  {
    Name: "Thief",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 227,
    Year: 2014,
    Plays: 14,
  },
  {
    Name: "The Unknown",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 204,
    Year: 2014,
    Plays: 16,
  },
  {
    Name: "Second Chances",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 218,
    Year: 2014,
    Plays: 9,
  },
  {
    Name: "Release",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 148,
    Year: 2014,
    Plays: 10,
  },
  {
    Name: "Warriors",
    Artist: "Imagine Dragons",
    Album: "Smoke + Mirrors (Deluxe)",
    Time: 170,
    Year: 2015,
    Plays: 48,
  },
  {
    Name: "Satisfya",
    Artist: "Imran Khan",
    Album: "Satisfya - Single",
    Time: 180,
    Year: 2013,
    Plays: 19,
  },
  {
    Name: "Only for the Weak",
    Artist: "In Flames",
    Album: "20th Anniversary",
    Time: 271,
    Year: 2001,
    Plays: null,
  },
  {
    Name: "Dirty Pretty",
    Artist: "In This Moment",
    Album: "Black Widow",
    Time: 247,
    Year: 2014,
    Plays: 81,
  },
  {
    Name: "Sick Like Me",
    Artist: "In This Moment",
    Album: "Black Widow",
    Time: 299,
    Year: 2014,
    Plays: 23,
  },
  {
    Name: "Blood",
    Artist: "In This Moment",
    Album: "Blood",
    Time: 207,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Burn",
    Artist: "In This Moment",
    Album: "Blood",
    Time: 284,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "From the Ashes",
    Artist: "In This Moment",
    Album: "Blood",
    Time: 266,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The In-Between",
    Artist: "In This Moment",
    Album: "Mother",
    Time: 254,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "We Will Rock You (feat. Maria Brink, Lzzy Hale and Taylor Momsen)",
    Artist: "In This Moment",
    Album: "Mother",
    Time: 185,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Hunting Grounds (feat. Joe Cotela of Ded)",
    Artist: "In This Moment",
    Album: "Mother",
    Time: 273,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Lay Me Down",
    Artist: "In This Moment",
    Album: "Mother",
    Time: 249,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Oh Lord",
    Artist: "In This Moment",
    Album: "Ritual",
    Time: 247,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Black Wedding (feat. Rob Halford)",
    Artist: "In This Moment",
    Album: "Ritual",
    Time: 247,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Roots",
    Artist: "In This Moment",
    Album: "Ritual",
    Time: 250,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Whore",
    Artist: "In This Moment",
    Album: "Whore - EP",
    Time: 245,
    Year: 2012,
    Plays: 26,
  },
  {
    Name: "Dernière Danse",
    Artist: "Indila",
    Album: "Mini World (Deluxe)",
    Time: 213,
    Year: 2013,
    Plays: 8,
  },
  {
    Name: "Ainsi Bas La Vida",
    Artist: "Indila",
    Album: "Mini World (Deluxe)",
    Time: 214,
    Year: 2014,
    Plays: 24,
  },
  {
    Name: "Parachute (Serban Ghenea Mix)",
    Artist: "Ingrid Michaelson",
    Album: "Parachute(s) Remixed - EP",
    Time: 200,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Parachute (Acoustic)",
    Artist: "Ingrid Michaelson",
    Album: "Parachute(s) Remixed - EP",
    Time: 193,
    Year: 2010,
    Plays: 13,
  },
  {
    Name: "Parachute (Dan Romer Spook Out)",
    Artist: "Ingrid Michaelson",
    Album: "Parachute(s) Remixed - EP",
    Time: 195,
    Year: 2011,
    Plays: 11,
  },
  {
    Name: "Jealous",
    Artist: "Ingrid Michaelson",
    Album: "Stranger Songs",
    Time: 187,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Somebody",
    Artist: "Internet Money, Lil Tecca & A Boogie wit da Hoodie",
    Album: "Somebody - Single",
    Time: 174,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "She's Kerosene",
    Artist: "The Interrupters",
    Album: "Fight the Good Fight",
    Time: 170,
    Year: 2018,
    Plays: 47,
  },
  {
    Name: "Gave You Everything",
    Artist: "The Interrupters",
    Album: "Fight the Good Fight",
    Time: 187,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Better to Burn",
    Artist: "Invictum",
    Album: "Scars to Hide - EP",
    Time: 300,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "God of Mercy and Compassion",
    Artist: "Irish Voices",
    Album: "Celtic Espiritu 2",
    Time: 128,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Fear of the Dark",
    Artist: "Iron Maiden",
    Album: "Fear of the Dark",
    Time: 438,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Invaders",
    Artist: "Iron Maiden",
    Album: "The Number Of The Beast",
    Time: 202,
    Year: 1982,
    Plays: 1,
  },
  {
    Name: "Children Of The Damned",
    Artist: "Iron Maiden",
    Album: "The Number Of The Beast",
    Time: 274,
    Year: 1982,
    Plays: 1,
  },
  {
    Name: "The Prisoner",
    Artist: "Iron Maiden",
    Album: "The Number Of The Beast",
    Time: 362,
    Year: 1982,
    Plays: 1,
  },
  {
    Name: "22 Acacia Avenue",
    Artist: "Iron Maiden",
    Album: "The Number Of The Beast",
    Time: 396,
    Year: 1982,
    Plays: 1,
  },
  {
    Name: "The Number Of The Beast",
    Artist: "Iron Maiden",
    Album: "The Number Of The Beast",
    Time: 290,
    Year: 1982,
    Plays: null,
  },
  {
    Name: "Gangland",
    Artist: "Iron Maiden",
    Album: "The Number Of The Beast",
    Time: 228,
    Year: 1982,
    Plays: null,
  },
  {
    Name: "Total Eclipse",
    Artist: "Iron Maiden",
    Album: "The Number Of The Beast",
    Time: 254,
    Year: 2002,
    Plays: null,
  },
  {
    Name: "Hallowed Be Thy Name",
    Artist: "Iron Maiden",
    Album: "The Number Of The Beast",
    Time: 434,
    Year: 1982,
    Plays: 11,
  },
  {
    Name: "Hallowed Be Thy Name (Live '01)",
    Artist: "Iron Maiden",
    Album: "Rock In Rio (Live)",
    Time: 444,
    Year: 2002,
    Plays: 6,
  },
  {
    Name: "La Temperatura",
    Artist: "J Álvarez",
    Album: "De Camino Pa' la Cima (Deluxe Edition)",
    Time: 215,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Fight for Your Right",
    Artist: "J Hus",
    Album: "Big Conspiracy",
    Time: 197,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Must Be",
    Artist: "J Hus",
    Album: "Big Conspiracy",
    Time: 208,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Common Sense",
    Artist: "J Hus",
    Album: "Common Sense",
    Time: 224,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Clartin",
    Artist: "J Hus",
    Album: "Common Sense",
    Time: 194,
    Year: 2017,
    Plays: 84,
  },
  {
    Name: "MIDDLE CHILD",
    Artist: "J. Cole",
    Album: "MIDDLE CHILD - Single",
    Time: 213,
    Year: 2019,
    Plays: 42,
  },
  {
    Name: "Snow on tha Bluff",
    Artist: "J. Cole",
    Album: "Snow on tha Bluff - Single",
    Time: 235,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Devil's Gonna Git You (feat. Blu Holliday)",
    Artist: "J2",
    Album: "Devil's Gonna Git You (feat. Blu Holliday) - Single",
    Time: 252,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Umbrella (feat. Jvzel)",
    Artist: "J2",
    Album: "Umbrella (feat. Jvzel) - Single",
    Time: 235,
    Year: 2015,
    Plays: 93,
  },
  {
    Name: "Nail Tech",
    Artist: "Jack Harlow",
    Album: "Come Home The Kids Miss You",
    Time: 206,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "WHATS POPPIN",
    Artist: "Jack Harlow",
    Album: "Sweet Action",
    Time: 139,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Baxter Avenue",
    Artist: "Jack Harlow",
    Album: "Thats What They All Say",
    Time: 207,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "WHATS POPPIN (Remix) [feat. DaBaby, Tory Lanez & Lil Wayne]",
    Artist: "Jack Harlow",
    Album:
      "WHATS POPPIN (Remix) [feat. DaBaby, Tory Lanez & Lil Wayne] - Single",
    Time: 227,
    Year: 2020,
    Plays: 45,
  },
  {
    Name: "Maybe I'm Too Young to Die (Voice Memo)",
    Artist: "Jack Vallier",
    Album: "Changes (EP) - EP",
    Time: 200,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "JACKBOYS",
    Artist: "JACKBOYS",
    Album: "JACKBOYS",
    Time: 46,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "GANG GANG",
    Artist: "JACKBOYS & Sheck Wes",
    Album: "JACKBOYS",
    Time: 244,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "OUT WEST (feat. Young Thug)",
    Artist: "JACKBOYS & Travis Scott",
    Album: "JACKBOYS",
    Time: 157,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "WHAT TO DO? (feat. Don Toliver)",
    Artist: "JACKBOYS & Travis Scott",
    Album: "JACKBOYS",
    Time: 250,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "GATTI",
    Artist: "JACKBOYS, Pop Smoke & Travis Scott",
    Album: "JACKBOYS",
    Time: 181,
    Year: 2019,
    Plays: 105,
  },
  {
    Name: "Sweet but Psycho",
    Artist: "Jada Facer",
    Album: "Sweet but Psycho - Single",
    Time: 163,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Way Up",
    Artist: "Jaden",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 153,
    Year: 2018,
    Plays: 16,
  },
  {
    Name: "B",
    Artist: "Jaden",
    Album: "SYRE",
    Time: 186,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "Icon",
    Artist: "Jaden",
    Album: "SYRE",
    Time: 220,
    Year: 2017,
    Plays: 6,
  },
  {
    Name: "K",
    Artist: "Jaden & Lido",
    Album: "ERYS (Deluxe)",
    Time: 280,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "The Wilhelm Scream",
    Artist: "James Blake",
    Album: "James Blake",
    Time: 277,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "balance (mufasa interlude)",
    Artist: "James Earl Jones",
    Album: "The Lion King: The Gift",
    Time: 43,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "the stars (mufasa interlude)",
    Artist: "James Earl Jones",
    Album: "The Lion King: The Gift",
    Time: 46,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "remember (mufasa interlude)",
    Artist: "James Earl Jones",
    Album: "The Lion King: The Gift",
    Time: 45,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "i'm home (mufasa, sarabi & simba interlude)",
    Artist: "James Earl Jones, Alfre Woodard & Donald Glover",
    Album: "The Lion King: The Gift",
    Time: 42,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Say You'll Stay",
    Artist: "James Smith",
    Album: "An EP by James Smith",
    Time: 210,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "The City's Yours",
    Artist: "Jamie Foxx & Quvenzhane Wallis",
    Album: "Annie (Original Motion Picture Soundtrack)",
    Time: 192,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "The Rock City Boy",
    Artist: "Jamil",
    Album: "Fairy Tail OP ED Theme Songs Vol.2",
    Time: 212,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "If No Be You (feat. Mayorkun)",
    Artist: "Jamopyper",
    Album: "If No Be You (feat. Mayorkun) - Single",
    Time: 211,
    Year: 2020,
    Plays: 28,
  },
  {
    Name: "Heroes Tonight",
    Artist: "Janji & Johnning",
    Album: "Heroes Tonight - Single",
    Time: 208,
    Year: 2015,
    Plays: 8,
  },
  {
    Name: "In My Head",
    Artist: "Jason Derulo",
    Album: "Jason Derulo (Deluxe Version)",
    Time: 198,
    Year: 2009,
    Plays: 5,
  },
  {
    Name: "Tip Toe (feat. French Montana)",
    Artist: "Jason Derulo",
    Album: "Tip Toe (feat. French Montana) - Single",
    Time: 187,
    Year: 2017,
    Plays: 63,
  },
  {
    Name: "Be the One",
    Artist: "Jason Derulo",
    Album: "2Sides (Side 1) - EP",
    Time: 161,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Talk Dirty",
    Artist: "Jason Derulo Ft. 2 Chainz",
    Album: "Talk Dirty (Single)",
    Time: 177,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Savage Love (Laxed - Siren Beat)",
    Artist: "Jawsh 685 x Jason Derulo",
    Album: "Savage Love (Laxed - Siren Beat) - Single",
    Time: 171,
    Year: 2020,
    Plays: 42,
  },
  {
    Name: "King's Dead",
    Artist: "Jay Rock, Kendrick Lamar, Future, James Blake",
    Album: "Black Panther: The Album",
    Time: 225,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Down (feat. Lil Wayne)",
    Artist: "Jay Sean",
    Album: "All or Nothing (Bonus Track Version)",
    Time: 212,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Izzo (H.O.V.A.)",
    Artist: "JAY-Z",
    Album: "The Hits Collection, Vol. 1 (Deluxe Edition)",
    Time: 240,
    Year: 2001,
    Plays: null,
  },
  {
    Name: "99 Problems",
    Artist: "JAY-Z",
    Album: "The Hits Collection, Vol. 1 (Deluxe Edition)",
    Time: 235,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Dirt Off Your Shoulder",
    Artist: "JAY-Z",
    Album: "The Hits Collection, Vol. 1 (Deluxe Edition)",
    Time: 242,
    Year: 2003,
    Plays: 3,
  },
  {
    Name: "My President Is Black (Remix)",
    Artist: "JAY-Z",
    Album: "The Hits Collection, Vol. 1 (Deluxe Edition)",
    Time: 238,
    Year: 2010,
    Plays: 24,
  },
  {
    Name: "Holy Grail (feat. Justin Timberlake)",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 338,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Picasso Baby",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 245,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Tom Ford",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 189,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "F*ckwithmeyouknowigotit (feat. Rick Ross)",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 243,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Oceans (feat. Frank Ocean)",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 238,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "F.U.T.W.",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 242,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Somewhereinamerica",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 148,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Crown",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 273,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Heaven",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 243,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Versus",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 51,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Part II (On the Run) [feat. Beyoncé]",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 333,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Beach Is Better",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 55,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "BBC",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 192,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "JAY Z Blue",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 230,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "La Familia",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 213,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Nickels and Dimes",
    Artist: "JAY-Z",
    Album: "Magna Carta... Holy Grail",
    Time: 303,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "No Church In the Wild (feat. Frank Ocean & The-Dream)",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 272,
    Year: 2011,
    Plays: 7,
  },
  {
    Name: "Lift Off (feat. Beyoncé)",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 266,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Ni**as In Paris",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 219,
    Year: 2011,
    Plays: 65,
  },
  {
    Name: "Otis (feat. Otis Redding)",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 178,
    Year: 2011,
    Plays: 11,
  },
  {
    Name: "Gotta Have It",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 140,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "New Day",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 272,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "That's My Bitch",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 202,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Welcome To the Jungle",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 174,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Who Gon Stop Me",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 256,
    Year: 2011,
    Plays: 11,
  },
  {
    Name: "Murder To Excellence",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 300,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Made In America (feat. Frank Ocean)",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 292,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Why I Love You (feat. Mr Hudson)",
    Artist: "JAY-Z & Kanye West",
    Album: "Watch the Throne",
    Time: 199,
    Year: 2011,
    Plays: 15,
  },
  {
    Name: "Dirt Off Your Shoulder/Lying from You",
    Artist: "Jay-Z & Linkin Park",
    Album: "Collision Course EP",
    Time: 244,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "Big Pimpin'/Papercut",
    Artist: "Jay-Z & Linkin Park",
    Album: "Collision Course EP",
    Time: 156,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "Jigga What/Faint",
    Artist: "Jay-Z & Linkin Park",
    Album: "Collision Course EP",
    Time: 211,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "Numb (Encore)",
    Artist: "Jay-Z & Linkin Park",
    Album: "Collision Course EP",
    Time: 205,
    Year: 2004,
    Plays: 2,
  },
  {
    Name: "Points of Authority/99 Problems/One Step Closer",
    Artist: "Jay-Z & Linkin Park",
    Album: "Collision Course EP",
    Time: 295,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "Run This Town (feat. Kanye West & Rihanna)",
    Artist: "JAY-Z, Kanye West & Rihanna",
    Album: "The Hits Collection, Vol. 1 (International Version)",
    Time: 268,
    Year: 2009,
    Plays: 7,
  },
  {
    Name: "All",
    Artist: "Jayryde & Lil Sleep",
    Album: "High Definition",
    Time: 241,
    Year: null,
    Plays: null,
  },
  {
    Name: "Is You Mad",
    Artist: "Jayryde & Lil Sleep",
    Album: "High Definition",
    Time: 253,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Neva",
    Artist: "Jayryde & Lil Sleep",
    Album: "High Definition",
    Time: 248,
    Year: null,
    Plays: null,
  },
  {
    Name: "Rubber Bands",
    Artist: "Jayryde & Lil Sleep",
    Album: "High Definition",
    Time: 160,
    Year: null,
    Plays: null,
  },
  {
    Name: "She Go",
    Artist: "Jayryde & Lil Sleep",
    Album: "High Definition",
    Time: 212,
    Year: null,
    Plays: null,
  },
  {
    Name: "Turn up",
    Artist: "Jayryde & Lil Sleep",
    Album: "High Definition",
    Time: 192,
    Year: null,
    Plays: null,
  },
  {
    Name: "Blow The Movie",
    Artist: "Jayryde & Lil Sleep ",
    Album: "High Definition",
    Time: 199,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "She Got it (dirty)",
    Artist: "Jayryde & Lil Sleep ",
    Album: "High Definition",
    Time: 180,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "M.I.A.",
    Artist: "Jayryde & Lil Sleep & CA",
    Album: "High Definition",
    Time: 268,
    Year: null,
    Plays: null,
  },
  {
    Name: "Psychic",
    Artist: "Jayryde & Lil Sleep & Kandis",
    Album: "High Definition",
    Time: 249,
    Year: null,
    Plays: null,
  },
  {
    Name: "Probably Cuz",
    Artist: "Jayryde & Lil Sleep & Medik",
    Album: "High Definition",
    Time: 235,
    Year: null,
    Plays: null,
  },
  {
    Name: "Waiting for",
    Artist: "Jayryde & Lil Sleep & Ms Kriss",
    Album: "High Definition",
    Time: 186,
    Year: null,
    Plays: null,
  },
  {
    Name: "Celebration",
    Artist: "Jayryde & Lil Sleep & Shano",
    Album: "High Definition",
    Time: 275,
    Year: null,
    Plays: null,
  },
  {
    Name: "Ciroc",
    Artist: "Jayryde & Lil Sleep & T Looney",
    Album: "High Definition",
    Time: 227,
    Year: null,
    Plays: null,
  },
  {
    Name: "Ok Ok",
    Artist: "JB Scofield",
    Album: "Ok Ok - Single",
    Time: 183,
    Year: 2019,
    Plays: 20,
  },
  {
    Name: "run away (scar & young simba interlude)",
    Artist: "JD McCrary & Chiwetel Ejiofor",
    Album: "The Lion King: The Gift",
    Time: 29,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "danger (young simba & young nala interlude)",
    Artist: "JD McCrary & Shahadi Wright Joseph",
    Album: "The Lion King: The Gift",
    Time: 16,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "I Just Can't Wait to Be King",
    Artist: "JD McCrary, Shahadi Wright Joseph & John Oliver",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 202,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Rains of Castamere",
    Artist: "Jeff Winner",
    Album: "My Epic Versions",
    Time: 190,
    Year: 2013,
    Plays: 16,
  },
  {
    Name: "Catch Fire",
    Artist: "Jenix",
    Album: "Kill the Silence",
    Time: 257,
    Year: 2011,
    Plays: 26,
  },
  {
    Name: "Amor, Amor, Amor (feat. Wisin)",
    Artist: "Jennifer Lopez",
    Album: "Amor, Amor, Amor (feat. Wisin) - Single",
    Time: 198,
    Year: 2017,
    Plays: 16,
  },
  {
    Name: "Dinero (feat. DJ Khaled & Cardi B)",
    Artist: "Jennifer Lopez",
    Album: "Dinero (feat. DJ Khaled & Cardi B) - Single",
    Time: 213,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "El Anillo",
    Artist: "Jennifer Lopez",
    Album: "El Anillo - Single",
    Time: 176,
    Year: 2018,
    Plays: 25,
  },
  {
    Name: "On the Floor (feat. Pitbull)",
    Artist: "Jennifer Lopez",
    Album: "Love?",
    Time: 284,
    Year: 2011,
    Plays: 29,
  },
  {
    Name: "Goin' In (Feat. Flo Rida)",
    Artist: "Jennifer Lopez",
    Album: "Step Up Revolution",
    Time: 249,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "I'm Into You (feat. Lil Wayne)",
    Artist: "Jennifer Lopez & Lil Wayne",
    Album: "I'm Into You (feat. Lil Wayne) - Single",
    Time: 234,
    Year: 2011,
    Plays: 7,
  },
  {
    Name: "Na Ba Ka",
    Artist: "Jeremiah Gyang & footplus",
    Album: "Na Ba Ka!",
    Time: 297,
    Year: 2006,
    Plays: 4,
  },
  {
    Name: "4 The Ladies (feat. A.K. From Do Or Die & Twista)",
    Artist: "Jeremih",
    Album: "Late Nights With Jeremih",
    Time: 278,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "Down On Me (feat. 50 Cent)",
    Artist: "Jeremih & 50 Cent",
    Album: "All About You",
    Time: 228,
    Year: 2010,
    Plays: 33,
  },
  {
    Name: "Paper",
    Artist: "Jeriq",
    Album: "Paper - Single",
    Time: 182,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Siren Song",
    Artist: "Jerry Cantrell",
    Album: "Siren Song - Single",
    Time: 300,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Phantasm",
    Artist: "Jesper Kyd",
    Album: "Jesper Kyd's Legacy (Original Soundtrack)",
    Time: 207,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "3 A.M.",
    Artist: "Jesse & Joy & Gente de Zona",
    Album: "3 A.M. - Single",
    Time: 183,
    Year: 2017,
    Plays: 31,
  },
  {
    Name: "Bang Bang",
    Artist: "Jessie J, Ariana Grande & Nicki Minaj",
    Album: "Bang Bang - Single",
    Time: 199,
    Year: 2014,
    Plays: 25,
  },
  {
    Name: "Meet Me In the Middle",
    Artist: "Jessie Ware",
    Album: "Fifty Shades of Grey",
    Time: 308,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Olofofo (feat. Shefzy)",
    Artist: "Jhay Splash",
    Album: "Olofofo (feat. Shefzy) - Single",
    Time: 237,
    Year: 2022,
    Plays: 36,
  },
  {
    Name: "The Vapors (feat. Vince Staples)",
    Artist: "Jhene Aiko",
    Album: "Sail Out",
    Time: 210,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Bed Peace (feat. Childish Gambino)",
    Artist: "Jhene Aiko",
    Album: "Sail Out",
    Time: 256,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Stay Ready (What a Life) [feat. Kendrick Lamar]",
    Artist: "Jhene Aiko",
    Album: "Sail Out",
    Time: 382,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Wth (feat. Ab-Soul)",
    Artist: "Jhene Aiko",
    Album: "Sail Out",
    Time: 199,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "The Worst",
    Artist: "Jhene Aiko",
    Album: "Sail Out",
    Time: 254,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "3:16 AM",
    Artist: "Jhene Aiko",
    Album: "Sail Out",
    Time: 200,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Comfort Inn Ending (Freestyle)",
    Artist: "Jhene Aiko",
    Album: "Sail Out",
    Time: 321,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "The Worst",
    Artist: "Jhené Aiko",
    Album: "Sail Out - EP",
    Time: 254,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Sativa (feat. Rae Sremmurd)",
    Artist: "Jhené Aiko",
    Album: "Sativa (feat. Rae Sremmurd) - Single",
    Time: 239,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Helicopters / Beware",
    Artist: "Jidenna",
    Album: "The Chief",
    Time: 378,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Best Boy",
    Artist: "JJ Wilde",
    Album: "Best Boy - Single",
    Time: 187,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Do Good",
    Artist: "Joe El.",
    Album: "Do Good - Single",
    Time: 199,
    Year: 2016,
    Plays: 36,
  },
  {
    Name: "Call",
    Artist: "Joeboy",
    Album: "Call - Single",
    Time: 165,
    Year: 2020,
    Plays: 14,
  },
  {
    Name: "Sip (Alcohol)",
    Artist: "Joeboy",
    Album: "Sip (Alcohol) - Single",
    Time: 158,
    Year: 2021,
    Plays: 19,
  },
  {
    Name: "Don't Call Me Back",
    Artist: "Joeboy & Mayorkun",
    Album: "Love & Light - EP",
    Time: 152,
    Year: 2019,
    Plays: 23,
  },
  {
    Name: "All of Me",
    Artist: "John Legend",
    Album: "Love in the Future",
    Time: 269,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Bliss",
    Artist: "John Legend & Teyana Taylor",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 210,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Sin City",
    Artist: "John Legend, Teyana Taylor, CyHi & Malik Yusef",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 268,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "odo (feat. Styl-Plus)",
    Artist: "Johnny Drille",
    Album: "Before We Fall Asleep",
    Time: 152,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "YEAH RIGHT",
    Artist: "Joji",
    Album: "BALLADS 1",
    Time: 174,
    Year: 2018,
    Plays: 19,
  },
  {
    Name: "Glimpse of Us",
    Artist: "Joji",
    Album: "Glimpse of Us - Single",
    Time: 233,
    Year: 2022,
    Plays: 6,
  },
  {
    Name: "Will He",
    Artist: "Joji",
    Album: "In Tongues - EP",
    Time: 202,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Carry Your Throne",
    Artist: "Jon Bellion",
    Album: "The Definition",
    Time: 203,
    Year: 2014,
    Plays: 18,
  },
  {
    Name: "All Time Low",
    Artist: "Jon Bellion",
    Album: "The Human Condition",
    Time: 217,
    Year: 2016,
    Plays: 41,
  },
  {
    Name: "Woke the F*ck Up",
    Artist: "Jon Bellion",
    Album: "The Human Condition",
    Time: 219,
    Year: 2016,
    Plays: 39,
  },
  {
    Name: "iRobot",
    Artist: "Jon Bellion",
    Album: "The Human Condition",
    Time: 208,
    Year: 2016,
    Plays: 24,
  },
  {
    Name: "Sucker",
    Artist: "Jonas Brothers",
    Album: "Happiness Begins",
    Time: 181,
    Year: 2019,
    Plays: 19,
  },
  {
    Name: "Burnin' Up",
    Artist: "Jonas Brothers",
    Album: "A Little Bit Longer",
    Time: 175,
    Year: 2008,
    Plays: 5,
  },
  {
    Name: "Basic Needs",
    Artist: "Jonathan Davis",
    Album: "Black Labyrinth",
    Time: 374,
    Year: 2018,
    Plays: 13,
  },
  {
    Name: "Wasteland",
    Artist: "Jonathan Hultén",
    Album: "Chants from Another Place",
    Time: 192,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Goodbyes",
    Artist: "Jorja Smith",
    Album: "Lost & Found",
    Time: 230,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Don't Watch Me Cry",
    Artist: "Jorja Smith",
    Album: "Lost & Found",
    Time: 190,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Isis (feat. Logic)",
    Artist: "Joyner Lucas",
    Album: "ADHD",
    Time: 236,
    Year: 2019,
    Plays: 15,
  },
  {
    Name: "I Love",
    Artist: "Joyner Lucas",
    Album: "I Love - Single",
    Time: 210,
    Year: 2018,
    Plays: 146,
  },
  {
    Name: "I'm Sorry",
    Artist: "Joyner Lucas",
    Album: "508-507-2209",
    Time: 349,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Claro Que Si (feat. Hyenas, Mohombie & Yasiris)",
    Artist: "Juan Magán",
    Album: "Claro Que Si (feat. Hyenas, Mohombie & Yasiris) - Single",
    Time: 182,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "Déjate Llevar (feat. Snova & B-Case)",
    Artist: "Juan Magán, Belinda & Manuel Turizo",
    Album: "Déjate Llevar - Single (feat. Snova & B-Case) - Single",
    Time: 233,
    Year: 2017,
    Plays: 70,
  },
  {
    Name: "Internacional",
    Artist: "Juan Magán, CeeLo Green & Andre Truth",
    Album: "Internacional - Single",
    Time: 216,
    Year: 2019,
    Plays: 8,
  },
  {
    Name: "Lucid Dreams",
    Artist: "Juice WRLD",
    Album: "Goodbye & Good Riddance",
    Time: 239,
    Year: 2017,
    Plays: 21,
  },
  {
    Name: "734",
    Artist: "Juice WRLD",
    Album: "Goodbye & Good Riddance (Anniversary Edition)",
    Time: 196,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Hide (feat. Seezyn)",
    Artist: "Juice WRLD",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 205,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Reminds Me of You",
    Artist: "Juice WRLD & The Kid LAROI",
    Album: "Reminds Me of You - Single",
    Time: 158,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Bandit",
    Artist: "Juice WRLD & YoungBoy Never Broke Again",
    Album: "Bandit - Single",
    Time: 189,
    Year: 2019,
    Plays: 124,
  },
  {
    Name: "Feline",
    Artist: "Juice WRLD, Polo G & Trippie Redd",
    Album: "Fighting Demons (Lyric Video Version)",
    Time: 212,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Bandz a Make Her Dance (feat. 2 Chainz & Lil Wayne)",
    Artist: "Juicy J",
    Album: "Stay Trippy",
    Time: 278,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: 'Shell Shocked (feat. Kill the Noise & Madsonik) [From "Teenage Mutant Ninja Turtles"]',
    Artist: "Juicy J, Wiz Khalifa & Ty Dolla $ign",
    Album:
      'Shell Shocked (feat. Kill the Noise & Madsonik) [From "Teenage Mutant Ninja Turtles"] - Single',
    Time: 203,
    Year: 2014,
    Plays: 64,
  },
  {
    Name: "Survive",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 90,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Escape",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 134,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Immortan's Citadel",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 521,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Blood Bag",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 150,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Spikey Cars",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 191,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Storm Is Coming",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 336,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Water",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 195,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "The Rig",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 253,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Brothers In Arms",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 262,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "The Bog",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 418,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Many Mothers",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 315,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Claw Trucks",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 331,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Chapter Doof (Extended Version)",
    Artist: "Junkie XL",
    Album: "Mad Max: Fury Road (Original Motion Picture Soundtrack)",
    Time: 424,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "We Are Not Things (Extended Version)",
    Artist: "Junkie XL",
    Album:
      "Mad Max: Fury Road (Original Motion Picture Soundtrack) [Deluxe Version]",
    Time: 102,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Redemption",
    Artist: "Junkie XL",
    Album:
      "Mad Max: Fury Road (Original Motion Picture Soundtrack) [Deluxe Version]",
    Time: 105,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Let Them Up",
    Artist: "Junkie XL",
    Album:
      "Mad Max: Fury Road (Original Motion Picture Soundtrack) [Deluxe Version]",
    Time: 156,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Coda (Bonus Track)",
    Artist: "Junkie XL",
    Album:
      "Mad Max: Fury Road (Original Motion Picture Soundtrack) [Deluxe Version]",
    Time: 283,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "All Around The World (feat. Ludacris)",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 244,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Boyfriend",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 171,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "As Long As You Love Me (feat. Big Sean)",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 229,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Take You",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 220,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Right Here (feat. Drake)",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 204,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Catching Feelings",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 234,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Fall",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 248,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Die In Your Arms",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 237,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Thought Of You",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 230,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Beauty And A Beat (feat. Nicki Minaj)",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 228,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "One Love",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 234,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Be Alright",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 189,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Believe",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 222,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Out Of Town Girl",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 213,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "She Don't Like The Lights",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 239,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Maria",
    Artist: "Justin Bieber",
    Album: "Believe (Deluxe Edition)",
    Time: 248,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Heartbreaker",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 261,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "All That Matters",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 188,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Hold Tight",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 255,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Recovery",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 180,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Bad Day",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 146,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "All Bad",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 181,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "PYD (feat. R. Kelly)",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 317,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Roller Coaster",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 200,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Change Me",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 164,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Confident (feat. Chance The Rapper)",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 247,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "One Life",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 242,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Backpack (feat. Lil Wayne)",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 251,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "What's Hatnin' (feat. Future)",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 208,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Swap It Out",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 241,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Memphis (feat. Big Sean)",
    Artist: "Justin Bieber",
    Album: "Journals",
    Time: 224,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Hold On",
    Artist: "Justin Bieber",
    Album: "Justice",
    Time: 170,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Ghost",
    Artist: "Justin Bieber",
    Album: "Justice",
    Time: 153,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Freedom",
    Artist: "Justin Bieber & Beam",
    Album: "Freedom. - EP",
    Time: 165,
    Year: 2021,
    Plays: 25,
  },
  {
    Name: "Love Never Felt So Good (Featuring Michael Jackson & Justin Timberlake)",
    Artist: "Justin Timberlake; Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 245,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Le temps",
    Artist: "Kaaris",
    Album: "Le bruit de mon âme",
    Time: 217,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "From Deep Within",
    Artist: "Kadavar & Elder",
    Album: "ELDOVAR - A Story of Darkness & Light",
    Time: 573,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "A Way for Us",
    Artist: "KAINA",
    Album: "Rise",
    Time: 213,
    Year: 2018,
    Plays: 47,
  },
  {
    Name: "Arise",
    Artist: "KAINA",
    Album: "Rise",
    Time: 233,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Believe",
    Artist: "Kalafina",
    Album: "Far on the Water",
    Time: 291,
    Year: 2014,
    Plays: 9,
  },
  {
    Name: "Magia",
    Artist: "Kalafina",
    Album: "Puella Magi Madoka Magica Music Collection",
    Time: 316,
    Year: 2011,
    Plays: 9,
  },
  {
    Name: "Lacrimosa",
    Artist: "Kalafina",
    Album: "Red Moon",
    Time: 254,
    Year: 2009,
    Plays: 14,
  },
  {
    Name: "to the beginning",
    Artist: "Kalafina",
    Album: "to the beginning",
    Time: 256,
    Year: 2012,
    Plays: 13,
  },
  {
    Name: "Manten",
    Artist: "Kalafina",
    Album: "to the beginning",
    Time: 315,
    Year: 2012,
    Plays: 23,
  },
  {
    Name: "to the beginning ~instrumental~",
    Artist: "Kalafina",
    Album: "to the beginning",
    Time: 254,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Way Down We Go",
    Artist: "KALEO",
    Album: "A / B",
    Time: 219,
    Year: 2015,
    Plays: 33,
  },
  {
    Name: "Loner",
    Artist: "Kali Uchis",
    Album: "Por Vida",
    Time: 212,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Donda Chant",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 52,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Jail",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 297,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "God Breathed",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 333,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Off The Grid",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 339,
    Year: 2021,
    Plays: 21,
  },
  {
    Name: "Hurricane",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 243,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Praise God",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 226,
    Year: 2021,
    Plays: 12,
  },
  {
    Name: "Jonah",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 195,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Ok Ok",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 204,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Junya",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 147,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Believe What I Say",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 242,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "24",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 197,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Remote Control",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 198,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Moon",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 156,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Heaven and Hell",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 145,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Donda",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 128,
    Year: 2021,
    Plays: 11,
  },
  {
    Name: "Keep My Spirit Alive",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 221,
    Year: 2021,
    Plays: 11,
  },
  {
    Name: "Jesus Lord",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 538,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "New Again",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 183,
    Year: 2021,
    Plays: 12,
  },
  {
    Name: "Tell The Vision",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 104,
    Year: 2021,
    Plays: 14,
  },
  {
    Name: "Lord I Need You",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 162,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Pure Souls",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 358,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Come to Life",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 310,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "No Child Left Behind",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 178,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Jail pt 2",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 297,
    Year: 2021,
    Plays: 12,
  },
  {
    Name: "Ok Ok pt 2",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 204,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Junya pt 2",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 182,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Jesus Lord pt 2",
    Artist: "Kanye West",
    Album: "Donda",
    Time: 690,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Never Abandon Your Family",
    Artist: "Kanye West",
    Album: "Donda (Deluxe)",
    Time: 207,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Stronger",
    Artist: "Kanye West",
    Album: "Graduation",
    Time: 312,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "Every Hour (feat. Sunday Service Choir)",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 112,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Selah",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 164,
    Year: 2019,
    Plays: 34,
  },
  {
    Name: "Follow God",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 104,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Closed on Sunday",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 151,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "On God",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 136,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Everything We Need (feat. Ty Dolla $ign & Ant Clemons)",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 116,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Water (feat. Ant Clemons)",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 168,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "God Is",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 203,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Hands On (feat. Fred Hammond)",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 203,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Use This Gospel (feat. Clipse & Kenny G)",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 213,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Jesus Is Lord",
    Artist: "Kanye West",
    Album: "JESUS IS KING",
    Time: 49,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Dark Fantasy",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 280,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Gorgeous (feat. Kid Cudi & Raekwon)",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 357,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Power",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 292,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "All of the Lights (Interlude)",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 62,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "All of the Lights",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 299,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Monster (feat. JAY Z, Rick Ross, Nicki Minaj & Bon Iver)",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 378,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "So Appalled (feat. JAY Z, Pusha T, Prynce Cy Hi, Swizz Beatz & RZA)",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 397,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Devil In a New Dress (feat. Rick Ross)",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 351,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Runaway (feat. Pusha T)",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 547,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Hell of a Life",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 327,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Blame Game (feat. John Legend)",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 469,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Lost In the World (feat. Bon Iver)",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 256,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Who Will Survive In America",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 98,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "See Me Now (feat. Beyoncé, Charlie Wilson & Big Sean) [Bonus Track]",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 363,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Runaway [Film] [Album Version (Explicit)]",
    Artist: "Kanye West",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 2069,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "On Sight",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 156,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Black Skinhead",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 188,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "I Am a God (feat. God)",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 231,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "New Slaves",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 256,
    Year: 2013,
    Plays: 8,
  },
  {
    Name: "Hold My Liquor",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 326,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "I'm In It",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 234,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Blood On the Leaves",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 360,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "Guilt Trip",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 243,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Send It Up",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 178,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Bound 2",
    Artist: "Kanye West",
    Album: "Yeezus",
    Time: 229,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "See You in My Nightmares (feat. Lil Wayne)",
    Artist: "Kanye West",
    Album: "808s & Heartbreak",
    Time: 258,
    Year: 2008,
    Plays: 23,
  },
  {
    Name: "Lost In the World (feat. Bon Iver)",
    Artist: "Kanye West & Bon Iver",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 256,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Blame Game (feat. John Legend)",
    Artist: "Kanye West & John Legend",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 469,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "I Love It",
    Artist: "Kanye West & Lil Pump",
    Album: "I Love It - Single",
    Time: 127,
    Year: 2018,
    Plays: 13,
  },
  {
    Name: "Runaway (feat. Pusha T)",
    Artist: "Kanye West & Pusha T",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 547,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "To the World",
    Artist: "Kanye West & R. Kelly",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 230,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Devil In a New Dress (feat. Rick Ross)",
    Artist: "Kanye West & Rick Ross",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 351,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "See Me Now (feat. Beyoncé, Charlie Wilson & Big Sean) [Bonus Track]",
    Artist: "Kanye West, Beyoncé, Charlie Wilson & Big Sean",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 363,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "The One",
    Artist: "Kanye West, Big Sean, 2 Chainz & Marsha Ambrosius",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 344,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Mercy.1",
    Artist: "Kanye West, Big Sean, Pusha T & 2 Chainz",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 326,
    Year: 2012,
    Plays: 12,
  },
  {
    Name: "Don't Like.1",
    Artist: "Kanye West, Chief Keef, Pusha T, Big Sean & Jadakiss",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 283,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Champions",
    Artist:
      "Kanye West, Gucci Mane, Big Sean, 2 Chainz, Travis Scott, Yo Gotti, Quavo & Desiigner",
    Album: "Champions - Single",
    Time: 334,
    Year: 2016,
    Plays: 12,
  },
  {
    Name: "Clique",
    Artist: "Kanye West, JAY-Z & Big Sean",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 293,
    Year: 2012,
    Plays: 11,
  },
  {
    Name: "So Appalled (feat. Jay-Z, Pusha T, Prynce Cy Hi, Swizz Beatz & RZA)",
    Artist: "Kanye West, JAY-Z, Pusha T, Prynce Cy Hi, Swizz Beatz & RZA",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 397,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Monster (feat. Jay-Z, Rick Ross, Nicki Minaj & Bon Iver)",
    Artist: "Kanye West, JAY-Z, Rick Ross, Nicki Minaj & Bon Iver",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 378,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Gorgeous (feat. Kid Cudi & Raekwon)",
    Artist: "Kanye West, Kid Cudi & Raekwon",
    Album: "My Beautiful Dark Twisted Fantasy (Deluxe Edition)",
    Time: 357,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "New God Flow.1",
    Artist: "Kanye West, Pusha T & Ghostface Killah",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 357,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "My Garden",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 237,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Gangsta",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 244,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Crazy",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 211,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Saturday Sunday",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 200,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "I Think I'm In Love",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 202,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Tumbao",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 230,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Mirror",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 257,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Lava",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 253,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Walk On Water",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 329,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Clocks",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 183,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Just Another Dude",
    Artist: "Kat Dahlia",
    Album: "My Garden",
    Time: 216,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Running Up That Hill (A Deal with God)",
    Artist: "Kate Bush",
    Album: "Hounds of Love (Remastered)",
    Time: 300,
    Year: 1985,
    Plays: null,
  },
  {
    Name: "Another Empty Bottle",
    Artist: "Katy McAllister",
    Album: "Katy Mac Throwbacks",
    Time: 228,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "I Kissed a Girl",
    Artist: "Katy Perry",
    Album: "One of the Boys",
    Time: 179,
    Year: 2008,
    Plays: 15,
  },
  {
    Name: "The One That Got Away (feat. B.o.B)",
    Artist: "Katy Perry",
    Album: "The One That Got Away (feat. B.o.B) - Single",
    Time: 262,
    Year: null,
    Plays: 6,
  },
  {
    Name: "Roar",
    Artist: "Katy Perry",
    Album: "PRISM (Deluxe)",
    Time: 223,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Rise",
    Artist: "Katy Perry",
    Album: "Rise - Single",
    Time: 203,
    Year: 2016,
    Plays: 71,
  },
  {
    Name: "Harleys In Hawaii",
    Artist: "Katy Perry",
    Album: "Smile",
    Time: 185,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "The One That Got Away",
    Artist: "Katy Perry",
    Album: "Teenage Dream",
    Time: 227,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Chained to the Rhythm (feat. Skip Marley)",
    Artist: "Katy Perry",
    Album: "Witness (Deluxe)",
    Time: 237,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Dark Horse",
    Artist: "Katy Perry Ft Juicy J",
    Album: "Dark Horse Single",
    Time: 215,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "Odd Look (feat. The Weeknd)",
    Artist: "Kavinsky",
    Album: "Kiss Land (Deluxe)",
    Time: 252,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Shake It (feat. Bory300)",
    Artist: "Kay Flock, Cardi B & Dougie B",
    Album: "Shake It (feat. Bory300) - Single",
    Time: 118,
    Year: 2022,
    Plays: 13,
  },
  {
    Name: "Codename: Rado (feat. Eeskay)",
    Artist: "KayDee Vibes",
    Album: "Codename: Rado (feat. Eeskay) - Single",
    Time: 217,
    Year: 2018,
    Plays: 22,
  },
  {
    Name: "Zaddy",
    Artist: "KayDee Vibes",
    Album: "Zaddy - Single",
    Time: 123,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "This Is Me",
    Artist: "Keala Settle & The Greatest Showman Ensemble",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 234,
    Year: 2017,
    Plays: 20,
  },
  {
    Name: "Again",
    Artist: "Kehlani",
    Album: "Again - Single",
    Time: 220,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Gangsta (Harley Quinn & Joker Flashback Version)",
    Artist: "Kehlani",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 169,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Striving Rabbit",
    Artist: "Keiji Inai",
    Album: "DanMachi - Memoria Freese (Original Soundtrack) -Sound of Memoria-",
    Time: 201,
    Year: 2020,
    Plays: 13,
  },
  {
    Name: "잊지마 (It G Ma)",
    Artist: "Keith Ape (feat. JayAllDay, Loota, Okasian & Kohh)",
    Album: "",
    Time: 322,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Motivation (feat. Lil Wayne)",
    Artist: "Kelly Rowland",
    Album: "Here I Am (International Bonus Track Edition)",
    Time: 243,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "BENZ  I Know REMIX",
    Artist: "Kelvyn Colt & GASHI",
    Album: "BENZ  I Know REMIX - Single",
    Time: 189,
    Year: 2020,
    Plays: 49,
  },
  {
    Name: "Désolé",
    Artist: "Kelvyn Colt & Jok'air",
    Album: "Désolé - Single",
    Time: 172,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "HUMBLE.",
    Artist: "Kendrick Lamar",
    Album: "DAMN.",
    Time: 177,
    Year: 2017,
    Plays: 12,
  },
  {
    Name: "HUMBLE.",
    Artist: "Kendrick Lamar",
    Album: "DAMN. COLLECTORS EDITION.",
    Time: 177,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Sherane A.K.A Master Splinter’s Daughter",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 273,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Bitch, Don’t Kill My Vibe",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 310,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Backseat Freestyle",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 212,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "The Art of Peer Pressure",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 324,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Money Trees (feat. Jay Rock)",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 386,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Poetic Justice (feat. Drake)",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 300,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Good Kid",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 214,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "m.A.A.d city (feat. MC Eiht)",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 350,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Swimming Pools (Drank) [Extended Version]",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 313,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Sing About Me, I'm Dying of Thirst",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 723,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Real (feat. Anna Wise)",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 443,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Compton (feat. Dr. Dre)",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 248,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The Recipe (feat. Dr. Dre)",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 352,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Black Boy Fly",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 278,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Now Or Never (feat. Mary J. Blige)",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 257,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Collect Calls",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 237,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Swimming Pools (Drank)",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 247,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Bitch, Don’t Kill My Vibe (feat. JAY Z) [Remix]",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 278,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Bitch, Don’t Kill My Vibe (feat. Emeli Sandé) [International Remix]",
    Artist: "Kendrick Lamar",
    Album: "good kid, m.A.A.d city (Deluxe)",
    Time: 306,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Wesley's Theory (feat. George Clinton & Thundercat)",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 287,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "For Free? (Interlude)",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 130,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "King Kunta",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 234,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Institutionalized (feat. Bilal, Anna Wise & Snoop Dogg)",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 271,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "These Walls (feat. Bilal, Anna Wise & Thundercat)",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 300,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "u",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 268,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Alright",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 219,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "For Sale? (Interlude)",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 291,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Momma",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 283,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Hood Politics",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 292,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "How Much a Dollar Cost (feat. James Fauntleroy & Ronald Isley)",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 261,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Complexion (A Zulu Love) [feat. Rapsody]",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 263,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "The Blacker the Berry",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 328,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "You Ain't Gotta Lie (Momma Said)",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 241,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "i",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 336,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Mortal Man",
    Artist: "Kendrick Lamar",
    Album: "To Pimp a Butterfly",
    Time: 727,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "The Gambler",
    Artist: "Kenny Rogers",
    Album: "Very Best of Kenny Rogers",
    Time: 211,
    Year: 1978,
    Plays: 6,
  },
  {
    Name: "Buyou",
    Artist: "Keri Hilson",
    Album: "No Boys Allowed",
    Time: 259,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "TiK ToK",
    Artist: "Kesha",
    Album: "Animal (Expanded Edition)",
    Time: 199,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Die Young",
    Artist: "Kesha",
    Album: "Warrior (Deluxe Version)",
    Time: 212,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Die Young (Remix)",
    Artist: "Kesha ft Juicy J, Wiz Khalifa & Becky G",
    Album: "",
    Time: 244,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Big Lyfe",
    Artist: "Kevin Gates",
    Album: "Big Lyfe - Single",
    Time: 240,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Dreka",
    Artist: "Kevin Gates",
    Album: "Dreka - Single",
    Time: 264,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Federal Pressure (feat. Moneybagg Yo)",
    Artist: "Kevin Gates",
    Album: "Federal Pressure (feat. Moneybagg Yo) - Single",
    Time: 171,
    Year: 2018,
    Plays: 12,
  },
  {
    Name: "2 Phones",
    Artist: "Kevin Gates",
    Album: "Islah (Deluxe)",
    Time: 240,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Thinking With My Dick (feat. Juicy J)",
    Artist: "Kevin Gates",
    Album: "Stranger Than Fiction",
    Time: 165,
    Year: 2013,
    Plays: 9,
  },
  {
    Name: "Know Better",
    Artist: "Kevin Gates",
    Album: "Suicide Squad (Original Motion Picture Soundtrack)",
    Time: 208,
    Year: 2016,
    Plays: 7,
  },
  {
    Name: "Know Better",
    Artist: "Kevin Gates",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 208,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Turn Me On",
    Artist: "Kevin Lyttle",
    Album: "Kevin Lyttle (US Domestic release)",
    Time: 192,
    Year: 2003,
    Plays: 13,
  },
  {
    Name: "I Will Not Break (feat. Lil Wayne)",
    Artist: "Kevin Rudolf",
    Album: "I Will Not Break (feat. Lil Wayne) - Single",
    Time: 208,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "I Made It (Cash Money Heroes) [feat. Birdman, Jay Sean & Lil Wayne]",
    Artist: "Kevin Rudolf",
    Album: "To the Sky",
    Time: 249,
    Year: 2010,
    Plays: 11,
  },
  {
    Name: "Coaster",
    Artist: "Khalid",
    Album: "American Teen",
    Time: 199,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Creepers",
    Artist: "Kid Cudi",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 194,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Frequency",
    Artist: "Kid Cudi",
    Album: "Passion, Pain & Demon Slayin'",
    Time: 298,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "WITHOUT YOU",
    Artist: "The Kid LAROI",
    Album: "F*CK LOVE (SAVAGE)",
    Time: 161,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "WITHOUT YOU (Miley Cyrus Remix)",
    Artist: "The Kid LAROI & Miley Cyrus",
    Album: "WITHOUT YOU (Miley Cyrus Remix) - Single",
    Time: 161,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Flesh and Bone",
    Artist: "The Killers",
    Album: "Battle Born",
    Time: 241,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "I Can't Be the Only One (Alternate Edit)",
    Artist: "Killswitch Engage",
    Album: "I Can't Be the Only One (Alternate Edit) - Single",
    Time: 203,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Can We Kiss Forever? (feat. Adriana Proenza)",
    Artist: "Kina",
    Album: "Can We Kiss Forever? (feat. Adriana Proenza) - Single",
    Time: 187,
    Year: 2018,
    Plays: 20,
  },
  {
    Name: "Can't Help Falling in Love",
    Artist: "Kina Grannis",
    Album: "Crazy Rich Asians (Original Motion Picture Soundtrack)",
    Time: 201,
    Year: 2018,
    Plays: 24,
  },
  {
    Name: "Money's All I Want",
    Artist: "King Fresco",
    Album: "Sunny D and Dutches",
    Time: 196,
    Year: 2017,
    Plays: 9,
  },
  {
    Name: "Steady",
    Artist: "King Jaynesiz",
    Album: "Steady - Single",
    Time: 210,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Work 'N' Grind",
    Artist: "King Perryy",
    Album: "Work 'N' Grind - Single",
    Time: 202,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "HIGHSCHOOL OF THE DEAD",
    Artist: "Kishida Kyoudan & The Myoujou Rocket",
    Album: "HIGHSCHOOL OF THE DEAD",
    Time: 202,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Ripple",
    Artist: "Kishida Kyoudan & The Myoujou Rocket",
    Album: "HIGHSCHOOL OF THE DEAD",
    Time: 227,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Mama",
    Artist: "Kizz Daniel",
    Album: "New Era",
    Time: 220,
    Year: 2016,
    Plays: 4,
  },
  {
    Name: "And so It Begins",
    Artist: "Klergy",
    Album: "And so It Begins - Single",
    Time: 208,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Caught in the Fire",
    Artist: "Klergy",
    Album: "Caught in the Fire - Single",
    Time: 246,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "The End",
    Artist: "Klergy",
    Album: "The End - Single",
    Time: 210,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Endgame",
    Artist: "Klergy",
    Album: "Endgame - Single",
    Time: 168,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Fight for Survival",
    Artist: "Klergy",
    Album: "Fight for Survival - Single",
    Time: 221,
    Year: 2018,
    Plays: 27,
  },
  {
    Name: "Where Your Secrets Hide (feat. Katie Garfield)",
    Artist: "Klergy",
    Album: "Where Your Secrets Hide (feat. Katie Garfield) - Single",
    Time: 221,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "World on Fire",
    Artist: "Klergy",
    Album: "World on Fire - Single",
    Time: 226,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Start a War",
    Artist: "Klergy & Valerie Broussard",
    Album: "Start a War - Single",
    Time: 214,
    Year: 2017,
    Plays: 41,
  },
  {
    Name: "Koni Koni Love (feat. Danny Young)",
    Artist: "Klever Jay",
    Album: "Klever Music Volume 1 - EP",
    Time: 247,
    Year: 2010,
    Plays: 15,
  },
  {
    Name: "Kimi wo Mamoritai",
    Artist: "Kobayashi Aika",
    Album: "COLOR",
    Time: 233,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "ZEZE (feat. Travis Scott & Offset)",
    Artist: "Kodak Black",
    Album: "ZEZE (feat. Travis Scott & Offset) - Single",
    Time: 228,
    Year: 2018,
    Plays: 17,
  },
  {
    Name: "Give Them",
    Artist: "Koker",
    Album: "Give Them - Single",
    Time: 183,
    Year: 2016,
    Plays: 30,
  },
  {
    Name: "Tsumetai Heya, Hitori",
    Artist: "Komatsu Mikako",
    Album: "Tsumetai Heya, Hitori",
    Time: 235,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The Devil Went Down to Georgia (feat. YelaWolf)",
    Artist: "Korn",
    Album: "The Devil Went Down to Georgia (feat. YelaWolf) - Single",
    Time: 231,
    Year: 2020,
    Plays: 26,
  },
  {
    Name: "GOATED (Intro)",
    Artist: "Kpdarula",
    Album: "The Created Playerrr",
    Time: 82,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Squeeze Me (Feat Ben Westbeech)",
    Artist: "Kraak and Smaak",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 197,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Don't Waste My Time",
    Artist: "Krept & Konan",
    Album: "Don't Waste My Time - Single",
    Time: 207,
    Year: 2014,
    Plays: 79,
  },
  {
    Name: "Fly Away",
    Artist: "Krys Talk",
    Album: "Fly Away - Single",
    Time: 288,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Down Like That (feat. Rick Ross, Lil Baby & S-X)",
    Artist: "KSI",
    Album: "Down Like That (feat. Rick Ross, Lil Baby & S-X) - Single",
    Time: 175,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Hole in My Head",
    Artist: "Kulick",
    Album: "Hydroplane - EP",
    Time: 191,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Furui Kyuujitsu no Uta",
    Artist: "Kurihara Masaki",
    Album: "Furui Kyuujitsu no Uta",
    Time: 225,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "All of Me",
    Artist: "Kurt Hugo Schneider, MAX & Zendaya",
    Album: "Piano Acoustic Covers, Vol. 1",
    Time: 233,
    Year: 2014,
    Plays: 12,
  },
  {
    Name: "Don't Keep Me Waiting (feat. Kidi)",
    Artist: "Kwesi Arthur",
    Album: "Don't Keep Me Waiting (feat. Kidi) - Single",
    Time: 227,
    Year: 2018,
    Plays: 26,
  },
  {
    Name: "Baajo",
    Artist: "Kwesi Arthur & Joeboy",
    Album: "Baajo - Single",
    Time: 160,
    Year: 2020,
    Plays: 127,
  },
  {
    Name: "Dark Thoughts",
    Artist: "Kyd the Band",
    Album: "Dark Thoughts - Single",
    Time: 220,
    Year: 2019,
    Plays: 27,
  },
  {
    Name: "Stole the Show (feat. Parson James)",
    Artist: "Kygo",
    Album: "Cloud Nine",
    Time: 223,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "With You (feat. Wrabel)",
    Artist: "Kygo",
    Album: "Kids in Love (Re-Release)",
    Time: 210,
    Year: 2017,
    Plays: 5,
  },
  {
    Name: "Kids in Love (feat. The Night Game)",
    Artist: "Kygo",
    Album: "Kids in Love (Re-Release)",
    Time: 263,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Get Along",
    Artist: "L.A. Guns",
    Album: "Checkered Past",
    Time: 330,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "We All Knew",
    Artist: "Labrinth",
    Album: "Euphoria (Original Score from the HBO Series)",
    Time: 181,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Oblivion (feat. Sia)",
    Artist: "Labrinth",
    Album: "Imagination & the Misfit Kid",
    Time: 253,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Jealous",
    Artist: "Labrinth",
    Album: "Jealous - Single",
    Time: 287,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Something's Got to Give",
    Artist: "Labrinth",
    Album: "Something's Got to Give - Single",
    Time: 229,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Trip the Darkness",
    Artist: "Lacuna Coil",
    Album: "Dark Adrenaline",
    Time: 193,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Aura",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 235,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Venus",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 233,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "G.U.Y.",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 232,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Sexxx Dreams",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 214,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Jewels N' Drugs (feat. T.I., Too $hort & Twista)",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 228,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "MANiCURE",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 199,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "ARTPOP",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 247,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Swine",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 268,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Donatella",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 264,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Fashion!",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 239,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Mary Jane Holland",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 277,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Dope",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 221,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Gypsy",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 248,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Applause",
    Artist: "Lady Gaga",
    Album: "ARTPOP",
    Time: 212,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Judas",
    Artist: "Lady Gaga",
    Album: "Born This Way",
    Time: 249,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Bad Romance",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 296,
    Year: 2009,
    Plays: 7,
  },
  {
    Name: "Alejandro",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 276,
    Year: 2009,
    Plays: 8,
  },
  {
    Name: "Monster",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 251,
    Year: 2009,
    Plays: 8,
  },
  {
    Name: "Speechless",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 272,
    Year: 2009,
    Plays: 4,
  },
  {
    Name: "Dance In The Dark",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 291,
    Year: 2009,
    Plays: 10,
  },
  {
    Name: "Telephone (feat. Beyoncé)",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 222,
    Year: 2009,
    Plays: 20,
  },
  {
    Name: "So Happy I Could Die",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 237,
    Year: 2009,
    Plays: 4,
  },
  {
    Name: "Teeth",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 220,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Just Dance (Feat. Colby O'Donis)",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 243,
    Year: 2009,
    Plays: 5,
  },
  {
    Name: "LoveGame",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 220,
    Year: 2009,
    Plays: 15,
  },
  {
    Name: "Paparazzi",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 211,
    Year: 2009,
    Plays: 11,
  },
  {
    Name: "Poker Face",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 241,
    Year: 2009,
    Plays: 34,
  },
  {
    Name: "Eh, Eh (Nothing Else I Can Say)",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 177,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Beautiful, Dirty, Rich",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 175,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "The Fame",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 224,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Money Honey",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 174,
    Year: 2009,
    Plays: 3,
  },
  {
    Name: "Starstruck (Feat. Space Cowboy and Flo Rida)",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 221,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Boys Boys Boys",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 203,
    Year: 2009,
    Plays: 35,
  },
  {
    Name: "Paper Gangsta",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 267,
    Year: 2009,
    Plays: 11,
  },
  {
    Name: "Brown Eyes",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 247,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "I Like It Rough",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 206,
    Year: 2009,
    Plays: 4,
  },
  {
    Name: "Summerboy",
    Artist: "Lady GaGa",
    Album: "The Fame Monster",
    Time: 255,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Bad Romance",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 294,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Alejandro",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 274,
    Year: 2009,
    Plays: 3,
  },
  {
    Name: "Monster",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 249,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Speechless",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 270,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Dance in the Dark",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 288,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Telephone (feat. Beyoncé)",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 220,
    Year: 2009,
    Plays: 9,
  },
  {
    Name: "So Happy I Could Die",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 234,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Teeth",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 220,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Bad Romance (Starsmith Remix)",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 295,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Just Dance (feat. Colby O'Donis)",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 242,
    Year: 2008,
    Plays: 7,
  },
  {
    Name: "LoveGame",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 216,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "Paparazzi",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 208,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Poker Face",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 237,
    Year: 2008,
    Plays: 7,
  },
  {
    Name: "Eh, Eh (Nothing Else I Can Say)",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 175,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Beautiful, Dirty, Rich",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 172,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "The Fame",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 221,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Money Honey",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 170,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Starstruck (feat. Space Cowboy & Flo Rida)",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 216,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Boys Boys Boys",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 200,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Paper Gangsta",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 263,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Brown Eyes",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 242,
    Year: 2008,
    Plays: 3,
  },
  {
    Name: "I Like It Rough",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 202,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Summerboy",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 253,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Disco Heaven",
    Artist: "Lady Gaga",
    Album: "The Fame Monster (Deluxe Edition)",
    Time: 221,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Sour Candy",
    Artist: "Lady Gaga & BLACKPINK",
    Album: "Chromatica",
    Time: 157,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Free Woman (Rina Sawayama & Clarence Clarity Remix)",
    Artist: "Lady Gaga, Rina Sawayama & Clarence Clarity",
    Album: "Dawn Of Chromatica",
    Time: 233,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Konko Below",
    Artist: "Lagbaja",
    Album: "Best of Nigerian Local Classics 1",
    Time: 372,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "Mountain View",
    Artist: "Lakeshore",
    Album: "Mountain View - Single",
    Time: 205,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Born To Die",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 286,
    Year: 2012,
    Plays: 31,
  },
  {
    Name: "Off To The Races",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 299,
    Year: 2012,
    Plays: 17,
  },
  {
    Name: "Blue Jeans",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 209,
    Year: 2012,
    Plays: 15,
  },
  {
    Name: "Video Games",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 282,
    Year: 2012,
    Plays: 14,
  },
  {
    Name: "Diet Mountain Dew",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 222,
    Year: 2012,
    Plays: 28,
  },
  {
    Name: "National Anthem",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 230,
    Year: 2012,
    Plays: 16,
  },
  {
    Name: "Dark Paradise",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 243,
    Year: 2012,
    Plays: 28,
  },
  {
    Name: "Radio",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 214,
    Year: 2012,
    Plays: 26,
  },
  {
    Name: "Carmen",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 248,
    Year: 2012,
    Plays: 21,
  },
  {
    Name: "Million Dollar Man",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 231,
    Year: 2012,
    Plays: 21,
  },
  {
    Name: "Summertime Sadness",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 265,
    Year: 2012,
    Plays: 18,
  },
  {
    Name: "This Is What Makes Us Girls",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 238,
    Year: 2012,
    Plays: 13,
  },
  {
    Name: "Without You",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 229,
    Year: 2012,
    Plays: 15,
  },
  {
    Name: "Lolita",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 220,
    Year: 2012,
    Plays: 13,
  },
  {
    Name: "Lucky Ones",
    Artist: "Lana Del Rey",
    Album: "Born To Die",
    Time: 227,
    Year: 2012,
    Plays: 17,
  },
  {
    Name: "Born to Die",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 285,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Off to the Races",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 299,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Blue Jeans",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 209,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Video Games",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 281,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Diet Mountain Dew",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 222,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "National Anthem",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 230,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Dark Paradise",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 243,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Radio",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 214,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Carmen",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 248,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Million Dollar Man",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 231,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Summertime Sadness",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 265,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "This Is What Makes Us Girls",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 238,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Without You",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 229,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Lolita",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 220,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Lucky Ones",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 225,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Ride",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 289,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "American",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 248,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Cola",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 260,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Body Electric",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 233,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Blue Velvet",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 158,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Gods & Monsters",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 237,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Yayo",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 321,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Bel Air",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 237,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Burning Desire",
    Artist: "Lana Del Rey",
    Album: "Born to Die - The Paradise Edition",
    Time: 231,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Doin' Time",
    Artist: "Lana Del Rey",
    Album: "Doin' Time - Single",
    Time: 201,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Honeymoon",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 351,
    Year: 2015,
    Plays: 31,
  },
  {
    Name: "Music To Watch Boys To",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 290,
    Year: 2015,
    Plays: 29,
  },
  {
    Name: "Terrence Loves You",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 290,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "God Knows I Tried",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 280,
    Year: 2015,
    Plays: 39,
  },
  {
    Name: "High By The Beach",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 257,
    Year: 2015,
    Plays: 25,
  },
  {
    Name: "Freak",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 295,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "Art Deco",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 295,
    Year: 2015,
    Plays: 21,
  },
  {
    Name: "Burnt Norton (Interlude)",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 82,
    Year: 2015,
    Plays: 26,
  },
  {
    Name: "Religion",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 323,
    Year: 2015,
    Plays: 59,
  },
  {
    Name: "Salvatore",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 281,
    Year: 2015,
    Plays: 26,
  },
  {
    Name: "The Blackest Day",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 365,
    Year: 2015,
    Plays: 40,
  },
  {
    Name: "24",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 296,
    Year: 2015,
    Plays: 26,
  },
  {
    Name: "Swan Song",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 323,
    Year: 2015,
    Plays: 40,
  },
  {
    Name: "Don't Let Me Be Misunderstood",
    Artist: "Lana Del Rey",
    Album: "Honeymoon",
    Time: 184,
    Year: 2015,
    Plays: 50,
  },
  {
    Name: "hope is a dangerous thing for a woman like me to have - but i have it",
    Artist: "Lana Del Rey",
    Album:
      "hope is a dangerous thing for a woman like me to have - but i have it - Single",
    Time: 324,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Love",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 272,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Lust for Life (feat. The Weeknd)",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 264,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "13 Beaches",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 295,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Cherry",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 180,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "White Mustang",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 164,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Summer Bummer (feat. A$AP Rocky & Playboi Carti)",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 260,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Groupie Love (feat. A$AP Rocky)",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 264,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "In My Feelings",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 238,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Coachella - Woodstock In My Mind",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 258,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "God Bless America - And All the Beautiful Women In It",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 276,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "When the World Was At War We Kept Dancing",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 275,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Beautiful People Beautiful Problems (feat. Stevie Nicks)",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 253,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Tomorrow Never Came (feat. SEAN ONO LENNON)",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 307,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Heroin",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 355,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Change",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 321,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Get Free",
    Artist: "Lana Del Rey",
    Album: "Lust for Life",
    Time: 334,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: 'Season of the Witch (From the Motion Picture "Scary Stories to Tell in the Dark")',
    Artist: "Lana Del Rey",
    Album:
      'Season of the Witch (From the Motion Picture "Scary Stories to Tell in the Dark") - Single',
    Time: 247,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Cruel World",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 400,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "Ultraviolence",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 251,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "Shades Of Cool",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 342,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "Brooklyn Baby",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 351,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "West Coast",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 256,
    Year: 2014,
    Plays: 17,
  },
  {
    Name: "Sad Girl",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 317,
    Year: 2014,
    Plays: 11,
  },
  {
    Name: "Pretty When You Cry",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 234,
    Year: 2014,
    Plays: 10,
  },
  {
    Name: "Money Power Glory",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 270,
    Year: 2014,
    Plays: 20,
  },
  {
    Name: "Fucked My Way Up To The Top",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 212,
    Year: 2014,
    Plays: 9,
  },
  {
    Name: "Old Money",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 271,
    Year: 2014,
    Plays: 28,
  },
  {
    Name: "The Other Woman",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 182,
    Year: 2014,
    Plays: 7,
  },
  {
    Name: "West Coast (Radio Mix)",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 227,
    Year: 2014,
    Plays: 16,
  },
  {
    Name: "Black Beauty",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 314,
    Year: 2014,
    Plays: 17,
  },
  {
    Name: "Guns And Roses",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 270,
    Year: 2014,
    Plays: 16,
  },
  {
    Name: "Florida Kilos",
    Artist: "Lana Del Rey",
    Album: "Ultraviolence (Limited Deluxe Edition)",
    Time: 256,
    Year: 2014,
    Plays: 11,
  },
  {
    Name: "Egedege (feat. Theresa Onuorah, Flavour & Phyno)",
    Artist: "Larry Gaaga",
    Album: "Egedege (feat. Theresa Onuorah, Flavour & Phyno) - Single",
    Time: 223,
    Year: 2021,
    Plays: 11,
  },
  {
    Name: "In My Head",
    Artist: "Larry Gaaga & Patoranking",
    Album: "In My Head - Single",
    Time: 194,
    Year: 2019,
    Plays: 113,
  },
  {
    Name: "No Panties",
    Artist: "Latto",
    Album: "Hit the Latto - EP",
    Time: 153,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Undiscovered",
    Artist: "Laura Welsh",
    Album: "Fifty Shades of Grey",
    Time: 173,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Verified (feat. Mayorkun)",
    Artist: "Laycon",
    Album: "...Shall We Begin...",
    Time: 186,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Fierce (feat. Reminisce & Chinko Ekun)",
    Artist: "Laycon",
    Album: "Who Is Laycon?",
    Time: 216,
    Year: 2019,
    Plays: 45,
  },
  {
    Name: "Kill Kill",
    Artist: "Le Destroy & The Bait",
    Album: "Cyberpunk 2077: Radio, Vol. 1 (Original Soundtrack)",
    Time: 202,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Warrior Inside",
    Artist: "Leader",
    Album: "Warrior Inside - Single",
    Time: 203,
    Year: 2015,
    Plays: 17,
  },
  {
    Name: "As We Fall",
    Artist: "League of Legends",
    Album: "As We Fall - Single",
    Time: 189,
    Year: 2017,
    Plays: 17,
  },
  {
    Name: "Legends Never Die",
    Artist: "League of Legends & Against The Current",
    Album: "Legends Never Die - Single",
    Time: 235,
    Year: 2017,
    Plays: 51,
  },
  {
    Name: "Warriors",
    Artist: "League of Legends, 2WEI & Edda Hayes",
    Album: "Warriors - Single",
    Time: 204,
    Year: 2020,
    Plays: 10,
  },
  {
    Name: "RISE (feat. The Word Alive)",
    Artist: "League of Legends, The Glitch Mob & Mako",
    Album: "RISE (feat. The Word Alive) - Single",
    Time: 192,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Awaken",
    Artist: "League of Legends, Valerie Broussard & Ray Chen",
    Album: "Awaken - Single",
    Time: 198,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Silver Lining",
    Artist: "Leaving Haven",
    Album: "Silver Lining - Single",
    Time: 206,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "He Lives in You",
    Artist: "Lebo M",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 305,
    Year: 2019,
    Plays: 127,
  },
  {
    Name: "Mbube",
    Artist: "Lebo M",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 116,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Not Dead Yet",
    Artist: "LEDGER",
    Album: "Ledger - EP",
    Time: 216,
    Year: 2018,
    Plays: 24,
  },
  {
    Name: "Hallelujah",
    Artist: "Leonard Cohen",
    Album: "Various Positions",
    Time: 279,
    Year: 1984,
    Plays: null,
  },
  {
    Name: 'Call the Shots (From the Motion Picture "Miss Bala")',
    Artist: "Leslie Grace",
    Album: 'Call the Shots (From the Motion Picture "Miss Bala") - Single',
    Time: 211,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Díganle (Tainy Remix)",
    Artist: "Leslie Grace, Becky G. & CNCO",
    Album: "Díganle (Tainy Remix) - Single",
    Time: 211,
    Year: 2018,
    Plays: 54,
  },
  {
    Name: "Before You Go",
    Artist: "Lewis Capaldi",
    Album: "Divinely Uninspired To a Hellish Extent (Extended Edition)",
    Time: 216,
    Year: 2019,
    Plays: 14,
  },
  {
    Name: "Scars of You",
    Artist: "A Light Divided",
    Album: "Scars of You - Single",
    Time: 226,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Press Rewind",
    Artist: "Lightscape",
    Album: "Circles - EP",
    Time: 231,
    Year: 2017,
    Plays: 74,
  },
  {
    Name: "Man Listening to Disc",
    Artist: "Liily",
    Album: "TV or Not TV",
    Time: 203,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Dark Divine",
    Artist: "Like Moths to Flames",
    Album: "Dark Divine",
    Time: 221,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "The Bigger Picture",
    Artist: "Lil Baby",
    Album: "The Bigger Picture - Single",
    Time: 252,
    Year: 2020,
    Plays: 80,
  },
  {
    Name: "Errbody",
    Artist: "Lil Baby",
    Album: "Errbody - Single",
    Time: 210,
    Year: 2020,
    Plays: 21,
  },
  {
    Name: "Woah",
    Artist: "Lil Baby",
    Album: "My Turn (Deluxe)",
    Time: 183,
    Year: 2019,
    Plays: 33,
  },
  {
    Name: "Right On",
    Artist: "Lil Baby",
    Album: "Right On - Single",
    Time: 213,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "Sum 2 Prove",
    Artist: "Lil Baby",
    Album: "Sum 2 Prove - Single",
    Time: 205,
    Year: 2020,
    Plays: 22,
  },
  {
    Name: "U-Digg (feat. Veeze)",
    Artist: "Lil Baby & 42 Dugg",
    Album: "U-Digg (feat. Veeze) - Single",
    Time: 235,
    Year: 2022,
    Plays: 5,
  },
  {
    Name: "2040",
    Artist: "Lil Baby & Lil Durk",
    Album: "The Voice of the Heroes",
    Time: 192,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Erased (feat. Ugly God)",
    Artist: "Lil Boom",
    Album: "Soul Eater",
    Time: 129,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Turn Down For What (Remix) [Feat. Juicy J, 2 Chainz & French Montana]",
    Artist: "Lil Jon & DJ Snake ",
    Album: "Turn Down For What (Remix) - Single",
    Time: 223,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Baby Favour",
    Artist: "Lil Kesh",
    Album: "Baby Favour - Single",
    Time: 221,
    Year: 2017,
    Plays: 37,
  },
  {
    Name: "Cause Trouble (feat. Ycee)",
    Artist: "Lil Kesh",
    Album: "Cause Trouble (feat. Ycee) - Single",
    Time: 193,
    Year: 2016,
    Plays: 11,
  },
  {
    Name: "Love Like This (feat. Fireboy DML)",
    Artist: "Lil Kesh",
    Album: "Ecstasy",
    Time: 189,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Efejoku",
    Artist: "Lil Kesh",
    Album: "Efejoku - Single",
    Time: 245,
    Year: 2015,
    Plays: 15,
  },
  {
    Name: "Gbese",
    Artist: "Lil Kesh",
    Album: "Gbese - Single",
    Time: 231,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Lyrically",
    Artist: "Lil Kesh",
    Album: "Lyrically - Single",
    Time: 204,
    Year: 2014,
    Plays: 20,
  },
  {
    Name: "Shoki",
    Artist: "Lil Kesh",
    Album: "Shoki - Single",
    Time: 176,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Shoki (Remix) [feat. Davido & Olamide] [Male Version]",
    Artist: "Lil Kesh",
    Album: "Shoki (Remix) [feat. Davido & Olamide] [Male Version] - Single",
    Time: 239,
    Year: 2014,
    Plays: 63,
  },
  {
    Name: "Ibile",
    Artist: "Lil Kesh",
    Album: "Yagi (Young and Getting It)",
    Time: 243,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Be Gone Thot!",
    Artist: "LIL MAYO",
    Album: "Be Gone Thot! - Single",
    Time: 73,
    Year: 2019,
    Plays: 18,
  },
  {
    Name: "Old Town Road (feat. Billy Ray Cyrus) [Remix]",
    Artist: "Lil Nas X",
    Album: "Old Town Road (feat. Billy Ray Cyrus) [Remix] - Single",
    Time: 157,
    Year: 2019,
    Plays: 12,
  },
  {
    Name: "Rodeo",
    Artist: "Lil Nas X & Cardi B",
    Album: "7 - EP",
    Time: 158,
    Year: 2019,
    Plays: 168,
  },
  {
    Name: "INDUSTRY BABY",
    Artist: "Lil Nas X & Jack Harlow",
    Album: "INDUSTRY BABY - Single",
    Time: 212,
    Year: 2021,
    Plays: 25,
  },
  {
    Name: "I've Been Waiting (feat. Fall Out Boy)",
    Artist: "Lil Peep & iLoveMakonnen",
    Album: "I've Been Waiting (feat. Fall Out Boy) - Single",
    Time: 233,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Rocking A Cardigan in Atlanta",
    Artist: "LIL SHORDIE SCOTT",
    Album: "Rocking A Cardigan in Atlanta - Single",
    Time: 96,
    Year: 2022,
    Plays: 8,
  },
  {
    Name: "Real Ties",
    Artist: "Lil Skies",
    Album: "Real Ties - Single",
    Time: 142,
    Year: 2019,
    Plays: 10,
  },
  {
    Name: "Ransom",
    Artist: "Lil Tecca",
    Album: "Ransom - Single",
    Time: 131,
    Year: 2019,
    Plays: 72,
  },
  {
    Name: "Twerk (Featuring Justin Bieber & Miley Cyrus)",
    Artist: "Lil Twist",
    Album: "Twerk (Featuring Justin Bieber & Miley Cyrus) [Single]",
    Time: 210,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Demon High",
    Artist: "Lil Uzi Vert",
    Album: "Demon High - Single",
    Time: 197,
    Year: 2021,
    Plays: 12,
  },
  {
    Name: "Baby Pluto",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 210,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Lo Mein",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 195,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Silly Watch",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 195,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "POP",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 227,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "You Better Move",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 196,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Homecoming",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 213,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "I'm Sorry",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 211,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Celebration Station",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 195,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Bigger Than Life",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 192,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Chrome Heart Tags",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 212,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Bust Me",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 194,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Prices",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 233,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Urgency (feat. Syd)",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 181,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Venetia",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 188,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Secure the Bag",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 238,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "P2",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 234,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Futsal Shuffle 2020 (Bonus Track)",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 198,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "That Way (Bonus Track)",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake",
    Time: 212,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Come This Way",
    Artist: "Lil Uzi Vert",
    Album: "Eternal Atake (Deluxe) - LUV vs. The World 2",
    Time: 172,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Erase Your Social",
    Artist: "Lil Uzi Vert",
    Album: "The Perfect LUV Tape",
    Time: 199,
    Year: 2016,
    Plays: 49,
  },
  {
    Name: "Lullaby",
    Artist: "Lil Uzi Vert",
    Album: "Pluto x Baby Pluto",
    Time: 261,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Believe Me (feat. Drake)",
    Artist: "Lil Wayne",
    Album: "Believe Me (feat. Drake) - Single",
    Time: 337,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "So Dedicated (Feat. Birdman)",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 164,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Same Damn Tune",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 186,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Cashed Out",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 238,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "No Worries (Feat. Detail)",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 210,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Mercy (Feat. Nicki Minaj)",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 288,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Burn",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 218,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Amen (Feat. Boo)",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 198,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Get Smoked (Feat. Lil Mouse)",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 230,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "My Homies (Remix) (Feat. Young Jeezy, Jae Millz & Gudda Gudda)",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 177,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Green Ranger (Feat. J. Cole)",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 201,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "I Don't Like",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 155,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "No Lie",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 151,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Magic (Feat. Flo)",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 154,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Wish You Would",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 182,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "A Dedication",
    Artist: "Lil Wayne",
    Album: "Dedication 4",
    Time: 370,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Im Good ft. The Weeknd",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 127,
    Year: null,
    Plays: 1,
  },
  {
    Name: "How Dedicated",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 52,
    Year: null,
    Plays: null,
  },
  {
    Name: "Dont Kill",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 259,
    Year: null,
    Plays: null,
  },
  {
    Name: "New Slaves",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 173,
    Year: null,
    Plays: null,
  },
  {
    Name: "Drama : Weezy",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 14,
    Year: null,
    Plays: null,
  },
  {
    Name: "Typa Way",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 314,
    Year: null,
    Plays: 3,
  },
  {
    Name: "You Song ft. Chance The Rapper",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 331,
    Year: null,
    Plays: null,
  },
  {
    Name: "Aint Worried ft. Eruo, Jae Millz",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 152,
    Year: null,
    Plays: null,
  },
  {
    Name: "Before Tune Gets Back ft. Lil Chuckee",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 204,
    Year: null,
    Plays: null,
  },
  {
    Name: "Started",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 180,
    Year: null,
    Plays: null,
  },
  {
    Name: "New Signees To Young Money",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 99,
    Year: null,
    Plays: null,
  },
  {
    Name: "Live Life ft. Euro",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 248,
    Year: null,
    Plays: null,
  },
  {
    Name: "Itchin",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 213,
    Year: null,
    Plays: null,
  },
  {
    Name: "Way Im Ballin ft. Mack Maine, Birdman",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 233,
    Year: null,
    Plays: null,
  },
  {
    Name: "Fortune Teller Interlude",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 61,
    Year: null,
    Plays: null,
  },
  {
    Name: "Thinkin About You",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 201,
    Year: null,
    Plays: null,
  },
  {
    Name: "Pure Colombia",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 219,
    Year: null,
    Plays: 4,
  },
  {
    Name: "Bugatti",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 205,
    Year: null,
    Plays: null,
  },
  {
    Name: "Still Got That Rock",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 204,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Competition Interlude",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 20,
    Year: null,
    Plays: null,
  },
  {
    Name: "FuckWitMeYouKnowIGotIt ft. T.I",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 225,
    Year: null,
    Plays: null,
  },
  {
    Name: "UOENO",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 229,
    Year: null,
    Plays: null,
  },
  {
    Name: "Levels ft. Vado",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 224,
    Year: null,
    Plays: null,
  },
  {
    Name: "Living Legend Interlude",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 46,
    Year: null,
    Plays: null,
  },
  {
    Name: "Cream ft. Euro",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 207,
    Year: null,
    Plays: null,
  },
  {
    Name: "Devastation ft. Gudda Gudda",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 199,
    Year: null,
    Plays: null,
  },
  {
    Name: "Fuckin Problems ft. Kidd Kidd, Euro",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 261,
    Year: null,
    Plays: null,
  },
  {
    Name: "Feds Watching ft. 2 Chainz, T.I.",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 325,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Luv",
    Artist: "Lil Wayne",
    Album: "Dedication 5",
    Time: 508,
    Year: null,
    Plays: null,
  },
  {
    Name: "Glory",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 306,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "He's Dead",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 271,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "I Feel Good",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 190,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "My Heart Races On (feat. Jake Troth)",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 228,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "London Roads",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 235,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "I'm That Nigga (feat. HoodyBaby)",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 224,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Psycho",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 244,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Murda (feat. Cory Gunz, Capo & Junior Reid)",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 229,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Thinking Bout You",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 243,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Without You (feat. Bibi Bourelly)",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 256,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Post Bail Ballin",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 235,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Pull Up (feat. Euro)",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 255,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Living Right (feat. Wiz Khalifa)",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 301,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "White Girl (feat. Young Jeezy)",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 283,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Pick Up Your Heart",
    Artist: "Lil Wayne",
    Album: "Free Weezy Album",
    Time: 370,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Funeral",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 194,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Mahogany",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 177,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Mama Mia",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 225,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "I Do It (feat. Big Sean & Lil Baby)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 184,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Dreams",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 227,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Stop Playin With Me",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 187,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Clap For Em",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 150,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Bing James (feat. Jay Rock)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 203,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Not Me",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 199,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Trust Nobody (feat. Adam Levine)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 168,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Know You Know (feat. 2 Chainz)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 164,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Wild Dogs",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 216,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Harden",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 182,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "I Don't Sleep (feat. Takeoff)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 200,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Sights and Silencers (feat. The-Dream)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 202,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Ball Hard (feat. Lil Twist)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 178,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Bastard (Satan's Kid)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 192,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Get Outta My Head (feat. XXXTENTACION)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 178,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Piano Trap",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 194,
    Year: 2020,
    Plays: 10,
  },
  {
    Name: "Line Em Up",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 179,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Darkside",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 139,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Never Mind",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 213,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "T.O. (feat. O.T. Genasis)",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 188,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Wayne's World",
    Artist: "Lil Wayne",
    Album: "Funeral",
    Time: 225,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Grindin' (feat. Drake)",
    Artist: "Lil Wayne",
    Album: "Grindin' (feat. Drake) - Single",
    Time: 306,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "I Am Not a Human Being",
    Artist: "Lil Wayne",
    Album: "I Am Not a Human Being",
    Time: 244,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Bill Gates",
    Artist: "Lil Wayne",
    Album: "I Am Not a Human Being",
    Time: 258,
    Year: 2010,
    Plays: 4,
  },
  {
    Name: "I Don't Like the Look of It (feat. Gudda Gudda)",
    Artist: "Lil Wayne",
    Album: "I Am Not a Human Being",
    Time: 197,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "IANAHB",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 338,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "Curtains (Feat. Boo)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 271,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "Days And Days (Feat. 2 Chainz)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 193,
    Year: 2013,
    Plays: 21,
  },
  {
    Name: "Gunwalk (Feat. Gudda Gudda)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 271,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "No Worries (Feat. Detail)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 221,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Back To You",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 329,
    Year: 2013,
    Plays: 39,
  },
  {
    Name: "Trigger Finger (Feat. Soulja Boy)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 272,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Beat The Shit (Feat. Gunplay)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 268,
    Year: 2013,
    Plays: 9,
  },
  {
    Name: "Rich As Fuck (Feat. 2 Chainz)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 223,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Trippy (Feat. Juicy J)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 263,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Bitches Love Me (Feat. Drake, Future)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 253,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Romance",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 260,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "God Bless Amerika",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 303,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Wowzers",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 225,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Hello",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 242,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Lay It Down (Feat. Nicki Minaj) (Bonus Track)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 245,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Hot Revolver (Feat. Dre) (Bonus Track)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 200,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "My Homies Still (Feat. Big Sean) (Bonus Track)",
    Artist: "Lil Wayne",
    Album: "I Am Not A Human Being II (Deluxe Edition)",
    Time: 247,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "No Worries (feat. Detail)",
    Artist: "Lil Wayne",
    Album: "I Am Not a Human Being II (Deluxe Version)",
    Time: 222,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Love Me (feat. Drake & Future)",
    Artist: "Lil Wayne",
    Album: "I Am Not a Human Being II (Deluxe Version)",
    Time: 255,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Swag Surfin'",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 254,
    Year: 2009,
    Plays: 16,
  },
  {
    Name: "Ice Cream Paint Job",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 210,
    Year: 2009,
    Plays: 30,
  },
  {
    Name: "D.O.A.",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 277,
    Year: 2009,
    Plays: 22,
  },
  {
    Name: "Interlude #1",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 83,
    Year: 2009,
    Plays: 4,
  },
  {
    Name: "Wasted",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 258,
    Year: 2009,
    Plays: 6,
  },
  {
    Name: "Watch My Shoes",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 284,
    Year: 2009,
    Plays: 3,
  },
  {
    Name: "Banned From TV",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 179,
    Year: 2009,
    Plays: 3,
  },
  {
    Name: "Throw It In The Bag",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 180,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Interlude #2",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 104,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Wetter",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 260,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Run This Town",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 169,
    Year: 2009,
    Plays: 15,
  },
  {
    Name: "I Gotta Feeling",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 216,
    Year: 2009,
    Plays: 4,
  },
  {
    Name: "Outro",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 98,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "I'm Goin In (New Verses) BONUS",
    Artist: "Lil Wayne",
    Album: "No Ceilings",
    Time: 186,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Fresh Feat. Mannie Fresh",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 117,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "B2b",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 191,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "My Name Is",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 216,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Where Ya At",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 210,
    Year: 2015,
    Plays: 12,
  },
  {
    Name: "Cross Me Feat. Future, Yo Gotti",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 205,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "I'm Nice",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 201,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Duck Feat. Jae Millz, Gudda Gudda, Shanell",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 315,
    Year: 2015,
    Plays: 38,
  },
  {
    Name: "Poppin Feat. Curren",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 233,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Jumpman",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 240,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Destroyed Feat. Euro",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 228,
    Year: 2015,
    Plays: 41,
  },
  {
    Name: "Finessin Feat. Baby E",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 167,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Millyrokk Feat. Lucci Lou, Turk",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 268,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Live From The Gutter Feat. Hoodybaby, T@",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 279,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Big Wings",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 217,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Post Malone",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 244,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Lil Bitch",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 222,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Get Ya Gat Feat. Lucci Lou, Hoodybaby",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 290,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "No Reason Feat. King Los",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 234,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Plastic Bag Feat. Jae Millz",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 274,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Hotline Bling",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 259,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Diamonds Dancing",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 306,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "No Days Off",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 276,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "The Weekend",
    Artist: "Lil Wayne",
    Album: "No Ceilings 2",
    Time: 257,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Kobe Bryant",
    Artist: "Lil Wayne",
    Album: "No Ceilings Tunechi - EP",
    Time: 143,
    Year: 2009,
    Plays: 3,
  },
  {
    Name: "American Star",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 216,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Da Da Da",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 220,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Get A Life",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 192,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Ground Zero",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 237,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "I'll Die For You (Bonus Track)",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 308,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "I'm So Over You (Bonus Track)",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 178,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Knockout",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 249,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "On Fire",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 248,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "One Way Trip",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 278,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Paradice",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 237,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "The Price Is Wrong",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 208,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Prom Queen",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 217,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Runnin",
    Artist: "Lil Wayne",
    Album: "Rebirth",
    Time: 271,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Coco",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 244,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Sh!t",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 258,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Trap House",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 259,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Selsun Blue",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 216,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Used To (feat. Drake)",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 263,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "No Type",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 241,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Fingers Hurting",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 253,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Hot Nigga",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 197,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "HollyWeezy",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 299,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Drunk In Love (feat. Christina Milian)",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 293,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "You Guessed It",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 243,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Try Me (feat. Mack Maine)",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 215,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Preach (feat. 2 Chainz)",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 181,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Alphabet",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 329,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "No Haters",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 222,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Admit It (feat. SNL)",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 243,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Dreams And Nightmares",
    Artist: "Lil Wayne",
    Album: "Sorry 4 The Wait 2",
    Time: 230,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Start a Fire (feat. Christina Milian)",
    Artist: "Lil Wayne",
    Album: "Start a Fire (feat. Christina Milian) - Single",
    Time: 233,
    Year: 2014,
    Plays: 12,
  },
  {
    Name: "My Homies Still (Feat Big Sean)",
    Artist: "Lil Wayne",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 246,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Go DJ",
    Artist: "Lil Wayne",
    Album: "Tha Carter",
    Time: 281,
    Year: 2004,
    Plays: 1,
  },
  {
    Name: "Best Rapper Alive",
    Artist: "Lil Wayne",
    Album: "Tha Carter II",
    Time: 293,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "3 Peat (Produced By Cool & Dre)",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 199,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "A Milli (Produced By Bangladesh)",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 221,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Dr. Carter (Produced By Swizz Beatz)",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 264,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Phone Home (Produced By David Banner)",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 191,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Let The Beat Build (Produced By Kanye West & Deezle)",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 309,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Shoot Me Down (Produced By Kanye West)",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 269,
    Year: 2008,
    Plays: 13,
  },
  {
    Name: "Lollipop (feat. Static Major)",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 299,
    Year: 2008,
    Plays: 22,
  },
  {
    Name: "Playin‚ With Fire (Produced By Streetrunner)",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 261,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Don't Get It",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 592,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Prostitute 2",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 350,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "I'm Me",
    Artist: "Lil Wayne",
    Album: "Tha Carter III",
    Time: 294,
    Year: 2007,
    Plays: 4,
  },
  {
    Name: "Intro",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 172,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Blunt Blowin",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 312,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "MegaMan",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 198,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "6 Foot 7 Foot (feat. Cory Gunz)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 248,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Nightmares Of The Bottom",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 281,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "She Will (feat. Drake)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 305,
    Year: 2011,
    Plays: 24,
  },
  {
    Name: "How To Hate (feat. T-Pain)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 278,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Interlude (feat. Tech N9ne)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 121,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "John (feat. Rick Ross)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 286,
    Year: 2011,
    Plays: 14,
  },
  {
    Name: "Abortion",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 223,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "So Special (feat. John Legend)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 232,
    Year: 2011,
    Plays: 8,
  },
  {
    Name: "How To Love",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 240,
    Year: 2011,
    Plays: 15,
  },
  {
    Name: "President Carter",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 255,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "It's Good (feat. Drake & Jadakiss)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 241,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Outro (feat. Bun B, Nas, Shyne & Busta Rhymes)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 232,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "I Like The View",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 281,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Mirror (feat. Bruno Mars)",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 228,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Two Shots",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 165,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Up Up And Away",
    Artist: "Lil Wayne",
    Album: "Tha Carter IV (Complete Edition)",
    Time: 233,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Mona Lisa (feat. Kendrick Lamar)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V",
    Time: 324,
    Year: 2018,
    Plays: 371,
  },
  {
    Name: "Life of Mr. Carter",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 220,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Holy",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 235,
    Year: 2020,
    Plays: 7,
  },
  {
    Name: "More to the Story (feat. Raekwon)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 201,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Scottie",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 284,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "F Him Good",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 209,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Siri (feat. 2 Chainz)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 292,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Lost",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 254,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "In This House (feat. Gucci Mane)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 212,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "What About Me (feat. Post Malone)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 216,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Hasta La Vista",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 171,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "I Love You Dwayne",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 120,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "I Love You Dwayne",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 120,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Don't Cry (feat. XXXTENTACION)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 249,
    Year: 2018,
    Plays: 12,
  },
  {
    Name: "Don't Cry (feat. XXXTENTACION)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 249,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Dedicate",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 189,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "Dedicate",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 189,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Uproar (feat. Swizz Beatz)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 193,
    Year: 2018,
    Plays: 17,
  },
  {
    Name: "Uproar (feat. Swizz Beatz)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 193,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Let It Fly (feat. Travis Scott)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 186,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Let It Fly (feat. Travis Scott)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 186,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Can't Be Broken",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 193,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Can't Be Broken",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 193,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Dark Side of the Moon (feat. Nicki Minaj)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 242,
    Year: 2018,
    Plays: 15,
  },
  {
    Name: "Dark Side of the Moon (feat. Nicki Minaj)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 242,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Mona Lisa (feat. Kendrick Lamar)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 324,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "What About Me (feat. Sosamann)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 216,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "What About Me (feat. Sosamann)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 216,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Open Letter",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 269,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Open Letter",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 269,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Famous (feat. Reginae Carter)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 242,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "Famous (feat. Reginae Carter)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 242,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Problems",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 208,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Problems",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 208,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Dope Niggaz (feat. Snoop Dogg)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 205,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Dope Niggaz (feat. Snoop Dogg)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 205,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Hittas",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 223,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Hittas",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 223,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Took His Time",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 262,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Took His Time",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 262,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Open Safe",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 223,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Open Safe",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 223,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Start This Shit Off Right (feat. Ashanti & Mack Maine)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 280,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Start This Shit Off Right (feat. Ashanti & Mack Maine)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 280,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Demon",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 214,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Demon",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 214,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Mess",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 212,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Mess",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 212,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Dope New Gospel (feat. Nivea)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 207,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Dope New Gospel (feat. Nivea)",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 207,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Perfect Strangers",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 249,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Perfect Strangers",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 249,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Used 2",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 240,
    Year: 2018,
    Plays: 16,
  },
  {
    Name: "Used 2",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 240,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Let It All Work Out",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 316,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Let It All Work Out",
    Artist: "Lil Wayne",
    Album: "Tha Carter V (Deluxe)",
    Time: 316,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Shimmy (feat. Doja Cat)",
    Artist: "Lil Wayne",
    Album: "Weezy Workout - EP",
    Time: 168,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Clap For Em",
    Artist: "Lil Wayne",
    Album: "Weezy Workout - EP",
    Time: 150,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "I Do It (feat. Big Sean & Lil Baby)",
    Artist: "Lil Wayne",
    Album: "Weezy Workout - EP",
    Time: 184,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Ball Hard (feat. Lil Twist)",
    Artist: "Lil Wayne",
    Album: "Weezy Workout - EP",
    Time: 178,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Ya Dig",
    Artist: "Lil Wayne",
    Album: "Ya Dig - Single",
    Time: 205,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Gonorrhea (feat. Drake)",
    Artist: "Lil Wayne & Drake",
    Album: "I Am Not a Human Being",
    Time: 262,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "With You (feat. Drake)",
    Artist: "Lil Wayne & Drake",
    Album: "I Am Not a Human Being",
    Time: 229,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "I'm Single (feat. Drake)",
    Artist: "Lil Wayne & Drake",
    Album: "I Am Not a Human Being",
    Time: 333,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Right Above It (feat. Drake)",
    Artist: "Lil Wayne & Drake",
    Album: "I Am Not a Human Being",
    Time: 271,
    Year: 2010,
    Plays: 9,
  },
  {
    Name: "That Ain't Me (feat. Jay Sean)",
    Artist: "Lil Wayne & Jay Sean",
    Album: "I Am Not a Human Being",
    Time: 242,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Popular (feat. Lil' Twist)",
    Artist: "Lil Wayne & Lil' Twist",
    Album: "I Am Not a Human Being",
    Time: 280,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "What's Wrong With Them (feat. Nicki Minaj)",
    Artist: "Lil Wayne & Nicki Minaj",
    Album: "I Am Not a Human Being",
    Time: 211,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Feelin' Like Tunechi",
    Artist: "Lil Wayne & Rich The Kid",
    Album: "Trust Fund Babies",
    Time: 186,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Trust Fund",
    Artist: "Lil Wayne & Rich The Kid",
    Album: "Trust Fund Babies",
    Time: 165,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Hold Up (feat. T Streets)",
    Artist: "Lil Wayne & T Streets",
    Album: "I Am Not a Human Being",
    Time: 250,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Scared of the Dark (feat. XXXTENTACION)",
    Artist: "Lil Wayne & Ty Dolla $ign",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 232,
    Year: 2018,
    Plays: 45,
  },
  {
    Name: "Comfortable (Produced By Kanye West)",
    Artist: "Lil Wayne Ft. Babyface",
    Album: "Tha Carter III",
    Time: 265,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Mrs. Officer (Produced By Wyclef Jean)",
    Artist: "Lil Wayne Ft. Bobby Valentino",
    Album: "Tha Carter III",
    Time: 287,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "La La (Produced By David Banner)",
    Artist: "Lil Wayne Ft. Brisco & Busta Rhymes",
    Album: "Tha Carter III",
    Time: 261,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Make Her Say",
    Artist: "Lil Wayne Ft. Jae Millz",
    Album: "No Ceilings",
    Time: 141,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Mr. Carter (Produced By Just Blaze)",
    Artist: "Lil Wayne Ft. Jay-Z",
    Album: "Tha Carter III",
    Time: 316,
    Year: 2008,
    Plays: 9,
  },
  {
    Name: "You Ain't Got Nuthin (Produced By Alchemist)",
    Artist: "Lil Wayne Ft. Juelz Santana & Fabolous",
    Album: "Tha Carter III",
    Time: 327,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Lollipop (Offical Remix)",
    Artist: "Lil Wayne Ft. Kanye West",
    Album: "Tha Carter III",
    Time: 262,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "I'm Good",
    Artist: "Lil Wayne Ft. Lucci Lou",
    Album: "No Ceilings",
    Time: 151,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Tie My Hands (Produced By Kanye West)",
    Artist: "Lil Wayne Ft. Robin Thicke",
    Album: "Tha Carter III",
    Time: 319,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Break Up",
    Artist: "Lil Wayne Ft. Short Dawg And Gudda Gudda",
    Album: "No Ceilings",
    Time: 233,
    Year: 2009,
    Plays: 3,
  },
  {
    Name: "Lollipop (Produced By Jim Jonsin & Deezle)",
    Artist: "Lil Wayne Ft. Static Major",
    Album: "Tha Carter III",
    Time: 299,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Got Money (Produced By Play-n-skillz)",
    Artist: "Lil Wayne Ft. T-Pain",
    Album: "Tha Carter III",
    Time: 244,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "I Think I Love Her",
    Artist: "Lil Wayne Ft. Tyga And Shanell",
    Album: "No Ceilings",
    Time: 240,
    Year: 2009,
    Plays: 3,
  },
  {
    Name: "YM Banger (feat. Jae Millz, Gudda Gudda & Tyga)",
    Artist: "Lil Wayne, Jae Millz, Gudda Gudda & Tyga",
    Album: "I Am Not a Human Being",
    Time: 235,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "YM Salute (feat. Lil' Twist & Nicki Minaj)",
    Artist:
      "Lil Wayne, Lil' Twist, Lil Chuckee, Gudda Gudda, Jae Millz & Nicki Minaj",
    Album: "I Am Not a Human Being",
    Time: 314,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Sucker for Pain (with Logic, Ty Dolla $ign & X Ambassadors)",
    Artist: "Lil Wayne, Wiz Khalifa & Imagine Dragons",
    Album: "Suicide Squad (Original Motion Picture Soundtrack)",
    Time: 244,
    Year: 2016,
    Plays: 4,
  },
  {
    Name: "Sucker For Pain (with Logic, Ty Dolla $ign & X Ambassadors)",
    Artist: "Lil Wayne, Wiz Khalifa & Imagine Dragons",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 244,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "My Dougie",
    Artist: "Lil Wil",
    Album: "My Dougie - Single",
    Time: 184,
    Year: 2007,
    Plays: 10,
  },
  {
    Name: "Drop The World",
    Artist: "Lil' Wayne",
    Album: "Rebirth",
    Time: 229,
    Year: 2010,
    Plays: 25,
  },
  {
    Name: "Believe Me Feat. Drake",
    Artist: "Lil' Wayne ",
    Album: "Believe Me (Single)",
    Time: 339,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Circle of Life / Nants' Ingonyama",
    Artist: "Lindiwe Mkhize & Lebo M",
    Album: "The Lion King (Original Motion Picture Soundtrack)",
    Time: 241,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Underground",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 264,
    Year: 2019,
    Plays: 54,
  },
  {
    Name: "Artemis",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 233,
    Year: 2019,
    Plays: 50,
  },
  {
    Name: "Til the Light Goes Out",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 286,
    Year: 2019,
    Plays: 51,
  },
  {
    Name: "Between Twilight",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 259,
    Year: 2019,
    Plays: 27,
  },
  {
    Name: "Foreverglow",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 238,
    Year: 2019,
    Plays: 24,
  },
  {
    Name: "Love Goes On and On (feat. Amy Lee)",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 246,
    Year: 2019,
    Plays: 28,
  },
  {
    Name: "Masquerade",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 201,
    Year: 2019,
    Plays: 26,
  },
  {
    Name: "Sleepwalking",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 227,
    Year: 2019,
    Plays: 32,
  },
  {
    Name: "Darkside",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 247,
    Year: 2019,
    Plays: 54,
  },
  {
    Name: "The Upside",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 227,
    Year: 2019,
    Plays: 24,
  },
  {
    Name: "Guardian",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 200,
    Year: 2019,
    Plays: 33,
  },
  {
    Name: "Aurora",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 215,
    Year: 2019,
    Plays: 33,
  },
  {
    Name: "The Upside (feat. Elle King)",
    Artist: "Lindsey Stirling",
    Album: "Artemis",
    Time: 228,
    Year: 2019,
    Plays: 27,
  },
  {
    Name: "The Phoenix",
    Artist: "Lindsey Stirling",
    Album: "Brave Enough (Deluxe Edition)",
    Time: 244,
    Year: 2016,
    Plays: 41,
  },
  {
    Name: "Something Wild (feat. Andrew McMahon In the Wilderness)",
    Artist: "Lindsey Stirling",
    Album: "Brave Enough (Deluxe Edition)",
    Time: 224,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Shatter Me (feat. Lzzy Hale)",
    Artist: "Lindsey Stirling",
    Album: "Shatter Me (Deluxe Version)",
    Time: 280,
    Year: 2014,
    Plays: 46,
  },
  {
    Name: "Roundtable Rival",
    Artist: "Lindsey Stirling",
    Album: "Shatter Me (Deluxe Version)",
    Time: 203,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Lose You Now",
    Artist: "Lindsey Stirling & Mako",
    Album: "Lose You Now - Single",
    Time: 193,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Guren No Yumiya",
    Artist: "Linked Horizon",
    Album: "Jiyuu E No Shingeki - Single",
    Time: 316,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Jiyuu No Tsubasa",
    Artist: "Linked Horizon",
    Album: "Jiyuu E No Shingeki - Single",
    Time: 328,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "Keys to the Kingdom",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 218,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "All for Nothing (feat. Page Hamilton)",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 213,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Guilty All the Same (feat. Rakim)",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 355,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "The Summoning",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 60,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "War",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 131,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Wastelands",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 195,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Until It's Gone",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 233,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Rebellion (feat. Daron Malakian)",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 224,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Mark the Graves",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 305,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Drawbar (feat. Tom Morello)",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 166,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Final Masquerade",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 217,
    Year: 2014,
    Plays: 9,
  },
  {
    Name: "A Line In the Sand",
    Artist: "LINKIN PARK",
    Album: "The Hunting Party",
    Time: 395,
    Year: 2014,
    Plays: 16,
  },
  {
    Name: "Papercut",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 184,
    Year: 2000,
    Plays: 3,
  },
  {
    Name: "Papercut (Live)",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 193,
    Year: 2002,
    Plays: null,
  },
  {
    Name: "One Step Closer",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 155,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Points of Authority (Live)",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 210,
    Year: 2002,
    Plays: null,
  },
  {
    Name: "A Place for My Head (Live)",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 191,
    Year: 2002,
    Plays: 1,
  },
  {
    Name: "With You",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 203,
    Year: 2000,
    Plays: 5,
  },
  {
    Name: "My December",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 260,
    Year: 2002,
    Plays: 2,
  },
  {
    Name: "Points Of Authority",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 200,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Crawling",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 209,
    Year: 2000,
    Plays: 12,
  },
  {
    Name: "High Voltage",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 225,
    Year: 2002,
    Plays: 8,
  },
  {
    Name: "Runaway",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 183,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "By Myself",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 189,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "In The End",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 216,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "A Place For My Head",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 184,
    Year: 2000,
    Plays: null,
  },
  {
    Name: "Forgotten",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 194,
    Year: 2000,
    Plays: null,
  },
  {
    Name: "Cure For The Itch",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 157,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "Pushing Me Away",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory",
    Time: 191,
    Year: 2000,
    Plays: 1,
  },
  {
    Name: "By Myself",
    Artist: "LINKIN PARK",
    Album: "Hybrid Theory (20th Anniversary Edition)",
    Time: 189,
    Year: 2000,
    Plays: 2,
  },
  {
    Name: "Rolling In the Deep (Live)",
    Artist: "LINKIN PARK",
    Album: "iTunes Festival: London 2011 - EP",
    Time: 264,
    Year: 2011,
    Plays: 14,
  },
  {
    Name: "Lost In The Echo",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 205,
    Year: 2012,
    Plays: 7,
  },
  {
    Name: "In My Remains",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 200,
    Year: 2012,
    Plays: 7,
  },
  {
    Name: "Burn It Down",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 231,
    Year: 2012,
    Plays: 6,
  },
  {
    Name: "Lies Greed Misery",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 147,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "I'll Be Gone",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 211,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Castle Of Glass",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 205,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Victimized",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 106,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Roads Untraveled",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 229,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Skin To Bone",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 168,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Until It Breaks",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 223,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Tinfoil",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 71,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Powerless",
    Artist: "LINKIN PARK",
    Album: "Living Things",
    Time: 223,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Foreword",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 13,
    Year: 2003,
    Plays: 19,
  },
  {
    Name: "Don't Stay",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 188,
    Year: 2003,
    Plays: 20,
  },
  {
    Name: "Somewhere I Belong",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 214,
    Year: 2003,
    Plays: 5,
  },
  {
    Name: "Lying From You",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 175,
    Year: 2003,
    Plays: 13,
  },
  {
    Name: "Hit The Floor",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 164,
    Year: 2003,
    Plays: 6,
  },
  {
    Name: "Easier To Run",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 204,
    Year: 2003,
    Plays: 3,
  },
  {
    Name: "Faint",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 162,
    Year: 2003,
    Plays: 65,
  },
  {
    Name: "Figure.09",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 197,
    Year: 2003,
    Plays: 16,
  },
  {
    Name: "Breaking The Habit",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 196,
    Year: 2003,
    Plays: 26,
  },
  {
    Name: "From The Inside",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 175,
    Year: 2003,
    Plays: 7,
  },
  {
    Name: "Nobody's Listening",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 178,
    Year: 2003,
    Plays: 4,
  },
  {
    Name: "Session",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 144,
    Year: 2003,
    Plays: 5,
  },
  {
    Name: "Numb",
    Artist: "LINKIN PARK",
    Album: "Meteora",
    Time: 187,
    Year: 2003,
    Plays: 79,
  },
  {
    Name: "Wake",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 100,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Given Up",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 189,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Leave Out All the Rest",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 209,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Bleed It Out",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 164,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Shadow of the Day",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 289,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "What I've Done",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 205,
    Year: 2007,
    Plays: 14,
  },
  {
    Name: "Hands Held High",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 233,
    Year: 2007,
    Plays: 12,
  },
  {
    Name: "No More Sorrow",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 221,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Valentine's Day",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 196,
    Year: 2007,
    Plays: 16,
  },
  {
    Name: "In Between",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 196,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "In Pieces",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 217,
    Year: 2007,
    Plays: 15,
  },
  {
    Name: "The Little Things Give You Away",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 383,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "No Roads Left (Bonus Track)",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 228,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Across the Line (Bonus Track)",
    Artist: "LINKIN PARK",
    Album: "Minutes to Midnight (Deluxe Edition)",
    Time: 191,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "New Divide",
    Artist: "LINKIN PARK",
    Album: "New Divide - EP",
    Time: 268,
    Year: 2009,
    Plays: 10,
  },
  {
    Name: "Nobody Can Save Me",
    Artist: "Linkin Park",
    Album: "One More Light",
    Time: 225,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Good Goodbye (feat. Pusha T and Stormzy)",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 211,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "Talking to Myself",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 231,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Battle Symphony",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 216,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Invisible",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 214,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Heavy (feat. Kiiara)",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 169,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Sorry for Now",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 203,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Halfway Right",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 217,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "One More Light",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 255,
    Year: 2017,
    Plays: 28,
  },
  {
    Name: "Sharp Edges",
    Artist: "LINKIN PARK",
    Album: "One More Light",
    Time: 178,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Opening",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 67,
    Year: 2002,
    Plays: 18,
  },
  {
    Name: "Pts.OF.Athrty (feat Jay Gordon)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 225,
    Year: 2002,
    Plays: 13,
  },
  {
    Name: "Enth E Nd (feat Kutmast Kurt & Motion Man)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 239,
    Year: 2002,
    Plays: 20,
  },
  {
    Name: "[Chali]",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 23,
    Year: 2002,
    Plays: 19,
  },
  {
    Name: "Frgt/10 (feat Chali 2Na & Alchemist)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 212,
    Year: 2002,
    Plays: 11,
  },
  {
    Name: "P5hng Me A*wy (feat Stephen Richards & Mike Shinoda)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 277,
    Year: 2002,
    Plays: 101,
  },
  {
    Name: "PLC. 4 Mie Hæd (feat Zion & Amp Zion)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 260,
    Year: 2002,
    Plays: 25,
  },
  {
    Name: "X-Ecutioner Style (feat Black Thought)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 109,
    Year: 2002,
    Plays: 14,
  },
  {
    Name: "H! Vltg3 (feat Evidence, Pharoahe Monch & DJ Babu)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 210,
    Year: 2002,
    Plays: 19,
  },
  {
    Name: "[Riff Raff]",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 21,
    Year: 2002,
    Plays: 14,
  },
  {
    Name: "WTH>You (feat Chairman Hahn & Aceyalone)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 252,
    Year: 2002,
    Plays: 160,
  },
  {
    Name: "NTR/Mssion",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 29,
    Year: 2002,
    Plays: 17,
  },
  {
    Name: "Ppr:Kut (feat Cheapshot, Jubacca, Rasco &  Planet Asia)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 206,
    Year: 2002,
    Plays: 16,
  },
  {
    Name: "Rnw@y (feat Backyard Bangers & Phoenix Orion)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 193,
    Year: 2002,
    Plays: 10,
  },
  {
    Name: "My<Dsmbr (feat Mickey P. & Kelli Ali)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 257,
    Year: 2002,
    Plays: 9,
  },
  {
    Name: "[Stef]",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 10,
    Year: 2002,
    Plays: 12,
  },
  {
    Name: "By_Myslf (feat Josh Abraham & Mike Shinoda)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 222,
    Year: 2002,
    Plays: 62,
  },
  {
    Name: "Kyur4 th Ich (feat Chairman Hahn)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 152,
    Year: 2002,
    Plays: 9,
  },
  {
    Name: "1stp Klosr (feat The Humble Brothers & Jonathan Davis)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 346,
    Year: 2002,
    Plays: 5,
  },
  {
    Name: "Krwlng (feat Mike Shinoda & Aaron Lewis)",
    Artist: "LINKIN PARK",
    Album: "Reanimation",
    Time: 340,
    Year: 2002,
    Plays: 47,
  },
  {
    Name: "The Requiem",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 121,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "The Radiance",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 57,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Burning In the Skies",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 253,
    Year: 2010,
    Plays: 9,
  },
  {
    Name: "Empty Spaces",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 18,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "When They Come for Me",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 293,
    Year: 2010,
    Plays: 7,
  },
  {
    Name: "Robot Boy",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 268,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Jornada Del Muerto",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 94,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Waiting for the End",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 231,
    Year: 2010,
    Plays: 11,
  },
  {
    Name: "Blackout",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 279,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Wretches and Kings",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 250,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Wisdom, Justice, and Love",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 98,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Iridescent",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 296,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Fallout",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 83,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "The Catalyst",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 339,
    Year: 2010,
    Plays: 5,
  },
  {
    Name: "The Messenger",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 181,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Blackbirds (Bonus Track)",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 201,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "The Catalyst",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 283,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Waiting for the End",
    Artist: "LINKIN PARK",
    Album: "A Thousand Suns (Deluxe Edition)",
    Time: 234,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "crossing field",
    Artist: "LiSA",
    Album: "crossing field",
    Time: 250,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "homura",
    Artist: "LiSA",
    Album: "homura - EP",
    Time: 274,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "MONEY",
    Artist: "LISA",
    Album: "LALISA - Single",
    Time: 168,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Gurenge",
    Artist: "LiSA",
    Album: "LEO-NiNE",
    Time: 237,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Oath Sign",
    Artist: "LiSA",
    Album: 'LOVER"S"MiLE',
    Time: 250,
    Year: 2011,
    Plays: 11,
  },
  {
    Name: "Rock Mode",
    Artist: "LiSA",
    Album: 'LOVER"S"MiLE',
    Time: 256,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Girl Crush",
    Artist: "Little Big Town",
    Album: "Pain Killer",
    Time: 193,
    Year: 2014,
    Plays: 14,
  },
  {
    Name: "My Love Won't Let You Down",
    Artist: "Little Mix",
    Album: "Confetti (Expanded Edition)",
    Time: 174,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Power",
    Artist: "Little Mix",
    Album: "Glory Days: The Platinum Edition",
    Time: 247,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Think About Us",
    Artist: "Little Mix",
    Album: "LM5 (Deluxe)",
    Time: 235,
    Year: 2018,
    Plays: 76,
  },
  {
    Name: "Woman Like Me (feat. Nicki Minaj)",
    Artist: "Little Mix",
    Album: "Woman Like Me (feat. Nicki Minaj) - Single",
    Time: 228,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Reggaetón Lento (Remix)",
    Artist: "Little Mix & CNCO",
    Album: "Glory Days: The Platinum Edition",
    Time: 188,
    Year: 2016,
    Plays: 333,
  },
  {
    Name: "Worst Mistake",
    Artist: "Living in Fiction",
    Album: "Worst Mistake - Single",
    Time: 257,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "What's Left of Me",
    Artist: "LOAD",
    Album: "SuperEgo",
    Time: 269,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "1-800-273-8255 (feat. Alessia Cara & Khalid)",
    Artist: "Logic",
    Album: "Everybody",
    Time: 250,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Broken People",
    Artist: "Logic & Rag'n'Bone Man",
    Album: "Bright: The Album",
    Time: 212,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Monalisa",
    Artist: "Lojay & Sarz",
    Album: "LV N ATTN - EP",
    Time: 213,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Nothing's Gonna Be Alright",
    Artist: "Lola Black",
    Album: "Nothing's Gonna Be Alright",
    Time: 234,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Carmina Burana: O Fortuna",
    Artist:
      "London Philharmonic Orchestra, David Parry, London Philharmonic Choir & The London Chorus",
    Album: "The 50 Greatest Pieces of Classical Music",
    Time: 162,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "The Night We Met",
    Artist: "Lord Huron",
    Album: "Strange Trails",
    Time: 208,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Everybody Wants To Rule the World",
    Artist: "Lorde",
    Album:
      "The Hunger Games: Catching Fire (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 155,
    Year: 2013,
    Plays: 14,
  },
  {
    Name: "Yellow Flicker Beat",
    Artist: "Lorde",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 234,
    Year: 2014,
    Plays: 30,
  },
  {
    Name: "Flicker (Kanye West Rework)",
    Artist: "Lorde",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 252,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Ladder Song",
    Artist: "Lorde",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 196,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Writer In the Dark",
    Artist: "Lorde",
    Album: "Melodrama",
    Time: 216,
    Year: 2017,
    Plays: 91,
  },
  {
    Name: "Writer In the Dark",
    Artist: "Lorde",
    Album: "Melodrama",
    Time: 216,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Tennis Court",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 199,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "400 Lux",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 234,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Royals",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 190,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Ribs",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 259,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Buzzcut Season",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 246,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "Team",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 193,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Glory and Gore",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 210,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "Still Sane",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 188,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "White Teeth Teens",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 216,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "A World Alone",
    Artist: "Lorde",
    Album: "Pure Heroine",
    Time: 294,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Never Enough",
    Artist: "Loren Allred",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 207,
    Year: 2017,
    Plays: 8,
  },
  {
    Name: "Never Enough (Reprise)",
    Artist: "Loren Allred",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 80,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Shake Dat (feat. Lil Jay)",
    Artist: "Loui",
    Album: "Shake Dat (Tik Tok Remix) [feat. Lil Jay] - Single",
    Time: 184,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Cry",
    Artist: "Lowborn",
    Album: "Cry - Single",
    Time: 226,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Demons and Angels",
    Artist: "Lowborn",
    Album: "Demons and Angels - Single",
    Time: 191,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Do Wrong",
    Artist: "Lowborn",
    Album: "Do Wrong - Single",
    Time: 220,
    Year: 2019,
    Plays: 15,
  },
  {
    Name: "Lacuna",
    Artist: "Lowborn",
    Album: "Lacuna - Single",
    Time: 256,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "On My Way",
    Artist: "Lowborn",
    Album: "On My Way - Single",
    Time: 195,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Genius (feat. Lil Wayne, Sia, Diplo & Labrinth) [Lil Wayne Remix]",
    Artist: "LSD",
    Album:
      "Genius (feat. Lil Wayne, Sia, Diplo & Labrinth) [Lil Wayne Remix] - Single",
    Time: 162,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Welcome to the Wonderful World Of (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 116,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Angel in Your Eyes (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 186,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Genius (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 213,
    Year: 2018,
    Plays: 16,
  },
  {
    Name: "Genius (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 213,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Audio (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 204,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Audio (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 204,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Thunderclouds (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 187,
    Year: 2018,
    Plays: 30,
  },
  {
    Name: "Thunderclouds (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 187,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Mountains (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 194,
    Year: 2018,
    Plays: 15,
  },
  {
    Name: "Mountains (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 194,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "No New Friends (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 175,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "Heaven Can Wait (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 195,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "It's Time (feat. Sia, Diplo & Labrinth)",
    Artist: "LSD",
    Album: "LABRINTH, SIA & DIPLO PRESENT... LSD",
    Time: 209,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Ho",
    Artist: "Ludacris",
    Album: "Back for the First Time",
    Time: 170,
    Year: 2000,
    Plays: 11,
  },
  {
    Name: "Last of a Dying Breed (feat. Lil Wayne)",
    Artist: "Ludacris",
    Album: "Theater of the Mind (Expanded Edition)",
    Time: 249,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Nuvole Bianche",
    Artist: "Ludovico Einaudi",
    Album: "Una Mattina",
    Time: 357,
    Year: 2004,
    Plays: 23,
  },
  {
    Name: "Despacito (feat. Justin Bieber) [Remix]",
    Artist: "Luis Fonsi & Daddy Yankee",
    Album: "Despacito (Remix) [feat. Justin Bieber] - Single",
    Time: 228,
    Year: 2017,
    Plays: 90,
  },
  {
    Name: "Despacito",
    Artist: "Luis Fonsi & Daddy Yankee",
    Album: "VIDA",
    Time: 229,
    Year: 2017,
    Plays: 123,
  },
  {
    Name: "Échame la Culpa",
    Artist: "Luis Fonsi & Demi Lovato",
    Album: "VIDA",
    Time: 173,
    Year: 2017,
    Plays: 16,
  },
  {
    Name: "Nightshade",
    Artist: "The Lumineers",
    Album:
      'For the Throne (Music Inspired by the HBO Series "Game of Thrones")',
    Time: 180,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Together",
    Artist: "Lunatica",
    Album: "The Edge Of Infinity (Deluxe Version)",
    Time: 242,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "Battle Scars",
    Artist: "Lupe Fiasco & Guy Sebastian",
    Album: "Food & Liquor II: The Great American Rap Album, Pt. 1",
    Time: 250,
    Year: 2012,
    Plays: 11,
  },
  {
    Name: "MAWEED (feat. Ajura)",
    Artist: "M-SIX Da Masterpiece",
    Album: "MAWEED (feat. Ajura) - Single",
    Time: 198,
    Year: 2021,
    Plays: 46,
  },
  {
    Name: "Bullion Van (feat. Runtown, Phyno & StormRex)",
    Artist: "M.I Abaga",
    Album: "The Chairman",
    Time: 264,
    Year: 2014,
    Plays: 46,
  },
  {
    Name: "Daddy (feat. Chillz)",
    Artist: "M.I Abaga",
    Album: "Daddy (feat. Chillz) - Single",
    Time: 186,
    Year: 2022,
    Plays: 40,
  },
  {
    Name: "Craze",
    Artist: "M.I Abaga",
    Album: "MI 2: The Movie",
    Time: 222,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Undisputed",
    Artist: "M.I Abaga",
    Album: "MI 2: The Movie",
    Time: 169,
    Year: 2010,
    Plays: 51,
  },
  {
    Name: "Lekki (feat. Odunsi, Ajebutter22 & Falz)",
    Artist: "M.I Abaga",
    Album: "Rendezvous",
    Time: 249,
    Year: 2018,
    Plays: 20,
  },
  {
    Name: "Bad Girls",
    Artist: "M.I.A.",
    Album: "Matangi",
    Time: 227,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Bad Girls (Nick Thayer Remix)",
    Artist: "M.I.A.",
    Album: "Step Up Revolution",
    Time: 278,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Stckhlm Syndrome (Interlude)",
    Artist: "Mabel",
    Album: "High Expectations",
    Time: 145,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Wild Boy (feat. 2 Chainz, French Montana, Meek Mill, Mystikal, Steve-O & Yo Gotti)",
    Artist: "Machine Gun Kelly",
    Album: "How Many Chainz?",
    Time: 215,
    Year: 2012,
    Plays: 68,
  },
  {
    Name: "Wild Boy (feat. Waka Flocka Flame)",
    Artist: "Machine Gun Kelly",
    Album: "Lace Up",
    Time: 231,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "Invincible (feat. Ester Dean)",
    Artist: "Machine Gun Kelly",
    Album: "Lace Up",
    Time: 185,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Home",
    Artist: "Machine Gun Kelly, X Ambassadors & Bebe Rexha",
    Album: "Bright: The Album",
    Time: 202,
    Year: 2017,
    Plays: 9,
  },
  {
    Name: "Ten Thousand Hours",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 249,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Thin Line (ft Buffalo Madonna)",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 256,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Neon Cathedral (ft Allen Stone)",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 274,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "BomBom (ft The Teaching)",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 295,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Jimmy Iovine (ft Ab-Soul)",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 233,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Wing$",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 299,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "A Wake (ft Evan Roman)",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 226,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Gold (ft Eighty4 Fly)",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 251,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Starting Over (ft Ben Bridwell)",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 251,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Cowboy Boots",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 257,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "My Oh My",
    Artist: "Macklemore & Ryan Lewis",
    Album: "The Heist (Deluxe Edition)",
    Time: 257,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "La Isla Bonita",
    Artist: "Madonna",
    Album: "Celebration",
    Time: 242,
    Year: 1986,
    Plays: 8,
  },
  {
    Name: "Hung Up",
    Artist: "Madonna",
    Album: "Confessions on a Dance Floor",
    Time: 337,
    Year: 2005,
    Plays: 1,
  },
  {
    Name: "Looking for Mercy",
    Artist: "Madonna",
    Album: "Madame X (Deluxe)",
    Time: 290,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Living For Love",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 218,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Devil Pray",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 245,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "Ghosttown",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 249,
    Year: 2015,
    Plays: 15,
  },
  {
    Name: "Unapologetic Bitch",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 231,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Illuminati",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 224,
    Year: 2015,
    Plays: 307,
  },
  {
    Name: "Bitch I'm Madonna (feat. Nicki Minaj)",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 227,
    Year: 2015,
    Plays: 59,
  },
  {
    Name: "Hold Tight",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 217,
    Year: 2015,
    Plays: 25,
  },
  {
    Name: "Joan of Arc",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 242,
    Year: 2015,
    Plays: 8,
  },
  {
    Name: "Iconic (feat. Chance the Rapper & Mike Tyson)",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 273,
    Year: 2015,
    Plays: 72,
  },
  {
    Name: "HeartBreakCity",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 213,
    Year: 2015,
    Plays: 11,
  },
  {
    Name: "Body Shop",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 219,
    Year: 2015,
    Plays: 9,
  },
  {
    Name: "Holy Water",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 249,
    Year: 2015,
    Plays: 26,
  },
  {
    Name: "Inside Out",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 263,
    Year: 2015,
    Plays: 25,
  },
  {
    Name: "Wash All Over Me",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 240,
    Year: 2015,
    Plays: 8,
  },
  {
    Name: "Best Night",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 213,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Veni Vidi Vici (feat. Nas)",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 279,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "S.E.X.",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 251,
    Year: 2015,
    Plays: 89,
  },
  {
    Name: "Messiah",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 202,
    Year: 2015,
    Plays: 10,
  },
  {
    Name: "Rebel Heart",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 201,
    Year: 2015,
    Plays: 6,
  },
  {
    Name: "Beautiful Scars",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 259,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Queen",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 255,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Borrowed Time",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 204,
    Year: 2015,
    Plays: 17,
  },
  {
    Name: "Graffiti Heart",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 219,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Autotune Baby",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 240,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Addicted",
    Artist: "Madonna",
    Album: "Rebel Heart (SuperDeluxe Edition)",
    Time: 213,
    Year: 2015,
    Plays: 8,
  },
  {
    Name: "Egao no Mahou",
    Artist: "MAGIC PARTY",
    Album: "Fairy Tail OP ED Theme Songs Vol.1",
    Time: 211,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "All My Love (feat. Ariana Grande)",
    Artist: "Major Lazer",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 212,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Night Riders (feat. Travi$ Scott, 2 Chainz, Pusha T & Mad Cobra)",
    Artist: "Major Lazer",
    Album: "Peace Is the Mission (Extended)",
    Time: 233,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Bubble Butt",
    Artist: "Major Lazer Ft. Tyga, Bruno Mars & Mystic",
    Album: "",
    Time: 227,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Might⁺U",
    Artist: "Makayla Phillips",
    Album:
      "「僕のヒーローアカデミア THE MOVIE ヒーローズ:ライジング」オリジナルサウンドトラック",
    Time: 389,
    Year: 2019,
    Plays: 77,
  },
  {
    Name: "Flashy",
    Artist: "Maleek Berry",
    Album: "Flashy - Single",
    Time: 153,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "Shout",
    Artist: "Malia J",
    Album: "Shout - Single",
    Time: 188,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Smells Like Teen Spirit",
    Artist: "Malia J",
    Album: "Smells Like Teen Spirit - Single",
    Time: 239,
    Year: 2021,
    Plays: 61,
  },
  {
    Name: "Hawái (Remix)",
    Artist: "Maluma & The Weeknd",
    Album: "Hawái (Remix) - Single",
    Time: 200,
    Year: 2020,
    Plays: 12,
  },
  {
    Name: "My Hero",
    Artist: "MAN WITH A MISSION",
    Album: "My Hero - Single",
    Time: 263,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Raise your flag",
    Artist: "MAN WITH A MISSION",
    Album: "The World's on Fire (European Edition)",
    Time: 247,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "The Maze",
    Artist: "Manchester Orchestra",
    Album: "A Black Mile To The Surface",
    Time: 178,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "The Silence",
    Artist: "Manchester Orchestra",
    Album: "A Black Mile To The Surface",
    Time: 419,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Beggin",
    Artist: "Måneskin",
    Album: "Chosen",
    Time: 211,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "MAMMAMIA",
    Artist: "Måneskin",
    Album: "MAMMAMIA - Single",
    Time: 186,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Presence (feat. Anfa Rose)",
    Artist: "Manu Crooks",
    Album: "Presence (feat. Anfa Rose) - Single",
    Time: 245,
    Year: 2017,
    Plays: 25,
  },
  {
    Name: "Bella Ciao (Versión Lenta de la Música Original de la Serie la Casa de Papel / Money Heist)",
    Artist: "Manu Pilas",
    Album:
      "Bella Ciao (Versión Lenta de la Música Original de la Serie la Casa de Papel / Money Heist) - Single",
    Time: 116,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Bella Ciao (Versión Orquestal de la Música Original de la Serie la Casa de Papel Money Heist)",
    Artist: "Manu Pilas",
    Album:
      "Bella Ciao (Versión Orquestal de la Música Original de la Serie la Casa de Papel Money Heist) - Single",
    Time: 320,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "Vivir Mi Vida",
    Artist: "Marc Anthony",
    Album: "3.0",
    Time: 252,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Vivir Mi Vida (Versión Pop)",
    Artist: "Marc Anthony",
    Album: "3.0",
    Time: 231,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Dancer in the Dark",
    Artist: "Marc Philippe",
    Album: "Top Deep Disco Tunes",
    Time: 248,
    Year: 2018,
    Plays: 76,
  },
  {
    Name: "Kingdom of One",
    Artist: "Maren Morris",
    Album:
      'For the Throne (Music Inspired by the HBO Series "Game of Thrones")',
    Time: 215,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "COLOR",
    Artist: "MARiA",
    Album: "COLOR",
    Time: 239,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "With You",
    Artist: "Marin Hoxha & Chris Linton",
    Album: "With You - Single",
    Time: 209,
    Year: 2018,
    Plays: 56,
  },
  {
    Name: "Can't Stop Me",
    Artist: "Mario Judah",
    Album: "Can't Stop Me - Single",
    Time: 112,
    Year: 2020,
    Plays: 29,
  },
  {
    Name: "Crush",
    Artist: "Mario Judah",
    Album: "Crush - Single",
    Time: 102,
    Year: 2020,
    Plays: 18,
  },
  {
    Name: "Die Very Rough",
    Artist: "Mario Judah",
    Album: "Die Very Rough - Single",
    Time: 91,
    Year: 2020,
    Plays: 19,
  },
  {
    Name: "Rockstar",
    Artist: "Mario Judah",
    Album: "Rockstar - Single",
    Time: 197,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Angola",
    Artist: "Marlene Diva",
    Album: "As Mulheres da Minha Vida - EP",
    Time: 236,
    Year: 2018,
    Plays: 24,
  },
  {
    Name: "1st N 3rd (feat. Lil Baby & Future)",
    Artist: "Marlo",
    Album: "1st N 3rd (feat. Lil Baby & Future) - Single",
    Time: 261,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Ruthless",
    Artist: "MarMar Oso",
    Album: "Oso Different",
    Time: 233,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "One More Night",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 219,
    Year: 2012,
    Plays: 14,
  },
  {
    Name: "Payphone (feat. Wiz Khalifa)",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 231,
    Year: 2012,
    Plays: 80,
  },
  {
    Name: "Daylight",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 226,
    Year: 2012,
    Plays: 30,
  },
  {
    Name: "Lucky Strike",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 185,
    Year: 2012,
    Plays: 31,
  },
  {
    Name: "The Man Who Never Lied",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 205,
    Year: 2012,
    Plays: 59,
  },
  {
    Name: "Love Somebody",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 229,
    Year: 2012,
    Plays: 20,
  },
  {
    Name: "Ladykiller",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 165,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Fortune Teller",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 205,
    Year: 2012,
    Plays: 17,
  },
  {
    Name: "Sad",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 194,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Tickets",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 210,
    Year: 2012,
    Plays: 19,
  },
  {
    Name: "Doin' Dirt",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 212,
    Year: 2012,
    Plays: 18,
  },
  {
    Name: "Beautiful Goodbye",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 258,
    Year: 2012,
    Plays: 10,
  },
  {
    Name: "Wipe Your Eyes",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 216,
    Year: 2012,
    Plays: 18,
  },
  {
    Name: "Wasted Years",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 215,
    Year: 2012,
    Plays: 12,
  },
  {
    Name: "Kiss",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 421,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Moves Like Jagger (feat. Christina Aguilera) [Studio Recording from The Voice Performance]",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 201,
    Year: 2012,
    Plays: 31,
  },
  {
    Name: "One More Night (Sticky K Remix)",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 237,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Payphone (feat. Wiz Khalifa) [Cutmore Remix]",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 191,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Payphone (feat. Wiz Khalifa) [Supreme Cuts Remix]",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 280,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Payphone (feat. Wiz Khalifa) [Sound of Arrows Remix]",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 302,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Payphone (feat. Wiz Khalifa) [The Others Remix]",
    Artist: "Maroon 5",
    Album: "Overexposed (Deluxe Version)",
    Time: 246,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Maps",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 190,
    Year: 2015,
    Plays: 55,
  },
  {
    Name: "Animals",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 231,
    Year: 2015,
    Plays: 44,
  },
  {
    Name: "It Was Always You",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 240,
    Year: 2015,
    Plays: 18,
  },
  {
    Name: "Unkiss Me",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 238,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Sugar",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 235,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "Leaving California",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 203,
    Year: 2015,
    Plays: 14,
  },
  {
    Name: "In Your Pocket",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 219,
    Year: 2015,
    Plays: 176,
  },
  {
    Name: "New Love",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 196,
    Year: 2015,
    Plays: 17,
  },
  {
    Name: "Coming Back for You",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 227,
    Year: 2015,
    Plays: 13,
  },
  {
    Name: "Feelings",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 194,
    Year: 2015,
    Plays: 10,
  },
  {
    Name: "My Heart Is Open (feat. Gwen Stefani)",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 237,
    Year: 2015,
    Plays: 29,
  },
  {
    Name: "This Summer's Gonna Hurt Like a Motherf****r",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 224,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Shoot Love",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 190,
    Year: 2015,
    Plays: 148,
  },
  {
    Name: "Sex and Candy",
    Artist: "Maroon 5",
    Album: "V (Deluxe)",
    Time: 265,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "In the Name of Love",
    Artist: "Martin Garrix & Bebe Rexha",
    Album: "In the Name of Love - Single",
    Time: 198,
    Year: 2016,
    Plays: 18,
  },
  {
    Name: "Used To Love",
    Artist: "Martin Garrix & Dean Lewis",
    Album: "Used To Love - Single",
    Time: 236,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Blank",
    Artist: "Massface",
    Album: "Blank - Single",
    Time: 296,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "China Plates",
    Artist: "Massive Wagons",
    Album: "Full Nelson",
    Time: 226,
    Year: 2018,
    Plays: 76,
  },
  {
    Name: "Haunted",
    Artist: "Maty Noyes",
    Album: "",
    Time: 165,
    Year: null,
    Plays: 5,
  },
  {
    Name: "Worship",
    Artist: "MAX",
    Album: "Colour Vision (Deluxe)",
    Time: 187,
    Year: 2018,
    Plays: 13,
  },
  {
    Name: "Stay the Same",
    Artist: "Mayday Parade",
    Album: "Sunnyland",
    Time: 200,
    Year: 2018,
    Plays: 12,
  },
  {
    Name: "Tú",
    Artist: "maye",
    Album: "Tú - Single",
    Time: 206,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Soldier Boy",
    Artist: "Mayorkun",
    Album: "Back In Office",
    Time: 145,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Back In Office",
    Artist: "Mayorkun",
    Album: "Back In Office",
    Time: 191,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Freedom",
    Artist: "Mayorkun",
    Album: "Back In Office",
    Time: 178,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Let Me Know",
    Artist: "Mayorkun",
    Album: "Back In Office",
    Time: 174,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Nakupenda",
    Artist: "Mayorkun",
    Album: "Back In Office",
    Time: 176,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Piece Of Mind",
    Artist: "Mayorkun",
    Album: "Back In Office",
    Time: 152,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Oluwa",
    Artist: "Mayorkun",
    Album: "Back In Office",
    Time: 88,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Back In Office",
    Artist: "Mayorkun",
    Album: "Back In Office - Single",
    Time: 191,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Certified Loner (No Competition)",
    Artist: "Mayorkun",
    Album: "Certified Loner (No Competition) - Single",
    Time: 165,
    Year: 2022,
    Plays: 149,
  },
  {
    Name: "Geng",
    Artist: "Mayorkun",
    Album: "Geng - EP",
    Time: 127,
    Year: 2020,
    Plays: 30,
  },
  {
    Name: "Of Lagos",
    Artist: "Mayorkun",
    Album: "Of Lagos - Single",
    Time: 165,
    Year: 2018,
    Plays: 171,
  },
  {
    Name: "True (feat. Kizz Daniel)",
    Artist: "Mayorkun",
    Album: "True (feat. Kizz Daniel) - Single",
    Time: 217,
    Year: 2018,
    Plays: 127,
  },
  {
    Name: "Feel Am",
    Artist: "Mayorkun & Flavour",
    Album: "Back In Office",
    Time: 182,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Desire",
    Artist: "Mayorkun & Gyakie",
    Album: "Back In Office",
    Time: 138,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "No Strings Attached",
    Artist: "Mayorkun & Joeboy",
    Album: "Back In Office",
    Time: 156,
    Year: 2021,
    Plays: 35,
  },
  {
    Name: "Holy Father",
    Artist: "Mayorkun & Victony",
    Album: "Back In Office",
    Time: 184,
    Year: 2021,
    Plays: 330,
  },
  {
    Name: "Jay Jay",
    Artist: "Mayorkun, DJ Maphorisa & Kabza De Small",
    Album: "Back In Office",
    Time: 331,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Bum Bum Tam Tam",
    Artist: "MC Fioti, Future, J Balvin, Stefflon Don & Juan Magán",
    Album: "Bum Bum Tam Tam - Single",
    Time: 213,
    Year: 2017,
    Plays: 37,
  },
  {
    Name: "Blue Notes 2 (feat. Lil Uzi Vert)",
    Artist: "Meek Mill",
    Album: "Blue Notes 2 (feat. Lil Uzi Vert) - Single",
    Time: 230,
    Year: 2021,
    Plays: 15,
  },
  {
    Name: "Dreams and Nightmares",
    Artist: "Meek Mill",
    Album: "Dreams and Nightmares (Deluxe Version)",
    Time: 230,
    Year: 2012,
    Plays: 26,
  },
  {
    Name: "Millidelphia (feat. Swizz Beatz)",
    Artist: "Meek Mill",
    Album: "Legends of the Summer - EP",
    Time: 215,
    Year: 2018,
    Plays: 45,
  },
  {
    Name: "Ima Boss (feat. Rick Ross)",
    Artist: "Meek Mill",
    Album: "Self Made, Vol. 1 (Deluxe Version)",
    Time: 250,
    Year: 2011,
    Plays: 24,
  },
  {
    Name: "Go",
    Artist: "Meg Myers",
    Album: "Make a Shadow - EP",
    Time: 177,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "B.I.T.C.H.",
    Artist: "Megan Thee Stallion",
    Album: "B.I.T.C.H. - Single",
    Time: 183,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Realer",
    Artist: "Megan Thee Stallion",
    Album: "Fever",
    Time: 149,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Hood Rat Shit",
    Artist: "Megan Thee Stallion",
    Album: "Fever",
    Time: 181,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Cash Shit (feat. DaBaby)",
    Artist: "Megan Thee Stallion",
    Album: "Fever",
    Time: 192,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Simon Says (feat. Juicy J)",
    Artist: "Megan Thee Stallion",
    Album: "Fever",
    Time: 200,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Hot Girl Summer (feat. Nicki Minaj & Ty Dolla $ign)",
    Artist: "Megan Thee Stallion",
    Album: "Hot Girl Summer (feat. Nicki Minaj & Ty Dolla $ign) - Single",
    Time: 199,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Savage",
    Artist: "Megan Thee Stallion",
    Album: "Suga",
    Time: 155,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Hot Girl",
    Artist: "Megan Thee Stallion",
    Album: "Tina Snow",
    Time: 196,
    Year: 2018,
    Plays: 18,
  },
  {
    Name: "Diamonds (with Normani)",
    Artist: "Megan Thee Stallion & Normani",
    Album: "Birds of Prey: The Album",
    Time: 199,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Tk - Unravel / Tokyo ghoul opening (Full radio)",
    Artist: "Meli-chan",
    Album: "",
    Time: 238,
    Year: null,
    Plays: 4,
  },
  {
    Name: "Kissing Disease",
    Artist: "Melodium",
    Album: "Cerebro Spin",
    Time: 257,
    Year: 2008,
    Plays: 30,
  },
  {
    Name: "Kissing Disease (Piano Solo)",
    Artist: "Melodium",
    Album: "Kissing Disease (Piano Solo) - Single",
    Time: 549,
    Year: 2019,
    Plays: 46,
  },
  {
    Name: "Gentility",
    Artist: "Melvitto & Wande Coal",
    Album: "Gentility - Single",
    Time: 225,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "This Light I Hold (feat. Jacoby Shaddix)",
    Artist: "Memphis May Fire",
    Album: "This Light I Hold",
    Time: 248,
    Year: 2016,
    Plays: 39,
  },
  {
    Name: "Space Cadet (feat. Gunna)",
    Artist: "Metro Boomin",
    Album: "NOT ALL HEROES WEAR CAPES",
    Time: 203,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Hotel California",
    Artist: "Meytal",
    Album: "The Witness",
    Time: 290,
    Year: 2019,
    Plays: 17,
  },
  {
    Name: "The Batman",
    Artist: "Michael Giacchino",
    Album: "The Batman (Original Motion Picture Soundtrack)",
    Time: 407,
    Year: 2022,
    Plays: 14,
  },
  {
    Name: "Bad",
    Artist: "Michael Jackson",
    Album: "Bad",
    Time: 247,
    Year: 1987,
    Plays: 16,
  },
  {
    Name: "Dirty Diana",
    Artist: "Michael Jackson",
    Album: "Bad",
    Time: 280,
    Year: 1987,
    Plays: 12,
  },
  {
    Name: "Smooth Criminal",
    Artist: "Michael Jackson",
    Album: "Bad",
    Time: 257,
    Year: 1987,
    Plays: 15,
  },
  {
    Name: "You Are Not Alone (Single Version)",
    Artist: "Michael Jackson",
    Album: "The Essential Michael Jackson",
    Time: 295,
    Year: 1995,
    Plays: null,
  },
  {
    Name: "Thriller",
    Artist: "Michael Jackson",
    Album: "Thriller (25th Anniversary)",
    Time: 357,
    Year: 1982,
    Plays: null,
  },
  {
    Name: "Beat It",
    Artist: "Michael Jackson",
    Album: "Thriller (25th Anniversary)",
    Time: 258,
    Year: 1982,
    Plays: 7,
  },
  {
    Name: "Billie Jean",
    Artist: "Michael Jackson",
    Album: "Thriller (25th Anniversary)",
    Time: 294,
    Year: 1982,
    Plays: 8,
  },
  {
    Name: "Beat It 2008 (Thriller 25th Anniversary Remix) [feat. Fergie]",
    Artist: "Michael Jackson",
    Album: "Thriller (25th Anniversary)",
    Time: 251,
    Year: 1982,
    Plays: 37,
  },
  {
    Name: "Billie Jean (Long Version)",
    Artist: "Michael Jackson",
    Album: "Thriller (25th Anniversary)",
    Time: 382,
    Year: 1982,
    Plays: 6,
  },
  {
    Name: "Love Never Felt So Good",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 236,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Chicago",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 247,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Loving You",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 197,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "A Place with No Name",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 337,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Slave to the Rhythm",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 258,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Do You Know Where Your Children Are",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 278,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Blue Gangsta",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 256,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Xscape",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 246,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Love Never Felt So Good (Original Version)",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 201,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Chicago (Original Version)",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 285,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Loving You (Original Version)",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 184,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "A Place with No Name (Original Version)",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 297,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Slave to the Rhythm (Original Version)",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 277,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Do You Know Where Your Children Are (Original Version)",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 281,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Blue Gangsta (Original Version)",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 258,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Xscape (Original Version)",
    Artist: "Michael Jackson",
    Album: "Xscape (Deluxe Edition)",
    Time: 346,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Tightrope",
    Artist: "Michelle Williams",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 234,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "AVENGE WORLD (Originally Performed by Konomi Suzuki from Freezing Vibration)",
    Artist: "MIDORI ORGEL",
    Album: "ORGEL Anime Songs Vol.17 - EP",
    Time: 244,
    Year: 2013,
    Plays: 60,
  },
  {
    Name: "Jumpin Out The Window (Remix) BONUS",
    Artist: "Mike Baggz Ft. Lil Wayne And Rick Ross",
    Album: "No Ceilings",
    Time: 170,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Looks Like Sex",
    Artist: "Mike Posner",
    Album: "Looks Like Sex - Single",
    Time: 204,
    Year: 2011,
    Plays: 9,
  },
  {
    Name: "Introduction",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 66,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "January 11th, 2017",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 187,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Wide Open",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 169,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Song About You",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 190,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Move On",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 178,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Drip",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 325,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Staring at the Fire",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 158,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Amen",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 31,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Stuck in the Middle",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 201,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "One More Song",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 12,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "How It's Supposed to Be",
    Artist: "Mike Posner",
    Album: "A Real Good Kid",
    Time: 325,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Perfect",
    Artist: "Mike Posner & Matthew Schuler",
    Album: "A Real Good Kid",
    Time: 384,
    Year: 2019,
    Plays: 18,
  },
  {
    Name: "Place To Start",
    Artist: "Mike Shinoda",
    Album: "Post Traumatic",
    Time: 133,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Nothing Makes Sense Anymore",
    Artist: "Mike Shinoda",
    Album: "Post Traumatic",
    Time: 213,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Buy the World (feat. Lil Wayne, Kendrick Lamar & Future)",
    Artist: "Mike WiLL Made-It",
    Album: "Buy the World (feat. Lil Wayne, Kendrick Lamar & Future) - Single",
    Time: 226,
    Year: 2014,
    Plays: 23,
  },
  {
    Name: "23 (Featuring Miley Cyrus, Wiz Khalifa & Juicy J)",
    Artist: "Mike Will Made-It ",
    Album: "23 (Featuring Miley Cyrus, Wiz Khalifa & Juicy J) - Single",
    Time: 252,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Amen (Pre Fight Prayer)",
    Artist: "Mike WiLL Made-It & Lil Wayne",
    Album: "Creed II: The Album",
    Time: 121,
    Year: 2018,
    Plays: 28,
  },
  {
    Name: "Runnin",
    Artist: "Mike WiLL Made-It, A$AP Rocky, A$AP Ferg & Nicki Minaj",
    Album: "Creed II: The Album",
    Time: 131,
    Year: 2018,
    Plays: 82,
  },
  {
    Name: "If I Ruled the World",
    Artist: "MILCK",
    Album: "Into Gold - EP",
    Time: 200,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Drown",
    Artist: "milet",
    Album: "eyes",
    Time: 214,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "Tell me",
    Artist: "milet",
    Album: "eyes",
    Time: 223,
    Year: 2020,
    Plays: 32,
  },
  {
    Name: "Prover",
    Artist: "milet",
    Album: "eyes",
    Time: 241,
    Year: 2020,
    Plays: 21,
  },
  {
    Name: "Drown (TV size)",
    Artist: "milet",
    Album: "Vinland Saga (Original Soundtracks)",
    Time: 91,
    Year: 2020,
    Plays: 41,
  },
  {
    Name: "Adore You",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 278,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "We Can't Stop",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 231,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "SMS (Bangerz) (feat. Britney Spears)",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 169,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "4x4 feat. (Nelly)",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 191,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "My Darlin' (feat. Future)",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 243,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Wrecking Ball",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 223,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Love Money Party (feat. Big Sean)",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 219,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "#GETITRIGHT",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 264,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Drive",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 255,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "FU (feat. French Montana)",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 231,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Do My Thang",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 225,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Maybe You're Right",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 213,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Someone Else",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 288,
    Year: 2013,
    Plays: 22,
  },
  {
    Name: "Rooting For My Baby",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 200,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "On My Own",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 232,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Hands In the Air (feat. Ludacris)",
    Artist: "Miley Cyrus",
    Album: "Bangerz (Deluxe Version)",
    Time: 202,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "See You Again",
    Artist: "Miley Cyrus",
    Album: "Meet Miley Cyrus",
    Time: 190,
    Year: 2007,
    Plays: 7,
  },
  {
    Name: "Into the Storm",
    Artist: "Mitchell Broom",
    Album: "Into the Storm - Single",
    Time: 168,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Together We Rise",
    Artist: "Mitchell Broom",
    Album: "Oblivion",
    Time: 207,
    Year: 2019,
    Plays: 169,
  },
  {
    Name: "Move Your Body",
    Artist: "Mo' Hits All Stars",
    Album: "Currliculum Vitae",
    Time: 241,
    Year: 2007,
    Plays: 7,
  },
  {
    Name: "Be Close to You",
    Artist: "Mo' Hits All Stars",
    Album: "Currliculum Vitae",
    Time: 223,
    Year: 2007,
    Plays: 21,
  },
  {
    Name: "Booty Call",
    Artist: "Mo' Hits All Stars",
    Album: "Currliculum Vitae",
    Time: 313,
    Year: 2007,
    Plays: 25,
  },
  {
    Name: "Move Your Body",
    Artist: "Mo' Hits All Stars",
    Album: "51Lex Presents Stop The Violence",
    Time: 224,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Power Flow",
    Artist: "Monique",
    Album: "Power Flow",
    Time: 240,
    Year: 2014,
    Plays: 15,
  },
  {
    Name: "Long Live Death",
    Artist: "Mono Inc.",
    Album: "Welcome to Hell",
    Time: 225,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Renai Circulation",
    Artist: "MONOGATARI Series",
    Album: "Bakemonogatari Gekihanongakushu (Original Soundtrack)",
    Time: 255,
    Year: 2010,
    Plays: 4,
  },
  {
    Name: "Sugar Sweet Nightmare",
    Artist: "MONOGATARI Series",
    Album: "Bakemonogatari Gekihanongakushu (Original Soundtrack)",
    Time: 271,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Stamina (feat. Lil Uzi Vert)",
    Artist: "Moosh & Twist",
    Album: "Stamina (feat. Lil Uzi Vert) - Single",
    Time: 271,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Stinking Rich (feat. Dave)",
    Artist: "MoStack & J Hus",
    Album: "Stacko",
    Time: 210,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Voices",
    Artist: "Motionless In White",
    Album: "Graveyard Shift",
    Time: 224,
    Year: 2017,
    Plays: 8,
  },
  {
    Name: "Reincarnate",
    Artist: "Motionless In White",
    Album: "Reincarnate",
    Time: 220,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Woza (feat. Boohle)",
    Artist: "Mr JazziQ, Kabza De Small & Lady Du",
    Album: "Party With The English",
    Time: 391,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Bones",
    Artist: "MS MR",
    Album: "Bones - Single of the Week",
    Time: 253,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Moonwalk Through Customs",
    Artist: "Murkemz",
    Album: "Alright Bet",
    Time: 155,
    Year: 2003,
    Plays: 40,
  },
  {
    Name: "Made in Valhalla",
    Artist: "Murkemz",
    Album: "Made in Valhalla - Single",
    Time: 90,
    Year: 2019,
    Plays: null,
  },
  {
    Name: ".MM (feat. Marquel DelJuan)",
    Artist: "Murkemz",
    Album: ".MM (feat. Marquel DelJuan) - Single",
    Time: 137,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Naruto Main Theme",
    Artist: "MUSASHI PROJECT",
    Album: "NARUTO ORIGINAL SOUNDTRACK",
    Time: 266,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Thought Contagion",
    Artist: "Muse",
    Album: "Simulation Theory (Super Deluxe)",
    Time: 206,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Ballin’",
    Artist: "Mustard & Roddy Ricch",
    Album: "Perfect Ten",
    Time: 180,
    Year: 2019,
    Plays: 25,
  },
  {
    Name: "S・S・S",
    Artist: "MY FIRST STORY",
    Album: "S・S・S",
    Time: 133,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "WINNER",
    Artist: "MY FIRST STORY",
    Album: "S・S・S",
    Time: 259,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "M.A.D",
    Artist: "MY FIRST STORY",
    Album: "S・S・S",
    Time: 231,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "The Swinger",
    Artist: "My Memory Remains",
    Album: "Chapter Two",
    Time: 241,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "This Is My Life",
    Artist: "My Name Is Kay",
    Album: "Step Up Revolution",
    Time: 229,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Sweat",
    Artist: "Myles Erlick",
    Album: "Sweat - Single",
    Time: 154,
    Year: 2020,
    Plays: 25,
  },
  {
    Name: "Juniper",
    Artist: "Myrkur",
    Album: "Juniper - Single",
    Time: 218,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Aye",
    Artist: "N.A.P.P.Y & Burna Boy",
    Album: "Aye - Single",
    Time: 207,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Lemon",
    Artist: "N.E.R.D & Rihanna",
    Album: "NO ONE EVER REALLY DIES",
    Time: 219,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "Straight Outta Compton",
    Artist: "N.W.A",
    Album: "Straight Outta Compton",
    Time: 257,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Gangsta Gangsta",
    Artist: "N.W.A",
    Album: "Straight Outta Compton",
    Time: 335,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Dopeman (Remix)",
    Artist: "N.W.A",
    Album: "Straight Outta Compton",
    Time: 320,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Fuck Tha Police",
    Artist: "N.W.A",
    Album: "Straight Outta Compton",
    Time: 315,
    Year: 2016,
    Plays: 4,
  },
  {
    Name: "Express Yourself",
    Artist: "N.W.A",
    Album: "Straight Outta Compton",
    Time: 263,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Quiet On Tha Set",
    Artist: "N.W.A",
    Album: "Straight Outta Compton",
    Time: 237,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "8 Ball (Remix)",
    Artist: "N.W.A",
    Album: "Straight Outta Compton",
    Time: 290,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Real Niggaz",
    Artist: "N.W.A",
    Album: "Straight Outta Compton",
    Time: 267,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Báilame",
    Artist: "Nacho",
    Album: "Báilame - Single",
    Time: 206,
    Year: 2017,
    Plays: 51,
  },
  {
    Name: "Raro",
    Artist: "Nacho & Chyno Miranda",
    Album: "Raro - Single",
    Time: 199,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Ya No Más (feat. Sebastián Yatra)",
    Artist: "Nacho, Joey Montana & Yandel",
    Album: "Ya No Más (feat. Sebastián Yatra) - Single",
    Time: 231,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Vultures",
    Artist: "Naïka",
    Album: "Lost in Paradïse, Pt. 1 (EP)",
    Time: 143,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "African Sun",
    Artist: "Naïka",
    Album: "Lost in Paradïse, Pt. 1 (EP)",
    Time: 158,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Big Steps (feat. J Perry)",
    Artist: "Naïka",
    Album: "Lost in Paradïse, Pt. 1 (EP)",
    Time: 128,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "On My Way",
    Artist: "Naïka",
    Album: "Lost in Paradïse, Pt. 1 (EP)",
    Time: 123,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Head in the Clouds",
    Artist: "Naïka",
    Album: "Lost in Paradïse, Pt. 1 (EP)",
    Time: 157,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Opotoyi (Marlians)",
    Artist: "Naira Marley",
    Album: "Opotoyi (Marlians) - Single",
    Time: 242,
    Year: 2019,
    Plays: 10,
  },
  {
    Name: "PXTA",
    Artist: "Naira Marley",
    Album: "PXTA - Single",
    Time: 208,
    Year: 2019,
    Plays: 82,
  },
  {
    Name: "Anywhere",
    Artist: "Naira Marley & Ms Banks",
    Album: "Anywhere - Single",
    Time: 179,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Mafo",
    Artist: "Naira Marley & Young Jonn",
    Album: "Mafo - Single",
    Time: 214,
    Year: 2019,
    Plays: 24,
  },
  {
    Name: "Feel Free to F* Off",
    Artist: "Nameless",
    Album: "The Men's Club Original Soundtrack",
    Time: 154,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "No Pain, No Game",
    Artist: "nano",
    Album: "No Pain, No Game <nano ver.> - Single",
    Time: 202,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Savior of Song (feat. My First Story)",
    Artist: "nano",
    Album: "Savior of Song (Arpeggio of Blue Steel Ver.) - Single",
    Time: 246,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "She's So Gone",
    Artist: "Naomi Scott",
    Album: "Lemonade Mouth (Original TV Movie Soundtrack)",
    Time: 186,
    Year: 2011,
    Plays: 17,
  },
  {
    Name: "Strings And Bling",
    Artist: "Nasty C",
    Album: "Strings and Bling",
    Time: 224,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "All In",
    Artist: "Nasty C & T.I.",
    Album: "Zulu Man With Some Power",
    Time: 233,
    Year: 2020,
    Plays: 27,
  },
  {
    Name: "Careless Whisper",
    Artist: "Nataly Dawn",
    Album: "Careless Whisper - Single",
    Time: 163,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Love Is A Mystery",
    Artist: "Natalya Milyaeva",
    Album: "Islands - Essential Einaudi",
    Time: 182,
    Year: 2011,
    Plays: 8,
  },
  {
    Name: "Reluctant Heroes",
    Artist: "NateWantsToBattle",
    Album: "Reluctant Heroes - Single",
    Time: 265,
    Year: 2015,
    Plays: 50,
  },
  {
    Name: "Casting Crowns",
    Artist: "Nathaniel Bassey & Lovesong",
    Album: "God of Love - EP",
    Time: 436,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Bungee Jumping (feat. Emeli Sandé & Rahat Fateh Ali Khan)",
    Artist: "Naughty Boy",
    Album: "Bungee Jumping (feat. Emeli Sandé & Rahat Fateh Ali Khan) - Single",
    Time: 229,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "La La La (feat. Sam Smith)",
    Artist: "Naughty Boy",
    Album: "La La La (feat. Sam Smith) - EP",
    Time: 220,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Runnin' (Lose It All) [feat. Beyoncé & Arrow Benjamin]",
    Artist: "Naughty Boy",
    Album: "Runnin' (Lose It All) [feat. Beyoncé & Arrow Benjamin] - Single",
    Time: 213,
    Year: 2015,
    Plays: 28,
  },
  {
    Name: "Turks (feat. Travis Scott)",
    Artist: "NAV & Gunna",
    Album: "Good Intentions (Brown Boy 2 Deluxe Version)",
    Time: 161,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Miss Independent",
    Artist: "Ne-Yo",
    Album: "Year of the Gentleman",
    Time: 232,
    Year: 2008,
    Plays: 13,
  },
  {
    Name: "Push Back",
    Artist: "Ne-Yo, Bebe Rexha & Stefflon Don",
    Album: "Push Back - Single",
    Time: 221,
    Year: 2018,
    Plays: 26,
  },
  {
    Name: "Freakshow",
    Artist: "The Nearly Deads",
    Album: "Freakshow - Single",
    Time: 208,
    Year: 2018,
    Plays: 35,
  },
  {
    Name: "Once Upon a Time (feat. Patoranking)",
    Artist: "Nedro",
    Album: "Once Upon a Time (feat. Patoranking) - Single",
    Time: 251,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "As You Fade Away",
    Artist: "NEFFEX",
    Album: "As You Fade Away - EP",
    Time: 256,
    Year: 2022,
    Plays: 2,
  },
  {
    Name: "Believe",
    Artist: "NEFFEX",
    Album: "Bite Me - EP",
    Time: 156,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Born a Rockstar",
    Artist: "NEFFEX",
    Album: "Born a Rockstar - EP",
    Time: 205,
    Year: 2021,
    Plays: 29,
  },
  {
    Name: "Till I Let Go",
    Artist: "NEFFEX",
    Album: "Born a Rockstar - EP",
    Time: 180,
    Year: 2021,
    Plays: 23,
  },
  {
    Name: "Manifest It",
    Artist: "NEFFEX",
    Album: "Don't Wanna Let Myself Down - EP",
    Time: 186,
    Year: 2021,
    Plays: 24,
  },
  {
    Name: "Fall Asleep",
    Artist: "NEFFEX",
    Album: "Fall Asleep - Single",
    Time: 199,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Fight Back",
    Artist: "NEFFEX",
    Album: "Fight Back - Single",
    Time: 200,
    Year: 2017,
    Plays: 101,
  },
  {
    Name: "Grateful",
    Artist: "NEFFEX",
    Album: "Grateful - Single",
    Time: 182,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Home",
    Artist: "NEFFEX",
    Album: "Home - Single",
    Time: 136,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Hype",
    Artist: "NEFFEX",
    Album: "Hype - Single",
    Time: 150,
    Year: 2018,
    Plays: 22,
  },
  {
    Name: "Let Me Down",
    Artist: "NEFFEX",
    Album: "Let Me Down - Single",
    Time: 165,
    Year: 2017,
    Plays: 34,
  },
  {
    Name: "Lose My Mind",
    Artist: "NEFFEX",
    Album: "Lose My Mind - Single",
    Time: 142,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Myself",
    Artist: "NEFFEX",
    Album: "Myself - Single",
    Time: 194,
    Year: 2019,
    Plays: 14,
  },
  {
    Name: "Numb",
    Artist: "NEFFEX",
    Album: "Numb - Single",
    Time: 144,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "One Shot",
    Artist: "NEFFEX",
    Album: "One Shot - Single",
    Time: 175,
    Year: 2018,
    Plays: 17,
  },
  {
    Name: "Play",
    Artist: "NEFFEX",
    Album: "Play - Single",
    Time: 135,
    Year: 2018,
    Plays: 17,
  },
  {
    Name: "Play Dead",
    Artist: "NEFFEX",
    Album: "Price Tag",
    Time: 211,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Pull Me Apart",
    Artist: "NEFFEX",
    Album: "Pull Me Apart - Single",
    Time: 145,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Immortal",
    Artist: "NEFFEX",
    Album: "Retribution",
    Time: 183,
    Year: 2022,
    Plays: 8,
  },
  {
    Name: "Rumors",
    Artist: "NEFFEX",
    Album: "Rumors - Single",
    Time: 247,
    Year: 2017,
    Plays: 141,
  },
  {
    Name: "The Show",
    Artist: "NEFFEX",
    Album: "The Show - Single",
    Time: 234,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "We Could Do It All",
    Artist: "NEFFEX",
    Album: "We Could Do It All - Single",
    Time: 139,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Just a Dream",
    Artist: "Nelly",
    Album: "5.0 (Deluxe Version)",
    Time: 237,
    Year: 2010,
    Plays: 19,
  },
  {
    Name: "Let It Burn",
    Artist: "Nemesea",
    Album: "Uprise",
    Time: 226,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Lapdance",
    Artist: "Nerd",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 221,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Pas le temps",
    Artist: "NERIH",
    Album: "Pas le temps - Single",
    Time: 156,
    Year: 2021,
    Plays: 24,
  },
  {
    Name: "Are You in There",
    Artist: "Neverwake",
    Album: "Are You in There - Single",
    Time: 240,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "You're a Jerk",
    Artist: "New Boyz",
    Album: "You're a Jerk - EP",
    Time: 189,
    Year: 2009,
    Plays: 15,
  },
  {
    Name: "CLOUDS",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 243,
    Year: 2021,
    Plays: 33,
  },
  {
    Name: "THAT'S A JOKE",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 229,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "JUST LIKE YOU",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 251,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "STORY",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 279,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "PRIDEFUL",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 205,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "LOST (feat. Hopsin)",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 234,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "LAYERS",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 195,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "DRIFTING",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 200,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "TRUST (feat. Tech N9ne)",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 264,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "PAID MY DUES",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 211,
    Year: 2021,
    Plays: 15,
  },
  {
    Name: "CLOUDS (Edit)",
    Artist: "NF",
    Album: "CLOUDS (THE MIXTAPE)",
    Time: 229,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Face It",
    Artist: "NF",
    Album: "Mansion",
    Time: 219,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Paralyzed",
    Artist: "NF",
    Album: "Mansion",
    Time: 270,
    Year: 2015,
    Plays: 108,
  },
  {
    Name: "No Name",
    Artist: "NF",
    Album: "No Name - Single",
    Time: 183,
    Year: 2018,
    Plays: 13,
  },
  {
    Name: "PAID MY DUES",
    Artist: "NF",
    Album: "PAID MY DUES - Single",
    Time: 211,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Let You Down",
    Artist: "NF",
    Album: "Perception",
    Time: 212,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Lie",
    Artist: "NF",
    Album: "Perception",
    Time: 209,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "The Search",
    Artist: "NF",
    Album: "The Search",
    Time: 248,
    Year: 2019,
    Plays: 49,
  },
  {
    Name: "Leave Me Alone",
    Artist: "NF",
    Album: "The Search",
    Time: 308,
    Year: 2019,
    Plays: 48,
  },
  {
    Name: "Time",
    Artist: "NF",
    Album: "The Search",
    Time: 240,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Returns",
    Artist: "NF",
    Album: "The Search",
    Time: 232,
    Year: 2019,
    Plays: 9,
  },
  {
    Name: "When I Grow Up",
    Artist: "NF",
    Album: "The Search",
    Time: 196,
    Year: 2019,
    Plays: 35,
  },
  {
    Name: "Why",
    Artist: "NF",
    Album: "The Search",
    Time: 187,
    Year: 2019,
    Plays: 25,
  },
  {
    Name: "Therapy Session",
    Artist: "NF",
    Album: "Therapy Session",
    Time: 331,
    Year: 2016,
    Plays: 30,
  },
  {
    Name: "So Long (feat. The RTE Concert Orchestra) [Live]",
    Artist: "Niall Horan",
    Album: "Flicker (feat. The RTE Concert Orchestra) [Live]",
    Time: 217,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Speed of Sound",
    Artist: "Nick Phoenix",
    Album: "Speed of Sound",
    Time: 200,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "MEGATRON",
    Artist: "Nicki Minaj",
    Album: "MEGATRON - Single",
    Time: 190,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "I’m the Best",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 216,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Roman's Revenge (feat. Eminem)",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 276,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Did It On’em",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 212,
    Year: 2010,
    Plays: 5,
  },
  {
    Name: "Right Thru Me",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 235,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Fly (feat. Rihanna)",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 212,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Save Me",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 185,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Moment 4 Life (feat. Drake)",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 279,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Check It Out (feat. will.i.am)",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 251,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Blazin (feat. Kanye West)",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 301,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Here I Am",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 175,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Dear Old Nicki",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 233,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Your Love",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 245,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Last Chance (feat. Natasha Bedingfield)",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 231,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Super Bass",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 200,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Blow Ya Mind",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 220,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Muny",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 227,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Girls Fall Like Dominoes",
    Artist: "Nicki Minaj",
    Album: "Pink Friday",
    Time: 224,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Pound The Alarm",
    Artist: "Nicki Minaj",
    Album: "Pink Friday (Roman Reloaded)",
    Time: 205,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "High School (feat. Lil Wayne)",
    Artist: "Nicki Minaj",
    Album: "Pink Friday: Roman Reloaded the Re-Up (Booklet Version)",
    Time: 218,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "All Things Go",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 293,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "I Lied",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 304,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "The Crying Game",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 265,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Get On Your Knees (feat. Ariana Grande)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 216,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Feeling Myself (feat. Beyoncé)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 237,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Only (feat. Drake, Lil Wayne & Chris Brown)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 312,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Want Some More",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 229,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Four Door Aventador",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 182,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Favorite (feat. Jeremih)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 242,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Buy a Heart (feat. Meek Mill)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 255,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Trini Dem Girls (feat. Lunchmoney Lewis)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 194,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Anaconda",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 260,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "The Night Is Still Young",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 227,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Pills N Potions",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 268,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Bed of Lies (feat. Skylar Grey)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 269,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Grand Piano",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 259,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Big Daddy (feat. Meek Mill)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 199,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Shanghai",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 219,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Win Again",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 250,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Mona Lisa",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 208,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Put You in a Room",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 179,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Truffle Butter (feat. Drake & Lil Wayne)",
    Artist: "Nicki Minaj",
    Album: "The Pinkprint (Deluxe)",
    Time: 219,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Ganja Burn",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 294,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Barbie Dreams",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 279,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Rich Sex (feat. Lil Wayne)",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 192,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Hard White",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 193,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Bed (feat. Ariana Grande)",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 189,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Thought I Knew You (feat. The Weeknd)",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 198,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Run & Hide",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 154,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Chun Swae (feat. Swae Lee)",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 370,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Chun-Li",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 191,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "LLC",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 221,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Good Form",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 199,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "Nip Tuck",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 207,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "2 Lit 2 Late Interlude",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 55,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Come See About Me",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 246,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Sir (feat. Future)",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 224,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Miami",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 190,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Coco Chanel (feat. Foxy Brown)",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 224,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Inspirations Outro",
    Artist: "Nicki Minaj",
    Album: "Queen",
    Time: 58,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Yikes",
    Artist: "Nicki Minaj",
    Album: "Yikes - Single",
    Time: 156,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Familia (feat. Bantu) [Spider-Man: Into the Spider-Verse]",
    Artist: "Nicki Minaj & Anuel AA",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 174,
    Year: 2018,
    Plays: 19,
  },
  {
    Name: "Majesty (feat. Eminem)",
    Artist: "Nicki Minaj & Labrinth",
    Album: "Queen",
    Time: 295,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "No Frauds",
    Artist: "Nicki Minaj, Drake & Lil Wayne",
    Album: "No Frauds - Single",
    Time: 272,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Poison (New Main Version)",
    Artist: "Nicole Scherzinger",
    Album: "Killer Love",
    Time: 227,
    Year: 2010,
    Plays: 10,
  },
  {
    Name: "Bye Bye Beautiful",
    Artist: "Nightwish",
    Album: "Bye Bye Beautiful",
    Time: 259,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "How's the Heart?",
    Artist: "Nightwish",
    Album: "HUMAN. :II: NATURE.",
    Time: 302,
    Year: 2020,
    Plays: 6,
  },
  {
    Name: "Storytime",
    Artist: "Nightwish",
    Album: "Imaginaerum",
    Time: 322,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Ghost River",
    Artist: "Nightwish",
    Album: "Imaginaerum",
    Time: 324,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Music (Edit)",
    Artist: "Nightwish",
    Album: "Music (Edit) - Single",
    Time: 286,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Tomorrow",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 232,
    Year: 2012,
    Plays: 7,
  },
  {
    Name: "The Drummer",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 236,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "In Our Eyes",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 302,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "The Gentle Roar",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 224,
    Year: 2012,
    Plays: 10,
  },
  {
    Name: "Mother Protect",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 305,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "Last Night",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 199,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "Somebody",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 171,
    Year: 2012,
    Plays: 7,
  },
  {
    Name: "Love to the Test",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 228,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "DJ Ease My Mind",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 243,
    Year: 2012,
    Plays: 202,
  },
  {
    Name: "Winterheart",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 246,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "The Fox",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 259,
    Year: 2012,
    Plays: 24,
  },
  {
    Name: "Under the Bridges",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 239,
    Year: 2012,
    Plays: 6,
  },
  {
    Name: "All This Youth",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 237,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "The Drummer (First Demo)",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 272,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Everybody's Talking",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 227,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Taylor (2009 Island Sessions)",
    Artist: "Niki & The Dove",
    Album: "Instinct (Deluxe Version)",
    Time: 304,
    Year: 2012,
    Plays: 12,
  },
  {
    Name: "Less Than",
    Artist: "Nine Inch Nails",
    Album: "Add Violence",
    Time: 210,
    Year: 2017,
    Plays: 225,
  },
  {
    Name: "Never Back Down",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 203,
    Year: 2014,
    Plays: 62,
  },
  {
    Name: "Break the World",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 182,
    Year: 2014,
    Plays: 43,
  },
  {
    Name: "Where I Belong",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 217,
    Year: 2014,
    Plays: 36,
  },
  {
    Name: "Lights We Burn",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 218,
    Year: 2014,
    Plays: 40,
  },
  {
    Name: "Fear And Shadows",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 218,
    Year: 2014,
    Plays: 70,
  },
  {
    Name: "In the Dark",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 212,
    Year: 2014,
    Plays: 106,
  },
  {
    Name: "Light It Up",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 180,
    Year: 2014,
    Plays: 31,
  },
  {
    Name: "Love Me Now",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 209,
    Year: 2014,
    Plays: 35,
  },
  {
    Name: "Cover Your Own",
    Artist: "Nine Lashes",
    Album: "From Water to War",
    Time: 236,
    Year: 2014,
    Plays: 33,
  },
  {
    Name: "Anthem Of The Lonely",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 241,
    Year: 2012,
    Plays: 103,
  },
  {
    Name: "The Intervention",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 215,
    Year: 2012,
    Plays: 10,
  },
  {
    Name: "Get Back",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 185,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "Afterglow",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 266,
    Year: 2012,
    Plays: 143,
  },
  {
    Name: "Adrenaline",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 202,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Believe Your Eyes",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 219,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "Our Darkest Day",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 211,
    Year: 2012,
    Plays: 87,
  },
  {
    Name: "Memo",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 217,
    Year: 2012,
    Plays: 7,
  },
  {
    Name: "Write It Down",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 169,
    Year: 2012,
    Plays: 10,
  },
  {
    Name: "The Void",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 171,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "My Friend",
    Artist: "Nine Lashes",
    Album: "World We View",
    Time: 224,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "Serve the Servants",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 216,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Scentless Apprentice",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 227,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Heart Shaped Box",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 281,
    Year: 1993,
    Plays: 1,
  },
  {
    Name: "Rape Me",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 169,
    Year: 1993,
    Plays: 1,
  },
  {
    Name: "Frances Farmer Will Have Her Revenge on Seattle",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 249,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Dumb",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 152,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Very Ape",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 115,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Milk It",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 234,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Pennyroyal Tea",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 217,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Radio Friendly Unit Shifter",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 291,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Tourette's",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 95,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "All Apologies",
    Artist: "Nirvana",
    Album: "In Utero",
    Time: 230,
    Year: 1993,
    Plays: null,
  },
  {
    Name: "Dive",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 235,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Sliver",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 136,
    Year: 1992,
    Plays: 2,
  },
  {
    Name: "Stain",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 160,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Been A Son",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 115,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Turnaround",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 139,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Molly's Lips",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 114,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Son Of A Gun",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 168,
    Year: 1992,
    Plays: 2,
  },
  {
    Name: "(New Wave) Polly",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 108,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Beeswax",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 170,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Downer",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 103,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Mexican Seafood",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 115,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Hairspray Queen",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 253,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Aero Zeppelin",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 281,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Big Long Now",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 303,
    Year: 1992,
    Plays: null,
  },
  {
    Name: "Aneurysm",
    Artist: "Nirvana",
    Album: "Incesticide",
    Time: 276,
    Year: 1992,
    Plays: 1,
  },
  {
    Name: "Smells Like Teen Spirit",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 301,
    Year: 1991,
    Plays: 2,
  },
  {
    Name: "In Bloom",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 254,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Come as You Are",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 219,
    Year: 1991,
    Plays: 3,
  },
  {
    Name: "Breed",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 183,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Lithium",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 256,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Polly",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 176,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Territorial Pissings",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 143,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Drain You",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 223,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Lounge Act",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 156,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Stay Away",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 212,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "On a Plain",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 196,
    Year: 1991,
    Plays: 1,
  },
  {
    Name: "Something in the Way",
    Artist: "Nirvana",
    Album: "Nevermind",
    Time: 1235,
    Year: 1991,
    Plays: null,
  },
  {
    Name: "Dead Inside",
    Artist: "Nita Strauss, David Draiman & Disturbed",
    Album: "Dead Inside - Single",
    Time: 240,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Walls of Anxiety",
    Artist: "No name faces",
    Album: "Walls of Anxiety",
    Time: 241,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "My Hero",
    Artist: "No name faces",
    Album: "Walls of Anxiety",
    Time: 289,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Part of Me",
    Artist: "Noah Kahan",
    Album: "I Was / I Am",
    Time: 239,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Goyang Mama Muda",
    Artist: "Nofin Asia",
    Album: "Spesial Album",
    Time: 321,
    Year: 2020,
    Plays: 14,
  },
  {
    Name: "Spirit In the Sky",
    Artist: "Norman Greenbaum",
    Album: "Spirit In the Sky",
    Time: 242,
    Year: 1969,
    Plays: null,
  },
  {
    Name: "Motivation",
    Artist: "Normani",
    Album: "Motivation - Single",
    Time: 193,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Coronation",
    Artist: "Nostalghia & Tyler Bates",
    Album: "John Wick: Chapter 2 (Original Motion Picture Soundtrack)",
    Time: 179,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "This Is the Time (Ballast)",
    Artist: "NOTHING MORE",
    Album: "Nothing More",
    Time: 220,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Here's to the Heartache",
    Artist: "NOTHING MORE",
    Album: "Nothing More",
    Time: 257,
    Year: 2014,
    Plays: 17,
  },
  {
    Name: "God Went North",
    Artist: "NOTHING MORE",
    Album: "Nothing More",
    Time: 369,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Go to War",
    Artist: "NOTHING MORE",
    Album: "The Stories We Tell Ourselves",
    Time: 245,
    Year: 2017,
    Plays: 11,
  },
  {
    Name: "Disconnected",
    Artist: "Novena",
    Album: "Eleventh Hour",
    Time: 323,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Bae",
    Artist: "O.T. Genasis",
    Album: "Bae - Single",
    Time: 156,
    Year: 2018,
    Plays: 157,
  },
  {
    Name: "When I Get It (feat. Young Thug)",
    Artist: "O.T. Genasis",
    Album: "When I Get It (feat. Young Thug) - Single",
    Time: 197,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Take My Hand",
    Artist: "Oberg",
    Album: "Take My Hand - Single",
    Time: 161,
    Year: 2020,
    Plays: 16,
  },
  {
    Name: "Bet (feat. Skepta & Michael Phantom)",
    Artist: "Octavian",
    Album: "Bet (feat. Skepta & Michael Phantom) - Single",
    Time: 166,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Lightning",
    Artist: "Octavian",
    Album: "SPACEMAN",
    Time: 235,
    Year: 2018,
    Plays: 16,
  },
  {
    Name: "express (feat. Santi & Nasty C)",
    Artist: "Odunsi (The Engine)",
    Album: "rare.",
    Time: 154,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Fighting Gravity",
    Artist: "Of Mice & Men",
    Album: "Echo",
    Time: 296,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "U Guessed It (Extended Version) [feat. Key!]",
    Artist: "OG Maco",
    Album: "U Guessed It - Single",
    Time: 209,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Better Now",
    Artist: "Oh Wonder",
    Album: "No One Else Can Wear Your Crown (Deluxe)",
    Time: 198,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "I Won't Let You Down (Shockbit Remix)",
    Artist: "Ok Go",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 146,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Without You",
    Artist: "Okey Sokay",
    Album: "Without You",
    Time: 266,
    Year: 2014,
    Plays: 55,
  },
  {
    Name: "Happiness Does Not Wait (2021 Version)",
    Artist: "Ólafur Arnalds",
    Album: "Happiness Does Not Wait (2021 Version) - Single",
    Time: 196,
    Year: 2021,
    Plays: 18,
  },
  {
    Name: "Do Better",
    Artist: "Olamide",
    Album: "Carpe Diem",
    Time: 192,
    Year: 2020,
    Plays: 212,
  },
  {
    Name: "Plenty (feat. Fireboy DML)",
    Artist: "Olamide",
    Album: "Carpe Diem",
    Time: 169,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Eyan Mayweather",
    Artist: "Olamide",
    Album: "Eyan Mayweather",
    Time: 216,
    Year: 2015,
    Plays: 60,
  },
  {
    Name: "Inferiority Complex",
    Artist: "Olamide",
    Album: "Eyan Mayweather",
    Time: 242,
    Year: 2015,
    Plays: 22,
  },
  {
    Name: "Lagos Boys",
    Artist: "Olamide",
    Album: "Eyan Mayweather",
    Time: 224,
    Year: 2015,
    Plays: 63,
  },
  {
    Name: "Science Student",
    Artist: "Olamide",
    Album: "Science Student - Single",
    Time: 203,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Somebody (feat. Phyno)",
    Artist: "Olamide",
    Album: "UY Scuti",
    Time: 200,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Ilefo Illuminati",
    Artist: "Olamide",
    Album: "Ybnl",
    Time: 275,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Hate Me",
    Artist: "Olamide & Wande Coal",
    Album: "Hate Me - Single",
    Time: 199,
    Year: 2022,
    Plays: 4,
  },
  {
    Name: "Broken Down",
    Artist: "Ollie",
    Album: "Broken Down - Single",
    Time: 205,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Yahooze",
    Artist: "Olu Maintain",
    Album: "Olu Maintain",
    Time: 255,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "I Get It In (Remix) BONUS",
    Artist: "Omarion Ft. Bag$ And Lil Wayne",
    Album: "No Ceilings",
    Time: 188,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Today Na Today",
    Artist: "Omawumi",
    Album: "Wonder Woman",
    Time: 214,
    Year: 2009,
    Plays: 44,
  },
  {
    Name: "Ma Cherie",
    Artist: "Omoakin",
    Album: "Just Press Play the EP",
    Time: 152,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "We Are",
    Artist: "ONE OK ROCK",
    Album: "Ambitions",
    Time: 255,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "Broken Heart of Gold (Acoustic)",
    Artist: "ONE OK ROCK",
    Album: "Broken Heart of Gold (Acoustic) - Single",
    Time: 219,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Eye Of The Storm",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 182,
    Year: 2019,
    Plays: 11,
  },
  {
    Name: "Stand Out Fit In",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 214,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Head High",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 207,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Grow Old Die Young",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 206,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Push Back",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 209,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Wasted Nights",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 224,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Change",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 176,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Letting Go",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 200,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Worst In Me",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 189,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "In The Stars (feat. Kiiara)",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 203,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Giants",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 164,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Unforgettable",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 195,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "The Last Time",
    Artist: "ONE OK ROCK",
    Album: "Eye of the Storm",
    Time: 170,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "The Beginning",
    Artist: "ONE OK ROCK",
    Album: "Jinsei × Boku =",
    Time: 292,
    Year: 2012,
    Plays: 27,
  },
  {
    Name: "Liar",
    Artist: "ONE OK ROCK",
    Album: "Niche Syndrome",
    Time: 217,
    Year: 2010,
    Plays: 53,
  },
  {
    Name: "Nobody's Home",
    Artist: "ONE OK ROCK",
    Album: "Niche Syndrome",
    Time: 257,
    Year: 2010,
    Plays: 5,
  },
  {
    Name: "Renegades (Acoustic) [Japanese Version]",
    Artist: "ONE OK ROCK",
    Album: "Renegades (Acoustic) [Japanese Version] - Single",
    Time: 247,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Answer Is Near",
    Artist: "ONE OK ROCK",
    Album: "Zankyō Reference",
    Time: 219,
    Year: 2011,
    Plays: 17,
  },
  {
    Name: "Pierce",
    Artist: "ONE OK ROCK",
    Album: "Zankyō Reference",
    Time: 265,
    Year: 2011,
    Plays: 7,
  },
  {
    Name: "The Way Back",
    Artist: "ONE OK ROCK",
    Album: "35xxxv (Deluxe Edition)",
    Time: 182,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Counting Stars",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 257,
    Year: 2014,
    Plays: 33,
  },
  {
    Name: "Love Runs Out",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 224,
    Year: 2014,
    Plays: 15,
  },
  {
    Name: "If I Lose Myself",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 241,
    Year: 2014,
    Plays: 9,
  },
  {
    Name: "Feel Again",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 185,
    Year: 2014,
    Plays: 7,
  },
  {
    Name: "What You Wanted",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 241,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "I Lived",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 234,
    Year: 2014,
    Plays: 36,
  },
  {
    Name: "Light It Up",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 250,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "Can’t Stop",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 249,
    Year: 2014,
    Plays: 11,
  },
  {
    Name: "Au Revoir",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 290,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Burning Bridges",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 257,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Something I Need",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 241,
    Year: 2014,
    Plays: 14,
  },
  {
    Name: "Preacher",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 248,
    Year: 2014,
    Plays: 7,
  },
  {
    Name: "Don't Look Down",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 99,
    Year: 2014,
    Plays: 10,
  },
  {
    Name: "Life In Color",
    Artist: "OneRepublic",
    Album: "Native",
    Time: 202,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Rescue Me",
    Artist: "OneRepublic",
    Album: "Rescue Me - Single",
    Time: 158,
    Year: 2019,
    Plays: 129,
  },
  {
    Name: "Somebody to Love",
    Artist: "OneRepublic",
    Album: "Somebody to Love - Single",
    Time: 181,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Start Again (feat. Logic)",
    Artist: "OneRepublic",
    Album: "13 Reasons Why (Season 2)",
    Time: 165,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "If I Lose Myself (Alesso vs OneRepublic)",
    Artist: "OneRepublic & Alesso",
    Album: "Native",
    Time: 214,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Whispers in My Head",
    Artist: "Onlap",
    Album: "The Awakening - EP",
    Time: 241,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "FANTASTIC TUNE",
    Artist: "Ono Kensho",
    Album: "FANTASTIC TUNE",
    Time: 248,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Tabidatsu mono he",
    Artist: "Ono Ryouko",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 120,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Kyouran Hey Kids!!",
    Artist: "THE ORAL CIGARETTES",
    Album: "Kyouran Hey Kids!! - EP",
    Time: 249,
    Year: 2015,
    Plays: 12,
  },
  {
    Name: "Love Is the Drug [Roxy Music cover] ",
    Artist: "Oscar Isaac and Carla Gugino",
    Album: "Sucker Punch",
    Time: 252,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Six Feet Under",
    Artist: "Oshins & Leslie Powell",
    Album: "Six Feet Under - Single",
    Time: 182,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Yoyo's World",
    Artist: "Otm Yo",
    Album: "Yoyo's World - Single",
    Time: 174,
    Year: 2020,
    Plays: 30,
  },
  {
    Name: "Beggin'",
    Artist: "Our Last Night",
    Album: "Beggin' - Single",
    Time: 176,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Drivers License",
    Artist: "Our Last Night",
    Album: "Drivers License - Single",
    Time: 236,
    Year: 2021,
    Plays: 86,
  },
  {
    Name: "Graveyard",
    Artist: "Our Last Night",
    Album: "Empires Fall",
    Time: 183,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "Uninstall",
    Artist: "Our Last Night",
    Album: "Empires Fall",
    Time: 155,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Empires Fall",
    Artist: "Our Last Night",
    Album: "Empires Fall",
    Time: 221,
    Year: 2022,
    Plays: 2,
  },
  {
    Name: "Surface Pressure",
    Artist: "Our Last Night",
    Album: "Enemy - EP",
    Time: 197,
    Year: 2022,
    Plays: 19,
  },
  {
    Name: "Tea Leaves",
    Artist: "Our Last Night",
    Album: "No Help - Single",
    Time: 214,
    Year: 2022,
    Plays: 5,
  },
  {
    Name: "Hell To Have You",
    Artist: "Our Last Night & Sam Tinnesz",
    Album: "Hell To Have You - Single",
    Time: 173,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Unseen",
    Artist: "Our Mirage",
    Album: "Unseen Relations",
    Time: 211,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Oju Mi Bloody (feat. Chinko Ekun & Mz Kiss)",
    Artist: "Oyibo Rebel",
    Album: "Oju Mi Bloody (feat. Chinko Ekun & Mz Kiss) - Single",
    Time: 211,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Only (feat. Oluwanisola)",
    Artist: "Oyindah",
    Album: "Only (feat. Oluwanisola) - Single",
    Time: 182,
    Year: 2020,
    Plays: 23,
  },
  {
    Name: "Aura (feat. Arthur Hanlon)",
    Artist: "Ozuna",
    Album: "Aura",
    Time: 187,
    Year: 2018,
    Plays: 18,
  },
  {
    Name: "Cama Vacía",
    Artist: "Ozuna",
    Album: "Cama Vacía - Single",
    Time: 201,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Hasta Que Salga el Sol",
    Artist: "Ozuna",
    Album: "Nibiru",
    Time: 188,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Se Preparó",
    Artist: "Ozuna",
    Album: "Odisea",
    Time: 188,
    Year: 2017,
    Plays: 64,
  },
  {
    Name: "FRZZN (feat. Teflon Sega)",
    Artist: "OZZIE",
    Album: "Colours",
    Time: 239,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "Bank Alert",
    Artist: "P-Square",
    Album: "Bank Alert - Single",
    Time: 253,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "No One Like You",
    Artist: "P-Square",
    Album: "Best of P-Square",
    Time: 268,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "Gimme Dat",
    Artist: "P-Square",
    Album: "Danger",
    Time: 262,
    Year: 2009,
    Plays: 4,
  },
  {
    Name: "Bring It On (feat. Dave Scott)",
    Artist: "P-Square",
    Album: "Double Trouble",
    Time: 240,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Collabo (feat. Don Jazzy)",
    Artist: "P-Square",
    Album: "Double Trouble",
    Time: 223,
    Year: 2014,
    Plays: 80,
  },
  {
    Name: "Do Me (Deluxe)",
    Artist: "P-Square",
    Album: "Gameover (Deluxe)",
    Time: 281,
    Year: 2007,
    Plays: 4,
  },
  {
    Name: "More Than a Friend (Deluxe)",
    Artist: "P-Square",
    Album: "Gameover (Deluxe)",
    Time: 253,
    Year: 2007,
    Plays: 6,
  },
  {
    Name: "Ifunanya (Deluxe)",
    Artist: "P-Square",
    Album: "Gameover (Deluxe)",
    Time: 266,
    Year: 2007,
    Plays: 11,
  },
  {
    Name: "Bizzy Body",
    Artist: "P-Square",
    Album: "Get Squared",
    Time: 289,
    Year: 2008,
    Plays: 5,
  },
  {
    Name: "Your Name",
    Artist: "P-Square",
    Album: "Get Squared",
    Time: 262,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Alingo",
    Artist: "P-Square",
    Album: "Greatest Hits",
    Time: 271,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Bizzy Body (Remix)",
    Artist: "P-Square",
    Album: "Greatest Hits",
    Time: 272,
    Year: 2007,
    Plays: 6,
  },
  {
    Name: "Temptation (Remix)",
    Artist: "P-Square",
    Album: "Greatest Hits",
    Time: 334,
    Year: 2007,
    Plays: 3,
  },
  {
    Name: "Beautiful Onyinye",
    Artist: "P-Square",
    Album: "Invasion",
    Time: 291,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Bunieya Enu",
    Artist: "P-Square",
    Album: "Invasion",
    Time: 284,
    Year: 2011,
    Plays: 8,
  },
  {
    Name: "Nobody Ugly",
    Artist: "P-Square",
    Album: "Nobody Ugly - Single",
    Time: 246,
    Year: 2017,
    Plays: 11,
  },
  {
    Name: "Omoge Mi",
    Artist: "P-Square",
    Album: "P - Square, Vol.4",
    Time: 275,
    Year: 2008,
    Plays: 4,
  },
  {
    Name: "All I Know So Far",
    Artist: "P!nk",
    Album: "All I Know So Far: Setlist",
    Time: 277,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Revenge (feat. Eminem)",
    Artist: "P!nk",
    Album: "Beautiful Trauma",
    Time: 226,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "What About Us",
    Artist: "P!nk",
    Album: "Beautiful Trauma",
    Time: 269,
    Year: 2017,
    Plays: 63,
  },
  {
    Name: "F**kin' Perfect",
    Artist: "P!nk",
    Album: "F**kin' Perfect (Perfect) - Single",
    Time: 213,
    Year: 2010,
    Plays: 4,
  },
  {
    Name: "Funhouse",
    Artist: "P!nk",
    Album: "Greatest Hits...So Far!!!",
    Time: 204,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Raise Your Glass",
    Artist: "P!nk",
    Album: "Greatest Hits...So Far!!!",
    Time: 203,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "F**kin' Perfect",
    Artist: "P!nk",
    Album: "Greatest Hits...So Far!!!",
    Time: 213,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Raise Your Glass",
    Artist: "P!nk",
    Album: "Raise Your Glass - Single",
    Time: 202,
    Year: 2010,
    Plays: 13,
  },
  {
    Name: "Rage",
    Artist: "Paaus & Lukrative",
    Album: "Rage - Single",
    Time: 196,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Wait.",
    Artist: "Painting Promises",
    Album: "Wait. - Single",
    Time: 257,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Massacre, The New American Dream",
    Artist: "Palaye Royale",
    Album: "The Bastards",
    Time: 185,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "You'll Be Fine",
    Artist: "Palaye Royale",
    Album: "Boom Boom Room (Side B)",
    Time: 213,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Mad World",
    Artist: "Palaye Royale",
    Album: "Mad World - Single",
    Time: 210,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Through Hell",
    Artist: "Palisades",
    Album: "Palisades",
    Time: 276,
    Year: 2017,
    Plays: 32,
  },
  {
    Name: "Fast Lane",
    Artist: "Palm Trees, Mdl & Abi F Jones",
    Album: "Fast Lane - Single",
    Time: 149,
    Year: 2019,
    Plays: 76,
  },
  {
    Name: 'Haru wa Yuku (From "Fate/Stay night: Heaven\'s Feel III. Spring Song")',
    Artist: "Pandora Journey",
    Album:
      'Haru wa Yuku (From "Fate/Stay night: Heaven\'s Feel III. Spring Song") - Single',
    Time: 279,
    Year: 2020,
    Plays: 10,
  },
  {
    Name: "Bohemian Rhapsody",
    Artist: "Panic! At the Disco",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 361,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Born for Greatness",
    Artist: "Papa Roach",
    Album: "Crooked Teeth (Deluxe Edition)",
    Time: 227,
    Year: 2017,
    Plays: 22,
  },
  {
    Name: "The Ending",
    Artist: "Papa Roach",
    Album: "Who Do You Trust?",
    Time: 209,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Stumble into the Light",
    Artist: "Parabelle",
    Album: "The Rose Avail",
    Time: 268,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "My Surrender",
    Artist: "Parabelle",
    Album: "",
    Time: 293,
    Year: null,
    Plays: 54,
  },
  {
    Name: "Careful",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 224,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Ignorance",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 218,
    Year: 2009,
    Plays: 6,
  },
  {
    Name: "Playing God",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 182,
    Year: 2009,
    Plays: 5,
  },
  {
    Name: "Brick By Boring Brick",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 253,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Turn It Off",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 259,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "The Only Exception",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 267,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Feeling Sorry",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 185,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Looking Up",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 209,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Where the Lines Overlap",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 198,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Misguided Ghosts",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 181,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "All I Wanted",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 228,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Decode",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 262,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Ignorance (Acoustic)",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 220,
    Year: 2009,
    Plays: 3,
  },
  {
    Name: "Where The Lines Overlap (Acoustic)",
    Artist: "Paramore",
    Album: "Brand New Eyes (Deluxe Edition)",
    Time: 192,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Fast In My Car",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 222,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Now",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 250,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Grow Up",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 230,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Daydreaming",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 271,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Interlude: Moving On",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 90,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Ain't It Fun",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 296,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Part II",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 281,
    Year: 2013,
    Plays: 22,
  },
  {
    Name: "Last Hope",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 309,
    Year: 2013,
    Plays: 10,
  },
  {
    Name: "Still Into You",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 216,
    Year: 2013,
    Plays: 11,
  },
  {
    Name: "Anklebiters",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 137,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Interlude: Holiday",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 69,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Proof",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 195,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Hate To See Your Heart Break",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 309,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "(One of Those) Crazy Girls",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 212,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Interlude: I'm Not Angry Anymore",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 52,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Be Alone",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 220,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Future",
    Artist: "Paramore",
    Album: "Paramore",
    Time: 472,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Misery Business",
    Artist: "Paramore",
    Album: "Riot!",
    Time: 211,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "Monster",
    Artist: "Paramore",
    Album: "",
    Time: 198,
    Year: null,
    Plays: 28,
  },
  {
    Name: "Hoop Earrings",
    Artist: "Pardison Fontaine",
    Album: "Hoop Earrings - Single",
    Time: 143,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Sweet but Psycho",
    Artist: "Parker Jenkins",
    Album: "Sweet but Psycho - Single",
    Time: 188,
    Year: 2018,
    Plays: 58,
  },
  {
    Name: "Vice Grip",
    Artist: "Parkway Drive",
    Album: "Ire (Deluxe Edition)",
    Time: 263,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Flash Light",
    Artist: "Parliament",
    Album: "Straight Outta Compton",
    Time: 268,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Friendships",
    Artist: "Pascal Letoublon",
    Album: "Deep House Chill, Vol. 03",
    Time: 242,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Confirm (feat. Davido)",
    Artist: "Patoranking",
    Album: "Confirm (feat. Davido) - Single",
    Time: 229,
    Year: 2019,
    Plays: 30,
  },
  {
    Name: "I'm In Love",
    Artist: "Patoranking",
    Album: "I'm In Love - Single",
    Time: 209,
    Year: 2020,
    Plays: 47,
  },
  {
    Name: "Paul (Skit)",
    Artist: "Paul Rosenberg",
    Album: "Kamikaze",
    Time: 35,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Spit on a Stranger",
    Artist: "Pavement",
    Album: "Terror Twilight",
    Time: 184,
    Year: 1999,
    Plays: null,
  },
  {
    Name: "Naruto",
    Artist: "Pelly",
    Album: "Naruto - Single",
    Time: 129,
    Year: 2020,
    Plays: 10,
  },
  {
    Name: "God Rest Ye Merry Gentlemen",
    Artist: "Pentatonix",
    Album: "A Pentatonix Christmas (Deluxe)",
    Time: 149,
    Year: 2016,
    Plays: 33,
  },
  {
    Name: "The Sound of Silence",
    Artist: "Pentatonix",
    Album: "The Sound of Silence - Single",
    Time: 212,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Disillusioned",
    Artist: "A Perfect Circle",
    Album: "Eat the Elephant",
    Time: 353,
    Year: 2018,
    Plays: 27,
  },
  {
    Name: "The Doomed",
    Artist: "A Perfect Circle",
    Album: "Eat the Elephant",
    Time: 281,
    Year: 2017,
    Plays: 8,
  },
  {
    Name: "Perfect Two",
    Artist: "Perfect Two",
    Album: "Perfect Two - Single",
    Time: 233,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Gunshot",
    Artist: "Peruzzi",
    Album: "Gunshot - Single",
    Time: 184,
    Year: 2021,
    Plays: 26,
  },
  {
    Name: "Entrepreneur (feat. JAY-Z)",
    Artist: "Pharrell Williams",
    Album: "Entrepreneur (feat. JAY-Z) - Single",
    Time: 258,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Freedom",
    Artist: "Pharrell Williams",
    Album: "Freedom - Single",
    Time: 163,
    Year: 2015,
    Plays: 18,
  },
  {
    Name: "Deal With It",
    Artist: "Phyno",
    Album: "Deal with It",
    Time: 125,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Ghost Mode (feat. Olamide)",
    Artist: "Phyno",
    Album: "No Guts No Glory",
    Time: 230,
    Year: 2012,
    Plays: 13,
  },
  {
    Name: "Link Up (feat. Burna Boy & MI)",
    Artist: "Phyno",
    Album: "The PlayMaker",
    Time: 218,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Obiagu",
    Artist: "Phyno",
    Album: "The PlayMaker",
    Time: 249,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Love The Way You Lie",
    Artist: "Piano Fruits Music & Emmanuel Pistacho",
    Album: "Love The Way You Lie - Single",
    Time: 125,
    Year: 2020,
    Plays: 22,
  },
  {
    Name: "Pray",
    Artist: "Picturesque",
    Album: "Pray - Single",
    Time: 224,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Comfortably Numb",
    Artist: "Pink Floyd",
    Album: "The Wall",
    Time: 382,
    Year: 1979,
    Plays: null,
  },
  {
    Name: "Epic Rains of Castamere",
    Artist: "Pisces Rising",
    Album: "Epic Rains of Castamere - Single",
    Time: 321,
    Year: 2016,
    Plays: 27,
  },
  {
    Name: "Give Me Everything (feat. Ne-Yo, Afrojack & Nayer)",
    Artist: "Pitbull",
    Album: "Planet Pit (Deluxe Version)",
    Time: 252,
    Year: 2011,
    Plays: 10,
  },
  {
    Name: "Do it (Feat Mayer Hawthorne)",
    Artist: "Pitbull",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 220,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Cuidao (feat. Yandel & Messiah)",
    Artist: "Play-N-Skillz",
    Album: "Cuidao (feat. Yandel & Messiah) - Single",
    Time: 184,
    Year: 2018,
    Plays: 14,
  },
  {
    Name: "Duffle Bag Boy (feat. Lil Wayne)",
    Artist: "Playaz Circle",
    Album: "Supply & Demand",
    Time: 258,
    Year: 2007,
    Plays: 2,
  },
  {
    Name: "Boss Friends (feat. DaBaby)",
    Artist: "Plies",
    Album: "Boss Friends (feat. DaBaby) - Single",
    Time: 167,
    Year: 2019,
    Plays: 26,
  },
  {
    Name: "Bounce",
    Artist: "Plies",
    Album: "Bounce - Single",
    Time: 187,
    Year: 2019,
    Plays: 52,
  },
  {
    Name: "Black Roses",
    Artist: "Pnk Sabbth",
    Album: "Indigo - EP",
    Time: 305,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Into the Dark (feat. Kellin Quinn)",
    Artist: "Point North",
    Album: "Brand New Vision",
    Time: 198,
    Year: 2020,
    Plays: 6,
  },
  {
    Name: "Masochist",
    Artist: "Polaris",
    Album: "The Death of Me",
    Time: 247,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Don't Play (feat. Lil Baby)",
    Artist: "Polo G",
    Album: "Hall of Fame 2.0",
    Time: 156,
    Year: 2021,
    Plays: 30,
  },
  {
    Name: "Black Man in America",
    Artist: "Polo G",
    Album: "Hall of Fame 2.0",
    Time: 174,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Fortnight",
    Artist: "Polo G",
    Album: "Hall of Fame 2.0",
    Time: 129,
    Year: 2021,
    Plays: 134,
  },
  {
    Name: "Twerksum",
    Artist: "Pooh Shiesty",
    Album: "Twerksum - Single",
    Time: 193,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Darkest Night",
    Artist: "POORSTACY",
    Album: "Bill & Ted Face The Music (Original Motion Picture Soundtrack)",
    Time: 135,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Hills Have Eyes",
    Artist: "POORSTACY",
    Album: "Hills Have Eyes - Single",
    Time: 130,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Jump",
    Artist: "POORSTACY",
    Album: "Party At The Cemetery",
    Time: 169,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Be Legendary",
    Artist: "Pop Evil",
    Album: "Pop Evil",
    Time: 203,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Christopher Walking",
    Artist: "Pop Smoke",
    Album: "Christopher Walking - Single",
    Time: 191,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Tell The Vision (feat. Kanye West & Pusha T)",
    Artist: "Pop Smoke",
    Album: "Faith",
    Time: 215,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Meet the Woo",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 121,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Welcome to the Party",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 214,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Hawk Em",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 118,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Better Have Your Gun",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 199,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Scenario",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 241,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Dior",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 216,
    Year: 2019,
    Plays: 19,
  },
  {
    Name: "Feeling",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 161,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "PTSD",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 199,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Brother Man",
    Artist: "Pop Smoke",
    Album: "Meet the Woo",
    Time: 182,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Element",
    Artist: "Pop Smoke",
    Album: "Meet the Woo 2",
    Time: 135,
    Year: 2020,
    Plays: 47,
  },
  {
    Name: "Wolves (feat. NAV)",
    Artist: "Pop Smoke",
    Album: "Meet the Woo 2 (Deluxe)",
    Time: 194,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Bad Bitch From Tokyo (Intro)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 48,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Aim For The Moon (feat. Quavo)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 175,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "For The Night (feat. Lil Baby & DaBaby)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 190,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "44 BullDog",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 150,
    Year: 2020,
    Plays: 60,
  },
  {
    Name: "Gangstas",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 160,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Yea Yea",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 185,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Creature (feat. Swae Lee)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 202,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Snitching (feat. Quavo & Future)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 259,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Make It Rain (feat. Rowdy Rebel)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 202,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "The Woo (feat. 50 Cent & Roddy Ricch)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 201,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "West Coast Shit (feat. Tyga & Quavo)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 192,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Enjoy Yourself (feat. KAROL G)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 197,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Mood Swings (feat. Lil Tjay)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 213,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Something Special",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 158,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "What You Know Bout Love",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 160,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Diana (feat. King Combs)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 188,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Got It On Me",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 164,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Tunnel Vision (Outro)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 132,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Dior (Bonus)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon",
    Time: 216,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Bad Bitch From Tokyo (Intro)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 48,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Aim For The Moon (feat. Quavo)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 175,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "For The Night (feat. Lil Baby & DaBaby)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 190,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "44 BullDog",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 150,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Gangstas",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 160,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Yea Yea",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 185,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Creature (feat. Swae Lee)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 202,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Snitching (feat. Quavo & Future)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 259,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Make It Rain (feat. Rowdy Rebel)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 202,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "The Woo (feat. 50 Cent & Roddy Ricch)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 201,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "West Coast Shit (feat. Tyga & Quavo)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 192,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Enjoy Yourself (feat. KAROL G)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 197,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Mood Swings (feat. Lil Tjay)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 213,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Something Special",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 158,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "What You Know Bout Love",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 160,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Diana (feat. King Combs)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 188,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Got It On Me",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 164,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Tunnel Vision (Outro)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 132,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Dior (Bonus)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 216,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Hotel Lobby",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 151,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Showin Off Pt.1 (feat. Fivio Foreign)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 96,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Showin Off Pt.2 (feat. Fivio Foreign)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 192,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Iced Out Audemars (feat. DAFI WOO)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 182,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Woo Year (feat. Dread Woo)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 181,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Tsunami (feat. Davido)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 208,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Backseat (feat. PnB Rock)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 170,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Imperfections (Interlude)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 108,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "She Feelin Nice (feat. Jamie Foxx)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 155,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Paranoia (feat. Gunna & Young Thug)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 212,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Hello (feat. A Boogie wit da Hoodie)",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 190,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Be Clearr",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 202,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Yea Yea (feat. Queen Naija) [Remix]",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 216,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Diana (feat. King Combs & Calboy) [Remix]",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 234,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Enjoy Yourself (feat. Burna Boy) [Remix]",
    Artist: "Pop Smoke",
    Album: "Shoot For The Stars Aim For The Moon (Deluxe)",
    Time: 197,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "War (feat. Lil Tjay)",
    Artist: "Pop Smoke",
    Album: "War (feat. Lil Tjay) - Single",
    Time: 223,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Silence",
    Artist: "Popcaan",
    Album: "Forever",
    Time: 215,
    Year: 2018,
    Plays: 58,
  },
  {
    Name: "Pool Party",
    Artist: "Popcaan",
    Album: "Pool Party - Single",
    Time: 185,
    Year: 2021,
    Plays: 18,
  },
  {
    Name: "rockstar (feat. 21 Savage)",
    Artist: "Post Malone",
    Album: "beerbongs & bentleys",
    Time: 218,
    Year: 2017,
    Plays: 63,
  },
  {
    Name: "Hollywood's Bleeding",
    Artist: "Post Malone",
    Album: "Hollywood's Bleeding",
    Time: 156,
    Year: 2019,
    Plays: 47,
  },
  {
    Name: "Enemies (feat. DaBaby)",
    Artist: "Post Malone",
    Album: "Hollywood's Bleeding",
    Time: 196,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Die For Me (feat. Future & Halsey)",
    Artist: "Post Malone",
    Album: "Hollywood's Bleeding",
    Time: 245,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Take What You Want (feat. Ozzy Osbourne & Travis Scott)",
    Artist: "Post Malone",
    Album: "Hollywood's Bleeding",
    Time: 229,
    Year: 2019,
    Plays: 48,
  },
  {
    Name: "Motley Crew",
    Artist: "Post Malone",
    Album: "Motley Crew - Single",
    Time: 184,
    Year: 2021,
    Plays: 95,
  },
  {
    Name: "Congratulations (feat. Quavo)",
    Artist: "Post Malone",
    Album: "Stoney (Deluxe)",
    Time: 220,
    Year: 2016,
    Plays: 8,
  },
  {
    Name: "Euthanasia",
    Artist: "Post Malone",
    Album: "Twelve Carat Toothache (Deluxe)",
    Time: 145,
    Year: 2022,
    Plays: 10,
  },
  {
    Name: "Sunflower (Spider-Man: Into the Spider-Verse)",
    Artist: "Post Malone & Swae Lee",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 158,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Heaven Knows",
    Artist: "The Pretty Reckless",
    Album: "Going to Hell (Deluxe Edition)",
    Time: 224,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Chop Elbow (feat. Falz)",
    Artist: "Prettyboy D-O",
    Album: "Everything Pretty",
    Time: 233,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Marlboro (feat. Foreign Heat)",
    Artist: "Prince of Falls",
    Album: "Till We Feel Something",
    Time: 220,
    Year: 2018,
    Plays: 73,
  },
  {
    Name: "Cita",
    Artist: "Prince Royce",
    Album: "ALTER EGO",
    Time: 216,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Don't Feed the Dark",
    Artist: "Project Vela",
    Album: "Don't Feed the Dark - Single",
    Time: 261,
    Year: 2018,
    Plays: 18,
  },
  {
    Name: "City of Kings",
    Artist: "PsychoYP",
    Album: "YPSZN2",
    Time: 156,
    Year: 2019,
    Plays: 12,
  },
  {
    Name: "ELEVATE",
    Artist: "PsychoYP",
    Album: "YPSZN2",
    Time: 218,
    Year: 2019,
    Plays: 11,
  },
  {
    Name: "$Ubtle Flex",
    Artist: "PsychoYP & DJ T1Z",
    Album: "$Ubtle Flex - Single",
    Time: 172,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Baby",
    Artist: "Quality Control, Lil Baby & DaBaby",
    Album: "Quality Control: Control The Streets, Vol. 2",
    Time: 142,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "We Will Rock You",
    Artist: "Queen",
    Album: "Greatest Hits",
    Time: 122,
    Year: 1977,
    Plays: 11,
  },
  {
    Name: "Bohemian Rhapsody",
    Artist: "Queen",
    Album: "A Night at the Opera (Deluxe Edition)",
    Time: 354,
    Year: 1975,
    Plays: 4,
  },
  {
    Name: "Butterflies",
    Artist: "Queen Naija",
    Album: "Queen Naija - EP",
    Time: 212,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "I Want It All / We Will Rock You Mash / Armageddon [Queen cover]",
    Artist: "Queen w Armageddon aka Geddy",
    Album: "Sucker Punch",
    Time: 308,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "The Way You Used To Do",
    Artist: "Queens of the Stone Age",
    Album: "Villains",
    Time: 274,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Burn It Up (feat. Wysin & Yandell)",
    Artist: "R. Kelly",
    Album: "TP.3 Reloaded",
    Time: 231,
    Year: 2005,
    Plays: 20,
  },
  {
    Name: "The Emptiness Within (feat. Danniel Wheeler)",
    Artist: "R.E.D",
    Album: "The Emptiness Within - EP",
    Time: 297,
    Year: 2019,
    Plays: 55,
  },
  {
    Name: "Kiss Your Hand (feat. Wande Coal)",
    Artist: "R2Bees",
    Album: "Da Revolution",
    Time: 268,
    Year: 2009,
    Plays: 24,
  },
  {
    Name: "Hands of Time",
    Artist: "Rachel Diggs",
    Album: "",
    Time: 224,
    Year: null,
    Plays: 4,
  },
  {
    Name: "Fight Song",
    Artist: "Rachel Platten",
    Album: "Wildfire",
    Time: 204,
    Year: 2015,
    Plays: 20,
  },
  {
    Name: "Exit Music (For a Film)",
    Artist: "Radiohead",
    Album: "OK Computer",
    Time: 267,
    Year: 1997,
    Plays: null,
  },
  {
    Name: "Dark Black Makeup",
    Artist: "Radkey",
    Album: "Delicious Rock Noise ",
    Time: 229,
    Year: 2015,
    Plays: 32,
  },
  {
    Name: "Unlock the Swag (feat. Jace of Two-9)",
    Artist: "Rae Sremmurd",
    Album: "SremmLife",
    Time: 322,
    Year: 2015,
    Plays: 10,
  },
  {
    Name: "No Flex Zone",
    Artist: "Rae Sremmurd",
    Album: "SremmLife",
    Time: 231,
    Year: 2014,
    Plays: 10,
  },
  {
    Name: "Throw Sum Mo (feat. Nicki Minaj & Young Thug)",
    Artist: "Rae Sremmurd",
    Album: "SremmLife",
    Time: 260,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Black Beatles (feat. Gucci Mane)",
    Artist: "Rae Sremmurd",
    Album: "SremmLife 2 (Deluxe)",
    Time: 291,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "The Morning",
    Artist: "Raekwon, Pusha T, Common, 2 Chainz, CyHi, Kid Cudi & D'Banj",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 275,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Human",
    Artist: "Rag'n'Bone Man",
    Album: "Human (Deluxe)",
    Time: 200,
    Year: 2016,
    Plays: 73,
  },
  {
    Name: "Skin",
    Artist: "Rag'n'Bone Man",
    Album: "Human (Deluxe)",
    Time: 239,
    Year: 2017,
    Plays: 14,
  },
  {
    Name: "Ijo Ope (feat. Zlatan, Chinko Ekun & Junior Boy)",
    Artist: "Rahman Jago",
    Album: "Ijo Ope (feat. Zlatan, Chinko Ekun & Junior Boy) - Single",
    Time: 175,
    Year: 2018,
    Plays: 20,
  },
  {
    Name: "Mo40",
    Artist: "Rahman Jago, Bad Boy Timz & Barry Jhay",
    Album: "Mo40 - Single",
    Time: 194,
    Year: 2020,
    Plays: 183,
  },
  {
    Name: "Now I Can Fly",
    Artist: "RAIGN",
    Album: "Now I Can Fly - Single",
    Time: 248,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Bury a Lie",
    Artist: "Rain City Drive",
    Album: "To Better Days",
    Time: 196,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Dimelo (feat. Wyclef Jean & Naughty Boy) [X Factor Recording]",
    Artist: "Rak-Su",
    Album:
      "Dimelo (feat. Wyclef Jean & Naughty Boy) [X Factor Recording]- Single",
    Time: 182,
    Year: 2017,
    Plays: 27,
  },
  {
    Name: 'One Punch Man Theme (Slow Version) [From "One Punch Man"]',
    Artist: "Ralpi Composer",
    Album: "Sweet Harp Sounds, Vol. 2",
    Time: 97,
    Year: 2016,
    Plays: 104,
  },
  {
    Name: "Beside You (feat. Soundr)",
    Artist: "Rameses B",
    Album: "Beside You (feat. Soundr) - Single",
    Time: 298,
    Year: 2016,
    Plays: 25,
  },
  {
    Name: "Main Title Theme - Westworld",
    Artist: "Ramin Djawadi",
    Album: "Westworld: Season 1 (Music from the HBO Series)",
    Time: 101,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Main Titles",
    Artist: "Ramin Djawadi, The Czech Film Orchestra & The Czech Film Choir",
    Album: "Game of Thrones (Music from the HBO® Series - Season 5)",
    Time: 105,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Pacific Rim (feat. Tom Morello)",
    Artist: "Ramin Djawadi, Tom Morello, Nick Glennie-Smith & Jasper Randall",
    Album:
      "Pacific Rim Soundtrack from Warner Bros. Pictures and Legendary Pictures",
    Time: 295,
    Year: 2013,
    Plays: 34,
  },
  {
    Name: "Lost Souls",
    Artist: "Raury",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 173,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "My Escape",
    Artist: "Ravenscode",
    Album: "District of Broken Hope",
    Time: 226,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Pillars of Resurrection",
    Artist: "Really Slow Motion",
    Album: "Charged",
    Time: 203,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Vengeance",
    Artist: "Really Slow Motion",
    Album: "Charged",
    Time: 133,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Mercury Rises",
    Artist: "Really Slow Motion",
    Album: "Charged",
    Time: 183,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Th3 Awak3n1ng",
    Artist: "Really Slow Motion",
    Album: "Fiery the Angels Rose",
    Time: 301,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Thunderborn",
    Artist: "Really Slow Motion",
    Album: "Iron Poetry",
    Time: 124,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Hall of the Gods",
    Artist: "Really Slow Motion",
    Album: "Iron Poetry",
    Time: 128,
    Year: 2015,
    Plays: 9,
  },
  {
    Name: "Colossus",
    Artist: "Really Slow Motion & Instrumental Core",
    Album: "Existentia",
    Time: 130,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Moment on Power",
    Artist: "Really Slow Motion & Instrumental Core",
    Album: "Existentia",
    Time: 229,
    Year: 2018,
    Plays: 18,
  },
  {
    Name: "The Cabinet",
    Artist: "Rectifire",
    Album: "The Cabinet - Single",
    Time: 244,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "The War We Made",
    Artist: "Red",
    Album: "Declaration",
    Time: 232,
    Year: 2020,
    Plays: 26,
  },
  {
    Name: "Breathe Into Me",
    Artist: "Red",
    Album: "End of Silence",
    Time: 214,
    Year: 2006,
    Plays: 10,
  },
  {
    Name: "Still Alive",
    Artist: "Red",
    Album: "Gone (Deluxe Edition)",
    Time: 199,
    Year: 2017,
    Plays: 13,
  },
  {
    Name: "Gone",
    Artist: "Red",
    Album: "Gone (Extended Single) - EP",
    Time: 219,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Descent",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 71,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Impostor",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 258,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Shadow and Soul",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 344,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Darkest Part",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 242,
    Year: 2015,
    Plays: 15,
  },
  {
    Name: "Fight To Forget",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 208,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Of These Chains",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 233,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Falling Sky",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 326,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "The Forest",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 55,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Yours Again",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 289,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "What You Keep Alive",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 322,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Gravity Lies",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 273,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Take Me Over",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 231,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "The Ever",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 250,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Part That's Holding On",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 285,
    Year: 2015,
    Plays: 7,
  },
  {
    Name: "Ascent",
    Artist: "Red",
    Album: "of Beauty and Rage",
    Time: 238,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Glass House",
    Artist: "Red",
    Album: "Release the Panic",
    Time: 212,
    Year: 2013,
    Plays: 8,
  },
  {
    Name: "Brace Yourself",
    Artist: "The Red Jumpsuit Apparatus",
    Album: "Brace Yourself - Single",
    Time: 207,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Paralysed",
    Artist: "RedHook",
    Album: "Paralysed - Single",
    Time: 198,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Chop Am",
    Artist: "Reekado Banks",
    Album: "Chop Am - Single",
    Time: 224,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Ozumba Mbadiwe",
    Artist: "Reekado Banks",
    Album: "Ozumba Mbadiwe - Single",
    Time: 212,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "My Bloody Eyes",
    Artist: "Regardless Of Me",
    Album: "My Bloody Eyes - Single",
    Time: 239,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Me Niego (feat. Ozuna & Wisin)",
    Artist: "Reik",
    Album: "Ahora",
    Time: 221,
    Year: 2018,
    Plays: 59,
  },
  {
    Name: "Perfecta",
    Artist: "Reik & Maluma",
    Album: "Perfecta - Single",
    Time: 174,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Spaceship Jocelyn",
    Artist: "Rema",
    Album: "Bad Commando - EP",
    Time: 199,
    Year: 2019,
    Plays: 25,
  },
  {
    Name: "Beamer (Bad Boys) [feat. Rvssian]",
    Artist: "Rema",
    Album: "Beamer (Bad Boys) [feat. Rvssian] - Single",
    Time: 195,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Toxic",
    Artist: "Reminisce & Adekunle Gold",
    Album: "Toxic - Single",
    Time: 171,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Hey Reporting Live It's Trap Bunny Bubbles (TikTok Dance)",
    Artist: "Remix Kingz",
    Album: "Hey Reporting Live It's Trap Bunny Bubbles (TikTok Dance) - Single",
    Time: 92,
    Year: 2020,
    Plays: 12,
  },
  {
    Name: "Beam Me Up",
    Artist: "Reo Cragun",
    Album: "Beam Me Up",
    Time: 173,
    Year: 2020,
    Plays: 29,
  },
  {
    Name: "Like Dat",
    Artist: "Rexxie & Victony",
    Album: "Nataraja - Single",
    Time: 187,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "What's Ur Sign?",
    Artist: "Reyanna Maria",
    Album: "What's Ur Sign? - Single",
    Time: 161,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Take Kare (feat. Young Thug & Lil Wayne)",
    Artist: "Rich Gang",
    Album: "Take Kare (feat. Young Thug & Lil Wayne) - Single",
    Time: 267,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Tapout (feat. Lil Wayne, Birdman, Mack Maine, Nicki Minaj & Future)",
    Artist: "Rich Gang",
    Album:
      "Tapout (feat. Lil Wayne, Birdman, Mack Maine, Nicki Minaj & Future) - Single",
    Time: 284,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Super Freak",
    Artist: "Rick James",
    Album: "Street Songs",
    Time: 205,
    Year: 1981,
    Plays: 1,
  },
  {
    Name: "So Sophisticated (feat. Meek Mill)",
    Artist: "Rick Ross",
    Album: "God Forgives, I Don't (Deluxe Edition)",
    Time: 247,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Intro",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 86,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Rich Is Gangsta",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 192,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Drug Dealers Dream",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 243,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Shots Fired",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 54,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Nobody (Feat. French Montana)",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 280,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Mafia Music III (Feat. Sizzla & Mavado)",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 306,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "War Ready (Feat. Jeezy)",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 423,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "What A Shame (Feat. French Montana)",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 135,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Supreme",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 212,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Blk & Wht",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 238,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Dope Bitch Skit",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 173,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "In Vein (Feat. The Weeknd)",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 261,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Sanctified (Feat. Big Sean & Kanye West)",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 285,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Walkin' On Air (Feat. Meek Mill)",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 267,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Thug Cry (Feat. Lil' Wayne)",
    Artist: "Rick Ross",
    Album: "Mastermind",
    Time: 258,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Running the Streets (feat. A Boogie wit da Hoodie & Denzel Curry)",
    Artist: "Rick Ross",
    Album: "Port of Miami 2",
    Time: 224,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Free Mason (feat. Jay-Z)",
    Artist: "Rick Ross",
    Album: "Teflon Don",
    Time: 247,
    Year: 2010,
    Plays: 32,
  },
  {
    Name: "B.M.F. (Blowin' Money Fast) [feat. Styles P]",
    Artist: "Rick Ross",
    Album: "Teflon Don",
    Time: 250,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Woo",
    Artist: "Rihanna",
    Album: "ANTI (Deluxe)",
    Time: 235,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Umbrella (feat. JAY Z)",
    Artist: "Rihanna",
    Album: "Good Girl Gone Bad: Reloaded",
    Time: 276,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "S&M",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 243,
    Year: 2010,
    Plays: 4,
  },
  {
    Name: "What's My Name? (feat. Drake)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 263,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Cheers (Drink To That)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 261,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Fading",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 199,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Only Girl (In The World)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 235,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "California King Bed",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 251,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Man Down",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 267,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Raining Men (feat. Nicki Minaj)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 224,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Complicated",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 257,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Skin",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 303,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Love The Way You Lie (Part II) (feat. Eminem)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 296,
    Year: 2010,
    Plays: 12,
  },
  {
    Name: "Love The Way You Lie (Part II) (Piano Version)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 249,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Who's That Chick? (Doritos Night) (Bonus Track)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 186,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Only Girl (In the World) (Remix) (Bonus Track)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 250,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Stick Up (The Saturday Night Live Song)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 134,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "What's My Name? (Version Rihanna) (Bonus Track)",
    Artist: "Rihanna",
    Album: "LOUD (Deluxe)",
    Time: 215,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Stupid In Love",
    Artist: "Rihanna",
    Album: "Rated R",
    Time: 241,
    Year: 2009,
    Plays: 13,
  },
  {
    Name: "Phresh Out the Runway",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 222,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Diamonds",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 225,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "Numb (feat. Eminem)",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 205,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Pour It Up",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 161,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Loveeeeeee Song (feat. Future)",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 256,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Jump",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 264,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Right Now (feat. David Guetta)",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 181,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "What Now",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 243,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Stay (feat. Mikky Ekko)",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 240,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Nobody's Business (feat. Chris Brown)",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 216,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Love Without Tragedy / Mother Mary",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 418,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Get It Over With",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 211,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "No Love Allowed",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 249,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Lost In Paradise",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 215,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Half of Me",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 192,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Diamonds (Dave Aude 100 Extended Mix)",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 303,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Diamonds (Gregor Salto Downtempo Remix)",
    Artist: "Rihanna",
    Album: "Unapologetic (Deluxe Version)",
    Time: 269,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Aphrodite",
    Artist: "RINI",
    Album: "After the Sun - EP",
    Time: 271,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "The Violence (Ghost Note Symphonies)",
    Artist: "Rise Against",
    Album: "The Ghost Note Symphonies, Vol. 1",
    Time: 260,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "Talking To Ourselves (Nowhere Sessions)",
    Artist: "Rise Against",
    Album: "Nowhere Sessions - EP",
    Time: 205,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Prayer of the Refugee",
    Artist: "Rise Against",
    Album: "The Sufferer & the Witness",
    Time: 199,
    Year: 2006,
    Plays: 3,
  },
  {
    Name: "God Rest Ye Merry Gentlemen (feat. Ashleigh Murray, & Casey Cott)",
    Artist: "Riverdale Cast",
    Album: "Riverdale: Season 2 (Original Television Soundtrack)",
    Time: 130,
    Year: 2018,
    Plays: 22,
  },
  {
    Name: 'Swordland (From "Sword Art Online") [Piano Version]',
    Artist: "RMaster",
    Album: 'Anime Piano Koto Collection (From "Sword Art Online")',
    Time: 215,
    Year: 2015,
    Plays: 17,
  },
  {
    Name: "DEALER",
    Artist: "RMR",
    Album: "DEALER - Single",
    Time: 144,
    Year: 2020,
    Plays: 100,
  },
  {
    Name: "DEALER",
    Artist: "RMR",
    Album: "DEALER - Single",
    Time: 144,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "See Me Fall (Y2K Remix)",
    Artist: "Ro Ransom & Y2K",
    Album: "Momentum (Mixtape)",
    Time: 201,
    Year: 2017,
    Plays: 14,
  },
  {
    Name: "Dragula",
    Artist: "Rob Zombie",
    Album: "Hellbilly Deluxe",
    Time: 222,
    Year: 1998,
    Plays: 14,
  },
  {
    Name: "No Membership",
    Artist: "Rockie Fresh",
    Album: "Destination (Deluxe Edition)",
    Time: 120,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "U.O.E.N.O. (feat. Future & Rick Ross)",
    Artist: "Rocko",
    Album: "U.O.E.N.O. (feat. Future & Rick Ross) - Single",
    Time: 262,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "The Box",
    Artist: "Roddy Ricch",
    Album: "Please Excuse Me For Being Antisocial",
    Time: 196,
    Year: 2019,
    Plays: 11,
  },
  {
    Name: "Beast of Burden",
    Artist: "The Rolling Stones",
    Album: "Fifty Shades of Grey",
    Time: 210,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Seasonless State",
    Artist: "Roman Lions",
    Album: "Gradients",
    Time: 287,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "You're the One",
    Artist: "Romantic Lovebirds",
    Album: "You're the One - Single",
    Time: 132,
    Year: 2022,
    Plays: 23,
  },
  {
    Name: "Guide Me Home",
    Artist: "Romantic Lovebirds",
    Album: "You're the One - Single",
    Time: 132,
    Year: 2022,
    Plays: 13,
  },
  {
    Name: "In My Bed (feat. Wale)",
    Artist: "Rotimi",
    Album: "The Beauty of Becoming",
    Time: 185,
    Year: 2019,
    Plays: 69,
  },
  {
    Name: "Sing",
    Artist: "Rotimi & Busta Rhymes",
    Album: "All or Nothing (Deluxe)",
    Time: 154,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Computers (feat. Bobby Shmurda)",
    Artist: "Rowdy Rebel",
    Album: "Computers (feat. Bobby Shmurda) - Single",
    Time: 305,
    Year: 2014,
    Plays: 21,
  },
  {
    Name: "Everybody Loves The Sunshine",
    Artist: "Roy Ayers Ubiquity",
    Album: "Straight Outta Compton",
    Time: 240,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Reason with Me",
    Artist: "Rudeboy",
    Album: "Reason with Me - Single",
    Time: 251,
    Year: 2021,
    Plays: 123,
  },
  {
    Name: "Take It",
    Artist: "Rudeboy",
    Album: "Take It - Single",
    Time: 228,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Madness",
    Artist: "Ruelle",
    Album: "Madness",
    Time: 211,
    Year: 2016,
    Plays: 11,
  },
  {
    Name: "Anamachi",
    Artist: "Runtown & Phyno",
    Album: "Soundgod Fest, Vol. 1",
    Time: 194,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "In My Own Skin",
    Artist: "Ryan Caraveo",
    Album: "In My Own Skin - Single",
    Time: 200,
    Year: 2017,
    Plays: 78,
  },
  {
    Name: "I'll See You Again (feat. Chi Chi)",
    Artist: "S3RL",
    Album: "I'll See You Again (feat. Chi Chi) - Single",
    Time: 224,
    Year: 2014,
    Plays: 18,
  },
  {
    Name: "Mtc",
    Artist: "S3RL",
    Album: "MTC - Single",
    Time: 260,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Winged Hussars",
    Artist: "Sabaton",
    Album: "The Last Stand",
    Time: 231,
    Year: 2016,
    Plays: 28,
  },
  {
    Name: "Remember Me",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 171,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Bad Girls",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 143,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Go Somewhere (feat. IamSu)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 271,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Gas Pedal (feat. IamSu)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 208,
    Year: 2014,
    Plays: 28,
  },
  {
    Name: "Red Nose",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 193,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "College Drop (feat. Kool John)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 174,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Put Me On (feat. Shady Bo)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 233,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Down On Your Luck (feat. August Alsina)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 136,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Mad At Me (feat. Jay Ant & IamSu)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 165,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Nothing To Me (feat. IamSu)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 214,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Don't You",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 137,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Second Hand Smoke (feat. Eric Bellinger)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 165,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Just a Kiss",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 159,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Desert of Mirages (feat. Berner & Kehlani)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 269,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Give It Up (feat. Berner & P-Lo)",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 223,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Gas Pedal (feat. Justin Bieber & IamSu) [Remix]",
    Artist: "Sage the Gemini",
    Album: "Remember Me (Deluxe Booklet Version)",
    Time: 279,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "The Best Part of Life",
    Artist: "SAINt JHN",
    Album: "The Best Part of Life - Single",
    Time: 196,
    Year: 2021,
    Plays: 70,
  },
  {
    Name: "Roses",
    Artist: "SAINt JHN",
    Album: "Collection One",
    Time: 173,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Trap (feat. Lil Baby)",
    Artist: "SAINt JHN",
    Album: "Ghetto Lenny's Love Songs",
    Time: 184,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "5 Thousand Singles",
    Artist: "SAINt JHN",
    Album: "Ghetto Lenny's Love Songs",
    Time: 165,
    Year: 2019,
    Plays: 56,
  },
  {
    Name: "Roses Remix (feat. Future)",
    Artist: "SAINt JHN",
    Album: "Roses Remix [feat. Future] - Single",
    Time: 187,
    Year: 2020,
    Plays: 217,
  },
  {
    Name: "Sucks to Be You",
    Artist: "SAINt JHN",
    Album: "While the World Was Burning",
    Time: 222,
    Year: 2020,
    Plays: 7,
  },
  {
    Name: "Ransom (feat. 6LACK & Kehlani)",
    Artist: "SAINt JHN",
    Album: "While the World Was Burning",
    Time: 203,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Beyond Myself (feat. Tigerwine)",
    Artist: "Saints Of Never After",
    Album: "Going for Gold - Single",
    Time: 198,
    Year: 2022,
    Plays: 5,
  },
  {
    Name: "WATER",
    Artist: "Salatiel, Pharrell Williams & Beyoncé",
    Album: "The Lion King: The Gift",
    Time: 152,
    Year: 2019,
    Plays: 116,
  },
  {
    Name: "Diamonds",
    Artist: "Sam Smith",
    Album: "Love Goes",
    Time: 212,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Before Lights Out (APETITAN)",
    Artist: "Samuel Kim",
    Album: "Attack on Titan: Epic Collection",
    Time: 238,
    Year: 2020,
    Plays: 11,
  },
  {
    Name: "Avatar: The Last Airbender Theme",
    Artist: "Samuel Kim",
    Album: "Avatar: The Last Airbender (Epic Collection) - Single",
    Time: 196,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Rengoku Theme",
    Artist: "Samuel Kim",
    Album: "Demon Slayer: Epic Collection - EP",
    Time: 196,
    Year: 2021,
    Plays: 22,
  },
  {
    Name: "Ezio's Family (Valhalla Version)",
    Artist: "Samuel Kim",
    Album: "Ezio's Family (Valhalla Version) - Single",
    Time: 143,
    Year: 2020,
    Plays: 13,
  },
  {
    Name: "Hashira Theme",
    Artist: "Samuel Kim",
    Album: "Hashira Theme - Single",
    Time: 270,
    Year: 2021,
    Plays: 12,
  },
  {
    Name: "Loki Theme Variant 1 (Loki Green Theme)",
    Artist: "Samuel Kim",
    Album: "Loki: Epic Collection - Single",
    Time: 139,
    Year: 2021,
    Plays: 35,
  },
  {
    Name: "Moonlight Sonata - Epic Version (Attack on Titan Style)",
    Artist: "Samuel Kim",
    Album: "Moonlight Sonata - Epic Version (Attack on Titan Style) - Single",
    Time: 252,
    Year: 2022,
    Plays: null,
  },
  {
    Name: 'Running Up That Hill - Epic Version (from "Stranger Things)',
    Artist: "Samuel Kim",
    Album:
      'Running Up That Hill - Epic Version (from "Stranger Things) - Single',
    Time: 138,
    Year: 2022,
    Plays: 30,
  },
  {
    Name: "Its My Life",
    Artist: "Sandaru Sathsara",
    Album: "Its My Life - Single",
    Time: 102,
    Year: 2021,
    Plays: 34,
  },
  {
    Name: "Never Get To Heaven",
    Artist: "Sarah Blaine",
    Album: "Never Get To Heaven - Single",
    Time: 221,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "MAD",
    Artist: "Sarz & WurlD",
    Album: "I LOVE GIRLS WITH TROBUL",
    Time: 238,
    Year: 2019,
    Plays: 28,
  },
  {
    Name: "Adara",
    Artist: "Sasha",
    Album: "51 Lex Presents Strong Thing",
    Time: 232,
    Year: 2007,
    Plays: 12,
  },
  {
    Name: "Runaway",
    Artist: "Sasha Alex Sloan",
    Album: "Runaway - Single",
    Time: 218,
    Year: 2017,
    Plays: 26,
  },
  {
    Name: "King Of Misery",
    Artist: "Saul",
    Album: "Rise As Equals",
    Time: 235,
    Year: 2020,
    Plays: 7,
  },
  {
    Name: "Pretenders (Eo1)",
    Artist: "SawanoHiroyuki[nZk]:mica",
    Album: "Into the Sky EP",
    Time: 223,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Sh0ut",
    Artist: "SawanoHiroyuki[nZk]:Tielle&Gemie",
    Album: "2V-Alk",
    Time: 245,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Best Friend (feat. Doja Cat)",
    Artist: "Saweetie",
    Album: "Best Friend (feat. Doja Cat) - Single",
    Time: 155,
    Year: 2021,
    Plays: 26,
  },
  {
    Name: "You Don't Own Me (feat. G-Eazy)",
    Artist: "SAYGRACE",
    Album: "FMA",
    Time: 201,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Legend",
    Artist: "The Score",
    Album: "ATLAS",
    Time: 189,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Purpose for Pain",
    Artist: "Scott Stapp",
    Album: "The Space Between the Shadows",
    Time: 198,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "THE SCOTTS",
    Artist: "THE SCOTTS, Travis Scott & Kid Cudi",
    Album: "THE SCOTTS - Single",
    Time: 165,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Hall of Fame (feat. will.i.am)",
    Artist: "The Script",
    Album: "Hall of Fame (feat. will.i.am) - Single",
    Time: 201,
    Year: 2012,
    Plays: 22,
  },
  {
    Name: "All I Got",
    Artist: "Sean Kingston",
    Album: "All I Got - Single",
    Time: 203,
    Year: 2016,
    Plays: 8,
  },
  {
    Name: "Fire Burning",
    Artist: "Sean Kingston",
    Album: "Fire Burning - Single",
    Time: 243,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Eenie Meenie",
    Artist: "Sean Kingston & Justin Bieber",
    Album: "Party All Night (Sleep All Day) - EP",
    Time: 201,
    Year: 2010,
    Plays: 14,
  },
  {
    Name: "Borracho",
    Artist: "Sech & DJ Khaled",
    Album: "Borracho - Single",
    Time: 219,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Look At Her Now",
    Artist: "Selena Gomez",
    Album: "Rare",
    Time: 162,
    Year: 2019,
    Plays: 8,
  },
  {
    Name: "Slow Down",
    Artist: "Selena Gomez",
    Album: "Stars Dance (Bonus Track Version)",
    Time: 210,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Bury Me Alive",
    Artist: "Self Deception",
    Album: "Endorse the Art - EP",
    Time: 241,
    Year: 2019,
    Plays: 151,
  },
  {
    Name: "Shade of Dark",
    Artist: "Self Deception",
    Album: "Endorse the Art - EP",
    Time: 208,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Hell and Back",
    Artist: "Self Deception",
    Album: "Hell and Back - Single",
    Time: 176,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Intoxicated Haze",
    Artist: "Self Deception",
    Album: "Intoxicated Haze - Single",
    Time: 219,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Don’t",
    Artist: "Self Deception",
    Album: "Self Deception",
    Time: 177,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "Weight of the World",
    Artist: "Self Deception",
    Album: "Self Deception",
    Time: 223,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Stockholm Hearts",
    Artist: "Self Deception",
    Album: "Stockholm Hearts - Single",
    Time: 197,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Overdose",
    Artist: "September Mourning",
    Album: "Volume III - EP",
    Time: 251,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Dancing with the Devil",
    Artist: "Set It Off",
    Album: "Midnight",
    Time: 202,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "My Way Back Home",
    Artist: "Sever",
    Album: "My Way Back Home - Single",
    Time: 180,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Dead To Me (feat. Lox Chatterbox)",
    Artist: "Sex Whales & Fraxo",
    Album: "",
    Time: 230,
    Year: null,
    Plays: 5,
  },
  {
    Name: "Faithfully",
    Artist: "Shaboozey",
    Album: "Lady Wrangler",
    Time: 219,
    Year: 2018,
    Plays: 143,
  },
  {
    Name: "Golden Child",
    Artist: "Shaboozey",
    Album: "Lady Wrangler",
    Time: 177,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "I Came Up",
    Artist: "Shaboozey",
    Album: "Lady Wrangler",
    Time: 243,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "Trampoline",
    Artist: "SHAED",
    Album: "MELT",
    Time: 184,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Give It Up To Me",
    Artist: "Shakira",
    Album: "Give It Up To Me",
    Time: 192,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Whenever, Wherever",
    Artist: "Shakira",
    Album: "Laundry Service",
    Time: 196,
    Year: 2001,
    Plays: 14,
  },
  {
    Name: "Hips Don't Lie (feat. Wyclef Jean)",
    Artist: "Shakira",
    Album: "Oral Fixation, Vol. 2",
    Time: 218,
    Year: 2005,
    Plays: 26,
  },
  {
    Name: "Loca (feat. Dizzee Rascal)",
    Artist: "Shakira",
    Album: "Sale el Sol (Bonus Track Edition)",
    Time: 193,
    Year: 2010,
    Plays: 5,
  },
  {
    Name: "Can't remember to forget you (feat. Rihanna)",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 206,
    Year: 2014,
    Plays: 10,
  },
  {
    Name: "Empire",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 239,
    Year: 2014,
    Plays: 7,
  },
  {
    Name: "You don't care about me",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 221,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "Dare (La La La)",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 186,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Cut me deep (feat. MAGIC!)",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 195,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "23",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 239,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "The one thing",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 192,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Medicine (feat. Blake Shelton)",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 198,
    Year: 2014,
    Plays: 19,
  },
  {
    Name: "Spotlight",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 203,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Broken record",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 194,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Nunca me acuerdo de olvidarte",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 206,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Loca por ti",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 221,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "La La La (Brasil 2014) [Feat. Carlinhos Brown]",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 197,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Chasing shadows",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 211,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "That way",
    Artist: "Shakira",
    Album: "Shakira",
    Time: 188,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Can't Remember to Forget You (feat. Rihanna)",
    Artist: "Shakira",
    Album: "Shakira. (Expanded Edition)",
    Time: 206,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "Waka Waka (This Time for Africa) [The Official 2010 FIFA World Cup (TM) Song] [feat. Freshlyground]",
    Artist: "Shakira",
    Album:
      "Waka Waka (This Time for Africa) [The Official 2010 FIFA World Cup (TM) Song] [feat. Freshlyground] - Single",
    Time: 202,
    Year: 2010,
    Plays: 4,
  },
  {
    Name: "Under Your Skin",
    Artist: "Shaman's Harvest",
    Album: "Rebelator",
    Time: 203,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "The Come Up",
    Artist: "Shaman's Harvest",
    Album: "Red Hands Black Deeds",
    Time: 207,
    Year: 2017,
    Plays: 5,
  },
  {
    Name: "It'll Be Okay",
    Artist: "Shawn Mendes",
    Album: "It'll Be Okay - Single",
    Time: 222,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Señorita",
    Artist: "Shawn Mendes & Camila Cabello",
    Album: "Señorita - Single",
    Time: 190,
    Year: 2019,
    Plays: 23,
  },
  {
    Name: "Gmail",
    Artist: "Sheck Wes",
    Album: "MUDBOY",
    Time: 216,
    Year: 2018,
    Plays: 86,
  },
  {
    Name: "Mo Bamba",
    Artist: "Sheck Wes",
    Album: "MUDBOY",
    Time: 183,
    Year: 2017,
    Plays: 97,
  },
  {
    Name: "YKTS",
    Artist: "Sheck Wes",
    Album: "YKTS - Single",
    Time: 194,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "You're The One I Love",
    Artist: "Shenseea & Rvssian",
    Album: "You're The One I Love - Single",
    Time: 130,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Geronimo",
    Artist: "Sheppard",
    Album: "Bombs Away (Deluxe Version)",
    Time: 218,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Kimi ga iru Kara",
    Artist: "Shimokawa Mikuni",
    Album: "Fairy Tail OP ED Theme Songs Vol.1",
    Time: 266,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "My Name (Wearing Me Out)",
    Artist: "Shinedown",
    Album: "Amaryllis",
    Time: 216,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "DEVIL",
    Artist: "Shinedown",
    Album: "ATTENTION ATTENTION",
    Time: 207,
    Year: 2018,
    Plays: 51,
  },
  {
    Name: "MONSTERS",
    Artist: "Shinedown",
    Album: "ATTENTION ATTENTION",
    Time: 248,
    Year: 2018,
    Plays: 18,
  },
  {
    Name: "Asking for It",
    Artist: "Shinedown",
    Album: "Threat to Survival",
    Time: 210,
    Year: 2015,
    Plays: 32,
  },
  {
    Name: "Savage (feat. LADIPOE)",
    Artist: "Show Dem Camp",
    Album: 'Clone Wars Vol. IV "These Buhari Times"',
    Time: 195,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Do Me Nice (feat. Buju)",
    Artist: "Show Dem Camp",
    Album: "The Palmwine Express",
    Time: 257,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Afterlife",
    Artist: "SHVPES",
    Album: "Greater Than",
    Time: 247,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "Breathe Me",
    Artist: "Sia",
    Album: "Colour the Small One (Deluxe Edition)",
    Time: 272,
    Year: 2004,
    Plays: 5,
  },
  {
    Name: "Everyday Is Christmas",
    Artist: "Sia",
    Album: "Everyday Is Christmas (Deluxe)",
    Time: 203,
    Year: 2017,
    Plays: 49,
  },
  {
    Name: "Sing For My Life",
    Artist: "Sia",
    Album: "Everyday Is Christmas (Deluxe)",
    Time: 224,
    Year: 2018,
    Plays: 16,
  },
  {
    Name: "Salted Wound",
    Artist: "Sia",
    Album: "Fifty Shades of Grey",
    Time: 270,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Bird Set Free",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 252,
    Year: 2015,
    Plays: 36,
  },
  {
    Name: "Alive",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 263,
    Year: 2015,
    Plays: 44,
  },
  {
    Name: "One Million Bullets",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 252,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Move Your Body",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 247,
    Year: 2016,
    Plays: 18,
  },
  {
    Name: "Unstoppable",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 217,
    Year: 2016,
    Plays: 120,
  },
  {
    Name: "Cheap Thrills",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 211,
    Year: 2016,
    Plays: 7,
  },
  {
    Name: "Reaper",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 219,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "House on Fire",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 241,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Footprints",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 193,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Sweet Design",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 145,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Broken Glass",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 264,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Space Between",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 288,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Cheap Thrills (feat. Sean Paul)",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 224,
    Year: 2016,
    Plays: 6,
  },
  {
    Name: "The Greatest (feat. Kendrick Lamar)",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 210,
    Year: 2016,
    Plays: 87,
  },
  {
    Name: "Confetti",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 246,
    Year: 2016,
    Plays: 4,
  },
  {
    Name: "Move Your Body (Alan Walker Remix)",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 217,
    Year: 2016,
    Plays: 7,
  },
  {
    Name: "Midnight Decisions",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 222,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Jesus Wept",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 329,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "The Greatest",
    Artist: "Sia",
    Album: "This Is Acting (Deluxe Version)",
    Time: 210,
    Year: 2016,
    Plays: 4,
  },
  {
    Name: "Chandelier",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 216,
    Year: 2014,
    Plays: 23,
  },
  {
    Name: "Big Girls Cry",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 211,
    Year: 2014,
    Plays: 15,
  },
  {
    Name: "Burn The Pages",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 193,
    Year: 2014,
    Plays: 20,
  },
  {
    Name: "Eye Of The Needle",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 249,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Hostage",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 172,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Straight for the Knife",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 209,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Fair Game",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 232,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Elastic Heart (feat. The Weeknd & Diplo)",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 257,
    Year: 2014,
    Plays: 7,
  },
  {
    Name: "Free the Animal",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 265,
    Year: 2014,
    Plays: 71,
  },
  {
    Name: "Fire Meet Gasoline",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 241,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Cellophane",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 268,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Dressed In Black",
    Artist: "Sia",
    Album: "1000 Forms Of Fear",
    Time: 400,
    Year: 2014,
    Plays: 220,
  },
  {
    Name: "Chandelier",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 216,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Big Girls Cry",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 210,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Burn the Pages",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 195,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Eye of the Needle",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 248,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Hostage",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 176,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Straight for the Knife",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 211,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Fair Game",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 231,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Elastic Heart",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 257,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Free the Animal",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 264,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Fire Meet Gasoline",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 241,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Cellophane",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 265,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Dressed In Black",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 400,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Chandelier (Piano Version)",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 241,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Elastic Heart (Piano Version)",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 250,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Chandelier (Four Tet Remix)",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 270,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Chandelier (Plastic Plates Remix)",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 263,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Elastic Heart (Clams Casino Remix)",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 319,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Elastic Heart (Blood Diamonds Remix)",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 307,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Big Girls Cry (Odesza Remix)",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 261,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Big Girls Cry (Bleachers Remix)",
    Artist: "Sia",
    Album: "1000 Forms of Fear (Deluxe Version)",
    Time: 244,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Turn Back Crime",
    Artist: "SIGNALS",
    Album: "Death in Divide",
    Time: 194,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Everybody Knows",
    Artist: "Sigrid",
    Album: "Justice League (Original Motion Picture Soundtrack)",
    Time: 265,
    Year: 2017,
    Plays: 79,
  },
  {
    Name: "Stranger",
    Artist: "Silent Hearts",
    Album: "Stranger - Single",
    Time: 235,
    Year: 2018,
    Plays: 30,
  },
  {
    Name: "Never Back Down",
    Artist: "Silver End",
    Album: "Conquer the Silence",
    Time: 282,
    Year: 2019,
    Plays: 14,
  },
  {
    Name: "Cornerstones",
    Artist: "Silver End",
    Album: "Conquer the Silence",
    Time: 275,
    Year: 2019,
    Plays: 40,
  },
  {
    Name: "Fly Away",
    Artist: "Silver End",
    Album: "Fly Away - Single",
    Time: 233,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Swordland",
    Artist: "Silver Storm",
    Album: "Virtual Reality - EP",
    Time: 177,
    Year: 2017,
    Plays: 16,
  },
  {
    Name: "Luminous Sword",
    Artist: "Silver Storm",
    Album: "Virtual Reality - EP",
    Time: 172,
    Year: 2017,
    Plays: 4,
  },
  {
    Name: "Tiff",
    Artist: "Simi",
    Album: "Simisola",
    Time: 212,
    Year: 2017,
    Plays: 114,
  },
  {
    Name: "So Bad",
    Artist: "Simi & Joeboy",
    Album: "So Bad - Single",
    Time: 197,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Outta My Head",
    Artist: "Simi & Praiz",
    Album: "Outta My Head - Single",
    Time: 224,
    Year: 2016,
    Plays: 6,
  },
  {
    Name: "Trust Your Gut",
    Artist: "Sink the Ship",
    Album: "Persevere",
    Time: 208,
    Year: 2018,
    Plays: 85,
  },
  {
    Name: "Gold (Is Just a Colour)",
    Artist: "Sins In Vain",
    Album: "Gold (Is Just a Colour) - Single",
    Time: 222,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "The First 21",
    Artist: "Sixx:A.M.",
    Album: "Hits",
    Time: 253,
    Year: 2021,
    Plays: 14,
  },
  {
    Name: "Penetrate",
    Artist: "Sixx:A.M.",
    Album: "Hits",
    Time: 278,
    Year: 2021,
    Plays: 30,
  },
  {
    Name: "Waiting All My Life",
    Artist: "Sixx:A.M.",
    Album: "Hits",
    Time: 197,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Maybe It’s Time (feat. Corey Taylor, Joe Elliott, Brantley Gilbert, Ivan Moody, Slash, Awolnation, Tommy Vext)",
    Artist: "Sixx:A.M.",
    Album:
      "Maybe It’s Time (feat. Corey Taylor, Joe Elliott, Brantley Gilbert, Ivan Moody, Slash, Awolnation, Tommy Vext) - Single",
    Time: 254,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Rise",
    Artist: "Sixx:A.M.",
    Album: "Prayers for the Damned",
    Time: 233,
    Year: 2016,
    Plays: 56,
  },
  {
    Name: "Shake Body",
    Artist: "Skales",
    Album: "Man of the Year",
    Time: 208,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "No Glory (feat. M.I.M.E & Drama B)",
    Artist: "Skan & Krale",
    Album: "No Glory (feat. M.I.M.E & Drama B) - Single",
    Time: 276,
    Year: 2017,
    Plays: 33,
  },
  {
    Name: "Glory (No Glory pt. II) [feat. Drama B]",
    Artist: "Skan, Krale & M.I.M.E",
    Album: "Glory (No Glory pt. II) [feat. Drama B] - Single",
    Time: 297,
    Year: 2021,
    Plays: 20,
  },
  {
    Name: "It Ain't Safe (feat. Young Lord)",
    Artist: "Skepta",
    Album: "Konnichiwa",
    Time: 223,
    Year: 2016,
    Plays: 15,
  },
  {
    Name: "That's Not Me (feat. JME)",
    Artist: "Skepta",
    Album: "Konnichiwa",
    Time: 185,
    Year: 2014,
    Plays: 7,
  },
  {
    Name: "Take a Step Back (feat. XXXTENTACION)",
    Artist: "Ski Mask the Slump God",
    Album: "You Will Regret (Reloaded)",
    Time: 210,
    Year: 2017,
    Plays: 26,
  },
  {
    Name: "Save the Day (feat. Coi Leray & lougotcash)",
    Artist: "Ski Mask the Slump God & Jacquees",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 178,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Daz How Star Do (feat. Teni, Falz & DJ Neptune)",
    Artist: "Skiibii",
    Album: "Daz How Star Do (feat. DJ Neptune, Falz & Teni) - Single",
    Time: 248,
    Year: 2019,
    Plays: 142,
  },
  {
    Name: "Hero",
    Artist: "Skillet",
    Album: "Awake (Deluxe Version)",
    Time: 186,
    Year: 2009,
    Plays: 22,
  },
  {
    Name: "Monster",
    Artist: "Skillet",
    Album: "Awake (Deluxe Version)",
    Time: 177,
    Year: 2009,
    Plays: 47,
  },
  {
    Name: "Awake and Alive",
    Artist: "Skillet",
    Album: "Awake (Deluxe Version)",
    Time: 209,
    Year: 2009,
    Plays: 74,
  },
  {
    Name: "Surviving The Game",
    Artist: "Skillet",
    Album: "Dominion",
    Time: 238,
    Year: 2021,
    Plays: 74,
  },
  {
    Name: "Battle Cry",
    Artist: "Skillet",
    Album: "Rise",
    Time: 225,
    Year: 2013,
    Plays: 10,
  },
  {
    Name: "Rise",
    Artist: "Skillet",
    Album: "Rise (Deluxe Edition)",
    Time: 260,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Not Gonna Die",
    Artist: "Skillet",
    Album: "Rise (Deluxe Edition)",
    Time: 225,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Feel Invincible",
    Artist: "Skillet",
    Album: "Unleashed",
    Time: 229,
    Year: 2016,
    Plays: 19,
  },
  {
    Name: "The Resistance",
    Artist: "Skillet",
    Album: "Unleashed",
    Time: 232,
    Year: 2016,
    Plays: 13,
  },
  {
    Name: "Legendary",
    Artist: "Skillet",
    Album: "Victorious",
    Time: 244,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Save Me",
    Artist: "Skillet",
    Album: "Victorious",
    Time: 223,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "The Reason",
    Artist: "Skrillex",
    Album: "The Leaving EP",
    Time: 256,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Scary Bolly Dub",
    Artist: "Skrillex",
    Album: "The Leaving EP",
    Time: 219,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Leaving",
    Artist: "Skrillex",
    Album: "The Leaving EP",
    Time: 286,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "FucK That (Original Mix)",
    Artist: "Skrillex",
    Album: "Recess EP",
    Time: 230,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Easy My Mind (Original Mix)",
    Artist: "Skrillex",
    Album: "Recess EP",
    Time: 302,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Fire Away (Original Mix)",
    Artist: "Skrillex",
    Album: "Recess EP",
    Time: 341,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Purple Lamborghini",
    Artist: "Skrillex & Rick Ross",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 215,
    Year: 2016,
    Plays: 11,
  },
  {
    Name: "Try It Out (Neon Mix)",
    Artist: "Skrillex Feat. Alvin Risk",
    Album: "Recess EP",
    Time: 229,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Coast Is Clear (Original Mix)",
    Artist: "Skrillex Feat. Chance The Rapper",
    Album: "Recess EP",
    Time: 243,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Dirty Vibe (Original Mix)",
    Artist: "Skrillex Feat. Diplo, G-Dragon & CL",
    Album: "Recess EP",
    Time: 206,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Recess (Original Mix)",
    Artist: "Skrillex Feat. Kill The Noise & Fatman Scoop",
    Album: "Recess EP",
    Time: 237,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Stranger (Original Mix)",
    Artist: "Skrillex Feat. KillaGraham & Sam Dew",
    Album: "Recess EP",
    Time: 290,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Doompy Poomp (Original Mix)",
    Artist: "Skrillex Feat. Mishka",
    Album: "Recess EP",
    Time: 205,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "All Is Fair In Love And Brostep (Original Mix)",
    Artist: "Skrillex Feat. Ragga Twins",
    Album: "Recess EP",
    Time: 249,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Ragga Bomb (Original Mix)",
    Artist: "Skrillex Feat. Ragga Twins",
    Album: "Recess EP",
    Time: 258,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Search and Destroy [Stooges cover] ",
    Artist: "Skunk Anansie",
    Album: "Sucker Punch",
    Time: 265,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Everything I Need (Film Version)",
    Artist: "Skylar Grey",
    Album: "Aquaman (Original Motion Picture Soundtrack) [Deluxe Edition]",
    Time: 196,
    Year: 2018,
    Plays: 35,
  },
  {
    Name: "Final Warning",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 220,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Wear Me Out",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 210,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Religion",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 189,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Love the Way You Lie, Pt. III (Demo)",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 251,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Sunshine",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 225,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Pulse",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 218,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Glow In the Dark",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 224,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Clear Blue Sky",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 229,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Tower (Don't Look Down)",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 241,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Ticking Time Bomb",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 254,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "White Suburban",
    Artist: "Skylar Grey",
    Album: "Don't Look Down",
    Time: 282,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "I Know You",
    Artist: "Skylar Grey",
    Album: "Fifty Shades of Grey",
    Time: 298,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "I Know You",
    Artist: "Skylar Grey",
    Album: "Fifty Shades of Grey (Original Motion Picture Soundtrack)",
    Time: 298,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Intro - Wilderness",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 94,
    Year: 2016,
    Plays: 4,
  },
  {
    Name: "Jump",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 268,
    Year: 2016,
    Plays: 5,
  },
  {
    Name: "Lemonade",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 233,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Kill for You (feat. Eminem)",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 291,
    Year: 2016,
    Plays: 42,
  },
  {
    Name: "Come up for Air",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 260,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Real World",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 242,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Straight Shooter",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 178,
    Year: 2016,
    Plays: 4,
  },
  {
    Name: "Off Road",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 197,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "In My Garden",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 195,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Moving Mountains",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 253,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Picture Perfect",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 275,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "We Used to Be Bad",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 250,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Closer",
    Artist: "Skylar Grey",
    Album: "Natural Causes",
    Time: 227,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Shame on You",
    Artist: "Skylar Grey",
    Album: "Shame on You - Single",
    Time: 235,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Falling Apart",
    Artist: "Skylar Grey",
    Album: "Skylar Grey",
    Time: 163,
    Year: 2022,
    Plays: 3,
  },
  {
    Name: "Dance Without You (Ricky Luna Remix)",
    Artist: "Skylar Grey",
    Album: "Step Up Revolution",
    Time: 194,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Wreak Havoc",
    Artist: "Skylar Grey",
    Album: "Suicide Squad (Original Motion Picture Soundtrack)",
    Time: 228,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Wreak Havoc",
    Artist: "Skylar Grey",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 228,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Shit, Man!",
    Artist: "Skylar Grey/Angel Haze",
    Album: "Don't Look Down",
    Time: 206,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Back From the Dead",
    Artist: "Skylar Grey/Big Sean/Travis Barker",
    Album: "Don't Look Down",
    Time: 262,
    Year: 2013,
    Plays: 23,
  },
  {
    Name: "C’mon Let Me Ride",
    Artist: "Skylar Grey/Eminem",
    Album: "Don't Look Down",
    Time: 218,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Love the Way You Lie",
    Artist: "A Skylit Drive",
    Album: "Punk Goes Pop, Vol. 4",
    Time: 297,
    Year: 2011,
    Plays: 23,
  },
  {
    Name: "Sucker (feat. Abstract)",
    Artist: "A Skylit Drive",
    Album: "Sucker - Single (feat. Abstract) - Single",
    Time: 228,
    Year: 2022,
    Plays: 9,
  },
  {
    Name: "Gary Heidnik (feat. Jonathan Davis)",
    Artist: "SKYND",
    Album: "Chapter I - Single",
    Time: 313,
    Year: 2018,
    Plays: 26,
  },
  {
    Name: "Richard Ramirez",
    Artist: "SKYND",
    Album: "Chapter I - Single",
    Time: 342,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Jim Jones",
    Artist: "SKYND",
    Album: "Chapter II - Single",
    Time: 394,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Katherine Knight",
    Artist: "SKYND",
    Album: "Chapter II - Single",
    Time: 308,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "The River Is Rising (feat. Myles Kennedy and The Conspirators)",
    Artist: "Slash",
    Album: "4 (feat. Myles Kennedy and The Conspirators)",
    Time: 222,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Empire to Ashes",
    Artist: "Sleeping With Sirens",
    Album: "Gossip",
    Time: 197,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Legends",
    Artist: "Sleeping With Sirens",
    Album: "Gossip",
    Time: 222,
    Year: 2017,
    Plays: 141,
  },
  {
    Name: "Yoruba Demon",
    Artist: "Slim T & Delali",
    Album: "Yoruba Demon - Single",
    Time: 192,
    Year: 2017,
    Plays: 75,
  },
  {
    Name: "Thug",
    Artist: "Slim Thug",
    Album: "Boss of All Bosses",
    Time: 230,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Before I Forget",
    Artist: "Slipknot",
    Album: "Antennas To Hell",
    Time: 278,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Breaking Out",
    Artist: "Smash Into Pieces",
    Album: "Evolver",
    Time: 192,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Godsent",
    Artist: "Smash Into Pieces",
    Album: "Godsent & All Eyes On You - Single",
    Time: 214,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "I've Got a Huge Crush On You",
    Artist: "Snckpck",
    Album: "Songs for Someone You Love",
    Time: 168,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Good Nights",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 126,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "You're Welcome (feat. Tech N9ne)",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 169,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Play",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 206,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Bout That Life",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 213,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Cali Luv (feat. The Cataracs)",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 198,
    Year: 2013,
    Plays: 8,
  },
  {
    Name: "Turn Up (feat. Ty Dolla $ign)",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 129,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Hopeless (feat. Dizzy Wright)",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 224,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "On. Now (feat. Trae Tha Truth)",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 195,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Hold You Down (feat. Cyhi the Prynce)",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 236,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Cash Rules",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 210,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Where We Are",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 218,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Nope (feat. Riff Raff)",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 135,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Business Is",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 155,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Hola",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 182,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Cookie Cutter Bitches",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 185,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Dammit",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 196,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Lord Be With You",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 205,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Fuck Your Phone",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 193,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Doin' Fine",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 206,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Fuck the Rent",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 196,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Gettin' It",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 144,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Bad Mornings",
    Artist: "Snow tha Product",
    Album: "Good Nights & Bad Mornings 2: The Hangover",
    Time: 254,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Nico and the Niners (Acapella)",
    Artist: "Social Repose",
    Album: "Nico and the Niners (Acapella) - Single",
    Time: 202,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "F**k You",
    Artist: "The Sockapellas",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 72,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Swing",
    Artist: "Sofi Tukker",
    Album: "Swing - Single",
    Time: 179,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Get Loose",
    Artist: "Sohanny & Vein",
    Album: "Step Up Revolution",
    Time: 197,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Stålfågel",
    Artist: "Soilwork",
    Album: "Verkligheten",
    Time: 265,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Heaven",
    Artist: "Solence",
    Album: "Brothers",
    Time: 218,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Animal in Me",
    Artist: "Solence",
    Album: "Direction",
    Time: 187,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Denied",
    Artist: "Sonic Syndicate",
    Album: "Only Inhuman (Tour Edition)",
    Time: 231,
    Year: 2007,
    Plays: 261,
  },
  {
    Name: "Turn It Up!",
    Artist: "Sonic Syndicate",
    Album: "We Rule The Night",
    Time: 218,
    Year: 2010,
    Plays: 5,
  },
  {
    Name: "Into the Sun (EP Version)",
    Artist: "Sons Of The East",
    Album: "Already Gone",
    Time: 300,
    Year: 2015,
    Plays: 9,
  },
  {
    Name: "Oblivion",
    Artist: "Soul Extract",
    Album: "Circadian Algorithm",
    Time: 257,
    Year: 2018,
    Plays: 16,
  },
  {
    Name: "Pretty Boy Swag",
    Artist: "Soulja Boy Tell 'Em",
    Album: "The DeAndre Way",
    Time: 236,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Kiss Me Thru the Phone (feat. Sammie)",
    Artist: "Soulja Boy Tell 'Em",
    Album: "iSouljaBoyTellem (Deluxe Version)",
    Time: 193,
    Year: 2008,
    Plays: 6,
  },
  {
    Name: "Crank That (Soulja Boy)",
    Artist: "Soulja Boy Tell 'Em",
    Album: "iSouljaBoyTellem (Deluxe Version)",
    Time: 223,
    Year: 2007,
    Plays: 19,
  },
  {
    Name: "U Mad Bro (feat. Kevin Flum)",
    Artist: "Speaker Knockerz",
    Album: "Married to the Money II #MTTM2",
    Time: 229,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "In Love with My Hand (feat. Zlatan)",
    Artist: "Speed Darlington",
    Album: "In Love with My Hand (feat. Zlatan) - Single",
    Time: 227,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Blessed Be",
    Artist: "Spiritbox",
    Album: "Blessed Be - Single",
    Time: 245,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Secret Garden",
    Artist: "Spiritbox",
    Album: "Eternal Blue",
    Time: 219,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "God of Mercy and Compassion",
    Artist: "St. Patrick Orthodox Church Choir",
    Album: "Christ Be With Me",
    Time: 193,
    Year: 2017,
    Plays: 9,
  },
  {
    Name: "How Many More Goodbyes (feat. Tony Harnell & Magnus Karlsson)",
    Artist: "Starbreaker",
    Album: "Dysphoria (feat. Tony Harnell & Magnus Karlsson)",
    Time: 299,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "A Brief History of the Future",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 97,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Manifest",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 267,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Echo",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 216,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Where the Skies End",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 393,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Perfect Machine",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 323,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Telekinetic",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 312,
    Year: 2019,
    Plays: 23,
  },
  {
    Name: "Stratosphere",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 257,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Faultline",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 216,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Solstice",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 341,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Trials",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 258,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Waking Up",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 229,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Other Worlds than These",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 258,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Diving Bell",
    Artist: "STARSET",
    Album: "Divisions",
    Time: 338,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "THE BREACH",
    Artist: "STARSET",
    Album: "HORIZONS",
    Time: 260,
    Year: 2021,
    Plays: 15,
  },
  {
    Name: "OTHERWORLDLY",
    Artist: "STARSET",
    Album: "HORIZONS",
    Time: 302,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "DEVOLUTION",
    Artist: "STARSET",
    Album: "HORIZONS",
    Time: 309,
    Year: 2021,
    Plays: 9,
  },
  {
    Name: "Ricochet (Acoustic Version)",
    Artist: "STARSET",
    Album: "Ricochet (Deluxe) - Single",
    Time: 291,
    Year: 2018,
    Plays: 110,
  },
  {
    Name: "Telepathic",
    Artist: "STARSET",
    Album: "Telepathic - Single",
    Time: 282,
    Year: 2017,
    Plays: 11,
  },
  {
    Name: "It Has Begun",
    Artist: "STARSET",
    Album: "Transmissions (Deluxe Edition)",
    Time: 316,
    Year: 2014,
    Plays: 42,
  },
  {
    Name: "My Demons",
    Artist: "STARSET",
    Album: "Transmissions (Deluxe Edition)",
    Time: 288,
    Year: 2013,
    Plays: 9,
  },
  {
    Name: "Antigravity",
    Artist: "STARSET",
    Album: "Transmissions (Deluxe Edition)",
    Time: 369,
    Year: 2014,
    Plays: 26,
  },
  {
    Name: "Frequency",
    Artist: "STARSET",
    Album: "Vessels",
    Time: 281,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Die for You",
    Artist: "STARSET",
    Album: "Vessels",
    Time: 317,
    Year: 2017,
    Plays: 5,
  },
  {
    Name: "Ricochet",
    Artist: "STARSET",
    Album: "Vessels",
    Time: 310,
    Year: 2017,
    Plays: 167,
  },
  {
    Name: "Monster",
    Artist: "STARSET",
    Album: "Vessels",
    Time: 256,
    Year: 2016,
    Plays: 39,
  },
  {
    Name: "Ricochet (Acoustic Version)",
    Artist: "STARSET",
    Album: "Vessels 2.0",
    Time: 292,
    Year: 2018,
    Plays: 9,
  },
  {
    Name: "Curtain Call",
    Artist: "State of Mine",
    Album: "Devil in Disguise",
    Time: 188,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Rise",
    Artist: "State of Mine",
    Album: "Devil in Disguise",
    Time: 197,
    Year: 2016,
    Plays: 545,
  },
  {
    Name: "Waste My Time",
    Artist: "State of Mine",
    Album: "Devil in Disguise",
    Time: 250,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Stones",
    Artist: "State of Mine",
    Album: "Devil in Disguise",
    Time: 205,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Killing Me",
    Artist: "State of Mine",
    Album: "Devil in Disguise",
    Time: 238,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Undertow",
    Artist: "State of Mine",
    Album: "Devil in Disguise",
    Time: 233,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Broke by Monday",
    Artist: "State of Mine",
    Album: "Devil in Disguise",
    Time: 226,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "What Hurts the Most",
    Artist: "State of Mine",
    Album: "What Hurts the Most - Single",
    Time: 216,
    Year: 2018,
    Plays: 24,
  },
  {
    Name: "Loud and Heavy",
    Artist: "State of Mine & Drew Jacobs",
    Album: "Loud and Heavy - Single",
    Time: 201,
    Year: 2022,
    Plays: null,
  },
  {
    Name: "Safeword",
    Artist: "Static Dress",
    Album: "Safeword - Single",
    Time: 171,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Ding-A-Ling",
    Artist: "Stefflon Don",
    Album: "Ding-A-Ling - Single",
    Time: 187,
    Year: 2017,
    Plays: 12,
  },
  {
    Name: "Astronomia 2K19 (Radio Edit)",
    Artist: "Stephan F",
    Album: "Astronomia 2K19 - Single",
    Time: 190,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Hero",
    Artist: "Sterling Knight",
    Album: "StarStruck",
    Time: 197,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Rage the Night Away (Feat Waka Flocka Flame)",
    Artist: "Steve Aoki",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 234,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Delirious (Boneless) (Feat Kid Ink)",
    Artist: "Steve Aoki, Chris Lake and Tujamo",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 223,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Weak At The Knees",
    Artist: "Steve Arrington's Hall Of Fame",
    Album: "Straight Outta Compton",
    Time: 228,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Autobots",
    Artist: "Steve Jablonsky",
    Album: "Transformers: The Score",
    Time: 153,
    Year: 2007,
    Plays: 6,
  },
  {
    Name: "The All Spark",
    Artist: "Steve Jablonsky",
    Album: "Transformers: The Score",
    Time: 214,
    Year: 2007,
    Plays: 2,
  },
  {
    Name: "Arrival to Earth",
    Artist: "Steve Jablonsky",
    Album: "Transformers: The Score",
    Time: 326,
    Year: 2007,
    Plays: 9,
  },
  {
    Name: "No Sacrifice, No Victory",
    Artist: "Steve Jablonsky",
    Album: "Transformers: The Score",
    Time: 177,
    Year: 2007,
    Plays: 4,
  },
  {
    Name: "Gravity",
    Artist: "Steven Price",
    Album: "Gravity (Original Motion Picture Soundtrack)",
    Time: 275,
    Year: 2013,
    Plays: 13,
  },
  {
    Name: "My Demon",
    Artist: "Stitched Up Heart",
    Album: "Darkness",
    Time: 189,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Lost (feat. Sully Erna)",
    Artist: "Stitched Up Heart",
    Album: "Lost (feat. Sully Erna) - Single",
    Time: 207,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Never Alone",
    Artist: "Stitched Up Heart",
    Album: "Never Alone",
    Time: 216,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Song #3",
    Artist: "Stone Sour",
    Album: "Hydrograd",
    Time: 256,
    Year: 2017,
    Plays: 22,
  },
  {
    Name: "African Party",
    Artist: "Stonebwoy",
    Album: "Anloga Junction",
    Time: 210,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Activate",
    Artist: "Stonebwoy & Davido",
    Album: "Activate - Single",
    Time: 217,
    Year: 2020,
    Plays: 44,
  },
  {
    Name: "Nukedzor (What's up)",
    Artist: "Stonebwoy, Joey B & Abra Cadabra",
    Album: "Nukedzor (What's up) - Single",
    Time: 229,
    Year: 2021,
    Plays: 2,
  },
  {
    Name: "Crown",
    Artist: "Stormzy",
    Album: "Crown - Single",
    Time: 213,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Cold",
    Artist: "Stormzy",
    Album: "Gang Signs & Prayer",
    Time: 156,
    Year: 2017,
    Plays: 2,
  },
  {
    Name: "Big For Your Boots",
    Artist: "Stormzy",
    Album: "Gang Signs & Prayer",
    Time: 238,
    Year: 2017,
    Plays: 43,
  },
  {
    Name: "Blinded By Your Grace, Pt. 2 (feat. MNEK)",
    Artist: "Stormzy",
    Album: "Gang Signs & Prayer",
    Time: 230,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Shut Up",
    Artist: "Stormzy",
    Album: "Gang Signs & Prayer",
    Time: 179,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Audacity (feat. Headie One)",
    Artist: "Stormzy",
    Album: "Heavy Is The Head",
    Time: 245,
    Year: 2019,
    Plays: 12,
  },
  {
    Name: "Shut Up (Studio Version)",
    Artist: "Stormzy",
    Album: "WickedSkengMan 4 - Single",
    Time: 180,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Kuronbe (feat. Zlatan Ibile, Pretty Boy D.O & Ice Prince)",
    Artist: "Straffitti",
    Album: "Kuronbe (feat. Zlatan Ibile, Pretty Boy D.O & Ice Prince) - Single",
    Time: 240,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Unwanted",
    Artist: "The Strange Familiar",
    Album: "Chasing Shadows",
    Time: 246,
    Year: null,
    Plays: 95,
  },
  {
    Name: "Meltdown (feat. Lorde, Pusha T, Q-Tip & HAIM)",
    Artist: "Stromae",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 242,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Could Have Been Me",
    Artist: "The Struts",
    Album: "Everybody Wants",
    Time: 187,
    Year: 2013,
    Plays: 36,
  },
  {
    Name: "Body Talks",
    Artist: "The Struts",
    Album: "YOUNG & DANGEROUS",
    Time: 178,
    Year: 2018,
    Plays: 20,
  },
  {
    Name: "CHANGE MY LIFE",
    Artist: "Stunna 4 Vegas & Blac Youngsta",
    Album: "RICH YOUNGIN",
    Time: 153,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Four Years",
    Artist: "Styl-Plus",
    Album: "Back and Better",
    Time: 278,
    Year: 2012,
    Plays: 14,
  },
  {
    Name: "Always On My Mind",
    Artist: "Styl-Plus",
    Album: "Expressions",
    Time: 262,
    Year: 2006,
    Plays: 7,
  },
  {
    Name: "Imagine That",
    Artist: "Styl-Plus",
    Album: "Expressions",
    Time: 299,
    Year: 2005,
    Plays: 2,
  },
  {
    Name: "Iya Basira",
    Artist: "Styl-Plus",
    Album: "Expressions",
    Time: 314,
    Year: 2006,
    Plays: 2,
  },
  {
    Name: "Call My Name",
    Artist: "Styl-Plus",
    Album: "Expressions",
    Time: 282,
    Year: 2003,
    Plays: 13,
  },
  {
    Name: "Olufunmi",
    Artist: "Styl-Plus",
    Album: "Expressions",
    Time: 311,
    Year: 2003,
    Plays: 3,
  },
  {
    Name: "Loose Guard",
    Artist: "Styles",
    Album: "Loose Guard - Single",
    Time: 151,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Cradles",
    Artist: "Sub Urban",
    Album: "Cradles - Single",
    Time: 209,
    Year: 2019,
    Plays: 9,
  },
  {
    Name: "PARAMOUR (feat. AURORA)",
    Artist: "Sub Urban",
    Album: "PARAMOUR (feat. AURORA) - Single",
    Time: 168,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Pieces",
    Artist: "Sum 41",
    Album: "All the Good Sh**: 14 Solid Gold Hits (2000-2008) [Deluxe Edition]",
    Time: 181,
    Year: 2004,
    Plays: 9,
  },
  {
    Name: "Intro",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 46,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "No Reason",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 184,
    Year: 2004,
    Plays: 2,
  },
  {
    Name: "We're All to Blame",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 218,
    Year: 2004,
    Plays: 7,
  },
  {
    Name: "Angels With Dirty Faces",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 143,
    Year: 2004,
    Plays: 2,
  },
  {
    Name: "Some Say",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 206,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "The Bitter End",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 171,
    Year: 2004,
    Plays: 2,
  },
  {
    Name: "Open Your Eyes",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 165,
    Year: 2004,
    Plays: 25,
  },
  {
    Name: "Slipping Away",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 149,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "I'm Not the One",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 214,
    Year: 2004,
    Plays: 20,
  },
  {
    Name: "Welcome to Hell",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 116,
    Year: 2004,
    Plays: null,
  },
  {
    Name: "Pieces",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 182,
    Year: 2004,
    Plays: 8,
  },
  {
    Name: "There's No Solution",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 198,
    Year: 2004,
    Plays: 2,
  },
  {
    Name: "88",
    Artist: "Sum 41",
    Album: "Chuck",
    Time: 280,
    Year: 2004,
    Plays: 2,
  },
  {
    Name: "The Hell Song",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 198,
    Year: null,
    Plays: null,
  },
  {
    Name: "Over My Head (Better Off Dead)",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 149,
    Year: 2002,
    Plays: 8,
  },
  {
    Name: "My Direction",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 122,
    Year: null,
    Plays: null,
  },
  {
    Name: "Still Waiting",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 158,
    Year: null,
    Plays: 1,
  },
  {
    Name: "A.N.I.C.",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 37,
    Year: null,
    Plays: 1,
  },
  {
    Name: "No Brains",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 166,
    Year: null,
    Plays: null,
  },
  {
    Name: "All Messed Up",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 164,
    Year: null,
    Plays: null,
  },
  {
    Name: "Mr. Amsterdam",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 176,
    Year: null,
    Plays: null,
  },
  {
    Name: "Thanks For Nothing",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 184,
    Year: null,
    Plays: null,
  },
  {
    Name: "Hyper-Insomnia-Para-Condrioid",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 152,
    Year: null,
    Plays: null,
  },
  {
    Name: "Billy Spleen",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 152,
    Year: null,
    Plays: null,
  },
  {
    Name: "Hooch",
    Artist: "Sum 41",
    Album: "Does This Look Infected?",
    Time: 208,
    Year: null,
    Plays: null,
  },
  {
    Name: "Out for Blood",
    Artist: "Sum 41",
    Album: "Order in Decline",
    Time: 216,
    Year: 2019,
    Plays: 78,
  },
  {
    Name: "Never There",
    Artist: "Sum 41",
    Album: "Order in Decline",
    Time: 260,
    Year: 2019,
    Plays: 143,
  },
  {
    Name: "Reason to Believe",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 208,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Screaming Bloody Murder",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 204,
    Year: 2011,
    Plays: 13,
  },
  {
    Name: "Skumf*k",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 204,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Time for You to Go",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 181,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Jessica Kill",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 170,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "What Am I to Say",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 252,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Holy Image of Lies",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 227,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Sick of Everyone",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 185,
    Year: 2011,
    Plays: 14,
  },
  {
    Name: "Happiness Machine",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 288,
    Year: 2011,
    Plays: 8,
  },
  {
    Name: "Crash",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 199,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Blood In My Eyes",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 256,
    Year: 2011,
    Plays: 15,
  },
  {
    Name: "Baby You Don't Wanna Know",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 214,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Back Where I Belong",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 221,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Exit Song",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 102,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Reason to Believe (Acoustic)",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 157,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "We're the Same (Bonus Track)",
    Artist: "Sum 41",
    Album: "Screaming Bloody Murder",
    Time: 249,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Underclass Hero",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 194,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "Walking Disaster",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 286,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "Speak Of The Devil",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 238,
    Year: 2007,
    Plays: 16,
  },
  {
    Name: "Dear Father",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 232,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "Count Your Last Blessings",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 183,
    Year: 2007,
    Plays: 13,
  },
  {
    Name: "Ma Poubelle",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 55,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "March Of The Dogs",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 189,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "The Jester",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 168,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "With Me",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 291,
    Year: 2007,
    Plays: 2,
  },
  {
    Name: "Pull The Curtain",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 258,
    Year: 2007,
    Plays: 12,
  },
  {
    Name: "King Of Contradiction",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 100,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "Best Of Me",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 265,
    Year: 2007,
    Plays: 13,
  },
  {
    Name: "Confusion And Frustration In Modern Times",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 226,
    Year: 2007,
    Plays: 1,
  },
  {
    Name: "So Long Goodbye",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 181,
    Year: 2007,
    Plays: 2,
  },
  {
    Name: "Look At Me",
    Artist: "Sum 41",
    Album: "Underclass Hero",
    Time: 243,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "A Murder of Crows",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 184,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Goddamn I'm Dead Again",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 202,
    Year: 2016,
    Plays: 9,
  },
  {
    Name: "Fake My Own Death",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 194,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Breaking the Chain",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 243,
    Year: 2016,
    Plays: 5,
  },
  {
    Name: "There Will Be Blood",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 209,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "13 Voices",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 272,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "War",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 209,
    Year: 2016,
    Plays: 6,
  },
  {
    Name: "God Save Us All (Death to POP)",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 233,
    Year: 2016,
    Plays: 6,
  },
  {
    Name: "The Fall and the Rise",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 189,
    Year: 2016,
    Plays: 5,
  },
  {
    Name: "Twisted By Design",
    Artist: "Sum 41",
    Album: "13 Voices",
    Time: 328,
    Year: 2016,
    Plays: 8,
  },
  {
    Name: "Bad Things",
    Artist: "Summer Kennedy",
    Album: "The Bright Side",
    Time: 237,
    Year: 2018,
    Plays: 13,
  },
  {
    Name: "Run Away",
    Artist: "Sunstroke Project & Olia Tira",
    Album: "Run Away - Single",
    Time: 177,
    Year: 2010,
    Plays: 16,
  },
  {
    Name: "The Promise",
    Artist: "Superfruit",
    Album: "The Promise - Single",
    Time: 250,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Eye of the Tiger",
    Artist: "Survivor",
    Album: "The Essential Survivor",
    Time: 244,
    Year: 1982,
    Plays: 2,
  },
  {
    Name: 'Krabby Step (Music From "Sponge on the Run" Movie)',
    Artist: "Swae Lee, Tyga & Lil Mosey",
    Album: 'Krabby Step (Music From "Sponge on the Run" Movie) - Single',
    Time: 196,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "The Sound of Silence (The Last Dance Remix)",
    Artist: "SWANN",
    Album: "Covers Vl:1 - EP",
    Time: 332,
    Year: 2020,
    Plays: 25,
  },
  {
    Name: "Holy Ghost",
    Artist: "Sweet Leke",
    Album: "Holy Ghost - Single",
    Time: 369,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Just One Truth",
    Artist: "Sympathy For Nothing",
    Album: "A Taste of Light",
    Time: 274,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Chop Suey!",
    Artist: "System Of A Down",
    Album: "Toxicity",
    Time: 210,
    Year: 2001,
    Plays: 3,
  },
  {
    Name: "Power is Power",
    Artist: "SZA & The Weeknd & Travis Scott",
    Album:
      'For the Throne (Music Inspired by the HBO Series "Game of Thrones")',
    Time: 211,
    Year: 2019,
    Plays: 25,
  },
  {
    Name: "MAKAVELI",
    Artist: "T-Classic",
    Album: "MAKAVELI - Single",
    Time: 138,
    Year: 2021,
    Plays: 8,
  },
  {
    Name: "Take Your Shirt Off",
    Artist: "T-Pain",
    Album: "Take Your Shirt Off - Single",
    Time: 228,
    Year: 2009,
    Plays: 15,
  },
  {
    Name: "Sometimes (feat. Olamide) [Remix]",
    Artist: "T.I BLAZE",
    Album: "Sometimes (Remix) [feat. Olamide] - Single",
    Time: 188,
    Year: 2022,
    Plays: 2,
  },
  {
    Name: "56 Bars (Intro)",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 184,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "I'm Illy",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 246,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Ready for Whatever",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 312,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "On Top of the World (feat. Ludacris & B.o.B)",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 300,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Live Your Life (feat. Rihanna)",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 338,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Whatever You Like",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 249,
    Year: 2008,
    Plays: 16,
  },
  {
    Name: "No Matter What",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 315,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "My Life Your Entertainment (feat. Usher)",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 296,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "Porn Star",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 211,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Swing Ya Rag (feat. Swizz Beatz)",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 198,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "What Up, What's Haapnin'?",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 301,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Every Chance I Get",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 289,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Slide Show (feat. John Legend)",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 222,
    Year: 2008,
    Plays: 1,
  },
  {
    Name: "You Ain't Missin' Nothing",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 310,
    Year: 2008,
    Plays: 10,
  },
  {
    Name: "Dead and Gone (feat. Justin Timberlake)",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 299,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "Collect Call",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 278,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "I Know You Missed Me",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 192,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "No Matter What",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 283,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Whatever You Like",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 252,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "What Up, What's Haapnin'",
    Artist: "T.I.",
    Album: "Paper Trail (Deluxe Version)",
    Time: 303,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Trap Muzik",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 242,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "I Can't Quit",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 259,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Be Easy",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 200,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "No More Talk",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 235,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Doin' My Job",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 255,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Let's Get Away",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 279,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "24's",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 285,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Rubber Band Man",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 349,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Look What I Got",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 187,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "I Still Luv You",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 300,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Let Me Tell You Something",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 222,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "T.I. Vs. T.I.P.",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 234,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Bezzle",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 296,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Kingofdasouth",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 302,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Be Better Than Me",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 302,
    Year: 2003,
    Plays: 2,
  },
  {
    Name: "Long Live Da' Game",
    Artist: "T.I.",
    Album: "Trap Muzik",
    Time: 134,
    Year: 2003,
    Plays: 1,
  },
  {
    Name: "Tha King",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 204,
    Year: null,
    Plays: null,
  },
  {
    Name: "Motivation",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 214,
    Year: null,
    Plays: null,
  },
  {
    Name: "U Don't Know Me",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 243,
    Year: null,
    Plays: 2,
  },
  {
    Name: "ASAP",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 284,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Prayin' For Help",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 262,
    Year: null,
    Plays: null,
  },
  {
    Name: "Why U Mad At Me",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 233,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Get Loose",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 252,
    Year: null,
    Plays: null,
  },
  {
    Name: "What They Do",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 228,
    Year: null,
    Plays: null,
  },
  {
    Name: "The Greatest",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 263,
    Year: null,
    Plays: null,
  },
  {
    Name: "Get Ya Shit Together",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 245,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Freak Though",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 223,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Countdown",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 295,
    Year: null,
    Plays: null,
  },
  {
    Name: "Bring Em Out",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 216,
    Year: null,
    Plays: null,
  },
  {
    Name: "Limelight",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 303,
    Year: null,
    Plays: null,
  },
  {
    Name: "Chillin' With My Bitch",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 236,
    Year: null,
    Plays: null,
  },
  {
    Name: "Stand Up",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 282,
    Year: null,
    Plays: null,
  },
  {
    Name: "My Life",
    Artist: "T.I.",
    Album: "Urban Legend",
    Time: 313,
    Year: null,
    Plays: 2,
  },
  {
    Name: "Swagga Like Us (feat. Kanye West & Lil Wayne)",
    Artist: "T.I. & JAY-Z",
    Album: "Paper Trail (Deluxe Version)",
    Time: 327,
    Year: 2008,
    Plays: null,
  },
  {
    Name: "Dynamite",
    Artist: "Taio Cruz",
    Album: "Rokstarr (Special Edition)",
    Time: 202,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Break Your Heart (feat. Ludacris)",
    Artist: "Taio Cruz & Ludacris",
    Album: "Rokstarr (Special Edition)",
    Time: 185,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Isabella's Lullaby",
    Artist: "Takahiro Obata",
    Album: "The Promised Neverland (Original Soundtrack) [Complete Edition]",
    Time: 149,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Isabella's Lullaby (No Vocal Version)",
    Artist: "Takahiro Obata",
    Album: "The Promised Neverland (Original Soundtrack) [Complete Edition]",
    Time: 149,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "FAIRY TAIL Main Theme",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 152,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Erza no Theme",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 174,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Mahou Hatsudou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 107,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Dragonslayer",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 119,
    Year: 2010,
    Plays: 12,
  },
  {
    Name: "Rakuen no Tou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 111,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Yami Guild",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 119,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Mirajane no Theme",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 110,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Nigiyaka na Machi",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 85,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Yousei no Shippo",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 81,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Hoshi Rei Mahou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 25,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Lucy Ganbaru",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 105,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Gray no Theme",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 131,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Natsu no Theme",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 115,
    Year: 2010,
    Plays: 4,
  },
  {
    Name: "Shukumei",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 172,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Shinobiyoru Kage",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 94,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Laxus Bousou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 103,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Fairy Law",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 120,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Nakama Tachi",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 147,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Kokyou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 98,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Lucy no Theme",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 90,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Koori no Senjin",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 116,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Yuuki",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 111,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Yami yo, Tsudoe!",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 110,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Eisen Wald",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 24,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Ankoku no Madoushi",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 148,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Salamander",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 136,
    Year: 2010,
    Plays: 12,
  },
  {
    Name: "Koori wa Maou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 135,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Mahou Taisen",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 100,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Kanashiki Kako",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 133,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Akuma Deliora",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 194,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Titania no Yoroi",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 99,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Meoagaru Kobushi",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 96,
    Year: 2010,
    Plays: 7,
  },
  {
    Name: "Saigo no Mahou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 95,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Guren no Ikari",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 118,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Ifuu Doudou -Rock ver.-",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 122,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "FAIRY TAIL Main Theme -Slow ver.-",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.1",
    Time: 154,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Kurogane",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 140,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Shishi no Hoshi Rei",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 130,
    Year: 2010,
    Plays: 6,
  },
  {
    Name: "Jaaku no Tsuchi Oto",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 172,
    Year: 2010,
    Plays: 14,
  },
  {
    Name: "Tsuioku ~Mezameru Tamashii~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 190,
    Year: 2010,
    Plays: 17,
  },
  {
    Name: "Atarashii Yuujou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 183,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Happy no Theme",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 91,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Ayashii Madoushi",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 94,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Makarov",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 94,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Fantasia",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 132,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Phantom Lord",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 29,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Madou no Chousensha",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 186,
    Year: 2010,
    Plays: 23,
  },
  {
    Name: "Haja no Sen Kaze",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 124,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Hisou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 96,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "FAIRY TAIL Main Theme -Piano ver.-",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 148,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Natsu no Mahou 1 ~Karyuu no Houkou~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 29,
    Year: 2010,
    Plays: 8,
  },
  {
    Name: "Natsu no Mahou 2 ~Karyuu no Tsurugi Kaku~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 26,
    Year: 2010,
    Plays: 13,
  },
  {
    Name: "Natsu no Mahou 3 ~Guren Karyuu Kobushi~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 22,
    Year: 2010,
    Plays: 12,
  },
  {
    Name: "Gurei no Mahou 1 ~Ice Make~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 23,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Gurei no Mahou 2 ~Ice Geyser~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 26,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Gurei no Mahou 3 ~Koori Ha Shichi Ren Mai~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 36,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Erza no Mahou 1 ~Kongou no Yoroi~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 22,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Erza no Mahou 2 ~Ten Wa no Yoroi~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 25,
    Year: 2010,
    Plays: 3,
  },
  {
    Name: "Erza no Mahou 3 ~Rengoku no Yoroi~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 34,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Kurakizan Hikari",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 42,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Hoshi Rei Ou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 94,
    Year: 2010,
    Plays: null,
  },
  {
    Name: 'Rakuen no Tou ~Rachmaninoff "Piano Kyousou Kyoku Dai 2 Ban C Tanchou OP." Dai 1 Gakushou Yori',
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 150,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Toki Hanata Reshi Chikara",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 160,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Kizuna",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 154,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Tsuioku ~Kanashiki Tamashii~",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 160,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Ma Shishou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 149,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Satan Soul",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 44,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Tai Ma Gekisen",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 210,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Eien no Mahou",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 127,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Fiore Oukoku",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 161,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "FAIRY TAIL Main Theme -METAL ver.-",
    Artist: "Takanashi Yasuharu",
    Album: "Fairy Tail Original Soundtrack Vol.2",
    Time: 122,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Casper",
    Artist: "Takeoff",
    Album: "The Last Rocket",
    Time: 197,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "The Less I Know the Better",
    Artist: "Tame Impala",
    Album: "Currents",
    Time: 218,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Seeking for the Reign",
    Artist: "Tarja",
    Album: "My Winter Storm",
    Time: 58,
    Year: 2007,
    Plays: 4,
  },
  {
    Name: "I'm Getting Ready (feat. Nicki Minaj)",
    Artist: "Tasha Cobbs Leonard",
    Album: "Heart. Passion. Pursuit. (Deluxe Edition)",
    Time: 506,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Cheers To the Tragedy",
    Artist: "Tattoo the Scars",
    Album: "Cheers To the Tragedy - Single",
    Time: 238,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Oceans (Where Feet May Fail) [feat. Kirk Franklin]",
    Artist: "Taylor Mosby",
    Album: "Breakthrough (Music From & Inspired By The Motion Picture)",
    Time: 265,
    Year: 2019,
    Plays: 15,
  },
  {
    Name: "Fearless",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 242,
    Year: 2009,
    Plays: 2,
  },
  {
    Name: "Fifteen",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 294,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Love Story",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 235,
    Year: 2009,
    Plays: 5,
  },
  {
    Name: "Hey Stephen",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 254,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "White Horse",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 234,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "You Belong With Me",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 231,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Breathe (feat. Colbie Caillat)",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 263,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Tell Me Why",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 200,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "You're Not Sorry",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 261,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "The Way I Loved You",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 244,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Forever & Always",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 225,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "The Best Day",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 245,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Change",
    Artist: "Taylor Swift",
    Album: "Fearless",
    Time: 281,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Safe & Sound (feat. The Civil Wars)",
    Artist: "Taylor Swift",
    Album: "The Hunger Games (Songs from District 12 and Beyond)",
    Time: 240,
    Year: 2011,
    Plays: 15,
  },
  {
    Name: "the lakes (original version)",
    Artist: "Taylor Swift",
    Album: "the lakes (original version) - Single",
    Time: 227,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "State Of Grace",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 295,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Red",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 223,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Treacherous",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 242,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "I Knew You Were Trouble",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 219,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "All Too Well",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 329,
    Year: 2012,
    Plays: 35,
  },
  {
    Name: "22",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 232,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "I Almost Do",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 244,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "We Are Never Ever Getting Back Together",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 193,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Stay Stay Stay",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 205,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The Last Time (Feat. Gary Lightbody Of Snow Patrol)",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 299,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Holy Ground",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 202,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Sad Beautiful Tragic",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 284,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The Lucky One",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 240,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Everything Has Changed (Feat. Ed Sheeran)",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 245,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Starlight",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 220,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Begin Again",
    Artist: "Taylor Swift",
    Album: "Red",
    Time: 237,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "The Moment I Knew",
    Artist: "Taylor Swift",
    Album: "Red (Deluxe Edition)",
    Time: 286,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Girl at Home",
    Artist: "Taylor Swift",
    Album: "Red (Deluxe Edition)",
    Time: 220,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Red (Original Demo Recording)",
    Artist: "Taylor Swift",
    Album: "Red (Deluxe Edition)",
    Time: 227,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "State of Grace (Acoustic Version)",
    Artist: "Taylor Swift",
    Album: "Red (Deluxe Edition)",
    Time: 323,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Come Back...Be Here",
    Artist: "Taylor Swift",
    Album: "Red (Deluxe Edition)",
    Time: 224,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Treacherous (Original Demo Recording)",
    Artist: "Taylor Swift",
    Album: "Red (Deluxe Edition)",
    Time: 240,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: 'Safe & Sound (from "the Hunger Games" Soundtrack) [feat. The Civil Wars]',
    Artist: "Taylor Swift",
    Album:
      'Safe & Sound (From "The Hunger Games" Soundtrack) [feat. The Civil Wars] - Single',
    Time: 241,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Mine",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 230,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Sparks Fly",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 260,
    Year: 2010,
    Plays: 19,
  },
  {
    Name: "Back to December",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 292,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Speak Now",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 240,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Dear John",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 403,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Mean",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 237,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "The Story of Us",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 265,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Never Grow Up",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 290,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Enchanted",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 352,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Better Than Revenge",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 217,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Innocent",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 302,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Haunted",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 242,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Last Kiss",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 367,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Long Live",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 317,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Ours",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 238,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "If This Was a Movie",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 234,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Superman",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 276,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Back to December (Acoustic Version)",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 292,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Haunted (Acoustic Version)",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 217,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Mine (US Version)",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 230,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Back to December (US Version)",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 292,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "The Story of Us (US Version)",
    Artist: "Taylor Swift",
    Album: "Speak Now",
    Time: 266,
    Year: 2010,
    Plays: null,
  },
  {
    Name: "Welcome To New York",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 214,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Blank Space",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 231,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Style",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 232,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Out Of The Woods",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 237,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "All You Had To Do Was Stay",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 195,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Shake It Off",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 221,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "I Wish You Would",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 209,
    Year: 2014,
    Plays: 52,
  },
  {
    Name: "Bad Blood",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 213,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Wildest Dreams",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 222,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "How You Get The Girl",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 249,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "This Love",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 251,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "I Know Places",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 197,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Clean",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 272,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Wonderland",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 247,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "You R In Love",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 268,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "New Romance",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 232,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Out Of The Woods (Voice Memo)",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 218,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Shake It Off (Voice Memo)",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 108,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "I Know Places (Voice Memo)",
    Artist: "Taylor Swift",
    Album: "1989 (Deluxe Version)",
    Time: 133,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Ball",
    Artist: "Tchap0",
    Album: "Paradox",
    Time: 205,
    Year: 2019,
    Plays: 17,
  },
  {
    Name: "Everybody Wants To Run the World (Running Version)",
    Artist: "Tears for Fears",
    Album: "Songs From the Big Chair (Super Deluxe)",
    Time: 273,
    Year: 1985,
    Plays: 18,
  },
  {
    Name: "DON'T JEALOUS ME",
    Artist: "Tekno, Yemi Alade, Mr Eazi & Lord Afrixana",
    Album: "The Lion King: The Gift",
    Time: 155,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "Damages",
    Artist: "Tems",
    Album: "For Broken Ears",
    Time: 169,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Try Me",
    Artist: "Tems",
    Album: "Try Me - Single",
    Time: 213,
    Year: 2019,
    Plays: 14,
  },
  {
    Name: "Billionaire",
    Artist: "Teni",
    Album: "Billionaire - EP",
    Time: 213,
    Year: 2019,
    Plays: 10,
  },
  {
    Name: "Marry",
    Artist: "Teni",
    Album: "Marry - Single",
    Time: 208,
    Year: 2020,
    Plays: 44,
  },
  {
    Name: "MOSLADO",
    Artist: "Teni",
    Album: "MOSLADO REFIX - EP",
    Time: 206,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Party Next Door",
    Artist: "Teni",
    Album: "Party Next Door - Single",
    Time: 209,
    Year: 2019,
    Plays: 38,
  },
  {
    Name: "INJURE ME",
    Artist: "Teni",
    Album: "WONDALAND",
    Time: 152,
    Year: 2021,
    Plays: 23,
  },
  {
    Name: "MOSLADO (Pheelz Remix)",
    Artist: "Teni & Pheelz",
    Album: "MOSLADO REFIX - EP",
    Time: 264,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Tokyo Drift",
    Artist: "Teriyaki Boyz",
    Album:
      "The Fast and the Furious: Tokyo Drift (Original Motion Picture Soundtrack)",
    Time: 255,
    Year: 2006,
    Plays: 1,
  },
  {
    Name: "Belong to the World",
    Artist: "The Weeknd",
    Album: "",
    Time: 476,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Higher",
    Artist: "The-Dream, Pusha T, Mase & Cocaine 80s",
    Album: "Kanye West Presents Good Music Cruel Summer",
    Time: 274,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Rise Up",
    Artist: "TheFatRat",
    Album: "Rise Up - Single",
    Time: 169,
    Year: 2019,
    Plays: 28,
  },
  {
    Name: "Angel",
    Artist: "Theory of a Deadman",
    Album: "Savages",
    Time: 202,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "History of Violence",
    Artist: "Theory of a Deadman",
    Album: "Say Nothing",
    Time: 234,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Attack",
    Artist: "Thirty Seconds to Mars",
    Album: "A Beautiful Lie",
    Time: 189,
    Year: 2005,
    Plays: 3,
  },
  {
    Name: "A Beautiful Lie",
    Artist: "Thirty Seconds to Mars",
    Album: "A Beautiful Lie",
    Time: 245,
    Year: 2005,
    Plays: 4,
  },
  {
    Name: "Red (feat. Merethe Soltvedt)",
    Artist: "Thomas Bergersen & Two Steps From Hell",
    Album: "Red (feat. Merethe Soltvedt) - Single",
    Time: 343,
    Year: 2021,
    Plays: 5,
  },
  {
    Name: "Cape of Hope",
    Artist: "Thomas Edwards",
    Album: "Cape of Hope - Single",
    Time: 154,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "The Introduction",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 60,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "We Are",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 198,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Light Up the Sky",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 239,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "The End Is Where We Begin",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 224,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Let the Sparks Fly",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 246,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "I Get Wicked",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 212,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Be Somebody",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 222,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "This Is a Warning",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 46,
    Year: 2012,
    Plays: 7,
  },
  {
    Name: "Courtesy Call",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 236,
    Year: 2012,
    Plays: 23,
  },
  {
    Name: "War of Change",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 231,
    Year: 2012,
    Plays: 15,
  },
  {
    Name: "Down",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 207,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "All I Need to Know",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 249,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Fly On the Wall",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 242,
    Year: 2012,
    Plays: 8,
  },
  {
    Name: "So Far Gone",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 269,
    Year: 2012,
    Plays: 9,
  },
  {
    Name: "Outroduction",
    Artist: "Thousand Foot Krutch",
    Album: "The End Is Where We Begin",
    Time: 37,
    Year: 2012,
    Plays: 5,
  },
  {
    Name: "Push",
    Artist: "Thousand Foot Krutch",
    Album: "Exhale",
    Time: 260,
    Year: 2016,
    Plays: 5,
  },
  {
    Name: "In My Room",
    Artist: "Thousand Foot Krutch",
    Album: "Oxygen: Inhale",
    Time: 279,
    Year: 2014,
    Plays: 17,
  },
  {
    Name: "Neurotic (feat. Lukas Rossi )",
    Artist: "Three Days Grace",
    Album: "EXPLOSIONS",
    Time: 197,
    Year: 2022,
    Plays: 6,
  },
  {
    Name: "Lifetime",
    Artist: "Three Days Grace",
    Album: "EXPLOSIONS",
    Time: 176,
    Year: 2022,
    Plays: 63,
  },
  {
    Name: "Chain of Abuse",
    Artist: "Three Days Grace",
    Album: "EXPLOSIONS",
    Time: 185,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "Fallen Angel",
    Artist: "Three Days Grace",
    Album: "Human",
    Time: 186,
    Year: 2015,
    Plays: 62,
  },
  {
    Name: "I Am Machine",
    Artist: "Three Days Grace",
    Album: "Human",
    Time: 201,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "The Good Life",
    Artist: "Three Days Grace",
    Album: "Life Starts Now",
    Time: 173,
    Year: 2009,
    Plays: 5,
  },
  {
    Name: "Pain",
    Artist: "Three Days Grace",
    Album: "One-X",
    Time: 202,
    Year: 2006,
    Plays: null,
  },
  {
    Name: "Never Too Late",
    Artist: "Three Days Grace",
    Album: "One-X",
    Time: 209,
    Year: 2006,
    Plays: 16,
  },
  {
    Name: "Infra-Red",
    Artist: "Three Days Grace",
    Album: "Outsider",
    Time: 230,
    Year: 2018,
    Plays: 60,
  },
  {
    Name: "Bastard",
    Artist: "Threewisemen",
    Album: "Bastard - Single",
    Time: 230,
    Year: 2012,
    Plays: 10,
  },
  {
    Name: "Stare At the Sun",
    Artist: "Thrice",
    Album: "The Artist In the Ambulance",
    Time: 203,
    Year: 2003,
    Plays: 8,
  },
  {
    Name: "The Artist In the Ambulance",
    Artist: "Thrice",
    Album: "The Artist In the Ambulance",
    Time: 219,
    Year: 2003,
    Plays: 8,
  },
  {
    Name: "Only Us",
    Artist: "Thrice",
    Album: "Palms",
    Time: 224,
    Year: 2018,
    Plays: 8,
  },
  {
    Name: "Black Honey",
    Artist: "Thrice",
    Album: "To Be Everywhere Is to Be Nowhere",
    Time: 239,
    Year: 2016,
    Plays: 56,
  },
  {
    Name: "Breathe",
    Artist: "Through Fire",
    Album: "Breathe",
    Time: 240,
    Year: 2016,
    Plays: 21,
  },
  {
    Name: "Driving In Style",
    Artist: "Thundermother",
    Album: "Heat Wave",
    Time: 223,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Memories",
    Artist: "Thutmose",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 199,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "MY POWER",
    Artist:
      "Tierra Whack, Beyoncé, Moonchild Sanelly, Nija, DJ Lag, Yemi Alade & Busiswa",
    Album: "The Lion King: The Gift",
    Time: 259,
    Year: 2019,
    Plays: 15,
  },
  {
    Name: "Win",
    Artist: "Timaya & Falz",
    Album: "Win - Single",
    Time: 223,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Apologize (feat. OneRepublic)",
    Artist: "Timbaland",
    Album: "Dreaming Out Loud",
    Time: 185,
    Year: 2006,
    Plays: 2,
  },
  {
    Name: "Hands In The Air (Feat. Ne-Yo)",
    Artist: "Timbaland",
    Album: "Step Up Revolution",
    Time: 241,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The Way I Are",
    Artist: "Timbaland, Keri Hilson & D.O.E.",
    Album: "In a Perfect World...",
    Time: 179,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "In Control (feat. Nico Schiesewitz)",
    Artist: "Time, The Valuator",
    Album: "In Control (feat. Nico Schiesewitz) - Single",
    Time: 230,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Lovely (feat. Charlotte Buchholz)",
    Artist: "Time, The Valuator",
    Album: "Lovely (feat. Charlotte Buchholz) - Single",
    Time: 238,
    Year: 2019,
    Plays: 107,
  },
  {
    Name: "Vibrant",
    Artist: "Time, The Valuator",
    Album: "Vibrant - Single",
    Time: 259,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Die Young",
    Artist: "Timeflies Tuesday",
    Album: "",
    Time: 240,
    Year: null,
    Plays: 13,
  },
  {
    Name: "The Leap",
    Artist: "Tinashé",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 246,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Take Me Back Remix (feat. Sway & Chipmunk)",
    Artist: "Tinchy Stryder, Taio Cruz",
    Album: "Take Me Back (e-Single)",
    Time: 257,
    Year: 2009,
    Plays: 19,
  },
  {
    Name: "Someday (feat. Ella Eyre)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 261,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Someday (Place In the Sun) [feat. Ella Eyre]",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 261,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Trampoline (feat. 2 Chainz)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 219,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Trampoline (feat. 2 Chainz)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 225,
    Year: 2013,
    Plays: 10,
  },
  {
    Name: "Don't Sell Out",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 193,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "It's OK (feat. Labrinth)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 269,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "It's OK (feat. Lambrinth)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 270,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Mosh Pit (feat. Dizzee Rascal & Ty Dolla $ign)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 251,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Mosh Pit (feat. Dizzee Rascal)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 250,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Looking Down the Barrel (feat. Patrick Okogwu)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 209,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Looking Down the Barrel",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 212,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Children of the Sun (feat. John Martin)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 231,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Childen of the Sun (feat. John Martin)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 229,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Witch Doctor (feat. Candice Pillay)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 188,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Shape (feat. Big Sean)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 245,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Lover Not a Fighter (feat. Labrinth)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 209,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "A Heart Can Save the World (feat. Emeli Sandé)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 222,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Tears Run Dry (feat. Sway Clarke)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 299,
    Year: 2013,
    Plays: 10,
  },
  {
    Name: "Tears Run Dry (feat. Sway Clarke II)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 303,
    Year: 2013,
    Plays: 39,
  },
  {
    Name: "Lost Ones (feat. Paloma Faith)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 278,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Lost Ones (feat. Paloma Faith)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 284,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Heroes (feat. Laura Mvula)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 226,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "5 Minutes",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 318,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "5 Minutes",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 314,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Do Till I (Bonus Track)",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 252,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Do Till I",
    Artist: "Tinie Tempah",
    Album: "Demonstration",
    Time: 258,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Till I'm Gone",
    Artist: "Tinie Tempah",
    Album: "Disc-Overy",
    Time: 210,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Written In The Stars",
    Artist: "Tinie Tempah",
    Album: "Disc-Overy",
    Time: 219,
    Year: 2011,
    Plays: 23,
  },
  {
    Name: "Pass Out",
    Artist: "Tinie Tempah",
    Album: "Disc-Overy (Deluxe)",
    Time: 267,
    Year: 2009,
    Plays: 18,
  },
  {
    Name: "Frisky (feat. Labrinth)",
    Artist: "Tinie Tempah",
    Album: "Disc-Overy (Deluxe)",
    Time: 295,
    Year: 2010,
    Plays: 65,
  },
  {
    Name: "KEYS TO THE KINGDOM",
    Artist: "Tiwa Savage & Mr Eazi",
    Album: "The Lion King: The Gift",
    Time: 198,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Ghoul",
    Artist: "Together Pangea",
    Album: "Dye",
    Time: 162,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Badman",
    Artist: "Tolani",
    Album: "Badman - Single",
    Time: 194,
    Year: 2020,
    Plays: 18,
  },
  {
    Name: "Superman Rising, Pt. 2 / Immovable",
    Artist: "Tom Holkenborg",
    Album: "Zack Snyder's Justice League (Original Motion Picture Soundtrack)",
    Time: 115,
    Year: 2021,
    Plays: 16,
  },
  {
    Name: "At the Speed of Force",
    Artist: "Tom Holkenborg",
    Album: "Zack Snyder's Justice League (Original Motion Picture Soundtrack)",
    Time: 260,
    Year: 2021,
    Plays: 12,
  },
  {
    Name: "I Don't Care",
    Artist: "Tom MacDonald",
    Album: "I Don't Care - Single",
    Time: 265,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Just You and I (Acoustic)",
    Artist: "Tom Walker",
    Album: "What a Time To Be Alive",
    Time: 198,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "I'm Not Afraid (feat. Wondra)",
    Artist: "Tommee Profitt",
    Album: "Cinematic Songs (Vol. 1)",
    Time: 254,
    Year: 2017,
    Plays: 1,
  },
  {
    Name: "Champion (feat. Nicole Serrano)",
    Artist: "Tommee Profitt",
    Album: "Cinematic Songs, Vol. 6",
    Time: 215,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "I'll Be Your Hero (feat. Stanaj)",
    Artist: "Tommee Profitt",
    Album: "Cinematic Songs, Vol. 7",
    Time: 223,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Wake Me Up (feat. Fleurie)",
    Artist: "Tommee Profitt",
    Album: "Covers, Vol. 1",
    Time: 312,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Believer (feat. Colton Dixon)",
    Artist: "Tommee Profitt",
    Album: "Covers, Vol. 1",
    Time: 268,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Gloria Regali (feat. Fleurie)",
    Artist: "Tommee Profitt",
    Album: "Gloria Regali",
    Time: 204,
    Year: 2019,
    Plays: 64,
  },
  {
    Name: "Onward & Upward (feat. Fleurie)",
    Artist: "Tommee Profitt",
    Album: "Gloria Regali",
    Time: 210,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Winter's Song (feat. Fleurie)",
    Artist: "Tommee Profitt",
    Album: "Gloria Regali",
    Time: 133,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Breathe",
    Artist: "Tommee Profitt & Fleurie",
    Album: "Cinematic Songs (Vol. 2)",
    Time: 217,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "In the End (feat. Fleurie) [Mellen Gi Remix]",
    Artist: "Tommee Profitt & Mellen Gi",
    Album: "In the End - Single",
    Time: 218,
    Year: 2019,
    Plays: 24,
  },
  {
    Name: "Un-Break My Heart",
    Artist: "Toni Braxton",
    Album: "Secrets (Remix Package)",
    Time: 270,
    Year: 1996,
    Plays: null,
  },
  {
    Name: "Draco",
    Artist: "Toph3r",
    Album: "Draco - Single",
    Time: 244,
    Year: 2020,
    Plays: 4,
  },
  {
    Name: "Intro (West Side)",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 176,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "2021- Interlude",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 133,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Blood on my Jeans",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 161,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Thugged out (feat. Block46)",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 181,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Diamonds",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 201,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Clout",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 114,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Ghost (feat. yfmroady & Block46)",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 177,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Confessions (Toxic Love)",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 191,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Rockstar Girl",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 142,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Wants & Needs",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 219,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Toph3r’s Freestyle",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 154,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Heartbreak",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 212,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Outro (Rap god)",
    Artist: "Toph3r",
    Album: "Grey Walls",
    Time: 94,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Pull Up",
    Artist: "Toph3r",
    Album: "Pull Up - Single",
    Time: 151,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Enchanted Waterfall",
    Artist: "Tory Lanez",
    Album: "Alone At Prom",
    Time: 191,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Broke In A Minute",
    Artist: "Tory Lanez",
    Album: "Broke In A Minute - Single",
    Time: 132,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Florida Shit",
    Artist: "Tory Lanez",
    Album: "Florida Shit - Single",
    Time: 209,
    Year: 2022,
    Plays: 4,
  },
  {
    Name: "Broke In A Minute",
    Artist: "Tory Lanez",
    Album: "The New Toronto 3",
    Time: 132,
    Year: 2020,
    Plays: 75,
  },
  {
    Name: "Praxis",
    Artist: "Totem",
    Album: "Praxis - Single",
    Time: 135,
    Year: 2021,
    Plays: 33,
  },
  {
    Name: "Limelight (feat. Manchester Orchestra)",
    Artist: "Touché Amoré",
    Album: "Lament",
    Time: 302,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Scream My Name",
    Artist: "Tove Lo",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 214,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Habits (Stay High)",
    Artist: "Tove Lo",
    Album: "Queen of the Clouds (Blueprint Edition)",
    Time: 209,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "Come Together (feat. An0maly)",
    Artist: "Trapt",
    Album: "Come Together (feat. An0maly) - Single",
    Time: 233,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "Headstrong",
    Artist: "Trapt",
    Album: "Trapt",
    Time: 286,
    Year: 2002,
    Plays: 1,
  },
  {
    Name: "Surfin Bird",
    Artist: "The Trashman",
    Album: "Battlefield Vietnam",
    Time: 144,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Let's Go (Feat. Yelawolf, Twista, Busta Rhymes & Lil Jon) (Ricky Luna Remix)",
    Artist: "Travis Barker",
    Album: "Step Up Revolution",
    Time: 225,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Ayy Ladies (feat. Tyga)",
    Artist: "Travis Porter",
    Album: "Ayy Ladies (feat. Tyga) - Single",
    Time: 213,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Bring It Back",
    Artist: "Travis Porter",
    Album: "Step Up Revolution",
    Time: 218,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "NO BYSTANDERS",
    Artist: "Travis Scott",
    Album: "ASTROWORLD",
    Time: 218,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "BUTTERFLY EFFECT",
    Artist: "Travis Scott",
    Album: "ASTROWORLD",
    Time: 190,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "HIGHEST IN THE ROOM",
    Artist: "Travis Scott",
    Album: "HIGHEST IN THE ROOM - Single",
    Time: 175,
    Year: 2019,
    Plays: 62,
  },
  {
    Name: "HIGHEST IN THE ROOM (REMIX) [feat. ROSALÍA & Lil Baby]",
    Artist: "Travis Scott",
    Album: "JACKBOYS",
    Time: 244,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Mamacita (feat. Rich Homie Quan & Young Thug)",
    Artist: "Travis Scott",
    Album: "Mamacita (feat. Rich Homie Quan & Young Thug) - Single",
    Time: 274,
    Year: 2014,
    Plays: 35,
  },
  {
    Name: "Pornography",
    Artist: "Travis Scott",
    Album: "Rodeo (Expanded Edition)",
    Time: 231,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "90210 (feat. Kacy Hill)",
    Artist: "Travis Scott",
    Album: "Rodeo (Expanded Edition)",
    Time: 339,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Nightcrawler (feat. Swae Lee & Chief Keef)",
    Artist: "Travis Scott",
    Album: "Rodeo (Expanded Edition)",
    Time: 321,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Antidote",
    Artist: "Travis Scott",
    Album: "Rodeo (Expanded Edition)",
    Time: 262,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Don't Stop the Music",
    Artist: "The Treblemakers",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 185,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Let It Whip",
    Artist: "The Treblemakers",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 141,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Right Round (feat. My Name Is Kay)",
    Artist: "The Treblemakers",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 197,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Trebles Finals: Bright Lights Bigger City/Magic",
    Artist: "The Treblemakers",
    Album:
      "Pitch Perfect (Original Motion Picture Soundtrack) [Special Edition]",
    Time: 154,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Bottoms Up (feat. Nicki Minaj)",
    Artist: "Trey Songz",
    Album: "Passion, Pain & Pleasure (Deluxe Version)",
    Time: 242,
    Year: 2010,
    Plays: 32,
  },
  {
    Name: "Mac 10 (feat. Lil Baby & Lil Duke)",
    Artist: "Trippie Redd",
    Album: "!",
    Time: 127,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Until the World Goes Cold",
    Artist: "Trivium",
    Album: "Silence In the Snow (Special Edition)",
    Time: 321,
    Year: 2015,
    Plays: 4,
  },
  {
    Name: "Bleed into Me",
    Artist: "Trivium",
    Album: "What the Dead Men Say",
    Time: 228,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Ojuju",
    Artist: "Troniq Music & Oxlade",
    Album: "Eclipse - EP",
    Time: 187,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "Bet On It",
    Artist: "Troy",
    Album: "High School Musical 2 (Original Soundtrack)",
    Time: 198,
    Year: 2007,
    Plays: 16,
  },
  {
    Name: 'Breaking Free (From "High School Musical")',
    Artist: "Troy & Gabriella",
    Album: "Sing Your Heart Out Disney",
    Time: 207,
    Year: 2006,
    Plays: 3,
  },
  {
    Name: "Giants (feat. SOYEON, DUCKWRTH, Thutmose & League of Legends)",
    Artist: "True Damage, Becky G. & Keke Palmer",
    Album:
      "Giants (feat. SOYEON, DUCKWRTH, Thutmose & League of Legends) - Single",
    Time: 191,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Naitu",
    Artist: "Turmion Kätilöt",
    Album: "Global Warning",
    Time: 251,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Stressed Out",
    Artist: "twenty one pilots",
    Album: "Blurryface",
    Time: 202,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Shy Away",
    Artist: "twenty one pilots",
    Album: "Scaled And Icy",
    Time: 175,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Heathens",
    Artist: "twenty one pilots",
    Album: "Suicide Squad: The Album (Collector's Edition)",
    Time: 195,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Jumpsuit",
    Artist: "twenty one pilots",
    Album: "Trench",
    Time: 238,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Chlorine",
    Artist: "twenty one pilots",
    Album: "Trench",
    Time: 324,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Bandito",
    Artist: "twenty one pilots",
    Album: "Trench",
    Time: 330,
    Year: 2018,
    Plays: 43,
  },
  {
    Name: "True Vengeance",
    Artist: "Twisted Jukebox",
    Album: "Allegiance",
    Time: 141,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Alive",
    Artist: "Twisted Jukebox",
    Album: "Rise Up",
    Time: 190,
    Year: 2019,
    Plays: 13,
  },
  {
    Name: "Grand Finale",
    Artist: "Twisted Jukebox & Dmitriy Mityukhin",
    Album: "Domination",
    Time: 143,
    Year: 2019,
    Plays: 17,
  },
  {
    Name: "Atlas",
    Artist: "Twisted Jukebox & Michael Emmerson",
    Album: "Life In Motion",
    Time: 260,
    Year: 2019,
    Plays: 7,
  },
  {
    Name: "Archangel",
    Artist: "Two Steps From Hell",
    Album: "Archangel",
    Time: 154,
    Year: 2011,
    Plays: 172,
  },
  {
    Name: "Strength of a Thousand Men",
    Artist: "Two Steps From Hell",
    Album: "Archangel",
    Time: 136,
    Year: 2011,
    Plays: 54,
  },
  {
    Name: "Norwegian Pirate",
    Artist: "Two Steps From Hell",
    Album: "Archangel",
    Time: 179,
    Year: 2011,
    Plays: 38,
  },
  {
    Name: "Victory",
    Artist: "Two Steps From Hell",
    Album: "Battlecry",
    Time: 320,
    Year: 2015,
    Plays: 56,
  },
  {
    Name: "Star Sky",
    Artist: "Two Steps From Hell",
    Album: "Battlecry",
    Time: 330,
    Year: 2015,
    Plays: 100,
  },
  {
    Name: "Sons of War",
    Artist: "Two Steps From Hell",
    Album: "Classics, Vol. 1",
    Time: 117,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "A Hole in the Sun",
    Artist: "Two Steps From Hell",
    Album: "Illumina Anthology",
    Time: 214,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Freedom Fighters",
    Artist: "Two Steps From Hell",
    Album: "Invincible",
    Time: 151,
    Year: 2010,
    Plays: 57,
  },
  {
    Name: "Heart of Courage",
    Artist: "Two Steps From Hell",
    Album: "Invincible",
    Time: 117,
    Year: 2010,
    Plays: 13,
  },
  {
    Name: "Protectors of the Earth",
    Artist: "Two Steps From Hell",
    Album: "Invincible",
    Time: 169,
    Year: 2010,
    Plays: 295,
  },
  {
    Name: "To Glory",
    Artist: "Two Steps From Hell",
    Album: "Invincible",
    Time: 275,
    Year: 2010,
    Plays: 93,
  },
  {
    Name: "Blackheart",
    Artist: "Two Steps From Hell",
    Album: "SkyWorld",
    Time: 266,
    Year: 2012,
    Plays: 27,
  },
  {
    Name: "Impossible (feat. Merethe Soltvedt)",
    Artist: "Two Steps From Hell",
    Album: "Unleashed",
    Time: 534,
    Year: 2017,
    Plays: 72,
  },
  {
    Name: "Wild Heart (feat. Felicia Farerre)",
    Artist: "Two Steps From Hell",
    Album: "Unleashed",
    Time: 219,
    Year: 2017,
    Plays: 15,
  },
  {
    Name: "Final Days of Rome (feat. Felicia Farerre)",
    Artist: "Two Steps From Hell",
    Album: "Unleashed",
    Time: 197,
    Year: 2017,
    Plays: 16,
  },
  {
    Name: "Emblem (feat. Felicia Farerre & Uyanga Bold)",
    Artist: "Two Steps From Hell",
    Album: "Unleashed",
    Time: 220,
    Year: 2017,
    Plays: 21,
  },
  {
    Name: "See Me Fight (feat. Linea Adamson)",
    Artist: "Two Steps From Hell",
    Album: "Unleashed",
    Time: 334,
    Year: 2017,
    Plays: 215,
  },
  {
    Name: "Aeterna",
    Artist: "Two Steps From Hell & Michal Cielecki",
    Album: "Orion",
    Time: 240,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Orion",
    Artist: "Two Steps From Hell & Michal Cielecki",
    Album: "Orion",
    Time: 488,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Battle At Hoback",
    Artist: "Two Steps From Hell & Nick Phoenix",
    Album: "Colin Frake On Fire Mountain",
    Time: 200,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Riders of the Apocalypse",
    Artist: "Two Steps From Hell & Nick Phoenix",
    Album: "Dragon",
    Time: 172,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Unbreakable",
    Artist: "Two Steps From Hell & Thomas Bergersen",
    Album: "Dragon",
    Time: 256,
    Year: 2019,
    Plays: 66,
  },
  {
    Name: "Bravestone",
    Artist: "Two Steps From Hell & Thomas Bergersen",
    Album: "Dragon",
    Time: 197,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "What Can I Do",
    Artist: "Tye Tribbett",
    Album: "Greater Than",
    Time: 463,
    Year: 2013,
    Plays: 36,
  },
  {
    Name: "Calories",
    Artist: "Tyler Cassidy",
    Album: "Calories - Single",
    Time: 102,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "I Can Fuxk You Better",
    Artist: "Tyler Cassidy",
    Album: "I Can Fuxk You Better - Single",
    Time: 181,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Fairy Jar",
    Artist: "Tyler Clark & HalaCG",
    Album: "Fairy Jar - Single",
    Time: 230,
    Year: 2022,
    Plays: 3,
  },
  {
    Name: "Guardian Angel",
    Artist: "Tyler James Williams & Coco Jones",
    Album: "Let It Shine (Music from the Original Movie)",
    Time: 222,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Don't Run Away",
    Artist: "Tyler James Williams Feat. IM5",
    Album: "Let It Shine (Music from the Original Movie)",
    Time: 176,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "The Scientist",
    Artist: "Tyler Ward, Kina Grannis & Lindsey Stirling",
    Album: "Tyler Ward Covers, Vol. 5",
    Time: 276,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "BEST INTEREST",
    Artist: "Tyler, The Creator",
    Album: "BEST INTEREST - Single",
    Time: 127,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Goblin",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 408,
    Year: 2011,
    Plays: 6,
  },
  {
    Name: "Yonkers",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 249,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "Radicals",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 438,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "She",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 253,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Transylvania",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 192,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Nightmare",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 322,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Tron Cat",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 253,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Her",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 211,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Sandwitches",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 291,
    Year: 2011,
    Plays: 7,
  },
  {
    Name: "Fish/Boppin Bitch",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 379,
    Year: 2011,
    Plays: 5,
  },
  {
    Name: "Analog",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 174,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Bitch Suck Dick",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 216,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Window",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 480,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "AU79",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 220,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Golden",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 343,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Burger",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 229,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Untitled 63",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 66,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Steak Sauce",
    Artist: "Tyler, the Creator",
    Album: "Goblin",
    Time: 202,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Wolf",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 110,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Jamba ft Hodgy Beats",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 212,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Cowboy",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 195,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Awkward",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 227,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Domo23",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 161,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Answer",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 230,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Slater ft Frank Ocean",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 233,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "48",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 247,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Colossus",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 213,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "PartyIsntOver/ Campfire/ Bimmer ft Laetitia Sadier & Frank Ocean",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 438,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "IFHY ft Pharrell",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 320,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Pigs",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 253,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Parking Lot ft Casey Veggies & Mike G",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 234,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Rusty ft Domo Genesis & Earl Sweatshirt",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 310,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Trashwang ft Na'kel, Jasper, Lucas, L-Boy, Taco, Left Brain & Lee Spielman",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 281,
    Year: 2013,
    Plays: 13,
  },
  {
    Name: "Treehome95 ft Coco O. & Erykah Badu",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 181,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Tamale",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 166,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Lone",
    Artist: "Tyler, The Creator",
    Album: "Wolf",
    Time: 236,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Lamba",
    Artist: "Uchaylee & MohBad",
    Album: "Lamba - Single",
    Time: 160,
    Year: 2020,
    Plays: 9,
  },
  {
    Name: "Kill Yourself (Pt. II)",
    Artist: "$uicideboy$",
    Album: "Gray/Grey",
    Time: 446,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Kill Yourself",
    Artist: "$uicideboy$",
    Album: "KILL YOURSELF Part I: The $uicide Saga - EP",
    Time: 174,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Kill Yourself (Part III)",
    Artist: "$uicideboy$",
    Album: "My Liver Will Handle What My Heart Can't",
    Time: 145,
    Year: 2015,
    Plays: 65,
  },
  {
    Name: "Ti Amo",
    Artist: "Umberto Tozzi",
    Album: "E' nell' aria…ti amo",
    Time: 245,
    Year: 1977,
    Plays: 4,
  },
  {
    Name: "It Has To Start Somewhere",
    Artist: "Underoath",
    Album: "Erase Me",
    Time: 191,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "I Gave Up",
    Artist: "Underoath",
    Album: "Erase Me",
    Time: 242,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Here Comes the Night",
    Artist: "Unions",
    Album: "Here Comes the Night - Single",
    Time: 208,
    Year: 2019,
    Plays: 4,
  },
  {
    Name: "Bury",
    Artist: "Unions",
    Album: "Unions - EP",
    Time: 209,
    Year: 2016,
    Plays: 41,
  },
  {
    Name: "Addicted To You (feat. Anna Mae)",
    Artist: "UNSECRET",
    Album: "Addicted To You (feat. Anna Mae) - Single",
    Time: 170,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "Welcome To Your Nightmare",
    Artist: "UNSECRET & MAYLYN",
    Album: "Welcome To Your Nightmare - Single",
    Time: 222,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Look What We Started",
    Artist: "UNSECRET & Rayelle",
    Album: "Look What We Started - Single",
    Time: 234,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Self Medicated",
    Artist: "Until I Wake",
    Album: "Until I Wake - EP",
    Time: 189,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Girl, You'll Be a Woman Soon",
    Artist: "Urge Overkill",
    Album: "Stull - EP",
    Time: 189,
    Year: 1992,
    Plays: 2,
  },
  {
    Name: "Lovers Death",
    Artist: "Ursine Vulpine & Annaca",
    Album: "Solace - EP",
    Time: 347,
    Year: 2019,
    Plays: 29,
  },
  {
    Name: "Yeah! (feat. Lil Jon & Ludacris)",
    Artist: "Usher",
    Album: "Confessions (Expanded Edition)",
    Time: 250,
    Year: 2004,
    Plays: 2,
  },
  {
    Name: "Deeper (feat. Lindsey Stirling)",
    Artist: "Valerie Broussard",
    Album: "Deeper (feat. Lindsey Stirling) - Single",
    Time: 185,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Killer",
    Artist: "Valerie Broussard",
    Album: "Killer - Single",
    Time: 150,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Banshee (feat. Yosh)",
    Artist: "Valiant Hearts",
    Album: "Banshee (feat. Yosh) - Single",
    Time: 229,
    Year: 2021,
    Plays: 6,
  },
  {
    Name: "Inside of Me (feat. Chris Motionless)",
    Artist: "VAMPS",
    Album: "Inside of Me - Single",
    Time: 207,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Role Play",
    Artist: "Vanish",
    Album: "Familiar Faces",
    Time: 197,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "She's So Gone",
    Artist: "Various Artists",
    Album: "Lemonade Mouth",
    Time: 186,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "One Last Night",
    Artist: "Vaults",
    Album: "Fifty Shades of Grey",
    Time: 199,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Early Momo (feat. GoodGirl LA)",
    Artist: "Vector",
    Album: "Early Momo (feat. GoodGirl LA) - Single",
    Time: 193,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Epic (feat. Amalien)",
    Artist: "The Veer Union",
    Album: "Decade II: Rock & Acoustic",
    Time: 237,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Nightmare",
    Artist: "Veracity",
    Album: "",
    Time: 225,
    Year: null,
    Plays: 37,
  },
  {
    Name: "The Bidding",
    Artist: "Victims",
    Album: "The Hell in My Veins - EP",
    Time: 210,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Relief",
    Artist: "Victims",
    Album: "The Hell in My Veins - EP",
    Time: 175,
    Year: 2019,
    Plays: 55,
  },
  {
    Name: "Kolomental",
    Artist: "Victony",
    Album: "Outlaw",
    Time: 197,
    Year: 2022,
    Plays: 9,
  },
  {
    Name: "Jó Riddim",
    Artist: "Victony",
    Album: "Saturn - EP",
    Time: 150,
    Year: 2020,
    Plays: 63,
  },
  {
    Name: "Decay (Reimagined)",
    Artist: "Villain of the Story",
    Album: "Alone in the Dark - EP",
    Time: 241,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Peace of Mind (Acoustic)",
    Artist: "Villain of the Story",
    Album: "Alone in the Dark - EP",
    Time: 246,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Peace of Mind (Acoustic) [Instrumental]",
    Artist: "Villain of the Story",
    Album: "Alone in the Dark - EP",
    Time: 246,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Home",
    Artist: "Vince Staples",
    Album:
      "Spider-Man: Into the Spider-Verse (Soundtrack From & Inspired by the Motion Picture)",
    Time: 211,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "Rise from the Ashes",
    Artist: "Visionatica",
    Album: "Enigma Fire",
    Time: 334,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Avant toi",
    Artist: "Vitaa & Slimane",
    Album: "VersuS",
    Time: 223,
    Year: 2019,
    Plays: 9,
  },
  {
    Name: "The Devil's Bleeding Crown",
    Artist: "Volbeat",
    Album: "Seal the Deal & Let's Boogie (Deluxe)",
    Time: 238,
    Year: 2016,
    Plays: 20,
  },
  {
    Name: "Wait A Minute My Girl",
    Artist: "Volbeat",
    Album: "Wait A Minute My Girl / Dagen Før - Single",
    Time: 140,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Dagen Før (feat. Stine Bramsen)",
    Artist: "Volbeat",
    Album: "Wait A Minute My Girl / Dagen Før - Single",
    Time: 249,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Gravity",
    Artist: "Wage War",
    Album: "Deadweight",
    Time: 231,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "No Smoke",
    Artist: "wahterboi",
    Album: "No Smoke - Single",
    Time: 113,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "No Hands (feat. Roscoe Dash & Wale)",
    Artist: "Waka Flocka Flame",
    Album: "Flockaveli",
    Time: 262,
    Year: 2010,
    Plays: 34,
  },
  {
    Name: "Grove St. Party (feat. Kebo Gotti)",
    Artist: "Waka Flocka Flame",
    Album: "Flockaveli",
    Time: 250,
    Year: 2010,
    Plays: 2,
  },
  {
    Name: "Are You Listening",
    Artist: "Wake Me",
    Album: "Are You Listening - Single",
    Time: 232,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Blood Moon",
    Artist: "Wake Me",
    Album: "Blood Moon - Single",
    Time: 214,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "The Kick",
    Artist: "Wande Coal",
    Album: "Best of Wande Coal",
    Time: 240,
    Year: 2013,
    Plays: 6,
  },
  {
    Name: "Who Born the Maga",
    Artist: "Wande Coal",
    Album: "Best of Wande Coal",
    Time: 185,
    Year: 2010,
    Plays: 15,
  },
  {
    Name: "You Bad",
    Artist: "Wande Coal",
    Album: "Best of Wande Coal",
    Time: 243,
    Year: 2010,
    Plays: 6,
  },
  {
    Name: "Bumper 2 Bumper",
    Artist: "Wande Coal",
    Album: "Bright Lights City Lights, Vol. 7",
    Time: 225,
    Year: 2018,
    Plays: 26,
  },
  {
    Name: "Slippin' Into Darkness",
    Artist: "War",
    Album: "The Very Best of War",
    Time: 227,
    Year: 1976,
    Plays: null,
  },
  {
    Name: "Mortals",
    Artist: "Warriyo",
    Album: "Mortals - Single",
    Time: 228,
    Year: 2016,
    Plays: 18,
  },
  {
    Name: "Electroman Adventures V2",
    Artist: "Waterflame",
    Album: "Community Favorites",
    Time: 238,
    Year: 2015,
    Plays: 27,
  },
  {
    Name: "Eye of the Storm Reborn",
    Artist: "Watt White",
    Album: "Eye of the Storm Reborn - Single",
    Time: 236,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Eye of the Storm",
    Artist: "WattWhite",
    Album: "",
    Time: 201,
    Year: null,
    Plays: 8,
  },
  {
    Name: "Bury Me Alive",
    Artist: "We Are the Fallen",
    Album: "Tear the World Down",
    Time: 286,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Sleep Well, My Angel",
    Artist: "We Are the Fallen",
    Album: "Tear the World Down",
    Time: 247,
    Year: 2010,
    Plays: 1,
  },
  {
    Name: "Cold Like War",
    Artist: "We Came As Romans",
    Album: "Cold Like War",
    Time: 226,
    Year: 2017,
    Plays: 7,
  },
  {
    Name: "I Knew You Were Trouble",
    Artist: "We Came As Romans",
    Album: "Punk Goes Pop, Vol. 6",
    Time: 218,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "The World I Used To Know",
    Artist: "We Came As Romans",
    Album: "We Came As Romans",
    Time: 194,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Alone Again",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 250,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Too Late",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 239,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Hardest To Love",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 211,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Scared To Live",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 191,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Snowchild",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 247,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Escape From LA",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 355,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "Heartless",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 198,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Faith",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 283,
    Year: 2020,
    Plays: 18,
  },
  {
    Name: "Blinding Lights",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 200,
    Year: 2019,
    Plays: 18,
  },
  {
    Name: "In Your Eyes",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 237,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Save Your Tears",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 215,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Repeat After Me (Interlude)",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 195,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "After Hours",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 361,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Until I Bleed Out",
    Artist: "The Weeknd",
    Album: "After Hours",
    Time: 190,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Heartless",
    Artist: "The Weeknd",
    Album: "After Hours (Deluxe)",
    Time: 198,
    Year: 2019,
    Plays: 3,
  },
  {
    Name: "The Hills",
    Artist: "The Weeknd",
    Album: "Beauty Behind the Madness",
    Time: 242,
    Year: 2015,
    Plays: 49,
  },
  {
    Name: "Earned It (Fifty Shades of Grey)",
    Artist: "The Weeknd",
    Album: "Fifty Shades of Grey",
    Time: 250,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Where You Belong",
    Artist: "The Weeknd",
    Album: "Fifty Shades of Grey",
    Time: 297,
    Year: 2015,
    Plays: 2,
  },
  {
    Name: "Wicked Games (Original)",
    Artist: "The Weeknd",
    Album: "House of Balloons (Original)",
    Time: 325,
    Year: 2011,
    Plays: 15,
  },
  {
    Name: "Professional",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 368,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "The Town",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 307,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Adaptation",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 283,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Love In the Sky",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 267,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Belong To the World",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 307,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Live For (feat. Drake)",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 224,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Wanderlust",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 306,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Kiss Land",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 455,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Pretty",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 375,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Tears In the Rain",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 446,
    Year: 2013,
    Plays: 17,
  },
  {
    Name: "Wanderlust (Pharrell Remix)",
    Artist: "The Weeknd",
    Album: "Kiss Land (Deluxe)",
    Time: 307,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Starboy (feat. Daft Punk)",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 230,
    Year: 2016,
    Plays: 41,
  },
  {
    Name: "Party Monster",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 249,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "False Alarm",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 220,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Reminder",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 218,
    Year: 2016,
    Plays: 17,
  },
  {
    Name: "Rockin’",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 232,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Secrets",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 265,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "True Colors",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 206,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Stargirl Interlude (feat. Lana Del Rey)",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 111,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Sidewalks (feat. Kendrick Lamar)",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 231,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Six Feet Under",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 237,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Love To Lay",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 223,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "A Lonely Night",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 220,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Attention",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 197,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Ordinary Life",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 221,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Nothing Without You",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 198,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "All I Know (feat. Future)",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 321,
    Year: 2016,
    Plays: 23,
  },
  {
    Name: "Die For You",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 260,
    Year: 2016,
    Plays: 16,
  },
  {
    Name: "I Feel It Coming (feat. Daft Punk)",
    Artist: "The Weeknd",
    Album: "Starboy",
    Time: 269,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "The Knowing",
    Artist: "The Weeknd",
    Album: "Trilogy",
    Time: 341,
    Year: 2011,
    Plays: 11,
  },
  {
    Name: "Next",
    Artist: "The Weeknd",
    Album: "Trilogy",
    Time: 360,
    Year: 2011,
    Plays: 10,
  },
  {
    Name: "Echoes of Silence",
    Artist: "The Weeknd",
    Album: "Trilogy",
    Time: 242,
    Year: 2011,
    Plays: 17,
  },
  {
    Name: "Till Dawn (Here Comes the Sun)",
    Artist: "The Weeknd",
    Album: "Trilogy",
    Time: 319,
    Year: 2011,
    Plays: 17,
  },
  {
    Name: "Beginning Of The End (Wyld Stallyns Edit)",
    Artist: "Weezer",
    Album: "Bill & Ted Face The Music (Original Motion Picture Soundtrack)",
    Time: 207,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Ijoya",
    Artist: "Weird MC",
    Album: "Ijoya - Single",
    Time: 215,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Kpakujemu (feat. Olamide, Lyta, Terri & Barry Jhay)",
    Artist: "WestSyde",
    Album: "Kpakujemu (feat. Olamide, Lyta, Terri & Barry Jhay) - Single",
    Time: 220,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Hurricane",
    Artist: "While She Sleeps",
    Album: "You Are We",
    Time: 283,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Father Song",
    Artist: "Wilfresh",
    Album: "Wilfresh",
    Time: 217,
    Year: 2018,
    Plays: 13,
  },
  {
    Name: "Esta Noche Lo Vamos a Hacer",
    Artist: "Wisin",
    Album: "Victory",
    Time: 240,
    Year: 2017,
    Plays: 20,
  },
  {
    Name: "Vacaciones",
    Artist: "Wisin",
    Album: "Victory",
    Time: 238,
    Year: 2016,
    Plays: 6,
  },
  {
    Name: "Escápate Conmigo (feat. Ozuna)",
    Artist: "Wisin",
    Album: "Victory",
    Time: 232,
    Year: 2017,
    Plays: 113,
  },
  {
    Name: "Nota de Amor (feat. Daddy Yankee)",
    Artist: "Wisin & Carlos Vives",
    Album: "Los Vaqueros: La Trilogía",
    Time: 232,
    Year: 2015,
    Plays: 8,
  },
  {
    Name: "Algo Me Gusta de Ti (feat. Chris Brown & T-pain)",
    Artist: "Wisin & Yandel",
    Album: "Líderes",
    Time: 275,
    Year: 2012,
    Plays: 14,
  },
  {
    Name: "Our Solemn Hour",
    Artist: "Within Temptation",
    Album: "The Heart of Everything",
    Time: 257,
    Year: 2007,
    Plays: 37,
  },
  {
    Name: "Let Us Burn",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 331,
    Year: 2014,
    Plays: 11,
  },
  {
    Name: "Dangerous (feat. Howard Jones)",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 293,
    Year: 2013,
    Plays: 27,
  },
  {
    Name: "And We Run (feat. Xzibit)",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 230,
    Year: 2014,
    Plays: 761,
  },
  {
    Name: "Paradise (What About Us?) [feat. Tarja]",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 319,
    Year: 2013,
    Plays: 35,
  },
  {
    Name: "Edge of the World",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 295,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Silver Moonlight",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 316,
    Year: 2014,
    Plays: 6,
  },
  {
    Name: "Covered By Roses",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 287,
    Year: 2014,
    Plays: 13,
  },
  {
    Name: "Covered By Roses",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 287,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Dog Days",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 287,
    Year: 2014,
    Plays: 19,
  },
  {
    Name: "Tell Me Why",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 372,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Tell Me Why",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 372,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Whole World Is Watching (feat. Dave Pirner)",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 243,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Radioactive",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 193,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Summertime Sadness",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 245,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Let Her Go",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 223,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "Dirty Dancer",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 254,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "And We Run (feat. Xzibit) [Evolution Track]",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 341,
    Year: 2014,
    Plays: 8,
  },
  {
    Name: "Silver Moonlight (Evolution Track)",
    Artist: "Within Temptation",
    Album: "Hydra (Deluxe Edition)",
    Time: 365,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Iron (Elements Live in Concert)",
    Artist: "Within Temptation",
    Album: "Let Us Burn: Elements & Hydra Live in Concert",
    Time: 344,
    Year: 2014,
    Plays: 11,
  },
  {
    Name: "The Reckoning (feat. Jacoby Shaddix)",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 251,
    Year: 2018,
    Plays: 209,
  },
  {
    Name: "Endless War",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 249,
    Year: 2018,
    Plays: 161,
  },
  {
    Name: "Raise Your Banner (feat. Anders Fridén)",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 334,
    Year: 2018,
    Plays: 184,
  },
  {
    Name: "Supernova",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 335,
    Year: 2018,
    Plays: 155,
  },
  {
    Name: "Holy Ground",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 250,
    Year: 2018,
    Plays: 19,
  },
  {
    Name: "In Vain",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 265,
    Year: 2018,
    Plays: 27,
  },
  {
    Name: "Firelight (feat. Jasper Steverlinck)",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 287,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Mad World",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 297,
    Year: 2018,
    Plays: 148,
  },
  {
    Name: "Mercy Mirror",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 229,
    Year: 2018,
    Plays: 157,
  },
  {
    Name: "Trophy Hunter",
    Artist: "Within Temptation",
    Album: "Resist (Extended Deluxe)",
    Time: 351,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "The Purge",
    Artist: "Within Temptation",
    Album: "Shed My Skin - EP",
    Time: 256,
    Year: 2020,
    Plays: 13,
  },
  {
    Name: "Entertain You",
    Artist: "Within Temptation",
    Album: "Shed My Skin - EP",
    Time: 211,
    Year: 2020,
    Plays: 123,
  },
  {
    Name: "Angels",
    Artist: "Within Temptation",
    Album: "The Silent Force",
    Time: 240,
    Year: 2004,
    Plays: 43,
  },
  {
    Name: "Aquarius",
    Artist: "Within Temptation",
    Album: "The Silent Force",
    Time: 286,
    Year: 2004,
    Plays: 1,
  },
  {
    Name: "Shot in the Dark",
    Artist: "Within Temptation",
    Album: "The Unforgiving",
    Time: 302,
    Year: 2011,
    Plays: 7,
  },
  {
    Name: "Iron",
    Artist: "Within Temptation",
    Album: "The Unforgiving",
    Time: 341,
    Year: 2011,
    Plays: 23,
  },
  {
    Name: "Paradise (What About Us?) [feat. Tarja]",
    Artist: "Within Temptation",
    Album: "",
    Time: 348,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Shed My Skin",
    Artist: "Within Temptation & Annisokay",
    Album: "Shed My Skin - EP",
    Time: 270,
    Year: 2021,
    Plays: 24,
  },
  {
    Name: "Look What I Got On",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 212,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "The Plug (feat. Berner)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 268,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Old Chanel (feat. Smoke DZA)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 268,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Look Into My Eyes",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 219,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "U.O.E.N.O. (feat. Rocko and Future)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 273,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Smoke A N*gga (feat. Juicy J)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 268,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "All I Know (feat. Big Sean)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 202,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Office Hours (Interlude)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 71,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Paradise (feat. Cassie)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 238,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Everything Is Good (feat. Juelz Santana)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 198,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Ground Up (feat. Domo Genesis)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 242,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Talkin' Bout (feat. Juicy J and Chris Brown)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 261,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Kush Do (feat. Rockie Fresh)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 235,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Shootin (feat. Juicy J)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 229,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Smokin' On A Doob (Interlude)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 127,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Karate Chop (Remix)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 131,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Fighter Jet (feat. Caligula)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 245,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "OZs and Lbs (feat. Chevy Woods and Berner)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 321,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Hella Dope (Interlude)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 110,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Drop Bands On It (feat. Mally Mall, Tyga and Fresh)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 221,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "She Said (feat. Tuki Carter)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 240,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Like Whaaat (Remix) (feat. Problem, Chris Brown, Tyga and Master P)",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 311,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "I Bet (feat. Ty Dolla )",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 225,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Away We Go (feat. D-Bomb and Majorino) [Bonus]",
    Artist: "Wiz Khalifa",
    Album: "Blacc Hollywood: The Mixtape",
    Time: 252,
    Year: 2013,
    Plays: null,
  },
  {
    Name: 'See You Again (feat. Charlie Puth) [From "Furious 7"]',
    Artist: "Wiz Khalifa",
    Album: "Nine Track Mind",
    Time: 230,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "When I'm Gone",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 248,
    Year: null,
    Plays: 4,
  },
  {
    Name: "On My Level (feat. Too $Hort)",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 272,
    Year: null,
    Plays: 3,
  },
  {
    Name: "Black and Yellow",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 217,
    Year: null,
    Plays: null,
  },
  {
    Name: "Roll Up",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 227,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Hopes & Dreams",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 238,
    Year: null,
    Plays: 1,
  },
  {
    Name: "Wake Up",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 226,
    Year: null,
    Plays: 3,
  },
  {
    Name: "The Race",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 335,
    Year: null,
    Plays: null,
  },
  {
    Name: "Star of the Show (feat. Chevy Woods)",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 286,
    Year: null,
    Plays: 1,
  },
  {
    Name: "No Sleep",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 191,
    Year: null,
    Plays: 2,
  },
  {
    Name: "Get Your S**t",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 276,
    Year: null,
    Plays: null,
  },
  {
    Name: "Top Floor",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 222,
    Year: null,
    Plays: null,
  },
  {
    Name: "Fly Solo",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 200,
    Year: null,
    Plays: null,
  },
  {
    Name: "Rooftops (feat. Curren$y)",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 260,
    Year: null,
    Plays: null,
  },
  {
    Name: "Cameras",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 269,
    Year: null,
    Plays: null,
  },
  {
    Name: "Taylor Gang (Bonus Track)",
    Artist: "Wiz Khalifa",
    Album: "Rolling Papers",
    Time: 335,
    Year: null,
    Plays: 2,
  },
  {
    Name: "Essence (feat. Tems)",
    Artist: "Wizkid",
    Album: "Made In Lagos",
    Time: 249,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Daddy Yo",
    Artist: "Wizkid",
    Album: "Sounds From the Other Side",
    Time: 160,
    Year: 2017,
    Plays: 9,
  },
  {
    Name: "Run Boy Run",
    Artist: "Woodkid",
    Album: "Run Boy Run - EP",
    Time: 213,
    Year: 2012,
    Plays: 7,
  },
  {
    Name: "SEARCHING FOR GLORY",
    Artist: "The Word Alive",
    Album: "MONOMANIA",
    Time: 216,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Why Am I Like This?",
    Artist: "The Word Alive",
    Album: "Violent Noise",
    Time: 193,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Wonderland",
    Artist: "The Word Alive",
    Album: "Wonderland - Single",
    Time: 197,
    Year: 2021,
    Plays: 10,
  },
  {
    Name: "All Rise",
    Artist: "Wovenwar",
    Album: "Wovenwar",
    Time: 216,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Eivol",
    Artist: "Writing the Future",
    Album: "Eivol - Single",
    Time: 215,
    Year: 2018,
    Plays: 4,
  },
  {
    Name: "Follow Me",
    Artist: "Written by Wolves",
    Album: "Follow Me - Single",
    Time: 210,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "Oxygen",
    Artist: "Written by Wolves",
    Album: "Oxygen - Single",
    Time: 237,
    Year: 2018,
    Plays: 25,
  },
  {
    Name: "Secrets",
    Artist: "Written by Wolves",
    Album: "Secrets - Single",
    Time: 237,
    Year: 2019,
    Plays: 5,
  },
  {
    Name: "To Tell You the Truth",
    Artist: "Written by Wolves",
    Album: "To Tell You the Truth / Starlight - Single",
    Time: 340,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Starlight",
    Artist: "Written by Wolves",
    Album: "To Tell You the Truth / Starlight - Single",
    Time: 227,
    Year: 2017,
    Plays: null,
  },
  {
    Name: "Diallo (feat. Youssou N'Dour & MB2)",
    Artist: "Wyclef Jean",
    Album: "The Ecleftic -2 Sides II A Book",
    Time: 442,
    Year: 2000,
    Plays: 11,
  },
  {
    Name: "Unsteady (Erich Lee Gravity Remix)",
    Artist: "X Ambassadors",
    Album: "Heartbreak",
    Time: 204,
    Year: 2016,
    Plays: 8,
  },
  {
    Name: "Stranger",
    Artist: "X Ambassadors",
    Album: "Love Songs Drug Songs - EP",
    Time: 243,
    Year: 2013,
    Plays: 7,
  },
  {
    Name: "HEY CHILD",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 208,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "CONFIDENCE (feat. K.Flay)",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 173,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "QUICKSAND",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 189,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "BOOM",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 164,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "RULE",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 205,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "HISTORY",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 257,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "RECOVER",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 212,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "WASTELAND",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 188,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "SHADOWS",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 194,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "I DON’T KNOW HOW TO PRAY",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 133,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "HOLD YOU DOWN",
    Artist: "X Ambassadors",
    Album: "ORION",
    Time: 197,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Jungle (Remix) [feat. JAY Z]",
    Artist: "X Ambassadors & Jamie N Commons",
    Album: "Jungle (Remix) [feat. JAY Z] - Single",
    Time: 207,
    Year: 2014,
    Plays: 18,
  },
  {
    Name: "The Greatest Love Song",
    Artist: "Xerona",
    Album: "The Men's Club Original Soundtrack",
    Time: 276,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "Animal",
    Artist: "XOV",
    Album:
      "The Hunger Games: Mockingjay, Pt. 1 (Original Motion Picture Soundtrack)",
    Time: 198,
    Year: 2014,
    Plays: 4,
  },
  {
    Name: "Look At Me!",
    Artist: "XXXTENTACION",
    Album: "Revenge",
    Time: 126,
    Year: 2015,
    Plays: 8,
  },
  {
    Name: "YuNg BrAtZ",
    Artist: "XXXTENTACION",
    Album: "Revenge",
    Time: 101,
    Year: 2016,
    Plays: 17,
  },
  {
    Name: "BAD!",
    Artist: "XXXTENTACION",
    Album: "SKINS",
    Time: 94,
    Year: 2018,
    Plays: 47,
  },
  {
    Name: "Moonlight",
    Artist: "XXXTENTACION",
    Album: "?",
    Time: 135,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "SAD!",
    Artist: "XXXTENTACION",
    Album: "?",
    Time: 166,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "NUMB",
    Artist: "XXXTENTACION",
    Album: "?",
    Time: 186,
    Year: 2018,
    Plays: 5,
  },
  {
    Name: "changes",
    Artist: "XXXTENTACION",
    Album: "?",
    Time: 121,
    Year: 2018,
    Plays: 2,
  },
  {
    Name: "Little Do You Know Beat Cry",
    Artist: "Yagih Mael",
    Album: "Little Do You Know Beat Cry - Single",
    Time: 154,
    Year: 2020,
    Plays: 6,
  },
  {
    Name: "Mahoukyou no Tabibito",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 139,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Three Dragon Slayers",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 140,
    Year: 2011,
    Plays: 4,
  },
  {
    Name: "Shippuu Jinrai",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 125,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Hagane no Hakunetsusen",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 135,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Rengougun, Shuuketsu!",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 90,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Carla no Kokuhaku",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 154,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Oracion Seis Arawaru!",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 39,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Gun-yuu Aiutsu",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 131,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Midnight Mezameru",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 119,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Dokuryuu no Cobra",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 101,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Nirvana no Hikari",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 149,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Heikou Sekai Edolas",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 144,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Fuyuujima no Tami",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 104,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Mystogan's Theme",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 161,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Tenkuu no Miko",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 127,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Tsubasa Aru Mono",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 129,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Chou Akuukan Mahou Anima",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 93,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Exceeds",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 102,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Kieyuku Mahou",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 125,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Ice Boy",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 121,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Tenshi Senmetsu Sakusen",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 146,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Tenshi no Kunou",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 196,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Pantherlily",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 139,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Ryuusahou",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 129,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Gekitou Mahoujin",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 153,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Seirei Kassen",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 127,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Seigi no Chikara",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 127,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Erza vs. Erza",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 140,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Dragon Force",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 145,
    Year: 2011,
    Plays: 2,
  },
  {
    Name: "Inishie no Mahou",
    Artist: "Yasuharu Takanashi",
    Album: "Fairy Tail Original Soundtrack Vol.3",
    Time: 179,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Haruka Naru Chi",
    Artist: "Yasuharu Takanashi",
    Album: "Haruka Naru Chi - Single",
    Time: 158,
    Year: 2022,
    Plays: 4,
  },
  {
    Name: "Tabidachi no Jokyoku - Overture: Fairy Tail Main Theme -",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 151,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Houou no Mai",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 76,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Ake ni Somaru Mura",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 80,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Main Title",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 41,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Bucks Touzokudan",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 172,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Lucy Harikiru",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 111,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Guild e no Kikan",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 58,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Eclair no Kioku",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 76,
    Year: 2012,
    Plays: 4,
  },
  {
    Name: "Tabi no Nakama",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 61,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Mahou no Machi Rose Garden",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 210,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Kage no Shuugeki",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 79,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Tsuigeki! Natsu to Gray",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 92,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Karado no Yakata",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 61,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Nokosareta Kotoba",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 114,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Yoki Nakama",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 86,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Carbuncle Raishuu",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 157,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Futatsu no Hounouseki",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 99,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Eclair wo Sukue!",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 35,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Veronica Koujousen",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 157,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Kurushii Tatakai",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 146,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Gekitou no Hate",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 115,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Fukkatsu no Gishiki",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 75,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "Houou Fukkatsu",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 108,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Shukumei no Miko Eclair",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 124,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Natsu Vs. Dyst",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 87,
    Year: 2012,
    Plays: 15,
  },
  {
    Name: "Jashin wo Yaku Honoo",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 138,
    Year: 2012,
    Plays: 10,
  },
  {
    Name: "Houou Horobi no Chikara",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 181,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Shukumei wo Tatsu Ya",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 49,
    Year: 2012,
    Plays: 3,
  },
  {
    Name: "Eien no Eclair",
    Artist: "Yasuharu Takanashi",
    Album: 'Movie "Fairy Tail - Houou no Miko -" Original Soundtrack',
    Time: 152,
    Year: 2012,
    Plays: 2,
  },
  {
    Name: "Talkin",
    Artist: "YBN Nahmir",
    Album: "Talkin - Single",
    Time: 125,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "Balance",
    Artist: "Ycee",
    Album: "Balance - Single",
    Time: 207,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Jagaban (Remix) [feat. Olamide]",
    Artist: "Ycee",
    Album: "Jagaban (Remix) [feat. Olamide] - Single",
    Time: 252,
    Year: 2015,
    Plays: 49,
  },
  {
    Name: "Aunty Lovina (feat. Patoranking)",
    Artist: "Ycee",
    Album: "Love Drunk",
    Time: 240,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "Dada (feat. Dapo Tuburna)",
    Artist: "Ycee",
    Album: "Ycee Vs Zaheer",
    Time: 214,
    Year: 2019,
    Plays: 37,
  },
  {
    Name: "Outer Space",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 241,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Change",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 192,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "American You",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 212,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Whiskey In A Bottle",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 248,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Ball And Chain",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 95,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Till It's Gone",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 275,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Devil In My Veins",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 238,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Best Friend feat. Eminem",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 314,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Empty Bottles",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 257,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Heartbreak",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 265,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Tennessee Love",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 294,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Box Chevy V",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 209,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Love Story",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 253,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Johnny Cash",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 285,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Have A Great Flight",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 303,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Sky's The Limit",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 268,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Disappear",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 314,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Fiddle Me This",
    Artist: "Yelawolf",
    Album: "Love Story",
    Time: 225,
    Year: 2015,
    Plays: null,
  },
  {
    Name: "Pain (feat. Adam Vanhoose)",
    Artist: "Yellopain",
    Album: "I'm Still Here Because I Didn't Give Up",
    Time: 141,
    Year: 2018,
    Plays: 27,
  },
  {
    Name: "BIG BANK (feat. 2 Chainz, Big Sean & Nicki Minaj)",
    Artist: "YG",
    Album: "STAY DANGEROUS",
    Time: 237,
    Year: 2018,
    Plays: 10,
  },
  {
    Name: "River Flows In You",
    Artist: "Yiruma",
    Album: "Yiruma Official Album 'Yiruma The Best Winter'",
    Time: 188,
    Year: 2001,
    Plays: 15,
  },
  {
    Name: "Feel Like This",
    Artist: "YNG Martyr",
    Album: "Feel Like This - Single",
    Time: 174,
    Year: 2019,
    Plays: 18,
  },
  {
    Name: "Murder on My Mind",
    Artist: "YNW Melly",
    Album: "Murder on My Mind - Single",
    Time: 269,
    Year: 2017,
    Plays: 32,
  },
  {
    Name: "Errbody Remix",
    Artist: "Yo Gotti Ft. Lil Wayne & Ludacris",
    Album: "The Blend Specialist Mixtapes",
    Time: 219,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Where Is My Mind [Pixies cover] ",
    Artist: "Yoav [feat Emily Browning]",
    Album: "Sucker Punch",
    Time: 371,
    Year: 2011,
    Plays: 1,
  },
  {
    Name: "Ooouuu",
    Artist: "Young M.A",
    Album: "Herstory - EP",
    Time: 234,
    Year: 2016,
    Plays: 5,
  },
  {
    Name: "Shinjū",
    Artist: "Young Medicine",
    Album: "Interlinked",
    Time: 200,
    Year: 2019,
    Plays: 9,
  },
  {
    Name: "Simple and Clean",
    Artist: "Young Medicine",
    Album: "Simple and Clean - Single",
    Time: 209,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "We Alright",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 312,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Trophies",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 188,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Bang",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 250,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Senile",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 199,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Induction Speech",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 321,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "One Time",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 261,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Lookin Ass",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 161,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Fresher Than Ever",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 406,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Back It Up",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 214,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Moment",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 279,
    Year: 2014,
    Plays: 3,
  },
  {
    Name: "You Already Know",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 249,
    Year: 2014,
    Plays: 2,
  },
  {
    Name: "Catch Me At the Light",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 208,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Video Model",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 238,
    Year: 2014,
    Plays: 5,
  },
  {
    Name: "Good Day",
    Artist: "Young Money",
    Album: "Rise Of An Empire (Deluxe Version)",
    Time: 224,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "Gooder",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 266,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Every Girl  (Prod. By Tha Bizness)",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 313,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Ms. Parker (Prod. By Tha Bizness)",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 320,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Wife Beater (Prod. By Kane Beatz)",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 283,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "New Shit (Prod. By Chase N. Cashe & B.Carr)",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 211,
    Year: 2009,
    Plays: 44,
  },
  {
    Name: "Play In My Band",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 248,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Girl I Got You",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 199,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Roger That",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 209,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Streets Is Watchin' (Prod. By David Banner)",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 221,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Finale",
    Artist: "Young Money",
    Album: "We Are Young Money",
    Time: 322,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "Lets Go Crazy BONUS",
    Artist: "Young Money (Lil Wayne, T-Streets, Shanell, And Mack Maine)",
    Album: "No Ceilings",
    Time: 256,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "In Da Club (feat. ItsLitBoi)",
    Artist: "Young Money & DanteOnTheBeat",
    Album: "In Da Club (feat. ItsLitBoi) - Single",
    Time: 126,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Fuck Da Bulls ",
    Artist: "Young Money Ft. Birdman",
    Album: "We Are Young Money",
    Time: 187,
    Year: 2009,
    Plays: null,
  },
  {
    Name: "She Is Gone (Prod. By Kane Beatz)",
    Artist: "Young Money Ft. Clyde McKnight",
    Album: "We Are Young Money",
    Time: 230,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Steady Mobbin'  (Prod. By Kane Beatz) ",
    Artist: "Young Money Ft. Gucci Mane",
    Album: "We Are Young Money",
    Time: 310,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Bedrock (Prod. By Kane Beatz)",
    Artist: "Young Money Ft. Lloyd",
    Album: "We Are Young Money",
    Time: 288,
    Year: 2009,
    Plays: 5,
  },
  {
    Name: "Pass The Dutch (Prod. By Chase N. Cashe)",
    Artist: "Young Money Ft. Shawt Dawg",
    Album: "We Are Young Money",
    Time: 306,
    Year: 2009,
    Plays: 1,
  },
  {
    Name: "Don't Rush (feat. Headie One)",
    Artist: "Young T & Bugsey",
    Album: "Don't Rush (feat. Headie One) - Single",
    Time: 207,
    Year: 2019,
    Plays: 35,
  },
  {
    Name: "Check",
    Artist: "Young Thug",
    Album: "Barter 6",
    Time: 230,
    Year: 2015,
    Plays: 1,
  },
  {
    Name: "Relationship (feat. Future)",
    Artist: "Young Thug",
    Album: "BEAUTIFUL THUGGER GIRLS",
    Time: 215,
    Year: 2017,
    Plays: 14,
  },
  {
    Name: "Hot (Remix) [feat. Gunna and Travis Scott]",
    Artist: "Young Thug",
    Album: "Hot (Remix) [feat. Gunna and Travis Scott] - Single",
    Time: 279,
    Year: 2019,
    Plays: 31,
  },
  {
    Name: "The London (feat. J. Cole & Travis Scott)",
    Artist: "Young Thug",
    Album: "The London (feat. J. Cole & Travis Scott) - Single",
    Time: 200,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Scoliosis (with Lil Double 0)",
    Artist: "Young Thug",
    Album: "Punk",
    Time: 170,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Hate The Game",
    Artist: "Young Thug",
    Album: "Punk",
    Time: 164,
    Year: 2021,
    Plays: 3,
  },
  {
    Name: "Digits",
    Artist: "Young Thug",
    Album: "Slime Season 3",
    Time: 176,
    Year: 2016,
    Plays: null,
  },
  {
    Name: "Just How It Is",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 207,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Sup Mate (feat. Future)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 238,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Ecstasy (feat. Machine Gun Kelly)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 178,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Hot (feat. Gunna)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 193,
    Year: 2019,
    Plays: 8,
  },
  {
    Name: "Light It Up",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 209,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Surf (feat. Gunna)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 184,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Bad Bad Bad (feat. Lil Baby)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 149,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Lil Baby",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 201,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "What's the Move (feat. Lil Uzi Vert)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 251,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "I Bought Her (feat. Lil Duke)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 201,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Jumped Out the Window",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 204,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "I'm Scared (feat. 21 Savage & Doe boy)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 200,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Cartier Gucci Scarf (feat. Lil Duke)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 198,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Big Tipper (feat. Lil Keed)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 223,
    Year: 2019,
    Plays: 2,
  },
  {
    Name: "Pussy",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 141,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Circle of Bosses (feat. Quavo)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 179,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Mannequin Challenge (feat. Juice WRLD)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 162,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Boy Back (feat. NAV)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 202,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "The London (feat. J. Cole & Travis Scott)",
    Artist: "Young Thug",
    Album: "So Much Fun",
    Time: 200,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "The London (feat. J. Cole & Travis Scott)",
    Artist: "Young Thug",
    Album: "So Much Fun (Deluxe)",
    Time: 200,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Chanel (Go Get It) [feat. Gunna & Lil Baby]",
    Artist: "Young Thug & Young Stoner Life",
    Album: "Slime Language",
    Time: 201,
    Year: 2018,
    Plays: 29,
  },
  {
    Name: "Gang Up",
    Artist: "Young Thug, 2 Chainz, Wiz Khalifa & PnB Rock",
    Album: "Fast & Furious 8: The Album",
    Time: 231,
    Year: 2017,
    Plays: 14,
  },
  {
    Name: "Adios",
    Artist: "Young Zay",
    Album: "Adios - Single",
    Time: 130,
    Year: 2020,
    Plays: null,
  },
  {
    Name: "I Get Sex",
    Artist: "YoungBlaze",
    Album: "I Get Sex - Single",
    Time: 240,
    Year: 2013,
    Plays: 12,
  },
  {
    Name: "Imma Shine",
    Artist: "Youngbloodz",
    Album: "Step Up",
    Time: 218,
    Year: 2006,
    Plays: 4,
  },
  {
    Name: "My Window (feat. Lil Wayne)",
    Artist: "YoungBoy Never Broke Again",
    Album: "Top",
    Time: 192,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Love the Way You Lie",
    Artist: "Your Favorite Martian",
    Album: "Love the Way You Lie - Single",
    Time: 208,
    Year: 2012,
    Plays: 38,
  },
  {
    Name: "Text Me Back",
    Artist: "Your Favorite Martian",
    Album: "Text Me Back - Single",
    Time: 204,
    Year: 2012,
    Plays: 11,
  },
  {
    Name: "Tig Ol' Bitties",
    Artist: "Your Favorite Martian",
    Album: "Tig Ol' Bitties - Single",
    Time: 219,
    Year: 2011,
    Plays: 3,
  },
  {
    Name: "Point Zero",
    Artist: "Yuki Kajiura",
    Album: "Fate / Zero Original Soundtrack",
    Time: 226,
    Year: 2017,
    Plays: 13,
  },
  {
    Name: "Rule the Battlefield",
    Artist: "Yuki Kajiura",
    Album: "Fate / Zero Original Soundtrack",
    Time: 196,
    Year: 2017,
    Plays: 10,
  },
  {
    Name: "This Day, and Never Again",
    Artist: "Yuki Kajiura",
    Album: "Fate / Zero Original Soundtrack",
    Time: 212,
    Year: 2017,
    Plays: 5,
  },
  {
    Name: "Patch Song",
    Artist: "Yuki Hayashi",
    Album: "PatchSong Funbari no Uta - Single",
    Time: 253,
    Year: 2022,
    Plays: 1,
  },
  {
    Name: "Tsunagu to Iukoto (feat. Farhan Sarasin) [Lo-Fi]",
    Artist: "Yuki Hayashi",
    Album: "Re-Build Lo-Fi Hip Hop",
    Time: 162,
    Year: 2021,
    Plays: 4,
  },
  {
    Name: "心を一つに",
    Artist: "Yuki Hayashi",
    Album:
      "「僕のヒーローアカデミア THE MOVIE ヒーローズ:ライジング」オリジナルサウンドトラック",
    Time: 144,
    Year: 2019,
    Plays: 127,
  },
  {
    Name: "受け継がれる心",
    Artist: "Yuki Hayashi",
    Album:
      "「僕のヒーローアカデミア THE MOVIE ヒーローズ:ライジング」オリジナルサウンドトラック",
    Time: 156,
    Year: 2019,
    Plays: 21,
  },
  {
    Name: "Sensenhukoku",
    Artist: "Yuki Hayashi & Takahiro Obata",
    Album: "Re-Build5",
    Time: 302,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Rewrite the Stars",
    Artist: "Zac Efron & Zendaya",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 217,
    Year: 2017,
    Plays: 26,
  },
  {
    Name: "Under My Shades",
    Artist: "Zara Larsson",
    Album: "Introducing",
    Time: 207,
    Year: 2013,
    Plays: 8,
  },
  {
    Name: "When Worlds Collide",
    Artist: "Zara Larsson",
    Album: "Introducing",
    Time: 210,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "In Love With Myself",
    Artist: "Zara Larsson",
    Album: "Introducing",
    Time: 162,
    Year: 2013,
    Plays: 19,
  },
  {
    Name: "Uncover",
    Artist: "Zara Larsson",
    Album: "Introducing",
    Time: 211,
    Year: 2013,
    Plays: 157,
  },
  {
    Name: "It's A Wrap",
    Artist: "Zara Larsson",
    Album: "Introducing",
    Time: 198,
    Year: 2013,
    Plays: 5,
  },
  {
    Name: "Dusk Till Dawn (feat. Sia) [Radio Edit]",
    Artist: "ZAYN",
    Album: "Dusk Till Dawn (feat. Sia) [Radio Edit] - Single",
    Time: 239,
    Year: 2017,
    Plays: 102,
  },
  {
    Name: "Good Years",
    Artist: "ZAYN",
    Album: "Icarus Falls",
    Time: 180,
    Year: 2018,
    Plays: 3,
  },
  {
    Name: "Mo Reala (feat. Future)",
    Artist: "Zaytoven",
    Album: "Trapholizay",
    Time: 278,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "Gravedigger's Chant",
    Artist: "Zeal & Ardor",
    Album: "Stranger Fruit",
    Time: 191,
    Year: 2018,
    Plays: 61,
  },
  {
    Name: "Vigil",
    Artist: "Zeal & Ardor",
    Album: "Wake of a Nation - EP",
    Time: 190,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "Beautiful Now (feat. Jon Bellion)",
    Artist: "Zedd",
    Album: "True Colors",
    Time: 218,
    Year: 2015,
    Plays: 5,
  },
  {
    Name: "Demons",
    Artist: "Zeds Dead",
    Album: "Step Up All In (Original Motion Picture Soundtrack)",
    Time: 233,
    Year: 2014,
    Plays: 1,
  },
  {
    Name: "The End / Undead",
    Artist: "Zero 9:36 & Hollywood Undead",
    Album: "The End / Undead - Single",
    Time: 186,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "In My Hands",
    Artist: "Zero 9:36, Travis Barker & Clever",
    Album: "In My Hands - Single",
    Time: 165,
    Year: 2020,
    Plays: 5,
  },
  {
    Name: "Loving You",
    Artist: "Zinoleesky",
    Album: "Loving You - Single",
    Time: 125,
    Year: 2022,
    Plays: 3,
  },
  {
    Name: "Naira Marley",
    Artist: "Zinoleesky",
    Album: "Naira Marley - Single",
    Time: 133,
    Year: 2021,
    Plays: 74,
  },
  {
    Name: "A Million Dreams",
    Artist: "Ziv Zaifman, Hugh Jackman & Michelle Williams",
    Album: "The Greatest Showman (Original Motion Picture Soundtrack)",
    Time: 269,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "Alubarika (feat. Buju)",
    Artist: "Zlatan",
    Album: "Alubarika (feat. Buju) - Single",
    Time: 198,
    Year: 2021,
    Plays: 1,
  },
  {
    Name: "Cho Cho (feat. Davido & Mayorkun)",
    Artist: "Zlatan",
    Album: "Cho Cho (feat. Davido & Mayorkun) - Single",
    Time: 169,
    Year: 2021,
    Plays: 30,
  },
  {
    Name: "Lagos Anthem",
    Artist: "Zlatan",
    Album: "Lagos Anthem - Single",
    Time: 209,
    Year: 2020,
    Plays: 23,
  },
  {
    Name: "Osanle (feat. Davido)",
    Artist: "Zlatan",
    Album: "Osanle (feat. Davido) - Single",
    Time: 210,
    Year: 2018,
    Plays: 161,
  },
  {
    Name: "Ale Yi",
    Artist: "Zlatan",
    Album: "Resan",
    Time: 161,
    Year: 2021,
    Plays: 7,
  },
  {
    Name: "Colorado",
    Artist: "Zugo & Dai Verse",
    Album: "Colorado - Single",
    Time: 193,
    Year: 2020,
    Plays: 3,
  },
  {
    Name: "You Say Run",
    Artist: "林 ゆうき",
    Album: "TVアニメ『僕のヒーローアカデミア』オリジナル・サウンドトラック",
    Time: 228,
    Year: 2016,
    Plays: 5,
  },
  {
    Name: "君はヒーローになれる",
    Artist: "林 ゆうき",
    Album: "TVアニメ『僕のヒーローアカデミア』オリジナル・サウンドトラック",
    Time: 176,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "My Hero Academia",
    Artist: "林 ゆうき",
    Album: "TVアニメ『僕のヒーローアカデミア』オリジナル・サウンドトラック",
    Time: 205,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Jet Set Run",
    Artist: "林ゆうき",
    Album:
      "TVアニメ「僕のヒーローアカデミア」 2nd オリジナル・サウンドトラック",
    Time: 225,
    Year: 2017,
    Plays: 3,
  },
  {
    Name: "君の力",
    Artist: "林ゆうき",
    Album:
      "TVアニメ「僕のヒーローアカデミア」 2nd オリジナル・サウンドトラック",
    Time: 173,
    Year: 2017,
    Plays: 72,
  },
  {
    Name: "我们不一样",
    Artist: "鐘偉",
    Album: "别再说谎",
    Time: 274,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Fork",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 227,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "36",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 89,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Feds Watching (Feat. Pharrell)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 247,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Where You Been",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 230,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "I Do It (Feat. Drake, Lil Wayne)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 373,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Used 2",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 225,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Netflix (Feat. Fergie)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 235,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Extra (Feat. Rich Homie Quan)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 287,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "U Da Realest",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 281,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Beautiful Pain (Feat. Lloyd, Mase)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 290,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "So We Can Live (Feat. T-Pain)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 406,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Mainstream Ratchet",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 238,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Black Unicorn (Feat. Chrisette Michele, Sunni Patterson)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 285,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Outroduction",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 300,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Employee Of The Month",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 195,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Live And Learn (It Will) (Feat. Dolla Boy, Pusha T)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 268,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Livin (Feat. IAMSU)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S II-Metime-(Deluxe Edition)",
    Time: 188,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Fork",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 227,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "36",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 88,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Feds Watching (feat. Pharrell)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 250,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Where U Been? (feat. Cap1)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 230,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "I Do It (feat. Drake & Lil Wayne)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 373,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Used 2",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 225,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Netflix (feat. Fergie)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 235,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Extra (feat. Rich Homie Quan)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 287,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "U Da Realest",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 281,
    Year: 2013,
    Plays: 3,
  },
  {
    Name: "Beautiful Pain (feat. Lloyd & Ma$e)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 290,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "So We Can Live (feat. T-Pain)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 406,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Mainstream Ratchet",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 238,
    Year: 2013,
    Plays: 2,
  },
  {
    Name: "Black Unicorn (feat. Chrisette Michele & Sunni Patterson)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 285,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Outroduction",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 300,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Employee of the Month",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 195,
    Year: 2013,
    Plays: 4,
  },
  {
    Name: "Live and Learn (It Will) [feat. Pusha T & Dolla Boy]",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 268,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Living (feat. IamSu)",
    Artist: "2 Chainz",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 188,
    Year: 2013,
    Plays: 1,
  },
  {
    Name: "Birthday Song (Feat. Kanye West)",
    Artist: "2 Chainz",
    Album: "Based On A T.R.U. Story (Deluxe Edition)",
    Time: 306,
    Year: 2012,
    Plays: 1,
  },
  {
    Name: "No Lie (feat. Drake)",
    Artist: "2 Chainz",
    Album: "Based On a T.R.U. Story (Deluxe Version)",
    Time: 237,
    Year: 2012,
    Plays: 131,
  },
  {
    Name: "Birthday Song (feat. Kanye West)",
    Artist: "2 Chainz",
    Album: "Based On a T.R.U. Story (Deluxe Version)",
    Time: 306,
    Year: 2012,
    Plays: 26,
  },
  {
    Name: "Dedication",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 299,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Smell Like Money (feat. Lil Wayne)",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 290,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Bounce (feat. Lil Wayne)",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 259,
    Year: 2016,
    Plays: 10,
  },
  {
    Name: "Gotta Lotta (feat. Lil Wayne)",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 216,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "MFN Right",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 205,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Blue C-Note (feat. Lil Wayne)",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 171,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Not Invited",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 197,
    Year: 2016,
    Plays: 2,
  },
  {
    Name: "Bentley Truck (feat. Lil Wayne)",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 279,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "100 Joints",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 219,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "Rolls Royce Weather Every Day (feat. Lil Wayne)",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 187,
    Year: 2016,
    Plays: 3,
  },
  {
    Name: "What Happened (feat. Lil Wayne)",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 298,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Section (feat. Lil Wayne)",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 235,
    Year: 2016,
    Plays: 1,
  },
  {
    Name: "Watch Out",
    Artist: "2 Chainz",
    Album: "Collegrove",
    Time: 207,
    Year: 2016,
    Plays: 6,
  },
  {
    Name: "Forgiven (feat. Marsha Ambrosius)",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 323,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Threat 2 Society",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 225,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Money in the Way",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 161,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Statute of Limitations",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 149,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "High Top Versace (feat. Young Thug)",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 176,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Whip (feat. Travis Scott)",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 226,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "NCAA",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 248,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Momma I Hit a Lick (feat. Kendrick Lamar)",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 173,
    Year: 2019,
    Plays: 30,
  },
  {
    Name: "Rule the World (feat. Ariana Grande)",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 245,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Girl's Best Friend (feat. Ty Dolla $ign)",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 192,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "2 Dollar Bill (feat. Lil Wayne & E-40)",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 240,
    Year: 2019,
    Plays: 6,
  },
  {
    Name: "I Said Me",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 331,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "I'm Not Crazy, Life Is (feat. Chance the Rapper & Kodak Black)",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 330,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "Sam",
    Artist: "2 Chainz",
    Album: "Rap or Go to the League",
    Time: 251,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "We Own It (Fast & Furious)",
    Artist: "2 Chainz & Wiz Khalifa",
    Album: "B.O.A.T.S. II #METIME (Deluxe)",
    Time: 227,
    Year: 2013,
    Plays: null,
  },
  {
    Name: "Amaka (feat. Peruzzi)",
    Artist: "2Baba",
    Album: "Amaka (feat. Peruzzi) - Single",
    Time: 227,
    Year: 2018,
    Plays: 25,
  },
  {
    Name: "Ole (feat. Freestyle) [Remastered Version]",
    Artist: "2Baba",
    Album: "Face 2 Face 10.0",
    Time: 290,
    Year: 2004,
    Plays: 19,
  },
  {
    Name: "Ghetto Life (feat. Rocksteady & Blackface Naija)",
    Artist: "2Baba",
    Album: "Face 2 Face 10.0",
    Time: 272,
    Year: 2014,
    Plays: null,
  },
  {
    Name: "Coded Tinz (feat. Phyno & Chief Obi)",
    Artist: "2Face",
    Album: "Chinkafa",
    Time: 251,
    Year: 2016,
    Plays: 8,
  },
  {
    Name: "Implication",
    Artist: "2Face Idibia",
    Album: "T.I.A: This Is Afrobeats (Dj Edu Presents...)",
    Time: 207,
    Year: 2009,
    Plays: 5,
  },
  {
    Name: "Don't Trust Me",
    Artist: "3OH!3",
    Album: "Want",
    Time: 192,
    Year: 2008,
    Plays: 2,
  },
  {
    Name: "青春サツバツ論(Full size)",
    Artist: "3年E組うた担(渚&茅野&業&磯貝&前原)",
    Album: "青春サツバツ論 - EP",
    Time: 223,
    Year: 2015,
    Plays: 3,
  },
  {
    Name: "Out of Your Mind",
    Artist: "4th Point",
    Album: "Out of Your Mind - Single",
    Time: 176,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "Youngblood",
    Artist: "5 Seconds of Summer",
    Album: "Youngblood (Deluxe)",
    Time: 203,
    Year: 2018,
    Plays: 7,
  },
  {
    Name: "She",
    Artist: "6DAYS",
    Album: "She - Single",
    Time: 161,
    Year: 2020,
    Plays: 1,
  },
  {
    Name: "MAMA (feat. Nicki Minaj & Kanye West)",
    Artist: "6ix9ine",
    Album: "DUMMY BOY",
    Time: 192,
    Year: 2018,
    Plays: 1,
  },
  {
    Name: "BEBE (feat. Anuel AA)",
    Artist: "6ix9ine",
    Album: "DUMMY BOY",
    Time: 217,
    Year: 2018,
    Plays: 35,
  },
  {
    Name: "TATI (feat. DJ SPINKING)",
    Artist: "6ix9ine",
    Album: "DUMMY BOY",
    Time: 154,
    Year: 2018,
    Plays: 6,
  },
  {
    Name: "GOOBA",
    Artist: "6ix9ine",
    Album: "TattleTales",
    Time: 132,
    Year: 2020,
    Plays: 7,
  },
  {
    Name: "Lovers",
    Artist: "7!!",
    Album: "Lovers",
    Time: 222,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Lovers (Instrumental)",
    Artist: "7!!",
    Album: "Lovers",
    Time: 221,
    Year: 2011,
    Plays: null,
  },
  {
    Name: "Teeth",
    Artist: "8 Graves",
    Album: "Red - EP",
    Time: 205,
    Year: 2020,
    Plays: 2,
  },
  {
    Name: "The Unknown",
    Artist: "10 Years",
    Album: "Violent Allies",
    Time: 180,
    Year: 2020,
    Plays: 139,
  },
  {
    Name: "a lot",
    Artist: "21 Savage",
    Album: "i am > i was",
    Time: 288,
    Year: 2018,
    Plays: null,
  },
  {
    Name: "Immortal",
    Artist: "21 Savage",
    Album: "Immortal - Single",
    Time: 254,
    Year: 2019,
    Plays: null,
  },
  {
    Name: "Ghostface Killers (feat. Travis Scott)",
    Artist: "21 Savage, Offset & Metro Boomin",
    Album: "Without Warning",
    Time: 268,
    Year: 2017,
    Plays: 22,
  },
  {
    Name: "Company (feat. Future)",
    Artist: "24kGoldn",
    Album: "El Dorado",
    Time: 213,
    Year: 2021,
    Plays: null,
  },
  {
    Name: "Not A Rapper (feat. Lil Baby & Yo Gotti)",
    Artist: "42 Dugg",
    Album: "Young & Turnt 2",
    Time: 107,
    Year: 2020,
    Plays: 37,
  },
  {
    Name: "She And I",
    Artist: "50 Cent",
    Album: "Curtis",
    Time: 224,
    Year: 2007,
    Plays: null,
  },
  {
    Name: "In Da Club",
    Artist: "50 Cent",
    Album: "Get Rich or Die Tryin",
    Time: 193,
    Year: 2003,
    Plays: 2,
  },
  {
    Name: "P.I.M.P.",
    Artist: "50 Cent",
    Album: "Get Rich or Die Tryin",
    Time: 249,
    Year: 2003,
    Plays: 3,
  },
  {
    Name: "Just a Lil Bit",
    Artist: "50 Cent",
    Album: "The Massacre",
    Time: 237,
    Year: 2005,
    Plays: null,
  },
  {
    Name: "She And I",
    Artist: "50 Cent",
    Album: "The Massacre (Explicit)",
    Time: 209,
    Year: 2005,
    Plays: null,
  },
  {
    Name: "My Life ft. Eminem, Adam Levin",
    Artist: "50 Cent",
    Album: "My Life (feat. Eminem & Adam L",
    Time: 244,
    Year: 2012,
    Plays: null,
  },
  {
    Name: "Sunday Night (feat. Phi)",
    Artist: "070 Shake",
    Album: "Sunday Night (feat. Phi) - Single",
    Time: 275,
    Year: 2016,
    Plays: 56,
  },
  {
    Name: "SCAR",
    Artist: "070 Shake & Jessie Reyez",
    Album: "The Lion King: The Gift",
    Time: 186,
    Year: 2019,
    Plays: 1,
  },
  {
    Name: "money machine",
    Artist: "100 gecs",
    Album: "1000 gecs",
    Time: 114,
    Year: 2019,
    Plays: 48,
  },
  {
    Name: "Harry Potter - Expecto Patronum (Goblins From Mars Trap Remix)",
    Artist: "",
    Album: "Youtube",
    Time: 163,
    Year: null,
    Plays: 65,
  },
  {
    Name: "Attack on Titan Theme (Guren no Yumiya) - Violin - Taylor Davis",
    Artist: "",
    Album: "",
    Time: 177,
    Year: null,
    Plays: null,
  },
  {
    Name: "Bleach Never Meant to Belong - Violin Solo, Taylor Davis",
    Artist: "",
    Album: "",
    Time: 211,
    Year: null,
    Plays: 3,
  },
  {
    Name: "DAVIDO x MEEK MILL - FANS MI (Official Music Video)",
    Artist: "",
    Album: "",
    Time: 223,
    Year: null,
    Plays: null,
  },
  {
    Name: "EPIC Game of Thrones (Extended Theme) Audio - PiscesRising",
    Artist: "",
    Album: "",
    Time: 213,
    Year: null,
    Plays: 24,
  },
  {
    Name: "Fairy Tail Main Theme (Violin and Piano) - Taylor Davis and Lara",
    Artist: "",
    Album: "",
    Time: 199,
    Year: null,
    Plays: null,
  },
  {
    Name: "Game of Thrones Theme - Violin - Taylor Davis",
    Artist: "",
    Album: "",
    Time: 225,
    Year: null,
    Plays: null,
  },
  {
    Name: "Hans-Zimmer-He_s-a-Pirate",
    Artist: "",
    Album: "",
    Time: 92,
    Year: null,
    Plays: null,
  },
  {
    Name: "Harry Potter Theme (Hedwig's Theme) - Violin - Taylor Davis",
    Artist: "",
    Album: "",
    Time: 267,
    Year: null,
    Plays: null,
  },
  {
    Name: "He's a Pirate (Disney's Pirates of the Caribbean Theme) Violin - Taylor Davis",
    Artist: "",
    Album: "",
    Time: 214,
    Year: null,
    Plays: null,
  },
  {
    Name: "Kafee_And_Timaya_Kokoroko",
    Artist: "",
    Album: "",
    Time: 266,
    Year: null,
    Plays: 2,
  },
  {
    Name: "Let It Go (Disney's Frozen) Violin - Taylor Davis",
    Artist: "",
    Album: "",
    Time: 224,
    Year: null,
    Plays: null,
  },
  {
    Name: "Naruto - Sadness and Sorrow (Violin) - Taylor Davis",
    Artist: "",
    Album: "",
    Time: 172,
    Year: null,
    Plays: null,
  },
  {
    Name: "Nifty Trick - Dub Drop - Teen Wolf 4x04 Music [myfreesong.net]",
    Artist: "",
    Album: "",
    Time: 170,
    Year: null,
    Plays: null,
  },
  {
    Name: "Skyrim Theme Live at E3 2012 on Violin and Pianos Taylor Davis, Kyle Landry, Lara",
    Artist: "",
    Album: "",
    Time: 241,
    Year: null,
    Plays: null,
  },
  {
    Name: "Song of Time and Song of Storms (Zelda OoT) Violin - Taylor Davis",
    Artist: "",
    Album: "",
    Time: 226,
    Year: null,
    Plays: null,
  },
  {
    Name: "Survivor-1-Eye-Of-The-Tiger",
    Artist: "",
    Album: "",
    Time: 247,
    Year: null,
    Plays: null,
  },
  {
    Name: "Tears For Fears - 'Shout' by Think Up Anger ft. Malia J.",
    Artist: "",
    Album: "",
    Time: 190,
    Year: null,
    Plays: 20,
  },
  {
    Name: "Transformers Arrival to Earth - Violins - Taylor Davis",
    Artist: "",
    Album: "",
    Time: 252,
    Year: null,
    Plays: null,
  },
];

export default musicLibrary;
